import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.content');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-content',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.content/view.scss */
@charset "UTF-8";
:host {
  container: wb-content/inline-size;
  min-width: 0;
  display: block;
  min-height: 100%;
  color: #172033;
  background: var(--wb-page-canvas, #f5f9fd);
}

/* Workbench sections share the same navigation on creation and experiment pages. */
/* Match the underline navigation used by scenario detail pages. */
.wb-workspace-nav {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #dbe6f3;
  border-radius: 0;
  background: transparent;
}

.wb-workspace-nav a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 48px;
  padding: 11px 18px;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  background: transparent;
  color: #56739a;
  font-size: 14px;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
  text-decoration: none;
  word-break: keep-all;
}

.wb-workspace-nav a i {
  flex: none;
  font-size: 16px;
}

.wb-workspace-nav a:hover {
  color: #125dd6;
  background: #eef5ff;
}

.wb-workspace-nav a.is-active {
  border-bottom-color: #1367ed;
  background: transparent;
  color: #1262e6;
  box-shadow: none;
}

.wb-workspace-nav a:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: -3px;
}

/* Content creation flow selected from the two approved workbench mockups. */
.wb-new-header-inner {
  min-height: 66px;
}

/* Match the media selector used by prompt management. */
.wb-new-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 14px;
  padding: 5px;
  border: 0;
  border-radius: 14px;
  background: #f1f5f9;
}

.wb-new-media-tabs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 44px;
  padding: 9px 12px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.wb-new-media-tabs button:hover:not(:disabled) {
  color: #4338ca;
  background: #e9edf5;
}

.wb-new-media-tabs button.is-active, .wb-new-media-tabs button.is-active:hover {
  border-color: #e0e7ff;
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.wb-new-media-tabs button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.wb-new-media-tabs button:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: -3px;
}

.wb-new-media-tabs i {
  font-size: 16px;
}

.wb-media-panel {
  min-width: 0;
}

.wb-new-source-card > *, .wb-new-source-choice strong {
  min-width: 0;
}

.wb-new-source-choice {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.wb-media-panel:focus-visible {
  outline: 2px solid #1263ec;
  outline-offset: 4px;
}

.wb-new-user {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-left: 14px;
  border-left: 1px solid #d9e5f4;
  color: #284676;
  font-weight: 700;
}

.wb-new-user i {
  display: grid;
  place-items: center;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #eaf2ff;
}

.wb-new-page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.wb-new-page-title h2 {
  margin: 0;
  color: #0d1c4d;
  font-size: 27px;
  font-weight: 800;
  line-height: 1.25;
}

.wb-new-page-title p {
  margin: 5px 0 0;
  color: #56709a;
  font-size: 13px;
}

.wb-new-breadcrumb {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
  color: #135ce0;
  font-size: 12px;
  font-weight: 700;
}

.wb-new-breadcrumb .fa-chevron-right {
  color: #a2b6d4;
  font-size: 10px;
}

.wb-new-source-card, .wb-new-list-card, .wb-new-selected-source, .wb-new-control-card, .wb-new-result-card, .wb-new-inline-alert {
  border: 1px solid #dce7f7;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(30, 77, 140, 0.035);
}

.wb-new-source-card {
  display: grid;
  grid-template-columns: minmax(210px, 0.95fr) repeat(2, minmax(220px, 1.6fr));
  align-items: center;
  gap: 18px;
  padding: 23px 24px;
  margin-bottom: 14px;
}

.wb-new-source-card h3 {
  margin: 0;
  color: #0b1d4c;
  font-size: 18px;
  font-weight: 800;
}

.wb-new-source-choice {
  display: flex;
  align-items: center;
  gap: 22px;
  width: 100%;
  min-height: 75px;
  padding: 14px 24px;
  border: 1px solid #cdddf5;
  border-radius: 7px;
  background: #fff;
  color: #132452;
  text-align: left;
}

.wb-new-source-choice:hover, .wb-new-source-choice.is-active {
  border-color: #1263ec;
  background: #eef5ff;
  color: #0758df;
}

.wb-new-source-choice > i:first-child {
  width: 35px;
  font-size: 30px;
  text-align: center;
}

.wb-new-source-choice strong {
  flex: 1;
  font-size: 17px;
  font-weight: 800;
}

.wb-new-source-choice > i:last-child {
  font-size: 12px;
}

.wb-new-list-card {
  padding: 15px 21px 12px;
  margin-bottom: 14px;
}

.wb-new-list-card > header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 45px;
  margin-bottom: 6px;
  color: #122968;
}

.wb-new-list-card > header > i {
  font-size: 19px;
}

.wb-new-list-card > header h3 {
  margin: 0;
  color: #10204e;
  font-size: 18px;
  font-weight: 800;
}

.wb-new-list-card > header p {
  margin: 0;
  color: #7085a9;
  font-size: 12px;
}

.wb-new-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(100%, 270px);
  min-height: 34px;
  margin-left: auto;
  padding: 0 11px;
  border: 1px solid #d4e1f5;
  border-radius: 6px;
  background: #fff;
  color: #8296b5;
}

.wb-new-search:focus-within {
  border-color: #1263ec;
  box-shadow: 0 0 0 2px #dceaff;
}

.wb-new-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #193264;
  font-size: 12px;
}

.wb-new-search input::placeholder {
  color: #93a6c0;
}

.wb-new-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 58px;
  margin-top: 5px;
  padding: 8px 2px 0;
  border-top: 1px solid #e6edf7;
  color: #6d83a5;
  font-size: 11px;
}

.wb-new-pagination > div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
}

.wb-new-pagination button {
  min-width: 44px;
  min-height: 44px;
  padding: 0 10px;
  border: 1px solid #d7e3f5;
  border-radius: 6px;
  background: #fff;
  color: #42628f;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.wb-new-pagination button.is-active {
  border-color: #1263ec;
  background: #1263ec;
  color: #fff;
}

.wb-new-pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.wb-new-pagination button:not(:disabled):hover {
  border-color: #1263ec;
}

.wb-new-pagination button:focus-visible {
  outline: 3px solid #8bb9ff;
  outline-offset: 2px;
}

.wb-new-table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.wb-new-table-scroll:focus-visible {
  outline: 2px solid #1263ec;
  outline-offset: 2px;
}

.wb-new-table-scroll.has-results {
  min-height: 273px;
}

.wb-new-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
  color: #355384;
  font-size: 13px;
}

.wb-new-table th, .wb-new-table td {
  min-width: 6rem;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.wb-new-table th:first-child, .wb-new-table td:first-child {
  min-width: 10rem;
}

.wb-new-table th {
  height: 38px;
  padding: 8px 14px;
  background: #f2f7fc;
  color: #526e9c;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.wb-new-table th:first-child {
  border-radius: 5px 0 0 5px;
}

.wb-new-table th:last-child {
  border-radius: 0 5px 5px 0;
}

.wb-new-table td {
  height: 47px;
  padding: 5px 14px;
  border-bottom: 1px solid #e2eaf6;
}

.wb-new-table tbody tr:last-child td {
  border-bottom: 0;
}

.wb-new-table tbody tr.is-working td {
  background: #f0fbf6;
}

.wb-new-table tbody tr.is-working td:first-child {
  color: #08764f;
  font-weight: 800;
}

.wb-new-strong {
  color: #0e2050;
  font-weight: 750;
}

.wb-new-table td:last-child {
  min-width: 9rem;
}

.wb-new-outline-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 31px;
  padding: 6px 14px;
  border: 1px solid #c6d9fa;
  border-radius: 5px;
  background: #fff;
  color: #0a50d1;
  font-size: 12px;
  font-weight: 750;
  text-decoration: none;
  white-space: nowrap;
}

.wb-new-outline-button:hover {
  border-color: #2772ed;
  background: #f2f7ff;
}

.wb-new-outline-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wb-new-empty-cell {
  padding: 26px 12px !important;
  color: #7d91ae;
  text-align: center;
}

.wb-new-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 88px;
  padding: 5px 11px;
  border-radius: 99px;
  color: #64748b;
  background: #eef2f6;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-status.is-ready {
  background: #dff7e9;
  color: #00895a;
}

.wb-new-status.is-review {
  background: #fff1d8;
  color: #bd6c06;
}

.wb-new-worked-status {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  padding: 5px 9px;
  border-radius: 99px;
  background: #dff7e9;
  color: #00895a;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-recent {
  margin-top: 14px;
}

.wb-new-selected-source {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 17px;
  min-height: 72px;
  padding: 13px 22px;
  margin-bottom: 9px;
}

.wb-new-selected-source > strong {
  color: #10224d;
  font-size: 15px;
  font-weight: 800;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.wb-new-context-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 11px;
  margin: -1px 0 9px;
  padding: 10px 21px;
  border: 1px solid #dbe8f8;
  border-radius: 6px;
  background: #fff;
}

.wb-new-context-label {
  color: #193264;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-context-options {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.wb-new-context-options button {
  min-height: 31px;
  padding: 5px 12px;
  border: 1px solid #d9e5f5;
  border-radius: 5px;
  background: #f8fbff;
  color: #587198;
  font-size: 11px;
  font-weight: 700;
}

.wb-new-context-options button.is-active {
  border-color: #1263ec;
  background: #edf5ff;
  color: #0758df;
}

.wb-new-context-card select {
  min-width: 190px;
  max-width: min(100%, 490px);
  min-height: 31px;
  padding: 5px 10px;
  border: 1px solid #d4e1f5;
  border-radius: 5px;
  background: #fff;
  color: #193264;
  font-size: 11px;
}

.wb-new-context-help {
  color: #7085a9;
  font-size: 11px;
}

.wb-new-source-kind {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 5px 18px 5px 15px;
  border: 1px solid #c8daf6;
  border-radius: 5px;
  background: #edf5ff;
  color: #0758df;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.wb-new-current-source {
  display: inline-flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 12px;
  color: #1e335c;
  font-size: 12px;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.wb-new-current-source strong {
  color: #10204e;
  font-size: 15px;
  font-weight: 800;
}

.wb-new-text-button {
  padding: 4px 0;
  border: 0;
  background: none;
  color: #0960e5;
  font-size: 12px;
  font-weight: 750;
}

.wb-new-inline-alert {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 12px 18px;
  margin-bottom: 9px;
  background: #fffaf0;
  color: #775416;
}

.wb-new-inline-alert > i {
  font-size: 18px;
}

.wb-new-inline-alert div {
  flex: 1;
}

.wb-new-inline-alert strong {
  font-size: 12px;
}

.wb-new-inline-alert p {
  margin: 2px 0 0;
  font-size: 11px;
}

.wb-new-inline-alert button, .wb-new-inline-alert a {
  padding: 7px 10px;
  border: 1px solid #e4c88d;
  border-radius: 5px;
  background: #fff;
  color: #765313;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.wb-new-analysis-alert {
  display: block;
  padding: 0;
  overflow: hidden;
}

.wb-new-inline-alert-main {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 12px 18px;
}

.wb-new-inline-alert-main > i {
  flex: 0 0 auto;
  font-size: 18px;
}

.wb-new-inline-alert-main > div {
  flex: 1;
  min-width: 0;
}

.wb-new-analysis-progress {
  padding: 0 18px 13px;
}

.wb-new-analysis-progress-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
  color: #6d541f;
}

.wb-new-analysis-progress-meta strong {
  font-size: 10px;
  font-weight: 800;
}

.wb-new-analysis-progress-meta small {
  font-size: 10px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.wb-new-analysis-progress-track {
  display: block;
  height: 7px;
  overflow: hidden;
  border-radius: 99px;
  background: #efdfbc;
}

.wb-new-analysis-progress-fill {
  position: relative;
  display: block;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
  background: linear-gradient(90deg, #1767e8, #4d96f7);
  transition: width 0.3s ease;
}

.wb-new-analysis-progress-fill::after {
  position: absolute;
  inset: 0;
  width: 45%;
  content: "";
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
  animation: wb-analysis-progress 1.3s ease-in-out infinite;
}

@keyframes wb-analysis-progress {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(320%);
  }
}
.wb-new-analysis-alert button:disabled {
  cursor: wait;
  opacity: 0.72;
}

.wb-analysis-card {
  margin-bottom: 10px;
  padding: 18px 20px;
  border: 1px solid #d9e6f7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(30, 77, 140, 0.035);
}

.wb-analysis-header, .wb-analysis-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.wb-analysis-header {
  justify-content: space-between;
  flex-wrap: wrap;
}

.wb-analysis-eyebrow {
  color: #1263ec;
  font-size: 11px;
  font-weight: 800;
}

.wb-analysis-header h3 {
  margin: 3px 0;
  color: #10204e;
  font-size: 17px;
  font-weight: 800;
}

.wb-analysis-header p {
  margin: 0;
  color: #7389a8;
  font-size: 11px;
}

.wb-analysis-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0;
}

.wb-analysis-summary span {
  padding: 5px 9px;
  border-radius: 99px;
  background: #f1f6fd;
  color: #49658d;
  font-size: 11px;
  font-weight: 700;
}

.wb-analysis-summary .is-ready {
  background: #e6f6ee;
  color: #087a55;
}

.wb-analysis-summary .is-warning {
  background: #fff3df;
  color: #945d0d;
}

.wb-analysis-layout {
  display: grid;
  grid-template-columns: minmax(230px, 1fr) minmax(300px, 1.3fr);
  gap: 14px;
}

.wb-analysis-cut-list {
  display: grid;
  align-content: start;
  gap: 6px;
  max-height: 290px;
  overflow-y: auto;
}

.wb-analysis-cut {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 52px;
  padding: 8px 11px;
  border: 1px solid #e0eaf7;
  border-radius: 6px;
  background: #fbfdff;
  color: #18345f;
  text-align: left;
}

.wb-analysis-cut:hover, .wb-analysis-cut.is-active {
  border-color: #71a8fb;
  background: #eef5ff;
}

.wb-analysis-cut.has-results {
  border-color: #aedac8;
  background: #f0faf5;
}

.wb-analysis-cut.has-results .wb-analysis-cut-number {
  background: #d9f2e6;
  color: #087149;
}

.wb-analysis-cut.has-results:hover {
  border-color: #64b695;
  background: #e9f7f0;
}

.wb-analysis-cut.has-results.is-active {
  border-color: #327beb;
  background: #eaf6f2;
  box-shadow: inset 0 0 0 1px #327beb;
}

.wb-analysis-cut-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 7px;
}

.wb-analysis-cut-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 99px;
  background: #edf1f6;
  color: #62748a;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.5;
  white-space: nowrap;
}

.wb-analysis-cut-status.is-ready {
  background: #d9f2e6;
  color: #086844;
}

.wb-analysis-cut-status.is-running {
  background: #e4efff;
  color: #1559b4;
}

.wb-analysis-cut-status.is-failed {
  background: #ffebe9;
  color: #ae352b;
}

.wb-analysis-cut:focus-visible {
  outline: 3px solid #8bb9ff;
  outline-offset: 2px;
}

.wb-analysis-cut-number {
  display: grid;
  place-items: center;
  flex: 0 0 25px;
  height: 25px;
  border-radius: 50%;
  background: #e7f0ff;
  color: #1162e9;
  font-size: 11px;
  font-weight: 800;
}

.wb-analysis-cut-copy {
  display: grid;
  flex: 1;
  gap: 2px;
  min-width: 0;
}

.wb-analysis-cut-copy small {
  color: #6c83a8;
  font-size: 10px;
}

.wb-analysis-cut-copy strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-analysis-cut > i {
  color: #7a9dca;
  font-size: 10px;
}

.wb-analysis-selected {
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  background: #f8fbff;
}

.wb-analysis-selected > small {
  color: #1263ec;
  font-size: 10px;
  font-weight: 800;
}

.wb-analysis-selected h4 {
  margin: 5px 0 8px;
  color: #152753;
  font-size: 16px;
}

.wb-analysis-selected p {
  margin: 0 0 12px;
  color: #405c85;
  font-size: 12px;
  line-height: 1.6;
}

.wb-analysis-selected dl {
  display: grid;
  gap: 7px;
  margin: 0;
}

.wb-analysis-selected dl > div {
  display: grid;
  grid-template-columns: 42px 1fr;
  gap: 8px;
  font-size: 11px;
}

.wb-analysis-selected dt {
  color: #6e87ab;
  font-weight: 800;
}

.wb-analysis-selected dd {
  margin: 0;
  color: #294570;
}

.wb-analysis-evidence-link {
  margin-top: 14px;
  padding: 0;
  border: 0;
  background: none;
  color: #095bdc;
  font-size: 11px;
  font-weight: 750;
}

.wb-guide-step {
  overflow: hidden;
  padding: 0;
  border-color: #d5e3f5;
  box-shadow: none;
}

.wb-guide-step.is-open {
  border-color: #4e91f7;
}

.wb-guide-step-header {
  display: grid;
  grid-template-columns: 30px 26px minmax(180px, 1fr) auto 28px;
  align-items: center;
  gap: 8px;
  min-height: 58px;
  padding: 10px 16px;
  background: #fff;
}

.wb-guide-active-header {
  grid-template-columns: 30px 26px minmax(180px, 1fr) 28px;
  border-bottom: 1px solid #e4edf8;
  background: #fbfdff;
}

.wb-guide-step-state, .wb-guide-step-number {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e9f1fd;
  color: #496889;
  font-size: 11px;
  font-weight: 850;
}

.wb-guide-step-state {
  width: 30px;
  height: 30px;
  background: #1268ed;
  color: #fff;
}

.wb-guide-step-state.is-complete {
  background: #1268ed;
}

.wb-guide-step-copy {
  min-width: 0;
}

.wb-guide-step-copy h3, .wb-guide-step-copy strong {
  margin: 0;
  color: #13284f;
  font-size: 13px;
  font-weight: 850;
}

.wb-guide-step-copy p, .wb-guide-step-copy small {
  display: block;
  overflow: hidden;
  margin: 2px 0 0;
  color: #6d84a6;
  font-size: 10px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-guide-cut-header, .wb-disclosure-header {
  cursor: pointer;
}

.wb-guide-cut-heading, .wb-disclosure-heading {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.wb-guide-cut-heading:focus-visible, .wb-disclosure-heading:focus-visible {
  outline: 2px solid #1263ec;
  outline-offset: 4px;
  border-radius: 2px;
}

.wb-guide-change-button, .wb-guide-chevron {
  min-height: 32px;
  padding: 5px 11px;
  border: 1px solid #c5d9f8;
  border-radius: 5px;
  background: #fff;
  color: #0758df;
  font-size: 11px;
  font-weight: 800;
}

.wb-guide-change-button:hover, .wb-guide-chevron:hover {
  border-color: #1263ec;
  background: #f2f7ff;
}

.wb-guide-chevron {
  width: 28px;
  min-height: 28px;
  padding: 0;
  border-color: transparent;
  color: #264c7e;
}

.wb-guide-step-body {
  padding: 4px 18px 18px;
  border-top: 1px solid #e8eff8;
}

.wb-guide-step-body .wb-analysis-header {
  padding-top: 12px;
}

.wb-guide-step-body .wb-analysis-header h4 {
  margin: 3px 0;
  color: #10204e;
  font-size: 16px;
  font-weight: 800;
}

.wb-trigger-editor > p {
  color: #6c83a8;
  font-size: 11px;
  line-height: 1.5;
}

.wb-trigger-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 7px 0;
}

.wb-trigger-row > span {
  display: grid;
  place-items: center;
  flex: 0 0 24px;
  height: 24px;
  border-radius: 50%;
  background: #eaf2ff;
  color: #1263ec;
  font-size: 11px;
  font-weight: 800;
}

.wb-trigger-row input {
  flex: 1;
  min-width: 0;
  min-height: 35px;
  padding: 6px 10px;
  border: 1px solid #d3e2f5;
  border-radius: 5px;
  background: #fff;
  color: #1d365e;
  font-size: 12px;
}

.wb-trigger-row button {
  min-height: 35px;
  padding: 5px 10px;
  border: 1px solid #f0ccca;
  border-radius: 5px;
  background: #fff;
  color: #aa4039;
  font-size: 11px;
  font-weight: 750;
}

.wb-trigger-add {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.wb-trigger-add input {
  flex: 1;
  min-width: 180px;
  min-height: 35px;
  padding: 6px 10px;
  border: 1px solid #d3e2f5;
  border-radius: 5px;
  color: #1d365e;
  font-size: 12px;
}

.wb-trigger-empty {
  padding: 10px;
  border: 1px dashed #d3e2f5;
  border-radius: 5px;
}

.wb-evidence-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 800px);
  max-height: min(90vh, 780px);
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 20px 70px rgba(15, 35, 70, 0.24);
}

.wb-evidence-dialog > header, .wb-evidence-dialog > footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
}

.wb-evidence-dialog > header {
  border-bottom: 1px solid #e2eaf6;
}

.wb-evidence-dialog > header small {
  color: #1263ec;
  font-size: 10px;
  font-weight: 800;
}

.wb-evidence-dialog h2 {
  margin: 4px 0 0;
  color: #10204e;
  font-size: 17px;
}

.wb-evidence-dialog > header button {
  min-height: 34px;
  padding: 5px 11px;
  border: 0;
  border-radius: 5px;
  background: #eef4fb;
  color: #3d5a85;
  font-size: 12px;
  font-weight: 750;
}

.wb-evidence-dialog > footer {
  border-top: 1px solid #e2eaf6;
  justify-content: flex-end;
}

.wb-evidence-body {
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px;
}

.wb-evidence-body section + section {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #e2eaf6;
}

.wb-evidence-body h3 {
  margin: 0 0 10px;
  color: #16305b;
  font-size: 13px;
}

.wb-evidence-body article {
  margin: 8px 0;
  padding: 10px 12px;
  border: 1px solid #e0eaf7;
  border-radius: 6px;
  background: #f9fbff;
}

.wb-evidence-body article strong {
  color: #1263ec;
  font-size: 11px;
}

.wb-evidence-body article p {
  margin: 5px 0 0;
  color: #314c75;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.wb-evidence-error {
  color: #ad3e32;
}

.wb-evidence-warning {
  margin: 0 0 12px;
  padding: 9px 11px;
  border-radius: 6px;
  background: #fff7df;
  color: #765514;
  font-size: 11px;
  line-height: 1.55;
}

.wb-custom-expression-dialog {
  width: min(100%, 540px);
  max-height: min(90vh, 760px);
  overflow-y: auto;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 20px 70px rgba(15, 35, 70, 0.24);
}

.wb-custom-expression-dialog > header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #e2eaf6;
}

.wb-custom-expression-dialog > header small {
  color: #1263ec;
  font-size: 11px;
  font-weight: 800;
}

.wb-custom-expression-dialog h2 {
  margin: 4px 0;
  color: #10204e;
  font-size: 18px;
}

.wb-custom-expression-dialog > header p, .wb-custom-expression-dialog form > p {
  margin: 3px 0 0;
  color: #7188ad;
  font-size: 12px;
  line-height: 1.5;
}

.wb-custom-expression-dialog > header button {
  align-self: start;
  padding: 6px 10px;
  border: 0;
  border-radius: 5px;
  background: #eef4fb;
  color: #3d5a85;
  font-size: 12px;
}

.wb-custom-expression-dialog form {
  display: flex;
  flex-direction: column;
  padding: 18px 22px;
}

.wb-custom-expression-dialog label {
  margin: 0 0 6px;
  color: #183568;
  font-size: 12px;
  font-weight: 800;
}

.wb-custom-expression-dialog input, .wb-custom-expression-dialog textarea {
  width: 100%;
  margin-bottom: 14px;
  padding: 10px 12px;
  border: 1px solid #cadcf5;
  border-radius: 6px;
  color: #183568;
  font: inherit;
  font-size: 13px;
}

.wb-custom-expression-dialog input:focus, .wb-custom-expression-dialog textarea:focus {
  outline: 2px solid #deebff;
  border-color: #1263ec;
}

.wb-custom-expression-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.wb-custom-expression-actions .wb-new-generate {
  min-height: 38px;
  padding: 7px 15px;
}

.wb-custom-expression-presets {
  padding: 16px 22px 20px;
  border-top: 1px solid #e2eaf6;
}

.wb-custom-expression-presets h3 {
  margin: 0 0 10px;
  color: #183568;
  font-size: 12px;
}

.wb-custom-expression-presets button {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 3px 10px;
  width: 100%;
  margin: 5px 0;
  padding: 10px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  background: #f9fbff;
  text-align: left;
}

.wb-custom-expression-presets button strong {
  color: #183568;
  font-size: 12px;
}

.wb-custom-expression-presets button span {
  grid-column: 1;
  color: #7188ad;
  font-size: 11px;
}

.wb-custom-expression-presets button em {
  grid-column: 2;
  grid-row: 1/3;
  align-self: center;
  color: #1263ec;
  font-size: 11px;
  font-style: normal;
}

.wb-custom-expression-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  gap: 12px;
  margin: 6px 0 12px;
  padding: 11px 12px;
  border: 1px solid #d8e6f9;
  border-radius: 6px;
  background: #f7fbff;
}

.wb-custom-expression-summary p {
  margin: 0;
  color: #3c5681;
  font-size: 11px;
  line-height: 1.5;
}

.wb-custom-expression-summary div {
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 7px;
}

.wb-custom-expression-summary button {
  padding: 5px 8px;
  border: 1px solid #cbdcf5;
  border-radius: 5px;
  background: #fff;
  color: #1263ec;
  font-size: 10px;
  font-weight: 750;
}

.wb-custom-expression-summary button.is-danger {
  color: #ae4943;
  border-color: #e8c9c7;
}

.wb-custom-expression-status {
  color: #1263ec;
  font-size: 11px;
}

@container wb-content (max-width: 760px) {
  .wb-analysis-layout {
    grid-template-columns: 1fr;
  }
  .wb-analysis-cut-list {
    max-height: 220px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .wb-new-analysis-progress-fill {
    transition: none;
  }
  .wb-new-analysis-progress-fill::after {
    animation: none;
  }
}
.wb-new-control-card {
  padding: 13px 20px;
  margin-bottom: 19px;
}

.wb-new-control-card.wb-guide-step {
  padding: 0;
  margin-bottom: 10px;
}

.wb-new-control-card.wb-guide-step:not(.is-open) > :not(.wb-guide-step-header) {
  display: none;
}

.wb-new-control-card.wb-guide-step > .wb-new-control-row {
  padding: 13px 20px;
}

.wb-new-control-card.wb-guide-step > .wb-new-control-row + .wb-new-control-row {
  padding-top: 2px;
}

.wb-expression-edit-heading, .wb-generation-settings-heading {
  display: flex;
  align-items: baseline;
  gap: 18px;
  padding: 15px 20px 2px;
}

.wb-expression-edit-heading strong, .wb-generation-settings-heading strong {
  color: #13284f;
  font-size: 14px;
  font-weight: 850;
}

.wb-expression-edit-heading span, .wb-generation-settings-heading span {
  color: #7188ad;
  font-size: 11px;
  line-height: 1.5;
}

.wb-expression-mode-row {
  grid-template-columns: 1fr;
  padding-top: 9px !important;
  padding-bottom: 10px !important;
}

.wb-generation-settings-heading {
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid #dce7f7;
}

.wb-new-control-row.wb-new-generation-primary-row {
  grid-template-columns: minmax(0, 1fr);
  align-items: end;
  padding-top: 9px;
}

.wb-new-control-row.wb-new-generation-primary-row.is-trigger {
  grid-template-columns: minmax(0, 1fr);
}

.wb-new-hint {
  margin-left: 9px;
  color: #8195b4;
  font-size: 10px;
  font-weight: 600;
}

.wb-new-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 13px;
  border-radius: 5px;
  background: #eaf3ff;
  color: #0758df;
  font-size: 12px;
}

.wb-new-control-card.wb-guide-step > .wb-new-summary {
  margin: 0 20px 14px;
}

.wb-trigger-intensity-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 20px 12px;
  padding: 9px 12px;
  border-radius: 5px;
  background: #eaf3ff;
  color: #0758df;
  font-size: 11px;
  font-weight: 750;
}

.wb-trigger-stage-editor {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  gap: 8px 16px;
  padding: 4px 20px 12px;
}

.wb-trigger-stage-editor > header {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  align-items: baseline;
  gap: 16px;
}

.wb-trigger-stage-editor > header strong {
  color: #17315e;
  font-size: 12px;
  font-weight: 850;
}

.wb-trigger-stage-editor > header p {
  margin: 0;
  color: #6c83a8;
  font-size: 11px;
  line-height: 1.5;
}

.wb-trigger-stage-editor .wb-trigger-editor {
  grid-column: 2;
  min-width: 0;
}

.wb-expression-stage-editor {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  gap: 8px 16px;
  padding: 4px 20px 14px;
}

.wb-expression-stage-editor > header {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  align-items: baseline;
  gap: 16px;
}

.wb-expression-stage-editor > header strong {
  color: #17315e;
  font-size: 12px;
  font-weight: 850;
}

.wb-expression-stage-editor > header p {
  margin: 0;
  color: #6c83a8;
  font-size: 11px;
  line-height: 1.5;
}

.wb-expression-stage-content {
  grid-column: 2;
  min-width: 0;
}

.wb-expression-stage-content > label {
  display: block;
  margin: 10px 0 6px;
  color: #193264;
  font-size: 11px;
  font-weight: 800;
}

.wb-expression-stage-content > small {
  display: block;
  margin-top: 6px;
  color: #7188ad;
  font-size: 10px;
}

.wb-shared-reference {
  min-width: 0;
  margin: 8px 20px 16px;
  padding: 15px 17px;
  border: 1px solid #d7e5f7;
  border-radius: 8px;
  background: #f8fbff;
}

.wb-shared-reference-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.wb-shared-reference-header h4 {
  margin: 0;
  color: #163362;
  font-size: 13px;
  font-weight: 800;
}

.wb-shared-reference-header p {
  margin: 4px 0 0;
  color: #6983a9;
  font-size: 11px;
  line-height: 1.5;
}

.wb-shared-reference-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.wb-shared-reference-selected {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 9px;
  border: 1px solid #d5e4f7;
  border-radius: 7px;
  background: #fff;
}

.wb-shared-reference-preview {
  display: block;
  width: 88px;
  height: 66px;
  padding: 0;
  overflow: hidden;
  border: 1px solid #d7e4f5;
  border-radius: 5px;
  background: #eef4fb;
  cursor: pointer;
}

.wb-shared-reference-preview img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wb-shared-reference-info {
  display: grid;
  justify-items: start;
  gap: 3px;
  min-width: 0;
}

.wb-shared-reference-info strong {
  overflow: hidden;
  max-width: 100%;
  color: #193264;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-shared-reference-info small {
  color: #7389aa;
  font-size: 10px;
}

.wb-shared-reference-info .wb-new-reference-select {
  min-height: 25px;
  padding: 3px 7px;
  font-size: 10px;
}

.wb-shared-reference-usage {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.wb-shared-reference-usage span {
  margin-right: 3px;
  color: #52709c;
  font-size: 10px;
  font-weight: 700;
}

.wb-shared-reference-usage button {
  min-height: 28px;
  padding: 4px 8px;
  border: 1px solid #d0dff4;
  border-radius: 5px;
  background: #fff;
  color: #52709c;
  font-size: 10px;
  font-weight: 750;
  cursor: pointer;
}

.wb-shared-reference-usage button.is-active {
  border-color: #1268ed;
  background: #eaf3ff;
  color: #0758df;
}

.wb-shared-reference-empty {
  margin-top: 12px;
  padding: 13px;
  border: 1px dashed #c9d9ef;
  border-radius: 6px;
  background: #fff;
  color: #7087a8;
  font-size: 11px;
}

.wb-shared-reference .wb-reproduction-library-controls {
  margin-top: 10px;
}

.wb-shared-reference-instruction {
  display: grid;
  gap: 5px;
  margin-top: 11px;
}

.wb-shared-reference-instruction label {
  color: #284879;
  font-size: 11px;
  font-weight: 800;
}

.wb-shared-reference-instruction textarea {
  width: 100%;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #cdddf3;
  border-radius: 5px;
  background: #fff;
  color: #17315e;
  font: inherit;
  font-size: 11px;
  line-height: 1.5;
}

.wb-shared-reference-instruction textarea:disabled {
  background: #f2f5fa;
  color: #8a9bb5;
}

.wb-shared-reference-instruction small {
  color: #7188ad;
  font-size: 10px;
}

.wb-generation-reference-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 20px 12px;
  padding: 9px 12px;
  border: 1px solid #e0e9f6;
  border-radius: 6px;
  color: #607b9f;
  font-size: 11px;
}

.wb-generation-reference-summary span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-generation-reference-summary button {
  flex: none;
  border: 0;
  background: transparent;
  color: #1263ec;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.wb-reference-plan {
  display: block;
  min-width: 0;
  margin: 8px 20px 18px;
  padding: 18px;
  border: 1px solid #d7e5f7;
  border-radius: 8px;
  background: #f8fbff;
}

.wb-reference-plan-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}

.wb-reference-plan-header h4 {
  margin: 0;
  color: #163362;
  font-size: 14px;
  font-weight: 800;
}

.wb-reference-plan-header p {
  margin: 3px 0 0;
  color: #6983a9;
  font-size: 11px;
  line-height: 1.5;
}

.wb-reference-plan-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
  min-width: 0;
}

.wb-reference-plan-image {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  padding: 7px;
  border: 1px solid #dbe7f7;
  border-radius: 7px;
  background: #fff;
}

.wb-reference-plan-image img {
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: contain;
  border-radius: 4px;
  background: #edf3fa;
}

.wb-reference-plan-image strong {
  overflow: hidden;
  color: #243d68;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-reference-plan-image small {
  color: #8195b2;
  font-size: 10px;
}

.wb-reference-plan-fields {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 5px;
  min-width: 0;
}

.wb-reference-plan-fields label {
  margin-top: 3px;
  color: #284879;
  font-size: 11px;
  font-weight: 800;
}

.wb-reference-plan-fields input, .wb-reference-plan-fields textarea {
  width: 100%;
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #cdddf3;
  border-radius: 5px;
  background: #fff;
  color: #17315e;
  font: inherit;
  font-size: 11px;
  line-height: 1.5;
}

.wb-reference-plan-fields input:focus, .wb-reference-plan-fields textarea:focus {
  border-color: #1263ec;
  outline: 2px solid #dceaff;
}

.wb-reference-traits {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.wb-reference-traits span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 27px;
  padding: 3px 5px 3px 9px;
  border: 1px solid #cfe0fb;
  border-radius: 99px;
  background: #eaf3ff;
  color: #1755ae;
  font-size: 10px;
  font-weight: 700;
}

.wb-reference-traits button {
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #3b69aa;
  font-size: 14px;
  cursor: pointer;
}

.wb-reference-trait-add {
  display: flex;
  gap: 6px;
}

.wb-reference-trait-add button {
  flex: none;
  padding: 6px 10px;
  border: 1px solid #bcd2f2;
  border-radius: 5px;
  background: #fff;
  color: #1263ec;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.wb-reference-trait-add button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wb-reference-plan-start {
  color: #55749e;
  font-size: 12px;
  line-height: 1.5;
}

.wb-reference-plan-note, .wb-reference-plan-empty {
  margin: 12px 0 0;
  color: #7188ad;
  font-size: 11px;
  line-height: 1.6;
}

.wb-reference-plan-empty {
  padding: 18px;
  border: 1px dashed #c9d9ef;
  border-radius: 6px;
  background: white;
}

.wb-stage-plan-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.wb-stage-plan-heading p {
  flex: 1 1 260px;
  margin: 0;
  color: #6380a7;
  font-size: 11px;
  line-height: 1.5;
}

.wb-expression-stage-content > .wb-new-prompt-tabs button:has(small) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 88px;
  min-height: 48px;
  border: 1px solid #d2e0f4;
  border-radius: 5px 5px 0 0;
}

.wb-expression-stage-content > .wb-new-prompt-tabs:has(button small) {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.wb-expression-stage-content > .wb-new-prompt-tabs button:has(small).is-active {
  border-color: #1263ec;
  background: #eaf3ff;
}

.wb-expression-stage-content > .wb-new-prompt-tabs button strong {
  font-size: 12px;
}

.wb-expression-stage-content > .wb-new-prompt-tabs button small {
  color: #7890b2;
  font-size: 10px;
  white-space: nowrap;
}

.wb-stage-plan-meta {
  margin: 7px 0 0;
  color: #537bb5;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.5;
}

@container wb-content (max-width: 760px) {
  .wb-shared-reference-selected {
    grid-template-columns: 72px minmax(0, 1fr);
  }
  .wb-shared-reference-preview {
    width: 72px;
    height: 54px;
  }
  .wb-shared-reference-usage {
    grid-column: 1/-1;
  }
  .wb-reference-plan-grid, .wb-expression-stage-editor, .wb-expression-stage-editor > header {
    grid-template-columns: 1fr;
  }
  .wb-reference-plan-image {
    max-width: 300px;
  }
  .wb-reference-trait-add {
    flex-wrap: wrap;
  }
  .wb-expression-stage-content {
    grid-column: 1;
  }
  .wb-expression-stage-content > .wb-new-prompt-tabs button:has(small) {
    min-width: 0;
    padding: 5px 2px;
  }
  .wb-expression-stage-content > .wb-new-prompt-tabs button small {
    overflow-wrap: anywhere;
    white-space: normal;
  }
}
.wb-trigger-prompt-handoff {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d7e5f7;
  border-radius: 6px;
  background: #f7fbff;
  color: #31527f;
}

.wb-trigger-prompt-handoff > i {
  margin-top: 2px;
  color: #1263ec;
}

.wb-trigger-prompt-handoff strong {
  color: #17315e;
  font-size: 11px;
}

.wb-trigger-prompt-handoff p {
  margin: 3px 0 0;
  color: #6c83a8;
  font-size: 10px;
}

.wb-new-summary strong {
  font-weight: 800;
}

.wb-new-summary-divider {
  width: 1px;
  height: 18px;
  margin: 0 7px;
  background: #b6cbed;
}

.wb-new-prompt-panel {
  margin: -8px 0 20px;
  padding: 14px 18px 16px;
  border: 1px solid #dce7f7;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(30, 77, 140, 0.035);
}

.wb-new-prompt-panel.wb-guide-step {
  overflow: visible;
  margin: 0 0 20px;
  padding: 0;
}

.wb-expression-prompt-panel {
  margin: 0;
  padding: 0;
  border: 0;
  border-top: 1px solid #dce7f7;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.wb-expression-prompt-header {
  min-height: 54px;
  padding: 10px 20px;
  border-bottom: 0;
  background: #fbfdff;
}

.wb-expression-prompt-title {
  min-width: 180px;
  margin-right: auto;
}

.wb-expression-prompt-title h3 {
  margin: 0;
  color: #17315e;
  font-size: 12px;
  font-weight: 850;
}

.wb-expression-prompt-title p {
  margin: 3px 0 0;
  color: #7188ad;
  font-size: 10px;
  line-height: 1.45;
}

.wb-expression-prompt-panel .wb-new-prompt-body {
  padding-right: 20px;
  padding-left: 20px;
}

.wb-new-prompt-panel.workbench-agent-panel-working {
  border-color: #bedafa;
  box-shadow: 0 0 0 1px rgba(40, 143, 255, 0.14), 0 4px 22px rgba(30, 105, 205, 0.12);
}

.wb-new-prompt-panel.workbench-agent-panel-reading {
  border-color: #83bcf4;
  box-shadow: 0 0 0 2px rgba(48, 139, 235, 0.19), 0 8px 30px rgba(21, 104, 205, 0.12);
  animation: wb-agent-reading-focus 900ms ease-out both;
}

@keyframes wb-agent-reading-focus {
  0% {
    box-shadow: 0 0 0 1px rgba(48, 139, 235, 0.15), 0 3px 12px rgba(21, 104, 205, 0.04);
  }
  45% {
    box-shadow: 0 0 0 3px rgba(48, 139, 235, 0.34), 0 8px 34px rgba(21, 104, 205, 0.2);
  }
  100% {
    box-shadow: 0 0 0 2px rgba(48, 139, 235, 0.19), 0 8px 30px rgba(21, 104, 205, 0.12);
  }
}
@media (prefers-reduced-motion: reduce) {
  .wb-new-prompt-panel.workbench-agent-panel-reading {
    animation: none;
  }
}
.wb-new-prompt-panel.workbench-agent-panel-complete {
  border-color: #c9e0fb;
  box-shadow: 0 0 0 1px rgba(40, 143, 255, 0.09), 0 4px 18px rgba(30, 105, 205, 0.08);
}

.wb-new-prompt-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6edf7;
}

.wb-new-prompt-header.wb-guide-step-header {
  display: grid;
  grid-template-columns: 30px 26px minmax(180px, 1fr) auto auto auto;
  padding: 10px 16px;
  border-bottom: 0;
}

.wb-new-prompt-header h3 {
  margin: 0;
  color: #10204e;
  font-size: 17px;
  font-weight: 800;
}

.wb-new-prompt-badge {
  padding: 5px 9px;
  border-radius: 15px;
  background: #eaf3ff;
  color: #1263e9;
  font-size: 11px;
  font-weight: 700;
}

.wb-new-prompt-draft {
  color: #748bab;
  font-size: 11px;
}

.wb-new-prompt-draft.is-edited {
  color: #bd6c0d;
}

.wb-new-text-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  padding: 4px 0;
  border: 0;
  background: none;
  color: #0758df;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-prompt-body {
  display: grid;
  grid-template-columns: minmax(190px, 290px) minmax(0, 1fr);
  gap: 18px;
  padding: 14px 18px;
  border-top: 1px solid #e6edf7;
}

.wb-new-prompt-nav {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
}

.wb-new-prompt-nav button {
  display: grid;
  grid-template-columns: 25px minmax(0, 1fr) auto;
  align-items: center;
  gap: 2px 8px;
  min-height: 58px;
  padding: 8px 10px;
  border: 0;
  border-bottom: 1px solid #e8eff9;
  background: #fff;
  text-align: left;
}

.wb-new-prompt-nav button:last-child {
  border-bottom: 0;
}

.wb-new-prompt-nav button:hover, .wb-new-prompt-nav button.is-active {
  background: #edf5ff;
}

.wb-new-prompt-nav button.is-active {
  box-shadow: inset 3px 0 #1263ec;
}

.wb-new-prompt-nav button > span {
  grid-row: 1/3;
  display: grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #e8f1ff;
  color: #1263e9;
  font-size: 12px;
  font-weight: 800;
}

.wb-new-prompt-nav strong {
  color: #183568;
  font-size: 12px;
}

.wb-new-prompt-nav small {
  grid-column: 2/4;
  color: #7188ad;
  font-size: 10px;
}

.wb-new-prompt-nav em {
  grid-column: 3;
  grid-row: 1;
  color: #0a67c8;
  font-size: 10px;
  font-style: normal;
  white-space: nowrap;
}

.wb-new-prompt-editor {
  min-width: 0;
  color: #193264;
}

.wb-new-prompt-editor h4 {
  margin: 0 0 4px;
  color: #10204e;
  font-size: 14px;
  font-weight: 800;
}

.wb-new-prompt-help, .wb-new-prompt-editor > small {
  margin: 0 0 10px;
  color: #7188ad;
  font-size: 11px;
}

.wb-new-prompt-editor label {
  display: block;
  margin: 10px 0 6px;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-prompt-base {
  max-height: 180px;
  overflow-y: auto;
  padding: 10px 12px;
  border: 1px solid #dce7f7;
  border-radius: 5px;
  background: #f8fbff;
}

.wb-new-prompt-base strong {
  color: #193264;
  font-size: 11px;
}

.wb-new-prompt-base p {
  margin: 6px 0 0;
  color: #4f668b;
  font-size: 11px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.wb-new-prompt-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 10px 0;
  border-bottom: 1px solid #e6edf7;
}

.wb-new-prompt-tabs button {
  min-width: 35px;
  padding: 6px 10px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #5f79a1;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-prompt-tabs button.is-active {
  border-color: #1263ec;
  color: #0758df;
}

.wb-new-prompt-textarea {
  display: block;
  width: 100%;
  min-height: 72px;
  padding: 10px 12px;
  border: 1px solid #cadcf5;
  border-radius: 5px;
  color: #183568;
  background: #fff;
  font: inherit;
  font-size: 12px;
  line-height: 1.5;
  resize: vertical;
}

.wb-new-prompt-textarea:focus {
  border-color: #1263ec;
  outline: 2px solid #deebff;
}

.wb-new-prompt-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 39px;
  margin-top: 12px;
  padding: 8px 11px;
  border: 1px solid #dce7f7;
  border-radius: 5px;
  background: #f9fbff;
  color: #193264;
  font-size: 11px;
  text-align: left;
}

.wb-new-prompt-preview strong {
  font-weight: 800;
}

.wb-new-prompt-preview span {
  margin-left: auto;
  color: #6880a3;
}

.wb-new-prompt-preview em {
  color: #0758df;
  font-style: normal;
  font-weight: 800;
}

.wb-new-prompt-footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding-top: 12px;
  border-top: 1px solid #e6edf7;
}

.wb-guide-action-bar {
  position: sticky;
  bottom: 0;
  z-index: 8;
  display: grid;
  grid-template-columns: 30px 26px minmax(180px, 1fr) auto auto auto;
  align-items: center;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -6px 16px rgba(23, 64, 119, 0.05);
}

.wb-guide-action-bar .wb-new-generation-blocked {
  grid-column: 4;
}

.wb-new-prompt-footer .wb-new-generate {
  min-height: 39px;
  min-width: 150px;
}

.wb-new-generation-blocked {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto 0 0;
  color: #9a5d12;
  font-size: 10px;
  line-height: 1.4;
}

.wb-new-generation-blocked i {
  color: #ca7b17;
}

.wb-new-image-results-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.wb-new-image-results-grid .wb-new-result-card {
  padding: 12px;
}

.wb-new-result-prompt-link {
  margin-left: auto;
  border: 0;
  background: none;
  color: #0758df;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-result-prompt-link i {
  margin-left: 5px;
}

.wb-new-result-prompt-link:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wb-new-result-view-controls {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: auto;
}

.wb-new-result-view-controls button {
  min-height: 29px;
  padding: 5px 9px;
  border: 1px solid #d7e5f6;
  border-radius: 4px;
  background: #fff;
  color: #5f79a1;
  font-size: 10px;
  font-weight: 800;
}

.wb-new-result-view-controls button.is-active {
  border-color: #1263ec;
  background: #1263ec;
  color: #fff;
}

.wb-new-result-view-controls button:last-child {
  margin-left: 7px;
  color: #0758df;
}

.wb-agent-image-results {
  margin: 14px 0;
}

.wb-agent-result-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  scroll-margin-top: 100px;
}

.wb-agent-result-filter strong {
  color: #16385e;
  font-size: 15px;
  overflow-wrap: anywhere;
}

.wb-agent-result-filter p, .wb-agent-result-image p {
  margin: 5px 0 0;
  color: #5f79a1;
  font-size: 12px;
}

.wb-agent-result-filter-actions {
  display: flex;
  gap: 8px;
}

.wb-agent-result-filter-actions button {
  padding: 7px 12px;
  border: 1px solid #d7e5f6;
  border-radius: 5px;
  background: #fff;
  color: #0758df;
}

.wb-agent-result-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: 20px;
}

.wb-agent-result-image {
  min-width: 0;
}

.wb-agent-result-image button {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 7px;
  overflow: hidden;
  background: #eef4fa;
  cursor: zoom-in;
}

.wb-agent-result-image img {
  display: block;
  width: 100%;
  height: 100%;
  max-height: 420px;
  aspect-ratio: 3/2;
  object-fit: contain;
}

.wb-agent-result-image strong {
  display: block;
  margin-top: 8px;
  color: #16385e;
  font-size: 14px;
  overflow-wrap: anywhere;
}

.wb-agent-result-image button:focus-visible, .wb-agent-result-filter-actions button:focus-visible {
  outline: 3px solid #1263ec;
  outline-offset: 3px;
}

.wb-new-result-query-error {
  color: #b42318;
}

@container wb-content (max-width: 600px) {
  .wb-agent-result-filter {
    scroll-margin-top: 160px;
  }
}
.wb-comparison {
  --compare-blue: #1263ec;
  --compare-ink: #10204e;
  padding: 0;
  border: 1px solid #d5e3f5;
  border-radius: 7px;
  background: #fff;
  color: var(--compare-ink);
  scroll-margin-top: 100px;
}

.wb-comparison.is-open {
  border-color: #4e91f7;
}

.wb-comparison-heading {
  display: grid;
  grid-template-columns: 30px 26px minmax(180px, 1fr) auto 28px;
  align-items: center;
  gap: 8px;
  min-height: 58px;
  padding: 10px 16px;
  background: #fff;
}

.wb-comparison-heading.is-disclosure {
  cursor: pointer;
}

.wb-comparison-heading-copy {
  min-width: 0;
}

.wb-comparison-heading-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 8px;
}

.wb-comparison-heading.is-disclosure:hover .wb-disclosure-heading {
  color: var(--compare-blue);
}

.wb-comparison-heading .wb-guide-chevron {
  grid-column: 5;
  grid-row: 1;
}

.wb-comparison-heading h3 {
  margin: 0;
  color: #13284f;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 850;
}

.wb-comparison-heading p {
  margin: 2px 0 0;
  color: #6d84a6;
  font-size: 10px;
  line-height: 1.45;
}

.wb-comparison > .wb-new-result-query-error {
  margin: 0;
  padding: 8px 18px;
  border-top: 1px solid #e8eff8;
}

#wb-comparison-body {
  padding: 14px 18px 18px;
  border-top: 1px solid #e8eff8;
}

.wb-comparison button, .wb-comparison select {
  font-family: inherit;
  cursor: pointer;
}

.wb-comparison button:focus-visible, .wb-comparison select:focus-visible {
  outline: 3px solid var(--compare-blue);
  outline-offset: 3px;
}

.wb-comparison button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.wb-comparison-expand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  flex-shrink: 0;
  min-height: 31px;
  padding: 6px 14px;
  border: 1px solid #c6d9fa;
  border-radius: 5px;
  background: #fff;
  color: #0a50d1;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.wb-comparison-expand:hover {
  border-color: var(--compare-blue);
  background: #f2f7ff;
}

.wb-comparison-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 30px;
  height: 30px;
  border: 1px solid #d9e5f6;
  border-radius: 6px;
  background: #fff;
  color: #2866c7;
  font-size: 12px;
  cursor: pointer;
}

.wb-comparison-download:hover:not(:disabled) {
  border-color: #8db5f3;
  background: #f2f7ff;
}

.wb-comparison-download:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wb-comparison-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.wb-comparison-expressions, .wb-comparison-modes {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 2px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  background: #f8fbff;
}

.wb-comparison-expressions button, .wb-comparison-modes button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 40px;
  padding: 7px 12px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #5f79a1;
  font-size: 13px;
  font-weight: 700;
}

.wb-comparison-expressions button.is-active {
  background: #eaf3ff;
  color: #0758df;
}

.wb-comparison-modes button.is-active {
  background: var(--compare-blue);
  color: #fff;
}

.wb-comparison-strength {
  display: grid;
  grid-template-columns: auto minmax(180px, 300px) minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
  background: #f5f9fe;
}

.wb-comparison-strength > strong {
  font-size: 13px;
  white-space: nowrap;
}

.wb-comparison-level-picker {
  min-width: 0;
}

.wb-comparison-level-picker > div:first-child {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px;
}

.wb-comparison-level-picker button {
  min-height: 40px;
  border: 1px solid #cdddf5;
  border-radius: 5px;
  background: white;
  color: #0758df;
  font-size: 14px;
  font-weight: 700;
}

.wb-comparison-level-picker button.is-active {
  border-color: var(--compare-blue);
  background: var(--compare-blue);
  color: white;
}

.wb-comparison-endpoints {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  color: #7188ad;
  font-size: 12px;
  line-height: 1.4;
}

.wb-comparison-endpoints > span:not(.wb-comparison-scale-line) {
  flex-shrink: 0;
}

.wb-comparison-scale-line {
  flex: 1;
  border-top: 1px solid #9cbbe7;
}

.wb-comparison-strength > p {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
}

.wb-fidelity-guide {
  margin: 0 0 12px;
  padding: 10px 12px;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
  background: #f8fbff;
  color: #526d95;
  font-size: 12px;
  line-height: 1.6;
}

.wb-fidelity-guide summary {
  cursor: pointer;
  color: #254878;
  font-size: 13px;
  font-weight: 700;
}

.wb-fidelity-guide p {
  margin: 8px 0;
}

.wb-fidelity-rubric {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  padding: 0;
  margin: 10px 0;
  list-style: none;
}

.wb-fidelity-rubric li {
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #e1eaf8;
  border-radius: 5px;
  background: white;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.wb-fidelity-rubric strong, .wb-fidelity-rubric span {
  display: block;
}

.wb-fidelity-rubric strong {
  color: #254878;
  margin-bottom: 3px;
}

.wb-fidelity-audit {
  padding: 8px 10px;
  border-radius: 5px;
  background: #edf3fc;
}

.wb-fidelity-audit ul {
  padding-left: 18px;
  margin: 4px 0 0;
}

.wb-fidelity-guide .wb-fidelity-review-note {
  margin-bottom: 0;
}

.wb-fidelity-result-note {
  margin: 0;
  padding: 0 5px 5px;
  color: #71633f;
  font-size: 11px;
  line-height: 1.5;
}

.wb-reproduction-setup {
  padding: 12px 16px;
  border-bottom: 1px solid #e1eaf8;
  background: #f8fbff;
  color: #637da3;
  font-size: 12px;
  line-height: 1.6;
}

.wb-reproduction-setup > strong {
  color: #254878;
  font-size: 13px;
}

.wb-reproduction-setup > p {
  margin: 5px 0 8px;
}

.wb-fidelity-review-row {
  display: grid;
  grid-template-columns: minmax(120px, 0.25fr) minmax(0, 1fr);
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e3ebf8;
  color: #5f79a1;
  font-size: 12px;
  line-height: 1.5;
}

.wb-fidelity-review-row strong {
  color: #274a80;
}

@container wb-content (max-width: 600px) {
  .wb-fidelity-review-row {
    grid-template-columns: 1fr;
    gap: 3px;
  }
}
.wb-reproduction-reference {
  display: flex;
  gap: 14px;
  align-items: center;
  margin: 12px 0;
  padding: 12px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  background: #f8fbff;
}

.wb-reproduction-reference > img {
  width: 160px;
  height: 100px;
  flex: 0 0 auto;
  object-fit: contain;
  border-radius: 4px;
  background: #edf3fa;
}

.wb-reproduction-reference > div {
  min-width: 0;
  color: #637da3;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.wb-reproduction-reference strong, .wb-reproduction-reference small, .wb-reproduction-reference span {
  display: block;
}

.wb-reproduction-reference strong {
  color: #254878;
  font-size: 13px;
}

.wb-reproduction-reference p {
  margin: 4px 0 0;
}

.wb-reproduction-library-controls {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.wb-reproduction-library-controls > div {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  width: 100%;
}

.wb-reproduction-library-controls button {
  padding: 6px 9px;
  border: 1px solid #dce7f7;
  border-radius: 5px;
  background: white;
  color: #637da3;
  font-size: 12px;
}

.wb-reproduction-library-controls button.is-active {
  color: #155fda;
  border-color: #7aa7f5;
  background: #edf4ff;
}

.wb-reproduction-library-controls small {
  width: 100%;
  color: #637da3;
  font-size: 11px;
}

#wb-comparison-body {
  container-type: inline-size;
}

@container (min-width: 1100px) {
  .wb-comparison-grid.is-reproduction-series {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
@container wb-content (max-width: 540px) {
  .wb-reproduction-reference {
    align-items: flex-start;
    flex-direction: column;
  }
  .wb-reproduction-reference > img {
    width: 100%;
    height: 150px;
  }
}
.wb-comparison-model-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
  background: #f5f9fe;
}

.wb-comparison-model-picker label {
  font-weight: 700;
  font-size: 13px;
}

.wb-comparison-model-picker select {
  max-width: 100%;
  min-height: 40px;
  padding: 7px 32px 7px 10px;
  border: 1px solid #cdddf5;
  border-radius: 5px;
  background: white;
  color: var(--compare-ink);
  font-size: 13px;
}

.wb-comparison-model-picker p {
  margin: 0;
  color: #7188ad;
  font-size: 12px;
}

.wb-comparison-trigger-note {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  margin: 0 0 12px;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
  background: #f5f9fe;
  color: #526e96;
  font-size: 13px;
}

.wb-comparison-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.wb-comparison-card {
  min-width: 0;
  padding: 6px;
  border: 1px solid #e1eaf8;
  border-radius: 6px;
  background: white;
}

.wb-comparison-card.is-video-source {
  border-color: #2e74ed;
  box-shadow: 0 0 0 1px #2e74ed;
}

.wb-comparison-card > header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  min-height: 46px;
  padding: 3px 4px 7px;
}

.wb-comparison-order {
  display: grid;
  place-items: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eaf3ff;
  color: #1263ec;
  font-size: 12px;
  font-weight: 700;
}

.wb-comparison-card h4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  margin: 0;
  color: var(--compare-ink);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.wb-comparison-more {
  display: grid;
  place-items: center;
  flex: 0 0 32px;
  min-width: 32px;
  min-height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #526e96;
  font-size: 16px;
}

.wb-comparison-menu {
  position: absolute;
  top: 44px;
  right: 6px;
  z-index: 4;
  min-width: 145px;
  padding: 5px;
  border: 1px solid #d5e3f5;
  border-radius: 9px;
  background: white;
  box-shadow: 0 5px 18px rgba(16, 32, 79, 0.12);
}

.wb-comparison-menu button {
  display: block;
  width: 100%;
  min-height: 40px;
  padding: 8px 10px;
  border: 0;
  border-radius: 5px;
  background: white;
  color: #244f87;
  text-align: left;
  font-size: 13px;
}

.wb-comparison-menu button:hover {
  background: #eff5ff;
}

.wb-comparison-menu button.is-danger {
  color: #b42318;
}

.wb-comparison-image {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 2/1;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: 7px;
  background: #eaf0f6;
  cursor: zoom-in !important;
}

.wb-comparison-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wb-comparison-image-expand {
  position: absolute;
  top: 7px;
  right: 7px;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(15, 36, 57, 0.6);
  color: white;
  font-size: 13px;
}

.wb-comparison-image-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  aspect-ratio: 2/1;
  padding: 14px;
  border-radius: 7px;
  background: #edf4fc;
  color: #6b83a5;
  text-align: center;
}

.wb-comparison-image-empty > i {
  font-size: 24px;
}

.wb-comparison-image-empty > strong {
  font-size: 14px;
}

.wb-comparison-image-empty > span {
  font-size: 12px;
}

.wb-comparison-card > footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 9px;
  min-height: 34px;
  padding: 8px 5px 4px;
  color: #637da3;
  font-size: 12px;
  line-height: 1.4;
}

.wb-comparison-card > footer > span + span {
  padding-left: 9px;
  border-left: 1px solid #dce7f7;
}

.wb-comparison-video-select {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 30px;
  margin-left: auto;
  padding: 4px 9px;
  border: 1px solid #bcd3f8;
  border-radius: 6px;
  background: #f5f9ff;
  color: #1455bf;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.wb-comparison-video-select:hover:not(:disabled) {
  background: #eaf2ff;
  border-color: #8bb6f8;
}

.wb-comparison-video-select.is-selected {
  border-color: #1d65dd;
  background: #e9f1ff;
  color: #0c4fb7;
}

.wb-comparison-video-select:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wb-comparison-candidates {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #6681a9;
  font-size: 12px;
}

.wb-comparison-candidates button {
  min-width: 40px;
  min-height: 40px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: #f4f8fe;
  color: #1761ce;
  font-size: 12px;
}

.wb-comparison-bottom-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.wb-comparison-bottom-actions button {
  min-height: 40px;
  padding: 5px 8px;
  border: 0;
  background: transparent;
  color: #4979b8;
  font-size: 12px;
}

.wb-comparison-empty {
  grid-column: 1/-1;
  padding: 40px 16px;
  color: #6a83aa;
  text-align: center;
  font-size: 15px;
}

.wb-comparison-progress, .wb-comparison-loading {
  padding: 12px 16px;
  margin: 0 0 16px;
  border-radius: 8px;
  background: #f0f6ff;
  color: #4d75ad;
  font-size: 13px;
}

.wb-comparison-progress {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.wb-comparison-progress p {
  flex-basis: 100%;
  margin: 0;
  color: #b42318;
}

.wb-comparison .wb-generation-progress {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  font-size: 13px;
}

.wb-comparison .wb-generation-progress p {
  margin: 0;
  color: #b42318;
}

.wb-comparison-loading i {
  margin-right: 8px;
}

.wb-comparison-backdrop {
  position: fixed;
  inset: 0;
  z-index: 48;
  background: rgba(13, 29, 54, 0.4);
}

.wb-comparison.is-expanded {
  position: fixed;
  inset: 0;
  z-index: 60;
  overflow: auto;
  padding: 22px 32px;
  border: 0;
  border-radius: 0;
  overscroll-behavior: contain;
}

.wb-comparison.is-expanded .wb-comparison-heading {
  grid-template-columns: 30px 26px minmax(180px, 1fr) auto;
}

.wb-comparison.is-expanded .wb-comparison-heading h3 {
  font-size: 18px;
}

.wb-comparison.is-expanded #wb-comparison-body {
  padding: 14px 0 0;
}

.wb-comparison.is-expanded .wb-comparison-strength {
  grid-template-columns: auto minmax(220px, 340px) minmax(0, 1fr);
}

@container wb-content (max-width: 1150px) {
  .wb-comparison-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wb-comparison-strength, .wb-comparison.is-expanded .wb-comparison-strength {
    grid-template-columns: auto minmax(180px, 340px);
    gap: 8px 14px;
  }
  .wb-comparison-strength > p {
    grid-column: 2;
  }
}
@container wb-content (max-width: 650px) {
  .wb-comparison-heading, .wb-comparison.is-expanded .wb-comparison-heading {
    grid-template-columns: 30px minmax(0, 1fr) 28px;
    gap: 8px;
    padding: 10px 12px;
  }
  .wb-comparison-heading-copy {
    grid-column: 2;
  }
  .wb-comparison-heading-actions {
    grid-column: 2/4;
    grid-row: 2;
    justify-self: end;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .wb-comparison-heading .wb-guide-chevron {
    grid-column: 3;
  }
}
@container wb-content (max-width: 600px) {
  .wb-comparison.is-expanded {
    padding: 14px 12px;
  }
  .wb-comparison.is-expanded .wb-comparison-heading h3 {
    font-size: 16px;
  }
  #wb-comparison-body {
    padding: 12px;
  }
  .wb-comparison-toolbar {
    gap: 10px;
  }
  .wb-comparison-expressions, .wb-comparison-modes {
    width: 100%;
  }
  .wb-comparison-expressions button, .wb-comparison-modes button {
    flex: 1;
    min-width: 0;
    gap: 5px;
    padding: 8px 5px;
    font-size: 12px;
  }
  .wb-comparison-strength, .wb-comparison.is-expanded .wb-comparison-strength {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    padding: 14px 12px;
  }
  .wb-comparison-strength > p {
    grid-column: 1;
  }
  .wb-comparison-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .wb-comparison {
    scroll-margin-top: 150px;
  }
}
.wb-generation-progress {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 12px;
  padding: 13px 15px;
  border: 1px solid #c8dcfa;
  border-radius: 7px;
  background: #f5f9ff;
  color: #1263e9;
}

.wb-generation-progress.is-complete {
  border-color: #bde8d2;
  background: #f3fcf7;
  color: #11905c;
}

.wb-generation-progress.is-error {
  border-color: #f0c1bd;
  background: #fff7f6;
  color: #bd3e35;
}

.wb-generation-progress-icon {
  display: grid;
  place-items: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e1edff;
  font-size: 14px;
}

.wb-generation-progress.is-complete .wb-generation-progress-icon {
  background: #ddf7e9;
}

.wb-generation-progress.is-error .wb-generation-progress-icon {
  background: #fde5e2;
}

.wb-generation-progress:not(.is-complete):not(.is-error) .wb-generation-progress-icon i,
.wb-new-report-bar.is-running > i {
  animation: wb-generation-spin 1.15s linear infinite;
}

.wb-generation-progress-copy {
  min-width: 0;
  flex: 1;
}

.wb-generation-progress-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wb-generation-progress-heading strong {
  color: #173468;
  font-size: 12px;
  font-weight: 800;
}

.wb-generation-progress-heading span {
  color: currentColor;
  font-size: 12px;
  font-weight: 800;
}

.wb-generation-progress-copy > p {
  margin: 3px 0 8px;
  color: #657fa7;
  font-size: 10px;
  line-height: 1.45;
}

.wb-generation-progress-track {
  overflow: hidden;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: #dfe9f7;
}

.wb-generation-progress-track > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #1768e8;
  transition: width 0.35s ease;
}

.wb-generation-progress.is-complete .wb-generation-progress-track > span,
.wb-model-generation-status.is-complete ~ * .wb-generation-progress-track > span {
  background: #18a66b;
}

.wb-generation-progress.is-error .wb-generation-progress-track > span {
  background: #d55249;
}

.wb-generation-progress-copy > p.wb-generation-progress-error,
.wb-model-generation-error {
  margin: 7px 0 0;
  color: #b93830;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.wb-model-generation-status {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 999px;
  background: #e9f2ff;
  color: #1263e9;
  font-size: 9px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-model-generation-status.is-complete {
  background: #e2f8ed;
  color: #0e8d59;
}

.wb-model-generation-status.is-error {
  background: #fee9e7;
  color: #bb3d35;
}

.wb-model-generation-progress {
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 6px;
  background: #f7faff;
}

.wb-model-generation-progress > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
  color: #6d84a7;
  font-size: 9px;
}

.wb-model-generation-progress > div:first-child strong {
  color: #2565c8;
  font-size: 10px;
}

@keyframes wb-generation-spin {
  to {
    transform: rotate(360deg);
  }
}
.wb-new-result-tiles {
  display: grid;
  grid-template-columns: repeat(5, minmax(92px, 1fr));
  gap: 5px;
  overflow-x: auto;
  margin-top: 10px;
}

.wb-new-result-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 92px;
  padding: 5px;
  border: 1px solid #e1eaf8;
  border-radius: 5px;
  background: #f6f9ff;
  color: #52709b;
  text-align: left;
}

.wb-new-result-tile:hover {
  border-color: #1263ec;
}

.wb-new-result-tile-open {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.wb-new-result-tile-open > span:first-child {
  font-size: 10px;
  font-weight: 800;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
}

.wb-new-result-tile-delete, .wb-new-result-tile-retry {
  display: inline-flex;
  min-height: 30px;
  align-self: flex-end;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border: 1px solid #fecaca;
  border-radius: 4px;
  background: #fff;
  color: #b91c1c;
  font-size: 11px;
  cursor: pointer;
}

.wb-new-result-tile-delete:hover {
  background: #fef2f2;
}

.wb-new-result-tile-retry {
  border-color: #bfd5fa;
  color: #155bc4;
}

.wb-new-result-tile-retry:hover {
  background: #edf4ff;
}

.wb-new-result-tile-delete:disabled, .wb-new-result-tile-retry:disabled {
  opacity: 0.5;
  cursor: wait;
}

.wb-new-result-tile-open:focus-visible, .wb-new-result-tile-delete:focus-visible, .wb-new-result-tile-retry:focus-visible {
  outline: 2px solid #1263ec;
  outline-offset: 2px;
}

.wb-new-result-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 12px;
  color: #52709b;
}

.wb-new-result-pagination button {
  padding: 5px 10px;
  border: 1px solid #dbe5f3;
  border-radius: 4px;
  background: #fff;
  color: #193264;
}

.wb-new-result-pagination button:disabled {
  opacity: 0.45;
}

.wb-new-result-tile img {
  display: block;
  width: 100%;
  aspect-ratio: 1.42;
  border-radius: 3px;
  object-fit: cover;
}

.wb-new-result-tile-empty {
  display: grid;
  place-items: center;
  width: 100%;
  min-height: 74px;
  color: #9aacc6;
  font-size: 18px;
}

.wb-new-result-tile-empty small {
  font-size: 10px;
}

.wb-new-result-tile-placeholder {
  grid-column: 1/-1;
  color: #8ba1c0;
  font-size: 11px;
}

.wb-new-main {
  container-type: inline-size;
  width: 100%;
  max-width: 1600px;
  margin-inline: auto;
}

@container (max-width: 1100px) {
  .wb-new-control-row {
    grid-template-columns: minmax(0, 1fr) minmax(150px, 0.5fr);
  }
  .wb-new-reference {
    grid-column: 1/-1;
  }
  .wb-new-generation-primary-row .wb-new-reference {
    grid-column: auto;
  }
  .wb-new-model-row {
    grid-template-columns: minmax(0, 1fr) minmax(110px, 0.3fr);
  }
  .wb-new-image-results-grid {
    grid-template-columns: 1fr;
  }
}
@container (max-width: 680px) {
  .wb-new-control-row, .wb-new-model-row, .wb-new-prompt-body {
    grid-template-columns: 1fr;
  }
  .wb-new-control-row.wb-new-generation-primary-row {
    grid-template-columns: 1fr;
  }
  .wb-new-reference {
    grid-column: auto;
  }
  .wb-new-result-tiles {
    grid-template-columns: repeat(5, minmax(105px, 1fr));
  }
  .wb-new-summary-divider {
    display: none;
  }
}
.wb-new-control-row {
  display: grid;
  grid-template-columns: minmax(230px, 1.2fr) minmax(180px, 0.65fr) minmax(310px, 1.65fr);
  align-items: center;
  gap: 18px;
}

.wb-new-control-row + .wb-new-control-row {
  margin-top: 13px;
  padding-top: 12px;
  border-top: 1px solid #e6edf7;
}

.wb-new-control-block {
  min-width: 0;
}

.wb-new-control-block > label {
  display: block;
  margin-bottom: 6px;
  color: #193264;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-segment, .wb-new-stepper {
  display: flex;
  gap: 3px;
}

.wb-new-segment {
  flex-wrap: wrap;
}

.wb-new-segment button, .wb-new-stepper button {
  min-height: 34px;
  padding: 5px 11px;
  border: 1px solid #dce7f6;
  border-radius: 5px;
  background: #f8fbff;
  color: #526994;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.wb-new-segment button {
  flex: 0 1 auto;
}

.wb-new-segment button.wb-add-expression {
  border-style: dashed;
  background: #fff;
  color: #1263ec;
}

.wb-new-segment button.is-active, .wb-new-stepper button.is-active {
  border-color: #0963ee;
  background: #1268ed;
  color: #fff;
}

.wb-new-segment button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wb-new-stepper button {
  min-width: 32px;
}

.wb-new-reference > div {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.wb-new-reference-name {
  overflow: hidden;
  max-width: 180px;
  color: #5c769d;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-selected-library {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: 9px;
  padding: 10px;
  border: 1px solid #cbdcf5;
  border-radius: 7px;
  background: #f4f8ff;
  text-align: left;
  cursor: pointer;
}

.wb-selected-library > img {
  flex: 0 0 72px;
  width: 72px;
  height: 54px;
  border-radius: 4px;
  object-fit: contain;
  background: white;
}

.wb-selected-library > span {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.wb-selected-library strong {
  color: #193264;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-selected-library small {
  color: #5c769d;
  font-size: 10px;
  line-height: 1.5;
}

.wb-selected-library:focus-visible {
  outline: 3px solid #85b6ff;
  outline-offset: 2px;
}

.wb-new-result-reference {
  display: grid;
  gap: 3px;
  margin: 7px 0;
  font-size: 10px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-new-result-reference > span {
  color: #1763d6;
}

.wb-new-result-reference > strong {
  color: #526e96;
  font-weight: 500;
}

.wb-new-reference-select {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  max-width: 260px;
  min-height: 35px;
  padding: 5px 10px;
  border: 1px solid #cbdcf5;
  border-radius: 5px;
  background: #fff;
  color: #193264;
  font-size: 11px;
  cursor: pointer;
}

.wb-new-reference-select:hover, .wb-new-reference-select:focus-visible {
  border-color: #2772ed;
  background: #f7faff;
}

.wb-new-reference-select span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-new-reference-select i {
  flex: none;
  color: #5577ad;
  font-size: 9px;
}

.wb-new-model-row {
  grid-template-columns: minmax(0, 1fr) minmax(100px, 0.18fr);
  align-items: start;
}

.wb-new-model-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.wb-new-model-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
  padding: 4px 7px 4px 10px;
  border: 1px solid #d7e2f3;
  border-radius: 6px;
  color: #172c58;
  background: #f9fbfe;
  font-size: 11px;
  font-weight: 700;
}

.wb-new-model-chip.has-model-setting {
  padding-right: 6px;
  border-color: #bdd5fa;
  background: #f5f9ff;
}

.wb-new-model-chip-label {
  white-space: nowrap;
}

.wb-new-model-remove {
  padding: 0 1px;
  border: 0;
  background: none;
  color: #597399;
  font-size: 15px;
  line-height: 1;
}

.wb-new-model-remove:hover, .wb-new-model-remove:focus-visible {
  color: #164f9f;
}

.wb-new-model-quality-inline {
  min-width: 0;
  margin: -4px 0 -4px 2px;
  padding-left: 7px;
  border-left: 1px solid #cbdcf5;
}

.wb-new-model-quality-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 34px;
  padding: 4px 7px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #164f9f;
  line-height: 1;
  white-space: nowrap;
}

.wb-new-model-quality-trigger:hover, .wb-new-model-quality-trigger:focus-visible {
  outline: 0;
  background: #e6f0ff;
}

.wb-new-model-quality-trigger em {
  color: #6880a5;
  font-size: 9px;
  font-style: normal;
  font-weight: 700;
}

.wb-new-model-quality-trigger strong {
  color: #164f9f;
  font-size: 10px;
  font-weight: 800;
}

.wb-new-model-quality-trigger i {
  color: #4b71a9;
  font-size: 8px;
  transition: transform 0.15s ease;
}

.wb-new-model-quality-inline.is-open .wb-new-model-quality-trigger {
  background: #e6f0ff;
}

.wb-new-model-quality-inline.is-open .wb-new-model-quality-trigger i {
  transform: rotate(180deg);
}

.wb-new-model-quality-inline .wb-new-dropdown-menu {
  left: 7px;
  width: 190px;
}

.wb-new-dropdown {
  position: relative;
  min-width: 108px;
}

.wb-new-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 36px;
  padding: 7px 11px;
  border: 1px solid #cbdcf5;
  border-radius: 6px;
  background: #fff;
  color: #193264;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.25;
  text-align: left;
  cursor: pointer;
}

.wb-new-dropdown-trigger:hover {
  border-color: #79a9f5;
  background: #f8fbff;
}

.wb-new-dropdown-trigger:focus-visible {
  outline: 3px solid #b9d5ff;
  outline-offset: 1px;
  border-color: #1263ec;
}

.wb-new-dropdown.is-open .wb-new-dropdown-trigger {
  border-color: #1263ec;
  box-shadow: 0 0 0 2px #dceaff;
}

.wb-new-dropdown-trigger > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-new-dropdown-trigger > i:last-child {
  flex: 0 0 auto;
  color: #3e68a8;
  font-size: 9px;
  transition: transform 0.15s ease;
}

.wb-new-dropdown.is-open .wb-new-dropdown-trigger > i:last-child {
  transform: rotate(180deg);
}

.wb-new-dropdown-trigger.is-add {
  width: auto;
  min-width: 116px;
  color: #0758df;
}

.wb-new-dropdown-trigger.is-add > i:first-child {
  color: #1263ec;
  font-size: 11px;
}

.wb-new-dropdown-menu {
  position: absolute;
  z-index: 40;
  top: calc(100% + 7px);
  left: 0;
  width: 100%;
  min-width: 100%;
  max-height: 260px;
  overflow-y: auto;
  padding: 5px;
  border: 1px solid #cbdcf5;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 48, 98, 0.16);
}

.wb-new-dropdown-menu button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 36px;
  padding: 8px 10px;
  border: 0;
  border-radius: 4px;
  background: #fff;
  color: #193264;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}

.wb-new-dropdown-menu button:hover, .wb-new-dropdown-menu button:focus-visible,
.wb-new-dropdown-menu button.is-selected {
  outline: 0;
  background: #edf5ff;
  color: #0758df;
}

.wb-new-dropdown-menu button i {
  flex: 0 0 auto;
  font-size: 10px;
}

.wb-new-dropdown-empty {
  display: block;
  padding: 9px 10px;
  color: #7085a9;
  font-size: 11px;
  white-space: nowrap;
}

.wb-new-dropdown-model {
  width: fit-content;
}

.wb-new-dropdown-model .wb-new-dropdown-menu {
  width: max(260px, 100%);
}

.wb-new-dropdown-count {
  width: 100%;
  max-width: 120px;
}

.wb-new-dropdown-cut {
  width: min(100%, 420px);
}

.wb-new-dropdown-cut .wb-new-dropdown-menu {
  min-width: 100%;
}

.wb-new-dropdown-video-model {
  width: 100%;
  min-width: 0;
}

.wb-new-dropdown-video-model .wb-new-dropdown-menu {
  width: 100%;
}

.wb-new-dropdown-duration {
  min-width: 108px;
  width: fit-content;
}

.wb-new-cost {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #12234d;
  font-size: 11px;
}

.wb-new-cost strong {
  font-weight: 800;
}

.wb-new-cost span {
  color: #0960e5;
  font-size: 13px;
  font-weight: 800;
}

.wb-new-generate {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 47px;
  padding: 9px 12px;
  border: 1px solid #0d5be7;
  border-radius: 6px;
  background: #1266ea;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-generate:hover:not(:disabled) {
  background: #0758d9;
}

.wb-new-generate:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wb-new-error {
  margin: 10px 0 0;
  color: #b42318;
  font-size: 12px;
}

.wb-generation-feedback {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid #f2b8b5;
  border-radius: 7px;
  background: #fff7f6;
  color: #8f261f;
}

.wb-generation-feedback > i {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #c7483e;
  font-size: 14px;
}

.wb-generation-feedback-copy {
  min-width: 0;
  flex: 1;
}

.wb-generation-feedback-copy strong {
  display: block;
  color: #7d231e;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.wb-generation-feedback-copy p {
  margin: 3px 0 0;
  color: #a13b34;
  font-size: 11px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-generation-feedback-close {
  display: grid;
  place-items: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  margin: -5px -7px 0 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #a75650;
  cursor: pointer;
}

.wb-generation-feedback-close:hover,
.wb-generation-feedback-close:focus-visible {
  outline: 0;
  background: #fde8e6;
  color: #8b251f;
}

.wb-new-media-control-row {
  display: grid;
  grid-template-columns: minmax(185px, 1fr) minmax(210px, 1.15fr) minmax(105px, 0.48fr);
  align-items: end;
  gap: 18px;
}

.wb-new-media-control-row.is-video {
  align-items: center;
}

.wb-new-media-control-row + .wb-new-media-action-row {
  margin-top: 13px;
  padding-top: 12px;
  border-top: 1px solid #e6edf7;
}

.wb-new-media-action-row {
  display: grid;
  grid-template-columns: minmax(150px, 0.7fr) minmax(210px, 1.15fr) minmax(170px, 0.72fr) minmax(190px, 0.82fr);
  align-items: center;
  gap: 18px;
}

.wb-new-media-action-row.is-three {
  grid-template-columns: minmax(230px, 1.45fr) minmax(170px, 0.72fr) minmax(190px, 0.82fr);
}

.wb-new-media-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid #d8e4f5;
  border-radius: 6px;
  background: #f8fbff;
}

.wb-new-media-summary > i {
  display: grid;
  place-items: center;
  flex: 0 0 28px;
  height: 28px;
  border-radius: 6px;
  background: #e9f2ff;
  color: #1463e4;
}

.wb-new-media-summary > img {
  flex: 0 0 44px;
  width: 44px;
  height: 34px;
  border-radius: 4px;
  object-fit: cover;
  background: #e8eef7;
}

.wb-new-media-summary div {
  min-width: 0;
}

.wb-new-media-summary strong, .wb-new-media-summary span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-new-media-summary strong {
  color: #172c58;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-media-summary span {
  margin-top: 2px;
  color: #7187a8;
  font-size: 10px;
}

.wb-new-media-source-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0758df;
  font-size: 10px;
  font-weight: 750;
}

.wb-new-media-cost {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wb-new-media-cost strong {
  color: #112653;
  font-size: 12px;
  font-weight: 800;
}

.wb-new-media-cost span {
  color: #0860e8;
  font-size: 13px;
  font-weight: 800;
}

.wb-new-media-cost small {
  color: #7589a8;
  font-size: 9px;
  line-height: 1.35;
}

.wb-audio-settings {
  padding: 18px 20px;
}

.wb-audio-options {
  display: grid;
  grid-template-columns: minmax(260px, 1.45fr) minmax(172px, 0.9fr) minmax(140px, 0.65fr);
  align-items: end;
  gap: 18px;
}

.wb-audio-options.is-narration {
  grid-template-columns: minmax(260px, 1.45fr) minmax(172px, 1.55fr);
}

.wb-audio-options .wb-new-stepper {
  min-height: 42px;
}

.wb-audio-options .wb-new-stepper button {
  min-width: 34px;
}

.wb-audio-field-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 12px;
  min-height: 18px;
  margin-bottom: 6px;
}

.wb-audio-field-heading > label {
  margin: 0;
  color: #193264;
  font-size: 11px;
  font-weight: 800;
}

.wb-audio-model-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #047857;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.wb-audio-model-status > span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
}

.wb-audio-model-status.is-unavailable {
  color: #b42318;
}

.wb-audio-select {
  position: relative;
  min-width: 0;
}

.wb-audio-select select {
  display: block;
  width: 100%;
  min-width: 0;
  height: 42px;
  padding: 8px 30px 8px 11px;
  appearance: none;
  border: 1px solid #cadcf5;
  border-radius: 6px;
  background: #fff;
  color: #193264;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
}

.wb-audio-select > i {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  color: #6b83a5;
  font-size: 10px;
  pointer-events: none;
}

.wb-audio-prompt {
  min-width: 0;
  margin-top: 20px;
}

.wb-audio-counter {
  color: #6b7f9e;
  font-size: 10px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.wb-audio-prompt textarea {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 108px;
  padding: 11px 12px;
  border: 1px solid #cadcf5;
  border-radius: 6px;
  background: #fff;
  color: #193264;
  font: inherit;
  font-size: 12px;
  line-height: 1.65;
  resize: vertical;
}

.wb-audio-prompt textarea::placeholder {
  color: #8294ae;
  opacity: 1;
}

.wb-audio-select select:focus-visible, .wb-audio-prompt textarea:focus-visible {
  outline: 2px solid #c6ddff;
  outline-offset: 1px;
  border-color: #1263ec;
}

.wb-audio-help {
  margin: 7px 0 0;
  color: #6b7f9e;
  font-size: 10px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.wb-audio-settings > .wb-new-media-action-row {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #e6edf7;
}

.wb-audio-settings .wb-new-media-summary strong, .wb-audio-settings .wb-new-media-summary span {
  overflow: visible;
  white-space: normal;
}

.wb-audio-settings .wb-new-generate {
  grid-column: auto;
}

.wb-audio-generation-progress {
  margin: 16px 0 0;
}

.wb-audio-generation-progress .wb-generation-progress-heading {
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.wb-audio-generation-progress .wb-generation-progress-heading > span {
  color: #657fa7;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.wb-audio-generation-progress .wb-generation-progress-copy > p {
  font-size: 12px;
}

.wb-audio-generation-progress.is-error .wb-generation-progress-copy > p {
  color: #bd3e35;
}

.wb-audio-generation-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.wb-audio-generation-steps li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #7889a3;
  font-size: 11px;
}

.wb-audio-generation-steps i {
  font-size: 7px;
}

.wb-audio-generation-steps .is-current {
  color: #1263e9;
  font-weight: 800;
}

.wb-audio-generation-steps .is-complete {
  color: #11905c;
}

.wb-audio-generation-steps .is-error {
  color: #bd3e35;
  font-weight: 800;
}

.wb-audio-generation-progress .is-indeterminate > span {
  animation: wb-audio-progress 1.5s ease-in-out infinite alternate;
}

.wb-video-retry {
  margin-top: 12px;
}

@keyframes wb-audio-progress {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(285%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .wb-audio-generation-progress .is-indeterminate > span,
  .wb-audio-generation-progress .wb-generation-progress-icon i {
    animation: none;
  }
  .wb-audio-generation-progress .wb-generation-progress-track > span {
    transition: none;
  }
}
@container (max-width: 760px) {
  .wb-audio-options, .wb-audio-options.is-narration {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .wb-audio-duration {
    max-width: 230px;
  }
  .wb-audio-settings > .wb-new-media-action-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .wb-audio-settings > .wb-new-media-action-row > .wb-new-media-summary {
    grid-column: 1/-1;
  }
}
@container (max-width: 520px) {
  .wb-audio-settings {
    padding: 16px;
  }
  .wb-audio-options, .wb-audio-options.is-narration {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
  .wb-audio-duration {
    max-width: none;
  }
  .wb-audio-prompt {
    margin-top: 18px;
  }
  .wb-audio-settings > .wb-new-media-action-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
  .wb-audio-settings .wb-new-generate {
    width: 100%;
  }
}
.wb-new-results > header {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 11px;
}

.wb-new-results > header h3 {
  margin: 0;
  color: #10204e;
  font-size: 18px;
  font-weight: 800;
}

.wb-new-results > header p {
  margin: 0;
  color: #7188ad;
  font-size: 11px;
}

.wb-new-results-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.wb-new-result-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 14px;
}

.wb-new-result-card > header {
  display: flex;
  align-items: center;
  gap: 9px;
}

.wb-new-result-card > header strong {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  color: #10204e;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-new-result-card > header .wb-new-status {
  min-width: 56px;
}

.wb-new-result-number {
  display: grid;
  place-items: center;
  flex: 0 0 34px;
  height: 34px;
  border-radius: 50%;
  background: #eaf3ff;
  color: #1262e8;
  font-size: 15px;
  font-weight: 800;
}

.wb-new-result-caption {
  overflow: hidden;
  margin: 11px 0 8px;
  color: #637da3;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wb-new-result-visual {
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1.65/1;
  border-radius: 4px;
  background: #eef3fa;
}

.wb-new-result-visual img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.wb-new-result-visual video {
  display: block;
  width: 100%;
  height: 100%;
  background: #101827;
  object-fit: contain;
}

.wb-new-result-visual.is-audio {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(145deg, #edf6ff, #f7fbff);
}

.wb-new-result-visual.is-audio audio {
  width: 100%;
}

.wb-new-results-grid.is-empty {
  grid-template-columns: 1fr;
}

.wb-new-result-card.is-empty {
  min-height: 260px;
  justify-content: center;
}

.wb-new-result-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  height: 100%;
  color: #8ba1c0;
  font-size: 11px;
}

.wb-new-result-empty i {
  font-size: 27px;
}

.wb-new-result-meta {
  display: flex;
  justify-content: space-around;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 4px;
  border-radius: 5px;
  background: #f3f7fc;
  color: #2860b7;
  font-size: 11px;
  font-weight: 700;
}

.wb-new-result-actions {
  display: flex;
  gap: 0;
  margin-top: 8px;
  border: 1px solid #d7e5f6;
  border-radius: 5px;
}

.wb-new-result-actions button {
  flex: 1;
  min-height: 33px;
  border: 0;
  background: #fff;
  color: #45628e;
  font-size: 11px;
  font-weight: 700;
}

.wb-new-result-actions button + button {
  border-left: 1px solid #d7e5f6;
}

.wb-new-result-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.wb-new-result-actions i {
  margin-right: 5px;
}

.wb-new-report-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 11px;
  padding: 10px 14px;
  border: 1px solid #dbe9f9;
  border-radius: 6px;
  background: #fff;
  color: #7b91b1;
}

.wb-new-report-bar.is-running {
  border-color: #c8dcfa;
  background: #f8fbff;
  color: #1263e9;
}

.wb-new-report-bar.is-complete {
  border-color: #c7ead7;
  color: #0e9860;
}

.wb-new-report-bar.is-error {
  border-color: #f0c1bd;
  background: #fff9f8;
  color: #bd3e35;
}

.wb-new-report-bar > i {
  display: grid;
  place-items: center;
  flex: 0 0 30px;
  height: 30px;
  border-radius: 50%;
  background: #edf2f8;
  font-size: 17px;
}

.wb-new-report-bar.is-running > i {
  background: #e3efff;
}

.wb-new-report-bar.is-complete > i {
  background: #e4faee;
}

.wb-new-report-bar.is-error > i {
  background: #fde7e4;
}

.wb-new-report-bar > div {
  flex: 1;
}

.wb-new-report-bar strong {
  color: #122657;
  font-size: 11px;
  font-weight: 800;
}

.wb-new-report-bar p {
  margin: 1px 0 0;
  color: #6c85ab;
  font-size: 10px;
}

.wb-new-report-bar button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border: 1px solid #c5dafa;
  border-radius: 5px;
  background: #fff;
  color: #0758df;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.wb-new-report {
  margin-top: 9px;
  padding: 14px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  background: #fff;
}

.wb-new-report h4 {
  margin: 0 0 10px;
  color: #10204e;
  font-size: 13px;
  font-weight: 800;
}

.wb-new-advanced-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0 12px;
  padding: 8px 0;
  border: 0;
  background: none;
  color: #35649e;
  font-size: 12px;
  font-weight: 700;
}

.wb-new-advanced-area {
  margin-bottom: 20px;
}

@container wb-content (max-width: 1400px) {
  .wb-new-control-row {
    grid-template-columns: minmax(220px, 1fr) minmax(150px, 0.6fr);
  }
  .wb-new-reference {
    grid-column: 1/-1;
  }
  .wb-new-generation-primary-row .wb-new-reference {
    grid-column: auto;
  }
  .wb-new-model-row {
    grid-template-columns: minmax(0, 1fr) minmax(110px, 0.3fr);
  }
  .wb-new-generate {
    grid-column: 1/-1;
  }
  .wb-guide-action-bar .wb-new-generate {
    grid-column: auto;
  }
  .wb-new-media-control-row {
    grid-template-columns: minmax(200px, 1fr) minmax(200px, 1fr);
  }
  .wb-new-media-control-row > :last-child {
    grid-column: 1/-1;
  }
}
@container wb-content (max-width: 900px) {
  .wb-new-header-inner {
    flex-wrap: wrap;
  }
  .wb-new-source-card {
    grid-template-columns: 1fr 1fr;
  }
  .wb-new-source-card h3 {
    grid-column: 1/-1;
  }
  .wb-new-results-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wb-new-image-results-grid {
    grid-template-columns: 1fr;
  }
  .wb-new-media-action-row, .wb-new-media-action-row.is-three {
    grid-template-columns: 1fr 1fr;
  }
  .wb-new-media-action-row .wb-new-generate {
    grid-column: 1/-1;
  }
  .wb-guide-step-header, .wb-new-prompt-header.wb-guide-step-header {
    grid-template-columns: 30px 26px minmax(140px, 1fr) auto;
  }
  .wb-guide-step-header .wb-analysis-actions {
    grid-column: 3/-1;
    justify-content: flex-end;
  }
  .wb-guide-chevron {
    grid-column: 4;
    grid-row: 1;
  }
  .wb-guide-action-bar {
    grid-template-columns: 30px 26px minmax(140px, 1fr) auto auto;
  }
  .wb-guide-action-bar .wb-new-generation-blocked {
    grid-column: 3/-1;
  }
  .wb-new-control-row.wb-new-generation-primary-row {
    grid-template-columns: 1fr;
  }
}
@container wb-content (max-width: 650px) {
  .wb-new-page-title {
    flex-wrap: wrap;
  }
  .wb-new-main {
    padding-inline: 12px;
  }
  .wb-new-page-title h2 {
    font-size: 23px;
  }
  .wb-new-source-card {
    grid-template-columns: 1fr;
    padding: 16px;
  }
  .wb-new-source-card h3 {
    grid-column: auto;
  }
  .wb-new-source-choice {
    min-height: 58px;
  }
  .wb-new-list-card {
    padding: 12px;
  }
  .wb-new-list-card > header .wb-new-search {
    width: 100%;
    margin: 2px 0 6px;
  }
  .wb-new-control-row, .wb-new-model-row {
    grid-template-columns: 1fr;
  }
  .wb-new-media-control-row, .wb-new-media-action-row, .wb-new-media-action-row.is-three {
    grid-template-columns: 1fr;
  }
  .wb-new-media-control-row > :last-child, .wb-new-media-action-row .wb-new-generate {
    grid-column: auto;
  }
  .wb-new-dropdown-model .wb-new-dropdown-menu {
    left: auto;
    right: 0;
    width: min(300px, 100%);
  }
  .wb-new-reference, .wb-new-generate {
    grid-column: auto;
  }
  .wb-new-results-grid {
    grid-template-columns: 1fr;
  }
  .wb-new-prompt-body {
    grid-template-columns: 1fr;
  }
  .wb-new-prompt-footer {
    flex-wrap: wrap;
  }
  .wb-new-prompt-footer > button {
    flex: 1;
  }
  .wb-guide-step-header, .wb-new-prompt-header.wb-guide-step-header {
    grid-template-columns: 30px minmax(0, 1fr) auto;
    padding: 10px 12px;
  }
  .wb-guide-step-number {
    display: none;
  }
  .wb-guide-step-header .wb-analysis-actions {
    grid-column: 1/-1;
    justify-content: stretch;
    flex-wrap: wrap;
  }
  .wb-guide-step-header .wb-analysis-actions > button {
    flex: 1;
  }
  .wb-guide-chevron {
    grid-column: 3;
  }
  .wb-new-prompt-header .wb-new-prompt-badge, .wb-new-prompt-header .wb-new-prompt-draft {
    display: none;
  }
  .wb-guide-action-bar {
    position: static;
    display: flex;
    align-items: stretch;
    padding: 10px 12px;
  }
  .wb-guide-action-bar .wb-guide-step-copy {
    flex: 1 1 100%;
  }
  .wb-guide-action-bar .wb-new-generation-blocked {
    flex: 1 1 100%;
  }
  .wb-new-control-card.wb-guide-step > .wb-new-control-row {
    padding: 12px;
  }
  .wb-expression-edit-heading, .wb-generation-settings-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
    padding-right: 12px;
    padding-left: 12px;
  }
  .wb-new-control-card.wb-guide-step > .wb-new-summary, .wb-trigger-intensity-note {
    margin-right: 12px;
    margin-left: 12px;
  }
  .wb-trigger-stage-editor {
    grid-template-columns: 1fr;
    padding: 4px 12px 12px;
  }
  .wb-trigger-stage-editor > header {
    grid-template-columns: 1fr;
    gap: 3px;
  }
  .wb-trigger-stage-editor .wb-trigger-editor {
    grid-column: 1;
  }
  .wb-expression-stage-editor {
    grid-template-columns: 1fr;
    padding: 4px 12px 12px;
  }
  .wb-expression-stage-editor > header {
    grid-template-columns: 1fr;
    gap: 3px;
  }
  .wb-expression-stage-content {
    grid-column: 1;
  }
  .wb-expression-prompt-header {
    padding-right: 12px;
    padding-left: 12px;
  }
  .wb-expression-prompt-title {
    flex: 1 1 100%;
  }
  .wb-new-selected-source {
    gap: 10px;
    padding: 12px;
  }
}
.content-notebook-scale {
  width: 100%;
  min-width: 0;
}

.content-workbench-header {
  --workspace-header-max-width: 1600px;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}

.content-workbench-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(290px, 320px);
  align-items: start;
  gap: 18px;
}

.content-workbench-grid.is-scenario-console {
  grid-template-columns: minmax(220px, 248px) minmax(0, 1fr) minmax(300px, 328px);
  gap: 14px;
}

.content-panel {
  min-width: 0;
  border: 1px solid #dbe3ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.045);
}

.content-preview-panel {
  overflow: hidden;
  min-height: 700px;
}

.content-settings-panel {
  position: sticky;
  top: 72px;
  overflow: visible;
}

.content-cut-console {
  position: sticky;
  top: 72px;
  display: flex;
  max-height: calc(100dvh - 92px);
  flex-direction: column;
  overflow: hidden;
}

.content-cut-console-header {
  display: flex;
  min-height: 68px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e8edf3;
  padding: 15px 16px;
}

.content-cut-console-header h2 {
  color: #111827;
  font-size: 15px;
  font-weight: 850;
}

.content-cut-console-header > span {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 999px;
  background: #eff6ff;
  padding: 0 8px;
  color: #2563eb;
  font-size: 10px;
  font-weight: 800;
}

.content-cut-console-header > span.is-loading {
  background: #eef2ff;
  color: #4f46e5;
}

.content-cut-console-header > span.is-error {
  background: #fef2f2;
  color: #dc2626;
}

.content-cut-console-list {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 7px;
  overflow-y: auto;
  padding: 10px;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}

.content-cut-progress-item {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 14px;
  align-items: center;
  gap: 8px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 10px 8px;
  animation: content-cut-appear 220ms ease-out both;
}

.content-cut-progress-number {
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 8px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 850;
}

.content-cut-progress-copy strong,
.content-cut-progress-copy small {
  display: block;
  line-height: 1.45;
}

.content-cut-progress-copy strong {
  color: #1e293b;
  font-size: 10px;
}

.content-cut-memory-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
}

.content-cut-memory-heading > strong {
  min-width: 0;
  flex: 1;
}

.content-cut-memory-badge {
  display: inline-flex;
  min-height: 20px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 2px 7px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.4;
  white-space: nowrap;
  letter-spacing: -0.01em;
}

.content-cut-memory-badge.is-trauma {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.content-cut-memory-badge.is-positive {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.content-cut-progress-copy small {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
}

.content-cut-progress-item > i {
  color: #16a34a;
  font-size: 12px;
}

@keyframes content-cut-appear {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.content-cut-analysis-card {
  flex: 0 0 auto;
  border-bottom: 1px solid #e8edf3;
  background: #fbfdff;
  padding: 12px 10px;
}

.content-cut-analysis-card > header h3 {
  margin-top: 3px;
  color: #172033;
  font-size: 11px;
  font-weight: 900;
  line-height: 1.45;
}

.content-cut-analysis-card .content-console-analysis-summary {
  margin-top: 9px;
  border-color: #dbeafe;
  background: #fff;
  padding: 9px;
}

.content-cut-analysis-card .content-console-analysis-icon {
  width: 30px;
  height: 30px;
}

.content-cut-analysis-card .content-analysis-button {
  width: 100%;
  margin-top: 8px;
}

.content-analysis-fallback-note {
  margin-top: 8px;
  border: 1px solid #fde68a;
  border-radius: 9px;
  background: #fffbeb;
  padding: 8px 9px;
  color: #92400e;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.5;
}

.content-cut-analysis-state {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 3px 8px;
  margin-top: 9px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  color: #334155;
}

.content-cut-analysis-state > i {
  grid-row: 1/span 2;
  margin-top: 2px;
  color: #2563eb;
  text-align: center;
}

.content-cut-analysis-state p {
  font-size: 10px;
  font-weight: 750;
  line-height: 1.55;
}

.content-cut-analysis-state small {
  color: #64748b;
  font-size: 9px;
  line-height: 1.5;
}

.content-cut-analysis-state.is-error {
  border-color: #fecaca;
  background: #fff7f7;
}

.content-cut-analysis-state.is-error > i {
  color: #dc2626;
}

.content-cut-analysis-state.is-loading {
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 8px 10px;
  border-color: #c7d2fe;
  background: linear-gradient(145deg, #ffffff, #f8faff);
  padding: 12px;
}

.content-cut-analysis-state.is-loading strong {
  display: block;
  color: #27344a;
  font-size: 10px;
  font-weight: 850;
  line-height: 1.5;
}

.content-cut-analysis-state.is-loading p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
  font-weight: 500;
  line-height: 1.5;
}

.content-cut-analysis-loader {
  width: 28px;
  height: 28px;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  border-radius: 999px;
  animation: content-analysis-spin 0.8s linear infinite;
}

.content-cut-analysis-progress {
  position: relative;
  grid-column: 1/-1;
  height: 3px;
  overflow: hidden;
  border-radius: 999px;
  background: #e0e7ff;
}

.content-cut-analysis-progress::after {
  position: absolute;
  inset: 0 auto 0 0;
  width: 42%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb, #818cf8);
  content: "";
  animation: content-analysis-progress 1.35s ease-in-out infinite;
}

@keyframes content-analysis-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes content-analysis-progress {
  0% {
    transform: translateX(-110%);
  }
  100% {
    transform: translateX(340%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .content-cut-analysis-loader,
  .content-cut-analysis-progress::after {
    animation-duration: 2.4s;
  }
  .content-cut-progress-item {
    animation: none;
  }
}
.content-cut-console-item {
  position: relative;
  display: grid;
  min-height: 82px;
  grid-template-columns: 66px minmax(0, 1fr) 10px;
  align-items: center;
  gap: 9px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 7px;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.content-cut-console-item::before {
  position: absolute;
  top: 9px;
  bottom: 9px;
  left: 0;
  width: 3px;
  border-radius: 0 999px 999px 0;
  content: "";
}

.content-cut-console-item.is-trauma-memory::before {
  background: #fb7185;
}

.content-cut-console-item.is-positive-memory::before {
  background: #34d399;
}

.content-cut-console-item:hover:not(:disabled) {
  border-color: #93c5fd;
  background: #f8fbff;
}

.content-cut-console-item.is-selected {
  border-color: #2563eb;
  background: #eff6ff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.content-cut-console-item:disabled {
  cursor: not-allowed;
  opacity: 0.64;
}

.content-cut-console-thumb {
  position: relative;
  display: flex;
  aspect-ratio: 16/10;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 7px;
  background: #e2e8f0;
  color: #94a3b8;
}

.content-cut-console-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-cut-console-placeholder {
  font-size: 16px;
}

.content-cut-console-thumb em {
  position: absolute;
  top: 4px;
  left: 4px;
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  background: #2563eb;
  color: #fff;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);
}

.content-cut-console-copy,
.content-cut-console-copy strong,
.content-cut-console-copy small {
  display: block;
  min-width: 0;
}

.content-cut-console-copy strong {
  overflow: hidden;
  color: #172033;
  font-size: 11px;
  font-weight: 850;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-cut-console-copy small {
  margin-top: 3px;
  overflow: hidden;
  color: #64748b;
  font-size: 9px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-cut-console-status {
  display: inline-flex;
  width: fit-content;
  min-height: 20px;
  align-items: center;
  gap: 4px;
  margin-top: 7px;
  border-radius: 999px;
  background: #f1f5f9;
  padding: 0 7px;
  color: #64748b;
  font-size: 8px;
  font-weight: 850;
}

.content-cut-console-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-top: 7px;
}

.content-cut-console-badges .content-cut-console-status {
  margin-top: 0;
}

.content-cut-consistency-badge {
  display: inline-flex;
  min-height: 20px;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 0 7px;
  font-size: 8px;
  font-weight: 850;
}

.content-cut-consistency-badge.is-passed {
  background: #dcfce7;
  color: #047857;
}

.content-cut-consistency-badge.is-warning {
  background: #fef3c7;
  color: #a16207;
}

.content-cut-consistency-badge.is-failed {
  background: #ffe4e6;
  color: #be123c;
}

.content-cut-console-status.is-master,
.content-cut-console-status.is-complete {
  background: #dcfce7;
  color: #047857;
}

.content-cut-console-status.is-progress {
  background: #dbeafe;
  color: #1d4ed8;
}

.content-cut-console-status.is-locked,
.content-cut-console-status.is-error {
  background: #fff1f2;
  color: #be123c;
}

.content-cut-console-chevron {
  color: #94a3b8;
  font-size: 9px;
}

.content-cut-console-item.is-selected .content-cut-console-chevron {
  color: #2563eb;
}

.is-scenario-console .content-settings-panel {
  height: auto;
  max-height: calc(100dvh - 92px);
  overflow: hidden;
}

.is-scenario-console .content-settings-form {
  height: auto;
  max-height: calc(100dvh - 92px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}

.content-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-bottom: 1px solid #e5eaf0;
  padding: 0 18px;
}

.content-media-tabs button {
  position: relative;
  display: inline-flex;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  transition: color 160ms ease;
}

.content-media-tabs button::after {
  position: absolute;
  right: 12px;
  bottom: -1px;
  left: 12px;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: transparent;
  content: "";
}

.content-media-tabs button:hover,
.content-media-tabs button.is-active {
  color: #1d4ed8;
}

.content-media-tabs button.is-active::after {
  background: #2563eb;
}

.content-review-empty {
  display: flex;
  min-height: 520px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px;
  text-align: center;
}

.content-review-empty.has-cut-brief {
  min-height: 300px;
}

.content-preview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 20px 16px;
}

.content-preview-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.content-secondary-button,
.content-primary-button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 9px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 700;
  transition: 150ms ease;
}

.content-secondary-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}

.content-secondary-button:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-secondary-button.is-confirmed {
  border-color: #86efac;
  background: #f0fdf4;
  color: #047857;
}

.content-primary-button {
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #fff;
  box-shadow: 0 5px 12px rgba(29, 78, 216, 0.16);
}

.content-primary-button:hover {
  background: #1e40af;
}

.content-primary-button.is-confirmed {
  border-color: #059669;
  background: #059669;
}

.content-secondary-button:disabled,
.content-primary-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.content-model-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 0 20px 14px;
  border: 1px solid #ede9fe;
  border-radius: 10px;
  background: #faf9ff;
  padding: 10px 12px;
}

.content-filter-button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.content-filter-button small {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 1px 6px;
  font-size: 9px;
}

.content-filter-button.is-active {
  border-color: #6d28d9;
  background: #6d28d9;
  color: #fff;
}

.content-filter-button.is-active small {
  background: rgba(255, 255, 255, 0.2);
}

.content-master-media {
  position: relative;
  display: flex;
  aspect-ratio: 16/9;
  max-height: 570px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 20px;
  border: 1px solid #d6dee8;
  border-radius: 12px;
  background: #0f172a;
}

.content-master-media > img,
.content-master-media > video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-master-audio {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 36px;
  background: #0f2435;
}

.content-master-audio img {
  width: min(100%, 720px);
  max-height: 58%;
  border-radius: 10px;
  object-fit: contain;
}

.content-master-audio audio {
  width: min(100%, 720px);
}

.content-audio-placeholder,
.content-master-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #cbd5e1;
  font-size: 12px;
}

.content-audio-placeholder i,
.content-master-placeholder i {
  font-size: 32px;
}

.content-master-placeholder {
  position: absolute;
  inset: 0;
  background: #0f172a;
}

.content-thumbnail-strip {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 220px));
  justify-content: start;
  gap: 12px;
  margin: 14px 20px 0;
}

.content-thumbnail-strip.is-video {
  display: flex;
  overflow-x: auto;
  padding: 2px 2px 10px;
  scroll-padding-inline: 2px;
  scroll-snap-type: x proximity;
}

.content-thumbnail-strip.is-video .content-thumbnail {
  width: 184px;
  flex: 0 0 184px;
  scroll-snap-align: start;
}

.content-thumbnail {
  position: relative;
  aspect-ratio: 16/9;
  min-width: 0;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: 10px;
  background: #eef2f7;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.content-thumbnail:hover {
  transform: translateY(-1px);
  border-color: #bfdbfe;
}

.content-thumbnail.is-selected {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.13);
}

.content-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-thumbnail-index {
  position: absolute;
  z-index: 2;
  top: 7px;
  left: 7px;
  display: flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  backdrop-filter: blur(4px);
}

.content-thumbnail.is-selected .content-thumbnail-index {
  background: #2563eb;
}

.content-thumbnail-intensity {
  position: absolute;
  z-index: 2;
  bottom: 7px;
  left: 7px;
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  border: 1px solid rgba(255, 255, 255, 0.78);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  padding: 3px 8px;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  backdrop-filter: blur(4px);
}

.content-thumbnail.is-selected .content-thumbnail-intensity {
  background: #1d4ed8;
}

.content-thumbnail-meta {
  position: absolute;
  right: 7px;
  bottom: 7px;
  left: 7px;
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.78);
  padding: 4px 7px;
  color: #fff;
  backdrop-filter: blur(4px);
}

.content-thumbnail-meta strong,
.content-thumbnail-meta small {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-thumbnail-meta strong {
  font-weight: 800;
}

.content-thumbnail-meta small {
  color: #cbd5e1;
}

.content-thumbnail-check {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #10b981;
  font-size: 20px;
  filter: drop-shadow(0 1px 3px rgba(255, 255, 255, 0.8));
}

.content-thumbnail-batch-check {
  position: absolute;
  right: 8px;
  top: 8px;
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 10px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.24);
}

.content-thumbnail-placeholder {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 24px;
}

.content-selected-asset {
  margin: 16px 20px 20px;
  border: 1px solid #e1e7ee;
  border-radius: 11px;
  background: #fff;
}

.content-selected-asset-heading {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f5;
  padding: 12px 15px;
}

.content-selected-asset-heading h3 {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-selected-asset-heading p {
  margin-top: 3px;
  color: #7c8a9c;
  font-size: 10px;
}

.content-asset-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.content-asset-actions button {
  min-height: 31px;
  border: 1px solid #d6dee8;
  border-radius: 7px;
  padding: 0 10px;
  background: #fff;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.content-asset-actions button:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-asset-actions button.is-danger {
  border-color: #fecaca;
  color: #dc2626;
}

.content-asset-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.content-asset-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  padding: 15px;
}

.content-asset-detail-grid > div {
  min-width: 0;
  border-right: 1px solid #edf1f5;
  padding: 0 15px;
}

.content-asset-detail-grid > div:first-child {
  padding-left: 0;
}

.content-asset-detail-grid > div:last-child {
  border-right: 0;
  padding-right: 0;
}

.content-asset-detail-grid dt {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-asset-detail-grid dd {
  overflow: hidden;
  margin-top: 5px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-intensity-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #eff6ff;
  padding: 3px 8px;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 800;
}

.content-prompt-strategy-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #f5f3ff;
  padding: 3px 8px;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 800;
}

.content-status-badge {
  display: inline-flex;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 9px;
}

.content-status-badge.is-success {
  background: #ecfdf5;
  color: #047857;
}

.content-status-badge.is-danger {
  background: #fef2f2;
  color: #b91c1c;
}

.content-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #edf1f5;
  padding: 14px 20px;
  color: #64748b;
  font-size: 11px;
}

.content-pagination > div {
  display: flex;
  gap: 8px;
}

.content-overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-top: 1px solid #edf1f5;
  padding: 15px 20px;
  color: #64748b;
}

.content-overview h3,
.content-overview strong {
  color: #334155;
  font-size: 10px;
  font-weight: 800;
}

.content-overview p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-overview > p {
  max-width: 420px;
  margin-top: 0;
  text-align: right;
}

.content-overview > p strong,
.content-overview > p span {
  display: block;
}

.content-pagination button {
  min-height: 34px;
  border: 1px solid #d6dee8;
  border-radius: 7px;
  padding: 0 12px;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.content-pagination button:disabled {
  opacity: 0.4;
}

.content-settings-form {
  display: flex;
  flex-direction: column;
}

.content-settings-header {
  display: flex;
  min-height: 68px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 17px 18px 14px;
}

.content-settings-eyebrow {
  margin-bottom: 2px;
  color: #2563eb;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.content-settings-header h2 {
  color: #111827;
  font-size: 15px;
  font-weight: 800;
}

.content-settings-header p {
  margin-top: 4px;
  color: #7c8a9c;
  font-size: 10px;
  line-height: 1.5;
}

.content-running-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #eff6ff;
  padding: 4px 8px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-settings-section {
  position: relative;
  border-top: 1px solid #e8edf3;
  padding: 16px 18px;
}

.content-settings-section > h3 {
  margin-bottom: 14px;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-settings-accordion-row {
  border-top: 1px solid #e8edf3;
  background: #fff;
}

.content-settings-accordion-trigger {
  display: grid;
  width: 100%;
  min-height: 64px;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  border: 0;
  padding: 11px 18px;
  background: transparent;
  text-align: left;
  transition: background-color 160ms ease;
}

.content-settings-accordion-trigger:not(:disabled):hover {
  background: #f8fafc;
}

.content-settings-accordion-trigger:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

.content-settings-accordion-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 13px;
}

.content-settings-accordion-icon.is-reference {
  background: #f5f3ff;
  color: #7c3aed;
}

.content-settings-accordion-icon.is-intensity {
  background: #ecfdf5;
  color: #059669;
}

.content-settings-accordion-icon.is-generation {
  background: #fff7ed;
  color: #ea580c;
}

.content-settings-accordion-copy {
  min-width: 0;
}

.content-settings-accordion-copy strong,
.content-settings-accordion-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-settings-accordion-copy strong {
  color: #172033;
  font-size: 11px;
  font-weight: 800;
}

.content-settings-accordion-copy small {
  margin-top: 3px;
  color: #7c8a9c;
  font-size: 9px;
  line-height: 1.4;
}

.content-settings-accordion-state {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #94a3b8;
  font-size: 10px;
}

.content-scenario-library-row .content-settings-accordion-trigger {
  cursor: default;
}

.content-scenario-library-link {
  display: inline-flex;
  min-height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 850;
  white-space: nowrap;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.content-scenario-library-link:hover {
  border-color: #60a5fa;
  background: #eff6ff;
}

.content-scenario-library-link:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-settings-accordion-row.is-open .content-settings-accordion-trigger {
  background: #f8fbff;
}

.content-settings-accordion-row.is-open .content-settings-accordion-copy strong,
.content-settings-accordion-row.is-open .content-settings-accordion-state {
  color: #1d4ed8;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-trigger {
  cursor: not-allowed;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-icon {
  background: #f1f5f9;
  color: #94a3b8;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-copy strong {
  color: #475569;
}

.content-settings-section > .content-settings-accordion-row.is-prompt-row {
  margin: 16px -18px -16px;
}

.content-settings-section > .content-settings-accordion-row.is-prompt-row.is-open {
  margin-bottom: 0;
}

.content-settings-section > .content-prompt-selector.content-settings-accordion-body {
  margin-top: 0;
  border-top: 0;
  padding-top: 16px;
}

.content-settings-accordion-body {
  animation: content-settings-accordion-in 160ms ease-out;
}

.content-settings-locked-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid #e8edf3;
  background: rgba(255, 255, 255, 0.98);
  padding: 13px 18px 16px;
  backdrop-filter: blur(8px);
}

.content-settings-locked-footer p {
  margin-bottom: 8px;
  color: #7c8a9c;
  font-size: 9px;
  text-align: center;
}

.content-settings-locked-footer button {
  display: inline-flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 9px;
  background: #dbe5f5;
  color: #70829d;
  font-size: 11px;
  font-weight: 800;
  cursor: not-allowed;
}

@keyframes content-settings-accordion-in {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.content-reference-condition-section h3 {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-reference-condition-badge {
  display: inline-flex;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #ede9fe;
  padding: 4px 8px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-mode-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 11px;
}

.content-reference-mode-option {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 9px 8px;
  text-align: left;
  transition: 150ms ease;
}

.content-reference-mode-option strong,
.content-reference-mode-option span {
  display: block;
}

.content-reference-mode-option strong {
  color: #334155;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-mode-option span {
  margin-top: 4px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.4;
}

.content-reference-mode-option.is-selected {
  border-color: #8b5cf6;
  background: #f5f3ff;
  box-shadow: inset 0 0 0 1px rgba(139, 92, 246, 0.16);
}

.content-reference-mode-option.is-selected strong {
  color: #6d28d9;
}

.content-reference-mode-option:disabled {
  cursor: not-allowed;
  opacity: 0.46;
}

.content-reference-condition-card,
.content-reference-condition-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 11px;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  background: #faf9ff;
  padding: 10px;
}

.content-reference-condition-copy {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.content-reference-condition-copy strong {
  color: #172033;
  font-size: 11px;
}

.content-reference-condition-copy p {
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.35;
}

.content-reference-condition-copy p:last-child {
  color: #94a3b8;
}

.content-reference-condition-thumbnail {
  position: relative;
  width: 56px;
  height: 44px;
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid #ddd6fe;
  border-radius: 8px;
  background: #ede9fe;
}

.content-reference-condition-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-reference-condition-thumbnail span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0);
  color: transparent;
  transition: 150ms ease;
}

.content-reference-condition-thumbnail:hover span,
.content-reference-condition-thumbnail:focus-visible span {
  background: rgba(15, 23, 42, 0.48);
  color: #fff;
}

.content-reference-condition-icon {
  display: flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #ede9fe;
  color: #6d28d9;
}

.content-reference-condition-remove,
.content-reference-condition-empty > a {
  flex: 0 0 auto;
  border: 1px solid #c4b5fd;
  border-radius: 8px;
  background: #fff;
  padding: 6px 8px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-condition-empty > i {
  color: #8b5cf6;
  font-size: 18px;
}

.content-reference-condition-empty > div {
  min-width: 0;
  flex: 1;
}

.content-reference-condition-empty strong {
  color: #334155;
  font-size: 10px;
}

.content-reference-condition-empty p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-reference-detail-panel {
  margin-top: 10px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 10px;
}

.content-reference-detail-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 7px;
  color: #334155;
  font-size: 9px;
}

.content-reference-detail-heading:not(:first-child) {
  margin-top: 11px;
}

.content-reference-detail-heading strong {
  font-weight: 800;
}

.content-reference-detail-heading span {
  color: #64748b;
}

.content-reference-role-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.content-reference-role-chip,
.content-reference-strength-option {
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  padding: 6px 9px;
  color: #475569;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-role-chip.is-selected,
.content-reference-strength-option.is-selected {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}

.content-reference-strength-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.content-reference-strength-option {
  border-radius: 8px;
  text-align: center;
}

.content-reference-condition-guardrail {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 9px;
  border-radius: 8px;
  background: #ecfdf5;
  padding: 8px 9px;
  color: #047857;
  font-size: 9px;
  line-height: 1.5;
}

.content-reference-condition-guardrail.is-visual {
  background: #eff6ff;
  color: #1d4ed8;
}

@container wb-content (max-width: 1180px) {
  .content-reference-mode-grid {
    grid-template-columns: 1fr;
  }
}
.content-reference-recommendations {
  margin-top: 12px;
  border-top: 1px solid #ede9fe;
  padding-top: 12px;
}

.content-reference-recommendation-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.content-reference-recommendation-heading strong {
  color: #4c1d95;
  font-size: 10px;
}

.content-reference-recommendation-heading p {
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-reference-recommendation-heading > span {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #ede9fe;
  padding: 3px 7px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-recommendation-list {
  display: grid;
  gap: 11px;
  margin-top: 9px;
}

.content-reference-recommendation-group {
  min-width: 0;
}

.content-reference-recommendation-group-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  padding: 0 2px;
}

.content-reference-recommendation-group-heading strong,
.content-reference-recommendation-group-heading small {
  display: block;
}

.content-reference-recommendation-group-heading strong {
  color: #475569;
  font-size: 8.5px;
}

.content-reference-recommendation-group-heading small {
  margin-top: 1px;
  color: #94a3b8;
  font-size: 7.5px;
}

.content-reference-recommendation-group-heading > span {
  min-width: 18px;
  border-radius: 999px;
  background: #f1f5f9;
  padding: 2px 5px;
  color: #64748b;
  font-size: 7.5px;
  font-weight: 800;
  text-align: center;
}

.content-reference-recommendation-group-list {
  display: grid;
  gap: 7px;
}

.content-reference-recommendation-card {
  display: grid;
  min-width: 0;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #e9d5ff;
  border-radius: 9px;
  background: #fff;
  padding: 7px;
}

.content-reference-recommendation-preview-trigger,
.content-reference-recommendation-placeholder {
  width: 48px;
  height: 38px;
  border-radius: 7px;
  background: #f3e8ff;
}

.content-reference-recommendation-preview-trigger {
  position: relative;
  display: block;
  overflow: hidden;
  border: 0;
  padding: 0;
  cursor: zoom-in;
}

.content-reference-recommendation-preview-trigger img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 160ms ease;
}

.content-reference-recommendation-preview-trigger span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.58);
  color: #fff;
  font-size: 11px;
  opacity: 0;
  transition: opacity 160ms ease;
}

.content-reference-recommendation-preview-trigger:hover img,
.content-reference-recommendation-preview-trigger:focus-visible img {
  transform: scale(1.06);
}

.content-reference-recommendation-preview-trigger:hover span,
.content-reference-recommendation-preview-trigger:focus-visible span {
  opacity: 1;
}

.content-reference-recommendation-preview-trigger:focus-visible {
  outline: 2px solid #7c3aed;
  outline-offset: 2px;
}

.content-reference-recommendation-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b5cf6;
}

.content-reference-recommendation-card > div:not(.content-reference-recommendation-placeholder) {
  min-width: 0;
}

.content-reference-recommendation-card strong {
  display: block;
  color: #334155;
  font-size: 9px;
}

.content-reference-recommendation-card p {
  margin-top: 3px;
  color: #64748b;
  font-size: 8px;
}

.content-reference-recommendation-card p.content-reference-recommendation-reason {
  color: #7c3aed;
  font-size: 7.5px;
  font-weight: 700;
}

.content-reference-recommendation-apply,
.content-reference-recommendation-empty a,
.content-reference-recommendation-empty button {
  flex: 0 0 auto;
  border: 1px solid #c4b5fd;
  border-radius: 7px;
  background: #fff;
  padding: 5px 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 800;
}

.content-reference-recommendation-gallery-stage {
  position: relative;
  display: flex;
  min-height: 260px;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  overflow: auto;
  background: #020617;
  padding: 16px 64px;
}

.content-reference-recommendation-gallery-stage > img {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 74vh;
  border-radius: 8px;
  object-fit: contain;
}

.content-reference-recommendation-gallery-arrow {
  position: absolute;
  z-index: 1;
  top: 50%;
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  color: #fff;
  font-size: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  transform: translateY(-50%);
  transition: background 150ms ease, transform 150ms ease;
}

.content-reference-recommendation-gallery-arrow:hover,
.content-reference-recommendation-gallery-arrow:focus-visible {
  background: #7c3aed;
  transform: translateY(-50%) scale(1.05);
}

.content-reference-recommendation-gallery-arrow:focus-visible {
  outline: 2px solid #c4b5fd;
  outline-offset: 2px;
}

.content-reference-recommendation-gallery-arrow.is-previous {
  left: 12px;
}

.content-reference-recommendation-gallery-arrow.is-next {
  right: 12px;
}

@container wb-content (max-width: 640px) {
  .content-reference-recommendation-gallery-stage {
    padding: 12px 48px;
  }
  .content-reference-recommendation-gallery-arrow {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }
  .content-reference-recommendation-gallery-arrow.is-previous {
    left: 7px;
  }
  .content-reference-recommendation-gallery-arrow.is-next {
    right: 7px;
  }
}
.content-reference-recommendation-status,
.content-reference-recommendation-empty {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 9px;
  border-radius: 9px;
  background: #f5f3ff;
  padding: 9px;
  color: #6d28d9;
  font-size: 9px;
}

.content-reference-recommendation-empty {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
}

.content-reference-recommendation-empty strong,
.content-reference-recommendation-empty p {
  grid-column: 1;
}

.content-reference-recommendation-empty p {
  margin-top: 2px;
  color: #64748b;
  line-height: 1.45;
}

.content-reference-recommendation-empty a,
.content-reference-recommendation-empty button {
  grid-column: 2;
  grid-row: 1/span 2;
  align-self: center;
}

.content-reference-recommendation-empty.is-error {
  background: #fff1f2;
  color: #be123c;
}

.content-field {
  margin-top: 14px;
}

.content-field:first-of-type {
  margin-top: 0;
}

.content-field-label,
.content-field-row label,
.content-field-row span:first-child {
  display: block;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.content-field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.content-model-status,
.content-auto-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #ecfdf5;
  padding: 3px 7px;
  color: #047857;
  font-size: 9px;
  font-weight: 800;
}

.content-auto-badge.is-manual {
  background: #eff6ff;
  color: #1d4ed8;
}

.content-auto-badge.is-warning {
  background: #fff7ed;
  color: #c2410c;
}

.content-select-wrap {
  position: relative;
  margin-top: 8px;
}

.content-select-wrap select {
  width: 100%;
  min-height: 42px;
  appearance: none;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 8px 34px 8px 11px;
  color: #243244;
  font-size: 11px;
  font-weight: 700;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.content-select-wrap select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.13);
}

.content-select-wrap > i {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #94a3b8;
  font-size: 9px;
  pointer-events: none;
  transform: translateY(-50%);
}

.content-selected-patient-code {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 9px;
  color: #64748b;
  font-size: 9px;
}

.content-selected-patient-code > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-source-mode {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
  margin-top: 8px;
  border: 1px solid #dbe4ee;
  border-radius: 10px;
  background: #f1f5f9;
  padding: 4px;
}

.content-source-mode button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 7px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  transition: background-color 150ms ease, color 150ms ease, box-shadow 150ms ease;
}

.content-source-mode button:hover {
  color: #1d4ed8;
}

.content-source-mode button:focus-visible,
.content-memory-toggle button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-source-mode button.is-active {
  border-color: #dbeafe;
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.11);
}

.content-source-label {
  display: block;
  margin-top: 14px;
}

.content-memory-toggle {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
  margin-top: 10px;
}

.content-memory-toggle button {
  min-height: 34px;
  border: 1px solid #dbe4ee;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.content-memory-toggle button.is-active.is-trauma {
  border-color: #f5c56e;
  background: #fffbeb;
  color: #92400e;
}

.content-memory-toggle button.is-active.is-positive {
  border-color: #86d8bc;
  background: #ecfdf5;
  color: #047857;
}

.content-selected-scenario {
  margin-top: 10px;
  border: 1px solid #dbeafe;
  border-radius: 9px;
  background: #f8fbff;
  padding: 10px;
}

.content-selected-scenario span,
.content-selected-scenario strong {
  display: block;
}

.content-selected-scenario span {
  color: #2563eb;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.content-selected-scenario strong {
  margin-top: 3px;
  color: #172033;
  font-size: 11px;
}

.content-selected-scenario p {
  margin-top: 7px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.5;
}

.content-analysis-complete-badge {
  display: inline-flex !important;
  width: fit-content;
  margin-top: 8px;
  border-radius: 999px;
  background: #dcfce7;
  padding: 4px 7px;
  color: #15803d !important;
  font-size: 8px !important;
}

.content-analysis-demo-badge {
  display: inline-flex !important;
  width: fit-content;
  margin-top: 8px;
  border-radius: 999px;
  background: #dbeafe;
  padding: 4px 7px;
  color: #1d4ed8 !important;
  font-size: 8px !important;
}

.content-analysis-pending-badge {
  display: inline-flex !important;
  width: fit-content;
  margin-top: 8px;
  border-radius: 999px;
  background: #fef3c7;
  padding: 4px 7px;
  color: #92400e !important;
  font-size: 8px !important;
}

.content-scenario-analysis {
  margin-top: 12px;
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8faff 0, #fff 180px);
  padding: 12px;
}

.content-scenario-analysis-header {
  display: grid;
  gap: 10px;
}

.content-scenario-analysis-header h3 {
  margin-top: 2px;
  color: #172033;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.4;
}

.content-scenario-analysis-header p {
  margin-top: 4px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.55;
}

.content-analysis-button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #4338ca;
  border-radius: 9px;
  background: #4f46e5;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  box-shadow: 0 7px 16px rgba(79, 70, 229, 0.16);
}

.content-analysis-button:hover:not(:disabled) {
  background: #4338ca;
}

.content-analysis-button:disabled {
  cursor: wait;
  opacity: 0.72;
}

.content-analysis-empty,
.content-analysis-loading,
.content-analysis-error {
  display: flex;
  gap: 8px;
  margin-top: 11px;
  border-radius: 9px;
  padding: 10px;
  font-size: 9px;
  line-height: 1.55;
}

.content-analysis-empty {
  background: #eef2ff;
  color: #475569;
}

.content-analysis-empty i {
  margin-top: 2px;
  color: #4f46e5;
}

.content-analysis-loading {
  align-items: center;
  background: #eff6ff;
  color: #1e3a8a;
}

.content-analysis-loading strong,
.content-analysis-loading p {
  display: block;
}

.content-analysis-loading p {
  margin-top: 2px;
  color: #64748b;
}

.content-analysis-loader {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  border: 2px solid #bfdbfe;
  border-top-color: #2563eb;
  border-radius: 999px;
  animation: content-analysis-spin 0.8s linear infinite;
}

.content-analysis-progress-panel {
  margin-top: 8px;
  border-radius: 9px;
  background: #eff6ff;
  padding: 9px 10px 11px;
}

.content-analysis-progress-panel .wb-new-analysis-progress-meta {
  color: #1e4f99;
}

.content-analysis-progress-panel .wb-new-analysis-progress-track {
  background: #d8e7fb;
}

.content-analysis-error {
  background: #fef2f2;
  color: #b91c1c;
}

@keyframes content-analysis-spin {
  to {
    transform: rotate(360deg);
  }
}
.content-analysis-result {
  margin-top: 12px;
}

.content-console-analysis-summary {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 9px 10px;
  align-items: center;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 10px;
}

.content-console-analysis-icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #dbeafe;
  color: #2563eb;
  font-size: 13px;
}

.content-console-analysis-summary strong {
  display: block;
  color: #172033;
  font-size: 10px;
  font-weight: 850;
}

.content-console-analysis-summary p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-console-analysis-sfr {
  display: inline-flex;
  width: fit-content;
  min-height: 23px;
  grid-column: 1/-1;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #fff7ed;
  padding: 0 8px;
  color: #9a3412;
  font-size: 8px;
  font-weight: 850;
}

.content-console-analysis-sfr.is-ready {
  background: #dcfce7;
  color: #047857;
}

.is-scenario-console .content-scenario-analysis .content-analysis-meta,
.is-scenario-console .content-scenario-analysis .content-analysis-flow,
.is-scenario-console .content-scenario-analysis .content-analysis-triggers,
.is-scenario-console .content-scenario-analysis .content-analysis-cuts,
.is-scenario-console .content-scenario-analysis .content-continuity-history,
.is-scenario-console .content-scenario-analysis .content-analysis-disclaimer {
  display: none;
}

.is-scenario-console .content-scenario-analysis {
  margin-top: 10px;
  border-color: #dbeafe;
  background: #fff;
  padding: 10px;
}

.is-scenario-console .content-scenario-analysis-header {
  gap: 8px;
}

.is-scenario-console .content-scenario-analysis-header p {
  display: none;
}

.is-scenario-console .content-analysis-button {
  min-height: 34px;
  border-color: #c7d2fe;
  background: #eef2ff;
  color: #4338ca;
  box-shadow: none;
}

.is-scenario-console .content-analysis-button:hover:not(:disabled) {
  background: #e0e7ff;
}

.content-analysis-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.content-analysis-meta span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  background: #eef2ff;
  padding: 4px 7px;
  color: #4338ca;
  font-size: 8px;
  font-weight: 800;
}

.content-analysis-flow,
.content-analysis-triggers,
.content-analysis-cuts {
  margin-top: 14px;
}

.content-analysis-section-title {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 8px;
}

.content-analysis-section-title span,
.content-analysis-section-title strong {
  display: block;
}

.content-analysis-section-title span {
  color: #6366f1;
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.07em;
}

.content-analysis-section-title strong {
  margin-top: 2px;
  color: #172033;
  font-size: 11px;
  font-weight: 900;
}

.content-analysis-section-title small {
  color: #94a3b8;
  font-size: 8px;
  font-weight: 800;
}

.content-analysis-flow-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.content-analysis-flow-list li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #334155;
  font-size: 9px;
  font-weight: 800;
}

.content-analysis-flow-list li span {
  border: 1px solid #dbeafe;
  border-radius: 7px;
  background: #fff;
  padding: 5px 7px;
}

.content-analysis-flow-list li i {
  color: #94a3b8;
  font-size: 7px;
}

.content-analysis-trigger-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.content-analysis-trigger-chips span {
  border-radius: 999px;
  background: #fff7ed;
  padding: 5px 8px;
  color: #9a3412;
  font-size: 8px;
  font-weight: 800;
}

.content-analysis-cut {
  margin-top: 7px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.content-analysis-cut.is-selected {
  border-color: #0f766e;
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.1);
}

.content-analysis-cut.is-selected .content-analysis-cut-number {
  background: #0f766e;
}

.content-analysis-cut summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  padding: 9px;
  cursor: pointer;
  list-style: none;
}

.content-analysis-cut summary::-webkit-details-marker {
  display: none;
}

.content-analysis-cut-number {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #4f46e5;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
}

.content-analysis-cut-heading {
  min-width: 0;
}

.content-analysis-cut-heading strong,
.content-analysis-cut-heading small {
  display: block;
}

.content-analysis-cut-heading strong {
  overflow: hidden;
  color: #172033;
  font-size: 9px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-analysis-cut-heading small {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
}

.content-analysis-cut-confidence {
  border-radius: 999px;
  background: #ecfdf5;
  padding: 3px 5px;
  color: #047857;
  font-size: 7px;
  font-weight: 900;
}

.content-analysis-cut-confidence.needs-review {
  background: #fffbeb;
  color: #b45309;
}

.content-analysis-cut summary > i {
  color: #94a3b8;
  font-size: 8px;
  transition: transform 0.16s ease;
}

.content-analysis-cut[open] summary > i {
  transform: rotate(180deg);
}

.content-analysis-cut-body {
  border-top: 1px solid #eef2f7;
  padding: 10px;
}

.content-analysis-event {
  color: #334155;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.6;
}

.content-analysis-visual-grid,
.content-analysis-production-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 9px;
}

.content-analysis-visual-grid > div,
.content-analysis-production-grid > div {
  border-radius: 8px;
  background: #f8fafc;
  padding: 8px;
}

.content-analysis-visual-grid span,
.content-analysis-production-grid span {
  display: block;
  color: #6366f1;
  font-size: 7px;
  font-weight: 900;
}

.content-analysis-visual-grid p,
.content-analysis-production-grid p {
  margin-top: 3px;
  color: #475569;
  font-size: 8px;
  line-height: 1.5;
}

.content-analysis-evidence {
  display: flex;
  gap: 5px;
  margin-top: 9px;
  color: #64748b;
  font-size: 7px;
  line-height: 1.5;
}

.content-analysis-cut-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  border-top: 1px solid #eef2f7;
  padding-top: 9px;
}

.content-analysis-cut-action > div {
  min-width: 0;
}

.content-analysis-cut-action strong,
.content-analysis-cut-action small {
  display: block;
}

.content-analysis-cut-action strong {
  color: #172033;
  font-size: 8px;
  font-weight: 900;
}

.content-analysis-cut-action small {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
  line-height: 1.45;
}

.content-analysis-cut-action button {
  display: inline-flex;
  min-height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #99f6e4;
  border-radius: 8px;
  background: #f0fdfa;
  padding: 6px 9px;
  color: #0f766e;
  font-size: 8px;
  font-weight: 900;
}

.content-analysis-cut-action button.is-selected {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}

.content-analysis-cut-action button:disabled {
  cursor: not-allowed;
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #94a3b8;
}

.content-continuity-history {
  margin-top: 12px;
  border: 1px solid #a7f3d0;
  border-radius: 12px;
  background: #f0fdf8;
  padding: 11px;
}

.content-continuity-history-note {
  margin-top: 7px;
  color: #3f5f58;
  font-size: 8px;
  line-height: 1.55;
}

.content-continuity-history-list {
  display: grid;
  gap: 6px;
  margin-top: 9px;
}

.content-continuity-history-row {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #d1fae5;
  border-radius: 9px;
  background: #fff;
  padding: 6px;
}

.content-continuity-history-row.is-master {
  border-color: #34d399;
}

.content-continuity-history-thumb {
  display: flex;
  width: 38px;
  height: 30px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 0;
  border-radius: 6px;
  background: #e2e8f0;
  padding: 0;
  color: #64748b;
}

.content-continuity-history-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-continuity-history-row > div span,
.content-continuity-history-row > div strong,
.content-continuity-history-row > div small {
  display: block;
}

.content-continuity-history-row > div span {
  color: #0f766e;
  font-size: 7px;
  font-weight: 900;
}

.content-continuity-history-row > div strong {
  margin-top: 1px;
  overflow: hidden;
  color: #172033;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-continuity-history-row > div small {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
}

.content-continuity-master-badge,
.content-continuity-score {
  border-radius: 999px;
  background: #dcfce7;
  padding: 4px 6px;
  color: #166534;
  font-size: 7px;
  font-weight: 900;
  white-space: nowrap;
}

.content-continuity-score {
  background: #eff6ff;
  color: #1d4ed8;
}

.content-analysis-disclaimer {
  margin-top: 10px;
  border-top: 1px dashed #cbd5e1;
  padding-top: 9px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.5;
}

.content-patient-setup-alert {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 9px;
  margin-top: 10px;
  border: 1px solid #fbbf24;
  border-radius: 9px;
  background: #fffbeb;
  padding: 10px;
  color: #92400e;
}

.content-patient-setup-alert > i {
  margin-top: 2px;
  color: #d97706;
  font-size: 12px;
}

.content-patient-setup-alert strong {
  display: block;
  font-size: 10px;
  font-weight: 800;
}

.content-patient-setup-alert p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-patient-setup-alert a {
  display: inline-block;
  margin-top: 6px;
  border-radius: 6px;
  background: #fff;
  padding: 5px 7px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-prompt-selector {
  margin-top: 14px;
  border-top: 1px solid #edf1f5;
  padding-top: 14px;
}

.content-prompt-selection-summary {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  border-left: 2px solid #2563eb;
  padding: 4px 0 4px 9px;
}

.content-prompt-selection-summary > div {
  min-width: 0;
}

.content-prompt-selection-summary span {
  display: block;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 700;
}

.content-prompt-selection-summary > span {
  max-width: 45%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-prompt-selection-summary strong {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #1e3a8a;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-prompt-warning {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 8px;
  margin-top: 10px;
  border: 1px solid #fed7aa;
  border-radius: 9px;
  background: #fff7ed;
  padding: 9px;
  color: #9a3412;
}

.content-prompt-warning > i {
  margin-top: 2px;
  font-size: 10px;
}

.content-prompt-warning strong {
  display: block;
  font-size: 10px;
}

.content-prompt-warning p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-prompt-warning button {
  margin-top: 6px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #1d4ed8;
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
}

.content-prompt-preview {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 9px;
  background: #fff;
}

.content-prompt-preview > summary {
  display: flex;
  min-height: 38px;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  color: #334155;
  font-size: 10px;
}

.content-prompt-preview > summary::-webkit-details-marker {
  display: none;
}

.content-prompt-preview > summary span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.content-prompt-preview > summary > i {
  color: #94a3b8;
  font-size: 8px;
  transition: transform 150ms ease;
}

.content-prompt-preview[open] > summary > i {
  transform: rotate(180deg);
}

.content-prompt-preview-body {
  display: grid;
  gap: 8px;
  border-top: 1px solid #edf1f5;
  background: #f8fafc;
  padding: 9px;
}

.content-prompt-layer {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.content-prompt-layer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 7px;
  color: #475569;
}

.content-prompt-layer-header strong,
.content-prompt-layer-header span {
  display: block;
}

.content-prompt-layer-header strong {
  color: #1e293b;
  font-size: 9px;
}

.content-prompt-layer-header span {
  margin-top: 1px;
  color: #94a3b8;
  font-size: 8px;
}

.content-prompt-layer > label {
  display: block;
  margin-top: 7px;
  color: #64748b;
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
}

.content-prompt-readonly {
  max-height: 82px;
  overflow: auto;
  margin-top: 3px;
  border-radius: 6px;
  background: #f8fafc;
  padding: 7px;
  color: #475569;
  font-size: 9px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.content-prompt-language-note {
  border-radius: 6px;
  background: #eff6ff;
  padding: 7px 8px;
  color: #1e40af;
  font-size: 8px;
  line-height: 1.5;
}

.content-mapped-scenario {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  border-left: 2px solid #10b981;
  padding: 7px 0 7px 10px;
}

.content-mapped-scenario > div {
  min-width: 0;
}

.content-mapped-scenario > div span {
  display: block;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-mapped-scenario strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #334155;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-mapped-scenario > p {
  grid-column: 1/-1;
  color: #64748b;
  font-size: 9px;
  line-height: 1.5;
}

.content-inline-warning {
  margin-top: 10px;
  border-radius: 8px;
  background: #fffbeb;
  padding: 9px 10px;
  color: #92400e;
  font-size: 10px;
  line-height: 1.5;
}

.content-inline-warning a {
  display: inline-block;
  margin-top: 4px;
  color: #1d4ed8;
  font-weight: 700;
}

.intensity-help > summary {
  display: inline-flex;
  cursor: pointer;
  list-style: none;
  align-items: center;
  gap: 7px;
  border-radius: 6px;
  color: #334155;
  font-size: 11px;
  font-weight: 800;
  outline: none;
}

.intensity-help > summary::-webkit-details-marker {
  display: none;
}

.intensity-help > summary i {
  color: #64748b;
  font-size: 12px;
}

.intensity-help > summary:focus-visible {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);
}

.content-intensity-popover {
  position: absolute;
  z-index: 10;
  top: 47px;
  right: 14px;
  width: min(245px, 100% - 28px);
  border: 1px solid #d7dee8;
  border-radius: 9px;
  background: #fff;
  padding: 12px 30px 12px 12px;
  color: #475569;
  font-size: 10px;
  line-height: 1.55;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.13);
}

.content-intensity-popover button {
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #94a3b8;
}

.content-intensity-steps {
  margin-top: 17px;
}

.content-intensity-presets {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
  margin-top: 17px;
}

.content-intensity-presets button {
  display: flex;
  min-width: 0;
  min-height: 44px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  border: 1px solid #dbe3ec;
  border-radius: 9px;
  background: #fff;
  color: #64748b;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

.content-intensity-presets button:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.content-intensity-presets button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-intensity-presets button.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px #2563eb;
}

.content-intensity-presets strong {
  font-size: 11px;
  font-weight: 800;
}

.content-intensity-presets small {
  font-size: 8px;
  font-weight: 700;
}

.content-intensity-steps input {
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: #dbe3ec;
  accent-color: #2563eb;
  cursor: pointer;
}

.content-intensity-steps input::-webkit-slider-thumb {
  width: 19px;
  height: 19px;
  appearance: none;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 2px 7px rgba(37, 99, 235, 0.28);
}

.content-intensity-steps input::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 2px 7px rgba(37, 99, 235, 0.28);
}

.content-intensity-labels {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 9px;
}

.content-intensity-labels output {
  color: #2563eb;
  font-size: 10px;
  font-weight: 800;
}

.content-field-help {
  margin-top: 8px;
  color: #64748b;
  font-size: 9px;
}

.content-inline-info {
  margin-top: 8px;
  border-radius: 8px;
  background: #eff6ff;
  padding: 8px 9px;
  color: #1d4ed8;
  font-size: 9px;
  line-height: 1.5;
}

.content-scope-toggle {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  margin-top: 8px;
  border-radius: 9px;
  background: #f1f5f9;
  padding: 4px;
}

.content-scope-toggle button {
  min-height: 34px;
  border-radius: 7px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.content-scope-toggle button.is-active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.12);
}

.content-readonly-field {
  margin-top: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
  padding: 11px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.content-image-model-profile {
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  padding: 12px;
}

.content-image-model-profile > header {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.content-image-model-profile-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
}

.content-image-model-profile > header > div {
  min-width: 0;
}

.content-image-model-profile > header span:not(.content-image-model-profile-icon) {
  display: block;
  color: #2563eb;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.content-image-model-profile > header strong {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #172033;
  font-size: 11px;
  font-weight: 850;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-image-model-profile-summary {
  margin-top: 9px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.55;
}

.content-image-model-profile-settings {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.content-image-model-profile-settings span {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  gap: 5px;
  border: 1px solid #dbe3ec;
  border-radius: 7px;
  background: #fff;
  padding: 4px 7px;
  color: #334155;
  font-size: 8px;
  font-weight: 750;
  line-height: 1.3;
}

.content-image-model-profile-settings i {
  color: #22c55e;
  font-size: 7px;
}

.content-image-model-profile-rule {
  display: flex;
  gap: 7px;
  margin-top: 10px;
  border-top: 1px solid #e2e8f0;
  padding-top: 9px;
  color: #1e40af;
  font-size: 8px;
  line-height: 1.5;
}

.content-image-model-profile-rule i {
  margin-top: 2px;
  color: #2563eb;
}

.content-continuity-source-card {
  margin-top: 8px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  background: linear-gradient(145deg, #ffffff 0%, #f5f9ff 100%);
  padding: 10px;
}

.content-continuity-source-head {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.content-continuity-source-preview {
  position: relative;
  width: 48px;
  height: 48px;
  overflow: hidden;
  border-radius: 9px;
  background: #e2e8f0;
}

.content-continuity-source-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-continuity-source-preview > span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.5);
  color: #fff;
  opacity: 0;
  transition: opacity 140ms ease;
}

.content-continuity-source-preview:hover > span,
.content-continuity-source-preview:focus-visible > span {
  opacity: 1;
}

.content-continuity-source-copy {
  min-width: 0;
}

.content-continuity-source-copy > span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #2563eb;
  font-size: 8px;
  font-weight: 850;
}

.content-continuity-source-copy strong {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #27344a;
  font-size: 10px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-continuity-source-copy p {
  margin-top: 3px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.45;
}

.content-continuity-keep-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 9px;
  border-top: 1px solid #dbeafe;
  padding-top: 9px;
}

.content-continuity-keep-list span {
  border-radius: 999px;
  background: #eaf2ff;
  padding: 3px 6px;
  color: #1d4ed8;
  font-size: 8px;
  font-weight: 750;
}

.content-continuity-source-remove {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 5px;
  margin-top: 9px;
  border-radius: 7px;
  background: #fff;
  padding: 0 8px;
  color: #64748b;
  font-size: 8px;
  font-weight: 800;
  box-shadow: inset 0 0 0 1px #dbe3ec;
}

.content-continuity-source-remove:hover {
  background: #fff7f7;
  color: #dc2626;
  box-shadow: inset 0 0 0 1px #fecaca;
}

.content-continuity-source-note {
  display: flex;
  gap: 6px;
  margin-top: 7px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.5;
}

.content-continuity-source-note i {
  margin-top: 2px;
  color: #3b82f6;
}

.content-candidate-note {
  margin-top: 9px;
  border-radius: 8px;
  background: #eff6ff;
  padding: 9px 10px;
  color: #1e40af;
  font-size: 9px;
  line-height: 1.5;
}

.content-candidate-note strong {
  display: block;
  font-size: 10px;
}

.content-video-settings {
  display: grid;
  gap: 14px;
  margin-top: 14px;
}

.content-video-settings > .content-field {
  margin-top: 0;
}

.content-source-summary {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 8px;
  border: 1px solid #dbeafe;
  border-radius: 9px;
  background: #f7fbff;
  padding: 8px;
}

.content-source-summary img {
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  border-radius: 6px;
  object-fit: cover;
}

.content-source-summary div {
  min-width: 0;
}

.content-source-summary strong {
  display: block;
  overflow: hidden;
  color: #334155;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-source-summary button {
  margin-top: 3px;
  color: #2563eb;
  font-size: 9px;
  font-weight: 700;
}

.content-source-summary .content-source-image-preview {
  position: relative;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  overflow: hidden;
  margin-top: 0;
  border-radius: 6px;
  color: #fff;
}

.content-source-summary .content-source-image-preview img {
  width: 100%;
  height: 100%;
}

.content-source-image-preview > span,
.content-video-source-preview > span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 140ms ease;
}

.content-source-image-preview:hover > span,
.content-source-image-preview:focus-visible > span,
.content-video-source-preview:hover > span,
.content-video-source-preview:focus-visible > span {
  opacity: 1;
}

.content-source-image-preview:focus-visible,
.content-video-source-preview:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-video-source-roster {
  display: grid;
  gap: 6px;
  margin-top: 8px;
}

.content-video-source-roster li {
  display: grid;
  min-height: 42px;
  grid-template-columns: 42px 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 5px 7px;
  color: #94a3b8;
  font-size: 9px;
}

.content-video-source-roster li.is-ready {
  border-style: solid;
  border-color: #bfdbfe;
  background: #f8fbff;
  color: #334155;
}

.content-video-source-roster img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  object-fit: cover;
}

.content-video-source-roster strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-video-source-roster button {
  color: #dc2626;
  font-weight: 800;
}

.content-video-source-roster .content-video-source-preview {
  position: relative;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 5px;
  color: #fff;
}

.content-video-source-roster .content-video-source-preview img {
  width: 100%;
  height: 100%;
}

.content-source-image-preview:disabled,
.content-video-source-preview:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.content-dashed-button {
  width: 100%;
  min-height: 39px;
  margin-top: 8px;
  border: 1px dashed #93c5fd;
  border-radius: 8px;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 700;
}

.content-cost-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 15px;
  border-top: 1px solid #edf1f5;
  padding-top: 13px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.content-cost-row strong {
  color: #172033;
  font-size: 13px;
}

.content-job-status {
  margin-top: 13px;
  border-radius: 9px;
  background: #eff6ff;
  padding: 10px;
}

.content-job-status > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #1e3a8a;
  font-size: 9px;
}

.content-job-status strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-progress-track {
  height: 5px;
  overflow: hidden;
  margin-top: 8px;
  border-radius: 999px;
  background: #dbeafe;
}

.content-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2563eb;
}

.content-job-status button {
  margin-top: 7px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 700;
}

.content-intensity-batch-status {
  margin-top: 13px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 11px;
}

.content-intensity-batch-header,
.content-intensity-batch-header > div,
.content-intensity-batch-rows li,
.content-intensity-batch-actions {
  display: flex;
  align-items: center;
}

.content-intensity-batch-header {
  justify-content: space-between;
  gap: 8px;
  color: #64748b;
  font-size: 9px;
}

.content-intensity-batch-header > div {
  gap: 7px;
}

.content-intensity-batch-header strong {
  color: #1d4ed8;
  font-size: 12px;
}

.content-intensity-batch-rows {
  display: grid;
  gap: 5px;
  margin-top: 10px;
}

.content-intensity-batch-rows li {
  display: grid;
  grid-template-columns: 42px 1fr auto auto;
  gap: 6px;
  color: #64748b;
  font-size: 9px;
}

.content-intensity-batch-rows strong {
  color: #334155;
}

.content-intensity-batch-rows em {
  color: #dc2626;
  font-style: normal;
  font-weight: 700;
}

.content-intensity-batch-rows small {
  color: #1d4ed8;
  font-weight: 800;
}

.content-intensity-batch-actions {
  gap: 7px;
  margin-top: 10px;
}

.content-intensity-batch-actions button {
  min-height: 32px;
  flex: 1;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #fff;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-intensity-batch-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.content-generate-button {
  display: inline-flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  border-radius: 9px;
  background: #1d4ed8;
  padding: 0 12px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.17);
}

.content-generate-button:hover {
  background: #1e40af;
}

.content-generate-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.is-scenario-console .content-generate-button {
  position: sticky;
  z-index: 4;
  bottom: 0;
  min-height: 50px;
  margin-top: 14px;
  border: 5px solid #fff;
  border-radius: 13px;
  background: #1d4ed8;
  font-size: 12px;
  box-shadow: 0 -8px 18px rgba(255, 255, 255, 0.92), 0 8px 18px rgba(29, 78, 216, 0.2);
}

.content-cut-inspector {
  margin: 14px 20px 0;
  overflow: hidden;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
}

.content-cut-inspector-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e8edf3;
  padding: 14px 16px;
}

.content-cut-inspector-title > span {
  color: #2563eb;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.04em;
}

.content-cut-inspector-title h3 {
  margin-top: 3px;
  color: #111827;
  font-size: 16px;
  font-weight: 900;
}

.content-cut-inspector-title p {
  margin-top: 4px;
  color: #64748b;
  font-size: 10px;
}

.content-cut-inspector-nav {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}

.content-cut-inspector-nav button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 10px;
}

.content-cut-inspector-nav button:hover:not(:disabled) {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-cut-inspector-nav button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.content-cut-inspector-nav span {
  min-width: 42px;
  color: #64748b;
  font-size: 10px;
  font-weight: 850;
  text-align: center;
}

.content-cut-inspector-event {
  margin: 14px 16px 0;
  border-left: 3px solid #2563eb;
  background: #f8fafc;
  padding: 10px 12px;
}

.content-cut-inspector-event strong {
  display: block;
  color: #2563eb;
  font-size: 9px;
  font-weight: 850;
}

.content-cut-inspector-event p {
  margin-top: 5px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.6;
}

.content-cut-inspector-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin: 14px 16px 0;
  overflow: hidden;
  border: 1px solid #e8edf3;
  border-radius: 10px;
}

.content-cut-inspector-grid > div {
  min-width: 0;
  border-right: 1px solid #e8edf3;
  border-bottom: 1px solid #e8edf3;
  padding: 11px 12px;
}

.content-cut-inspector-grid > div:nth-child(2n) {
  border-right: 0;
}

.content-cut-inspector-grid > div.is-wide {
  grid-column: 1/-1;
  border-right: 0;
}

.content-cut-inspector-grid > div.is-wide:last-child {
  border-bottom: 0;
}

.content-cut-inspector-grid dt {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2563eb;
  font-size: 9px;
  font-weight: 850;
}

.content-cut-inspector-grid dt i {
  width: 12px;
  text-align: center;
}

.content-cut-inspector-grid dd {
  margin-top: 6px;
  color: #475569;
  font-size: 10px;
  line-height: 1.55;
}

.content-cut-inspector-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px 13px;
  color: #64748b;
  font-size: 9px;
}

.content-cut-inspector-footer > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.content-cut-inspector-footer .content-cut-console-status {
  flex: 0 0 auto;
  margin-top: 0;
}

.content-cut-console-item:focus-visible,
.content-cut-inspector-nav button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-preview-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.content-panorama-entry small {
  display: inline-flex;
  min-height: 18px;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  padding: 0 6px;
  font-size: 9px;
  letter-spacing: 0.02em;
}

.content-thumbnail-panorama-check {
  position: absolute;
  z-index: 3;
  top: 8px;
  right: 36px;
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  gap: 3px;
  padding: 0 6px;
  font-size: 9px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.24);
}

.content-thumbnail-panorama-check small {
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
}

.content-panorama-summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin: 16px 20px 0;
  border: 1px solid #bfdbfe;
  border-radius: 11px;
  background: #f8fbff;
  padding: 12px;
}

.content-panorama-result-list {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
}

.content-panorama-result-card {
  display: flex;
  min-width: 0;
  overflow: hidden;
  flex-direction: column;
  border: 1px solid #dbeafe;
  border-radius: 9px;
  background: #fff;
  text-align: left;
}

.content-panorama-result-card:hover {
  border-color: #60a5fa;
  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.1);
}

.content-panorama-result-card.is-video-source {
  border-color: #34d399;
  box-shadow: 0 0 0 1px #34d399;
}

.content-panorama-result-image {
  display: flex;
  aspect-ratio: 2/1;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #0f172a;
  color: #93c5fd;
}

.content-panorama-result-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-panorama-result-label {
  display: flex;
  min-width: 0;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 8px;
}

.content-panorama-result-label strong,
.content-panorama-result-label small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-panorama-result-label strong {
  color: #1e293b;
  font-size: 9px;
  font-weight: 800;
}

.content-panorama-result-label small {
  color: #64748b;
  font-size: 8px;
}

.content-panorama-summary-preview {
  position: relative;
  aspect-ratio: 2/1;
  overflow: hidden;
  border-radius: 8px;
  background: #0f172a;
}

.content-panorama-summary-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-panorama-summary-preview span {
  position: absolute;
  top: 7px;
  left: 7px;
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.76);
  padding: 3px 7px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-summary-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 9px;
}

.content-panorama-summary-kicker {
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.content-panorama-summary-copy h3 {
  margin-top: 2px;
  color: #172033;
  font-size: 13px;
  font-weight: 800;
}

.content-panorama-summary-copy p {
  margin-top: 3px;
  color: #64748b;
  font-size: 10px;
}

.content-panorama-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.content-panorama-badges span {
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #fff;
  padding: 3px 7px;
  color: #475569;
  font-size: 9px;
  font-weight: 700;
}

.content-panorama-summary-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.content-reference-adherence {
  margin: 16px 20px 0;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 11px;
  background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
}

.content-shot-consistency {
  border-color: #bae6fd;
  background: linear-gradient(135deg, #fff 0%, #f0f9ff 100%);
}

.content-shot-consistency .content-reference-adherence-kicker {
  color: #0369a1;
}

.content-shot-consistency .content-reference-adherence-metrics {
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
}

.content-shot-consistency .content-reference-adherence-total em {
  margin-top: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  padding: 2px 7px;
  color: currentColor;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.content-shot-consistency .content-reference-adherence-metrics > div.is-below-threshold {
  background: #fff7ed;
}

.content-shot-consistency .content-reference-adherence-metrics > div.is-expected-change {
  background: #eff6ff;
}

.content-shot-consistency .content-reference-adherence-metrics dt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.content-shot-consistency .content-reference-adherence-metrics dt i,
.content-shot-consistency .content-reference-adherence-metrics > div.is-below-threshold dd,
.content-shot-consistency .content-reference-adherence-metrics > div.is-below-threshold small {
  color: #c2410c;
}

.content-shot-consistency .content-reference-adherence-metrics > div.is-expected-change dd,
.content-shot-consistency .content-reference-adherence-metrics > div.is-expected-change small {
  color: #1d4ed8;
}

.content-shot-consistency .content-reference-adherence-metrics small {
  margin-top: 3px;
  font-size: 8px;
  font-weight: 750;
}

.content-shot-consistency-pass {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 14px 12px;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  background: #f0fdf4;
  padding: 9px 10px;
  color: #15803d;
  font-size: 10px;
  font-weight: 750;
}

.content-reference-adherence-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 14px;
}

.content-reference-adherence-header > div {
  min-width: 0;
}

.content-reference-adherence-kicker {
  color: #6366f1;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.content-reference-adherence-header h3 {
  margin-top: 2px;
  color: #172033;
  font-size: 13px;
  font-weight: 800;
}

.content-reference-adherence-header p {
  overflow: hidden;
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-reference-adherence-action {
  display: inline-flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  background: #eef2ff;
  padding: 0 11px;
  color: #4338ca;
  font-size: 10px;
  font-weight: 800;
}

.content-reference-adherence-action:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.content-reference-adherence-summary {
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  align-items: stretch;
  gap: 12px;
  padding: 13px 14px 10px;
}

.content-reference-adherence-total {
  display: flex;
  min-height: 82px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
}

.content-reference-adherence-total strong {
  color: #334155;
  font-size: 22px;
  font-weight: 900;
}

.content-reference-adherence-total span {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
  font-weight: 700;
}

.content-reference-adherence-total.is-passed {
  border-color: #86efac;
  background: #f0fdf4;
}

.content-reference-adherence-total.is-passed strong {
  color: #15803d;
}

.content-reference-adherence-total.is-warning {
  border-color: #fde68a;
  background: #fffbeb;
}

.content-reference-adherence-total.is-warning strong {
  color: #a16207;
}

.content-reference-adherence-total.is-failed {
  border-color: #fecaca;
  background: #fef2f2;
}

.content-reference-adherence-total.is-failed strong {
  color: #dc2626;
}

.content-reference-adherence-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.content-reference-adherence-metrics > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #e2e8f0;
  padding: 11px;
}

.content-reference-adherence-metrics > div:last-child {
  border-right: 0;
}

.content-reference-adherence-metrics dt {
  color: #64748b;
  font-size: 9px;
  font-weight: 700;
}

.content-reference-adherence-metrics dd {
  margin-top: 5px;
  color: #1e293b;
  font-size: 14px;
  font-weight: 900;
}

.content-reference-adherence-status {
  display: inline-flex;
  border-radius: 999px;
  background: #f1f5f9;
  padding: 4px 7px;
  color: #475569;
  font-size: 9px;
}

.content-reference-adherence-status.is-passed {
  background: #dcfce7;
  color: #166534;
}

.content-reference-adherence-status.is-warning {
  background: #fef3c7;
  color: #92400e;
}

.content-reference-adherence-status.is-failed {
  background: #fee2e2;
  color: #991b1b;
}

.content-reference-adherence-role-scores {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 14px 10px;
}

.content-reference-adherence-role-scores span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  padding: 5px 8px;
  color: #1e3a8a;
  font-size: 9px;
}

.content-reference-adherence-role-scores em {
  color: #2563eb;
  font-style: normal;
  font-weight: 900;
}

.content-reference-adherence-policy,
.content-reference-adherence-warnings,
.content-reference-adherence-comparison,
.content-reference-adherence-empty,
.content-reference-adherence-error {
  margin: 0 14px 12px;
}

.content-reference-adherence-policy {
  display: flex;
  gap: 7px;
  border-radius: 8px;
  background: #eef2ff;
  padding: 8px 10px;
  color: #4338ca;
  font-size: 9px;
  line-height: 1.55;
}

.content-reference-adherence-policy i {
  margin-top: 2px;
}

.content-reference-adherence-warnings {
  display: grid;
  gap: 5px;
}

.content-reference-adherence-warnings li {
  display: flex;
  gap: 7px;
  border-left: 2px solid #f59e0b;
  background: #fffbeb;
  padding: 7px 9px;
  color: #92400e;
  font-size: 9px;
  line-height: 1.45;
}

.content-reference-adherence-warnings i {
  margin-top: 2px;
}

.content-reference-adherence-comparison {
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
}

.content-reference-adherence-comparison > strong {
  display: block;
  margin-bottom: 6px;
  color: #334155;
  font-size: 10px;
}

.content-reference-adherence-comparison > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px 0;
  color: #64748b;
  font-size: 9px;
}

.content-reference-adherence-comparison b {
  color: #1e293b;
}

.content-reference-adherence-empty {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 13px 0 2px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.55;
}

.content-reference-adherence-empty i {
  color: #6366f1;
  font-size: 15px;
}

.content-reference-adherence-error {
  border-radius: 8px;
  background: #fef2f2;
  padding: 8px 10px;
  color: #b91c1c;
  font-size: 9px;
}

.content-panorama-dialog {
  display: flex;
  width: min(980px, 100%);
  max-height: 92vh;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.34);
}

.content-panorama-dialog-header {
  display: flex;
  align-items: center;
  gap: 13px;
  border-bottom: 1px solid #e2e8f0;
  padding: 17px 20px;
}

.content-panorama-title-icon {
  display: flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 17px;
}

.content-panorama-dialog-header h2 {
  color: #172033;
  font-size: 16px;
  font-weight: 800;
}

.content-panorama-dialog-header p {
  margin-top: 3px;
  color: #64748b;
  font-size: 11px;
}

.content-panorama-beta {
  display: inline-flex;
  min-height: 20px;
  align-items: center;
  border-radius: 999px;
  background: #ede9fe;
  padding: 0 7px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-panorama-close {
  min-height: 40px;
  flex: 0 0 auto;
  border-radius: 8px;
  padding: 0 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.content-panorama-close:hover {
  background: #f1f5f9;
  color: #334155;
}

.content-panorama-dialog-body {
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
}

.content-panorama-setup-grid {
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(360px, 1.1fr);
  gap: 20px;
}

.content-panorama-source-card {
  overflow: hidden;
  align-self: start;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
}

.content-panorama-source-image {
  position: relative;
  aspect-ratio: 16/10;
  overflow: hidden;
  background: #0f172a;
}

.content-panorama-source-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-panorama-front-badge {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.66);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  padding: 0 9px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-source-card figcaption {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 12px 14px;
}

.content-panorama-source-card figcaption strong {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-panorama-source-card figcaption span {
  color: #64748b;
  font-size: 10px;
}

.content-panorama-settings {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 14px;
}

.content-panorama-explanation {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
  padding: 12px;
  color: #1d4ed8;
}

.content-panorama-explanation strong {
  color: #1e3a8a;
  font-size: 12px;
  font-weight: 800;
}

.content-panorama-explanation p {
  margin-top: 3px;
  color: #475569;
  font-size: 10px;
  line-height: 1.5;
}

.content-panorama-field-heading,
.content-panorama-field-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.content-panorama-field-heading label {
  color: #334155;
  font-size: 11px;
  font-weight: 800;
}

.content-panorama-field-heading span {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-panorama-field textarea {
  width: 100%;
  min-height: 96px;
  margin-top: 7px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 10px 11px;
  color: #172033;
  font-size: 12px;
  line-height: 1.5;
}

.content-panorama-field textarea::placeholder {
  color: #94a3b8;
}

.content-panorama-field textarea:focus {
  border-color: #2563eb;
  outline: 3px solid rgba(37, 99, 235, 0.14);
}

.content-panorama-field-meta {
  margin-top: 6px;
  color: #94a3b8;
  font-size: 9px;
}

.content-panorama-specs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.content-panorama-specs div {
  min-width: 0;
  border-right: 1px solid #e2e8f0;
  padding: 10px;
}

.content-panorama-specs div:last-child {
  border-right: 0;
}

.content-panorama-specs dt {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-panorama-specs dd {
  margin-top: 3px;
  color: #334155;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-cost-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  padding: 11px 12px;
}

.content-panorama-cost-icon {
  display: flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 13px;
}

.content-panorama-cost-summary > div:last-child {
  display: grid;
  min-width: 0;
  grid-template-columns: auto 1fr;
  align-items: baseline;
  column-gap: 8px;
  row-gap: 2px;
}

.content-panorama-cost-summary span {
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.content-panorama-cost-summary strong {
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 900;
}

.content-panorama-cost-summary small {
  grid-column: 1/-1;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-panorama-disclaimer,
.content-panorama-result-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 9px;
  background: #f8fafc;
  padding: 10px 11px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.5;
}

.content-panorama-progress {
  display: flex;
  max-width: 650px;
  min-height: 420px;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.content-panorama-progress-visual {
  position: relative;
  display: flex;
  width: 66px;
  height: 66px;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 25px;
}

.content-panorama-progress-visual > i {
  position: absolute;
  right: -5px;
  bottom: -5px;
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 10px;
}

.content-panorama-progress > h3 {
  margin-top: 15px;
  color: #172033;
  font-size: 16px;
  font-weight: 800;
}

.content-panorama-progress > p {
  margin-top: 5px;
  color: #64748b;
  font-size: 11px;
}

.content-panorama-stage-list {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  text-align: left;
}

.content-panorama-stage-list li {
  display: flex;
  min-height: 58px;
  align-items: center;
  gap: 11px;
  border-bottom: 1px solid #edf1f5;
  padding: 9px 12px;
}

.content-panorama-stage-list li:last-child {
  border-bottom: 0;
}

.content-panorama-stage-icon {
  display: flex;
  width: 27px;
  height: 27px;
  flex: 0 0 27px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe3ec;
  border-radius: 999px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 800;
}

.content-panorama-stage-list li.is-current .content-panorama-stage-icon {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}

.content-panorama-stage-list li.is-complete .content-panorama-stage-icon {
  border-color: #059669;
  background: #059669;
  color: #fff;
}

.content-panorama-stage-list strong {
  color: #334155;
  font-size: 11px;
  font-weight: 800;
}

.content-panorama-stage-list p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
}

.content-panorama-result-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.content-panorama-result-kicker {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #047857;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-result-heading h3 {
  margin-top: 4px;
  color: #172033;
  font-size: 16px;
  font-weight: 800;
}

.content-panorama-result-heading p {
  margin-top: 4px;
  color: #64748b;
  font-size: 10px;
}

.content-panorama-view-tabs {
  display: inline-flex;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 3px;
}

.content-panorama-view-tabs button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 0 10px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-view-tabs button.is-active {
  background: #1d4ed8;
  color: #fff;
}

.content-panorama-viewer {
  position: relative;
  display: flex;
  aspect-ratio: 2/1;
  max-height: 500px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 15px;
  border: 1px solid #1e293b;
  border-radius: 12px;
  background: #0f172a;
}

.content-panorama-viewer img {
  width: 100%;
  height: 100%;
  transition: object-position 180ms ease;
}

.content-panorama-viewer.is-immersive img {
  object-fit: cover;
  transform: scale(1.12);
}

.content-panorama-viewer.is-flat img {
  object-fit: contain;
}

.content-panorama-demo-badge {
  position: absolute;
  top: 11px;
  left: 11px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  padding: 4px 8px;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
}

.content-panorama-view-controls {
  position: absolute;
  right: 50%;
  bottom: 12px;
  display: flex;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 9px;
  background: rgba(15, 23, 42, 0.8);
  transform: translateX(50%);
}

.content-panorama-view-controls button {
  min-width: 40px;
  min-height: 38px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0 11px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
}

.content-panorama-view-controls button:last-child {
  border-right: 0;
}

.content-panorama-view-controls button:hover {
  background: rgba(255, 255, 255, 0.12);
}

.content-panorama-view-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.content-panorama-result-note {
  margin-top: 12px;
}

.content-panorama-result-note p {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.content-panorama-result-note strong {
  color: #475569;
}

.content-panorama-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #e2e8f0;
  padding: 14px 20px;
}

.content-panorama-dialog-footer > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.content-panorama-footer-secondary,
.content-panorama-footer-primary {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 9px;
  padding: 0 14px;
  font-size: 11px;
  font-weight: 800;
}

.content-panorama-footer-secondary {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}

.content-panorama-footer-secondary:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-panorama-footer-primary {
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #fff;
  box-shadow: 0 5px 12px rgba(29, 78, 216, 0.16);
}

.content-panorama-footer-primary:hover {
  background: #1e40af;
}

.content-panorama-footer-primary.is-confirmed {
  border-color: #059669;
  background: #059669;
}

.content-panorama-footer-secondary:disabled,
.content-panorama-footer-primary:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.content-panorama-entry:focus-visible,
.content-panorama-summary button:focus-visible,
.content-panorama-close:focus-visible,
.content-panorama-view-tabs button:focus-visible,
.content-panorama-view-controls button:focus-visible,
.content-panorama-footer-secondary:focus-visible,
.content-panorama-footer-primary:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

@container wb-content (max-width: 1439px) {
  .content-workbench-grid {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 310px);
  }
  .content-workbench-grid.is-scenario-console {
    grid-template-columns: 218px minmax(0, 1fr) 300px;
    gap: 12px;
  }
  .content-cut-console-item {
    grid-template-columns: 58px minmax(0, 1fr) 8px;
  }
}
@container wb-content (max-width: 1279px) {
  .content-workbench-grid {
    grid-template-columns: 1fr;
  }
  .content-workbench-grid.is-scenario-console {
    grid-template-columns: 1fr;
  }
  .content-settings-panel,
  .content-cut-console {
    position: static;
  }
  .content-cut-console {
    max-height: none;
  }
  .content-cut-console-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    overflow: visible;
  }
  .is-scenario-console .content-settings-panel {
    height: auto;
    max-height: none;
    overflow: visible;
  }
  .is-scenario-console .content-settings-form {
    height: auto;
    max-height: none;
    overflow: visible;
  }
  .content-settings-form {
    display: flex;
    flex-direction: column;
  }
  .content-settings-header {
    grid-column: 1/-1;
  }
  .content-settings-section {
    border-top: 1px solid #e8edf3;
    border-right: 0;
  }
  .content-settings-section:last-child {
    border-right: 0;
  }
}
@container wb-content (max-width: 1023px) {
  .content-settings-form {
    grid-template-columns: 1fr;
  }
  .content-settings-section {
    border-right: 0;
  }
}
@container wb-content (max-width: 767px) {
  .content-preview-header,
  .content-selected-asset-heading,
  .content-overview {
    align-items: flex-start;
    flex-direction: column;
  }
  .content-overview > p {
    text-align: left;
  }
  .content-preview-actions,
  .content-asset-actions {
    width: 100%;
    justify-content: stretch;
  }
  .content-preview-actions button {
    flex: 1;
  }
  .content-panorama-summary {
    grid-template-columns: minmax(0, 1fr) auto;
    margin-inline: 14px;
  }
  .content-panorama-summary-actions {
    grid-column: 1/-1;
    justify-content: stretch;
  }
  .content-panorama-summary-actions button {
    flex: 1;
  }
  .content-reference-adherence {
    margin-inline: 14px;
  }
  .content-reference-adherence-header {
    align-items: flex-start;
  }
  .content-reference-adherence-summary {
    grid-template-columns: 1fr;
  }
  .content-shot-consistency .content-reference-adherence-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .content-panorama-setup-grid {
    grid-template-columns: 1fr;
  }
  .content-panorama-source-card {
    width: 100%;
    max-width: 520px;
    margin: 0 auto;
  }
  .content-panorama-result-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .content-panorama-dialog-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .content-panorama-dialog-footer > div {
    justify-content: stretch;
  }
  .content-panorama-dialog-footer > button,
  .content-panorama-dialog-footer > div > button {
    flex: 1;
  }
  .content-master-media {
    aspect-ratio: 4/3;
    margin-inline: 14px;
  }
  .content-cut-console-list,
  .content-cut-inspector-grid {
    grid-template-columns: 1fr;
  }
  .content-cut-inspector {
    margin-inline: 14px;
  }
  .content-cut-inspector-header,
  .content-cut-inspector-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .content-cut-inspector-grid > div,
  .content-cut-inspector-grid > div:nth-child(2n) {
    border-right: 0;
    border-bottom: 1px solid #e8edf3;
  }
  .content-cut-inspector-grid > div.is-wide {
    grid-column: auto;
    border-bottom: 0;
  }
  .content-thumbnail-strip,
  .content-selected-asset {
    margin-inline: 14px;
  }
  .content-asset-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 0;
  }
  .content-asset-detail-grid > div:nth-child(2) {
    border-right: 0;
  }
  .content-settings-form {
    display: block;
  }
  .content-settings-section {
    border-right: 0;
  }
  .content-model-filter {
    align-items: flex-start;
    flex-direction: column;
  }
}
@container wb-content (max-width: 479px) {
  .content-media-tabs {
    padding-inline: 8px;
  }
  .content-preview-actions {
    flex-direction: column;
  }
  .content-preview-actions button {
    width: 100%;
  }
  .content-panorama-summary {
    grid-template-columns: 1fr;
  }
  .content-panorama-summary-preview {
    max-width: 180px;
  }
  .content-panorama-summary-actions {
    grid-column: auto;
    flex-direction: column;
  }
  .content-reference-adherence-header {
    flex-direction: column;
  }
  .content-reference-adherence-action {
    width: 100%;
  }
  .content-reference-adherence-metrics {
    grid-template-columns: 1fr;
  }
  .content-shot-consistency .content-reference-adherence-metrics {
    grid-template-columns: 1fr;
  }
  .content-reference-adherence-metrics > div {
    border-right: 0;
    border-bottom: 1px solid #e2e8f0;
  }
  .content-reference-adherence-metrics > div:last-child {
    border-bottom: 0;
  }
  .content-panorama-dialog-header {
    align-items: flex-start;
    padding: 14px;
  }
  .content-panorama-title-icon {
    display: none;
  }
  .content-panorama-dialog-body,
  .content-panorama-dialog-footer {
    padding: 14px;
  }
  .content-panorama-specs {
    grid-template-columns: 1fr;
  }
  .content-panorama-specs div {
    border-right: 0;
    border-bottom: 1px solid #e2e8f0;
  }
  .content-panorama-specs div:last-child {
    border-bottom: 0;
  }
  .content-panorama-view-tabs {
    width: 100%;
  }
  .content-panorama-view-tabs button {
    flex: 1;
    justify-content: center;
  }
  .content-panorama-view-controls {
    width: calc(100% - 24px);
  }
  .content-panorama-view-controls button {
    flex: 1;
  }
  .content-panorama-dialog-footer > div {
    flex-direction: column;
  }
  .content-thumbnail-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .content-thumbnail-strip.is-video .content-thumbnail {
    width: 152px;
    flex-basis: 152px;
  }
  .content-asset-detail-grid {
    grid-template-columns: 1fr;
  }
  .content-asset-detail-grid > div {
    border-right: 0;
    border-bottom: 1px solid #edf1f5;
    padding: 0 0 10px;
  }
  .content-asset-detail-grid > div:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host * {
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
.wb-expression-stage-editor > .wb-blur-editor {
  grid-column: 1/-1;
}

.wb-blur-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  width: 100%;
  gap: 12px;
  padding: 16px;
}

.wb-blur-editor > label {
  color: #193264;
  font-size: 13px;
  font-weight: 700;
}

.wb-blur-coordinates input {
  width: 100%;
  min-width: 0;
  min-height: 40px;
  padding: 8px;
  border: 1px solid #c7d9f4;
  border-radius: 6px;
  background: #fff;
  color: #193264;
  font-family: inherit;
  font-size: 13px;
}

.wb-blur-editor p, .wb-blur-editor small {
  margin: 0;
  color: #567297;
  font-size: 13px;
  line-height: 1.6;
}

.wb-blur-source-picker {
  width: min(100%, 700px);
  min-width: 0;
}

.wb-blur-source-picker .wb-new-dropdown-trigger {
  min-height: 58px;
  padding: 9px 12px;
  font-family: inherit;
}

.wb-blur-source-picker .wb-new-dropdown-trigger:disabled {
  border-color: #dbe4f1;
  background: #f6f8fc;
  color: #7085a9;
  cursor: not-allowed;
}

.wb-blur-source-picker .wb-blur-source-copy {
  display: grid;
  min-width: 0;
  gap: 3px;
  white-space: normal;
}

.wb-blur-source-copy strong {
  font-size: 13px;
  font-weight: 650;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.wb-blur-source-copy .wb-blur-source-details {
  color: #567297;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-blur-source-picker .wb-new-dropdown-menu {
  max-height: min(320px, 50vh);
  padding: 6px;
  overscroll-behavior: contain;
}

.wb-blur-source-picker .wb-new-dropdown-menu button {
  min-height: 58px;
  padding: 9px 10px;
  font-family: inherit;
}

.wb-blur-source-picker .wb-new-dropdown-menu button:focus-visible {
  outline: 2px solid #1263ec;
  outline-offset: -2px;
}

.wb-blur-source-picker .wb-new-dropdown-menu button.is-selected {
  background: #edf5ff;
}

.wb-blur-source-picker .wb-new-dropdown-menu button.is-selected strong,
.wb-blur-source-picker .wb-new-dropdown-menu button.is-selected > i {
  color: #0758df;
}

.wb-blur-source-picker .wb-new-dropdown-menu button > i {
  margin-right: 2px;
  font-size: 12px;
}

.wb-blur-canvas {
  position: relative;
  width: min(100%, 700px);
  overflow: hidden;
  touch-action: none;
  cursor: crosshair;
  border-radius: 8px;
  background: #102739;
}

.wb-blur-canvas.is-loading {
  min-height: 240px;
  pointer-events: none;
  cursor: progress;
}

.wb-blur-canvas.is-loading::after {
  content: "기준 이미지 불러오는 중…";
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: #c9d8e7;
  font-size: 13px;
}

.wb-blur-canvas.is-loading img {
  visibility: hidden;
}

.wb-blur-canvas img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  pointer-events: none;
  user-select: none;
}

.wb-blur-region {
  position: absolute;
  box-sizing: border-box;
  border: 2px solid #1266ed;
  background: rgba(28, 111, 245, 0.18);
  pointer-events: none;
}

.wb-blur-region span {
  display: inline-block;
  padding: 2px 6px;
  background: #1266ed;
  color: #fff;
  font-size: 12px;
}

.wb-blur-preview-error {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  width: min(100%, 700px);
  min-height: 200px;
  padding: 24px;
  border: 1px dashed #b8cbe5;
  border-radius: 8px;
  background: #f5f8fd;
  color: #567297;
  font-size: 13px;
  text-align: center;
}

.wb-blur-preview-error button {
  padding: 8px 12px;
  border: 1px solid #b8d1f7;
  border-radius: 6px;
  background: #fff;
  color: #0758df;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.wb-blur-coordinates {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 10px;
}

.wb-blur-coordinates label {
  display: grid;
  min-width: 0;
  gap: 4px;
  font-size: 12px;
  line-height: 1.5;
}

.wb-blur-levels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.wb-blur-levels li {
  display: grid;
  align-content: start;
  min-width: 0;
  gap: 4px;
  padding: 10px;
  border: 1px solid #dbe7f8;
  border-radius: 6px;
  color: #42628b;
  font-size: 12px;
  line-height: 1.5;
}

.wb-blur-levels strong {
  white-space: nowrap;
}

.wb-blur-levels span {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

@container wb-content (max-width: 640px) {
  .wb-blur-coordinates {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wb-blur-levels {
    grid-template-columns: 1fr;
  }
}
.pane-table-hint {
  margin: 0;
  padding: 8px 14px;
  color: #526d8c;
  font-size: 12px;
  line-height: 1.5;
}

.wb-new-table th:last-child, .wb-new-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 1;
  background: #fff;
  box-shadow: -3px 0 6px rgba(26, 55, 83, 0.08);
}

.wb-new-table th:last-child {
  background: #f5f9fd;
}

/* Image studio: existing editing/generation handlers are retained in two independent panes. */
.wb-new-main.is-image-studio {
  max-width: 1600px;
  padding: 16px 28px 20px;
}

.is-image-studio > .wb-new-page-title {
  display: none;
}

.is-image-studio > .wb-workspace-nav {
  margin-bottom: 12px;
}

.is-image-studio > .wb-new-media-tabs {
  margin-bottom: 12px;
}

.is-image-studio .wb-new-selected-source {
  margin-bottom: 8px;
  padding: 8px 12px;
  min-height: 38px;
}

.is-image-studio .wb-guide-step-number {
  display: none;
}

.is-image-studio .wb-analysis-card:not(.is-open) {
  display: none;
}

.wb-image-cut-strip {
  margin-bottom: 10px;
  padding: 9px 12px;
  border: 1px solid #dce7f7;
  border-radius: 8px;
  background: #fff;
}

.wb-image-cut-heading {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
}

.wb-image-cut-heading strong {
  min-width: 0;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.wb-image-cut-heading > button {
  flex: none;
  border: 0;
  background: transparent;
  color: #145ed0;
  font-size: 12px;
  padding: 4px;
}

.wb-image-cut-list {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 3px;
}

.wb-image-current-cut {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.wb-image-current-cut-meta, .wb-image-cut-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 8px;
}

.wb-image-current-cut-meta > small {
  color: #60738e;
  font-size: 11px;
}

.wb-image-cut-list button {
  display: grid;
  align-content: start;
  flex: 0 0 224px;
  max-width: 100%;
  gap: 5px;
  min-height: 70px;
  border: 1px solid #d6e2f3;
  border-radius: 6px;
  background: #fff;
  padding: 8px 10px;
  color: #526887;
  font-size: 12px;
  text-align: left;
}

.wb-image-cut-meta > span:first-child {
  color: #526887;
  font-size: 11px;
  font-weight: 700;
}

.wb-image-cut-title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #213d63;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-image-cut-list button:hover {
  border-color: #82aef1;
  background: #f5f9ff;
}

.wb-image-cut-list button:focus-visible {
  outline: 3px solid #8bb9ff;
  outline-offset: -3px;
}

.wb-image-cut-list button.is-active {
  border-color: #1c65d9;
  background: #eaf2ff;
  color: #1257bf;
  box-shadow: inset 0 0 0 1px #1c65d9;
  font-weight: 750;
}

.wb-image-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  align-items: stretch;
}

.wb-image-workspace-head {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 12px 14px;
  border: 1px solid #dce7f7;
  border-radius: 8px;
  background: #fff;
}

.wb-image-workspace-head h3 {
  margin: 0;
  font-size: 17px;
  color: #172c4d;
}

.wb-image-workspace-head p {
  margin: 3px 0 0;
  color: #617592;
  font-size: 12px;
}

.wb-image-settings-toggle {
  margin-left: auto;
  border: 1px solid #b9cff2;
  border-radius: 6px;
  background: #edf4ff;
  color: #145bc7;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 700;
}

.wb-image-scope-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.wb-image-scope-row > span {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 6px;
  background: #f2f6fc;
}

.wb-image-scope-row small {
  color: #60738e;
  font-size: 11px;
}

.wb-image-scope-row strong {
  color: #213d63;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-image-state-line {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 16px;
  width: 100%;
  color: #51677f;
  font-size: 12px;
}

.wb-image-workspace > .wb-new-results {
  container: wb-image-results/inline-size;
  min-width: 0;
  margin: 0;
  max-height: 72dvh;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.wb-image-workspace .wb-comparison-heading {
  grid-template-columns: minmax(0, 1fr) auto 26px;
  padding: 10px 12px;
}

.wb-image-workspace .wb-comparison-heading > .wb-guide-step-state {
  display: none;
}

.wb-image-workspace .wb-comparison-heading .wb-guide-chevron {
  grid-column: 3;
}

.wb-image-workspace #wb-comparison-body {
  padding: 12px;
}

.wb-image-workspace .wb-comparison-toolbar {
  gap: 8px;
}

.wb-image-workspace .wb-comparison-strength {
  grid-template-columns: 1fr;
  gap: 6px;
  padding: 9px;
}

.wb-image-workspace .wb-comparison-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.wb-image-workspace .wb-comparison-card {
  min-width: 0;
}

.wb-image-workspace .wb-comparison-card header {
  flex-wrap: wrap;
}

.wb-image-workspace .wb-comparison-image {
  aspect-ratio: 4/3;
}

.wb-image-workspace .wb-comparison-image img {
  object-fit: contain;
}

.wb-image-workspace .wb-comparison.is-expanded {
  max-height: none;
}

.wb-image-workspace .wb-comparison.is-expanded .wb-comparison-grid {
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.wb-image-settings.wb-new-control-card {
  display: none;
  min-width: 0;
  margin: 0;
  border-radius: 8px;
}

.wb-image-workspace.settings-open > .wb-image-settings {
  display: flex;
  flex-direction: column;
  max-height: 72dvh;
}

.wb-image-settings > .wb-guide-step-header {
  flex: none;
  grid-template-columns: minmax(0, 1fr) 26px;
  padding: 10px 12px;
}

.wb-image-settings > .wb-guide-step-header > .wb-guide-step-state {
  display: none;
}

.wb-image-settings > .wb-guide-step-header .wb-guide-chevron {
  grid-column: 2;
}

.wb-image-settings-body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-wrap: anywhere;
  overscroll-behavior: contain;
  padding: 12px;
  scrollbar-gutter: stable;
}

.wb-image-settings-body > * {
  min-width: 0;
}

.wb-image-settings-body .wb-new-control-row, .wb-image-settings-body .wb-new-model-row {
  grid-template-columns: 1fr;
  padding: 0;
  gap: 10px;
}

.wb-image-settings-body .wb-expression-edit-heading {
  padding: 0 0 10px;
}

.wb-image-settings-body .wb-new-segment {
  flex-wrap: wrap;
}

.wb-image-settings-body .wb-new-model-chips {
  flex-wrap: wrap;
}

.wb-image-settings-body textarea {
  min-height: 110px;
  max-height: 260px;
  resize: vertical;
  font-size: 13px;
  line-height: 1.65;
}

.wb-image-settings-body .wb-expression-stage-editor, .wb-image-settings-body .wb-shared-reference, .wb-image-settings-body .wb-reference-plan, .wb-image-settings-body .wb-new-prompt-panel {
  margin: 12px 0;
}

.wb-image-reference-details {
  padding: 10px;
  border: 1px solid #dce7f7;
  border-radius: 6px;
  margin-top: 12px;
}

.wb-image-reference-details > summary {
  cursor: pointer;
  color: #285080;
  font-size: 13px;
  font-weight: 700;
}

.wb-image-settings > .wb-new-prompt-footer {
  display: grid;
  flex: none;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid #d9e5f4;
  background: #fff;
}

.wb-image-settings > .wb-new-prompt-footer > .wb-guide-step-state, .wb-image-settings > .wb-new-prompt-footer > .wb-guide-step-copy {
  display: none;
}

.wb-image-settings > .wb-new-prompt-footer > .wb-new-summary {
  grid-column: 1/-1;
  margin: 0;
  padding: 8px;
  font-size: 11px;
  line-height: 1.5;
  flex-wrap: wrap;
}

.wb-image-settings > .wb-new-prompt-footer > p {
  grid-column: 1/-1;
  margin: 0;
}

.wb-image-settings > .wb-new-prompt-footer > button {
  min-width: 0;
  min-height: 40px;
  margin: 0;
  white-space: normal;
}

.wb-image-settings > .wb-new-prompt-footer > button:only-of-type {
  grid-column: 1/-1;
}

.wb-image-workspace button:focus-visible, .wb-image-reference-details > summary:focus-visible {
  outline: 3px solid #80aff8;
  outline-offset: 2px;
}

@container wb-content (min-width: 700px) {
  .wb-image-workspace {
    grid-template-columns: minmax(0, 1fr) 380px;
  }
  .wb-image-workspace > .wb-new-results {
    grid-column: 1;
    grid-row: 2;
    max-height: none;
    height: max(480px, 100dvh - 325px);
  }
  .wb-image-workspace > .wb-image-settings {
    display: flex;
    grid-column: 2;
    grid-row: 2;
    flex-direction: column;
    max-height: none;
    height: max(480px, 100dvh - 325px);
  }
  .wb-image-settings-toggle {
    display: none;
  }
}
@container wb-content (min-width: 1200px) {
  .wb-image-workspace {
    grid-template-columns: minmax(0, 1fr) 440px;
  }
}
@container wb-content (max-width: 699px) {
  .wb-image-scope-row {
    grid-template-columns: 1fr;
  }
  .wb-image-scope-row > span {
    flex-direction: row;
    gap: 10px;
    align-items: baseline;
  }
  .wb-image-scope-row small {
    flex: none;
    min-width: 78px;
  }
  .wb-image-workspace .wb-comparison-grid {
    grid-template-columns: 1fr;
  }
  .wb-image-workspace.settings-open > .wb-new-results {
    max-height: 40dvh;
  }
  .wb-image-workspace .wb-comparison-heading {
    display: flex;
    flex-wrap: wrap;
  }
  .wb-image-workspace .wb-comparison-heading-actions {
    flex-wrap: wrap;
  }
  .wb-image-workspace .wb-new-summary-divider {
    display: none;
  }
}
/* Fit the normal image workspace to the available screen, not the long settings form. */
.is-image-studio .wb-new-selected-source {
  min-height: 30px;
  padding: 5px 10px;
}

.is-image-studio .wb-new-selected-source button {
  min-height: 26px;
  padding: 3px 8px;
}

.is-image-studio .wb-image-cut-strip {
  padding: 6px 10px;
  margin-bottom: 8px;
}

.is-image-studio .wb-image-cut-heading {
  margin-bottom: 4px;
}

.is-image-studio .wb-image-cut-heading strong {
  font-size: 12px;
}

.is-image-studio .wb-image-cut-list button {
  padding: 8px 10px;
}

.wb-image-workspace-head {
  padding: 8px 10px;
  gap: 6px 12px;
}

.wb-image-workspace-head > div:first-child p {
  display: none;
}

.wb-image-scope-row > span {
  padding: 6px 8px;
  gap: 2px;
}

.wb-image-workspace .wb-comparison-heading p {
  display: none;
}

.wb-image-workspace .wb-comparison-strength {
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 5px;
}

.wb-image-workspace .wb-comparison-strength > strong {
  grid-column: 1/-1;
  font-size: 11px;
}

.wb-image-workspace .wb-comparison-strength > p {
  margin: 0;
  font-size: 11px;
}

.wb-image-workspace .wb-comparison-endpoints {
  font-size: 10px;
}

.wb-image-workspace .wb-comparison-toolbar button {
  min-height: 34px;
  padding: 6px 8px;
  font-size: 12px;
}

/* Use the actual layout height, including the header and any agent dock. */
@container workspace (min-width: 700px) {
  :host:has(.wb-new-main.is-image-studio:not(.image-advanced-open)) {
    height: 100%;
    min-height: 0;
  }
}
@container wb-content (min-width: 700px) {
  .content-notebook-scale:has(> .wb-new-main.is-image-studio:not(.image-advanced-open)) {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }
  .content-notebook-scale:has(> .wb-new-main.is-image-studio:not(.image-advanced-open)) > .content-workbench-header {
    flex: 0 0 auto;
  }
  .wb-new-main.is-image-studio:not(.image-advanced-open) {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    box-sizing: border-box;
    height: auto;
    min-height: 0;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .is-image-studio:not(.image-advanced-open) > .wb-workspace-nav, .is-image-studio:not(.image-advanced-open) > .wb-new-media-tabs {
    flex: none;
  }
  .is-image-studio:not(.image-advanced-open) > .wb-media-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: none;
  }
  .is-image-studio:not(.image-advanced-open) > .wb-media-panel > :not(.wb-image-workspace) {
    flex: none;
  }
  .is-image-studio:not(.image-advanced-open) .wb-image-workspace {
    flex: 1 0 420px;
    min-height: 420px;
    grid-template-rows: auto minmax(0, 1fr);
  }
  .is-image-studio:not(.image-advanced-open) .wb-image-workspace > .wb-new-results, .is-image-studio:not(.image-advanced-open) .wb-image-workspace > .wb-image-settings {
    height: auto;
    min-height: 0;
    max-height: none;
  }
  .is-image-studio .wb-image-workspace-head > div:first-child {
    display: none;
  }
  .is-image-studio .wb-analysis-card.is-open {
    max-height: 40dvh;
    overflow: auto;
  }
  .is-image-studio .wb-new-advanced-toggle {
    margin-top: 6px;
    margin-bottom: 0;
    padding: 6px 0;
  }
}
/* Comparison is the default; focused image viewing stays available in the next tab. */
.wb-image-view-tabs {
  display: flex;
  gap: 6px;
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 5px 0 8px;
  background: #f5f9fd;
}

.wb-image-view-tabs button {
  flex: 1;
  min-height: 34px;
  padding: 5px 8px;
  border: 1px solid #d3e1f3;
  border-radius: 6px;
  background: #fff;
  color: #556b89;
  font-size: 12px;
  font-weight: 700;
}

.wb-image-view-tabs button[aria-selected=true] {
  border-color: #2669d6;
  background: #eaf2ff;
  color: #155bc7;
}

.wb-image-view-tabs button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wb-image-compare-pane[hidden] {
  display: none !important;
}

.wb-image-focus {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 250px;
  height: calc(100% - 47px);
  padding: 10px;
  border: 1px solid #dce7f7;
  border-radius: 8px;
  background: #fff;
}

.wb-image-focus > ng-container {
  display: contents;
}

.wb-image-focus header {
  display: flex;
  gap: 8px;
  align-items: center;
  flex: none;
}

.wb-image-focus label {
  flex: none;
  font-size: 12px;
  color: #556c8e;
}

.wb-image-focus select {
  min-width: 0;
  flex: 1;
  height: 32px;
  padding: 4px 6px;
  border: 1px solid #d6e2f3;
  border-radius: 5px;
  background: #fff;
  font-size: 12px;
}

.wb-image-focus-visual {
  display: block;
  position: relative;
  flex: 1;
  width: 100%;
  min-height: 150px;
  border: 0;
  border-radius: 6px;
  background: #edf2f7;
  overflow: hidden;
  cursor: zoom-in;
}

.wb-image-focus-visual img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wb-image-focus-visual span {
  position: absolute;
  bottom: 8px;
  right: 8px;
  border-radius: 5px;
  padding: 4px 7px;
  background: rgba(23, 50, 80, 0.8509803922);
  color: #fff;
  font-size: 11px;
}

.wb-image-focus > p {
  flex: none;
  margin: 0;
  color: #647893;
  font-size: 11px;
}

.wb-image-focus-empty {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 12px;
  min-height: 200px;
  padding: 18px;
  text-align: center;
  color: #617594;
}

.wb-image-focus-empty i {
  font-size: 28px;
}

.wb-image-focus-empty p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

.wb-image-request-error {
  width: 100%;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid #f4c3c3;
  border-radius: 5px;
  background: #fff2f2;
  color: #a42d38;
  font-size: 12px;
}

.wb-image-settings-body .wb-expression-edit-heading {
  display: none;
}

.wb-image-workspace .wb-comparison-heading {
  min-height: 38px;
  padding: 6px 8px;
}

.wb-image-workspace .wb-comparison-heading-actions button {
  min-height: 28px;
  padding: 4px 7px;
  font-size: 11px;
}

.wb-image-workspace .wb-comparison-strength {
  padding: 6px;
  gap: 3px;
}

.wb-image-workspace .wb-comparison-level-picker > div:first-child {
  display: flex;
  gap: 4px;
}

.wb-image-workspace .wb-comparison-level-picker button {
  min-height: 28px;
  width: 30px;
  padding: 0;
  font-size: 12px;
}

.wb-image-workspace .wb-comparison-endpoints {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
}

.wb-image-workspace .wb-comparison-card > header {
  min-height: 38px;
  height: 38px;
}

@container wb-content (max-width: 699px) {
  .wb-image-focus {
    height: 48dvh;
    min-height: 280px;
  }
}
.wb-image-settings-body .wb-expression-stage-editor {
  display: block;
  padding: 0;
}

.wb-image-settings-body .wb-expression-stage-editor > header {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px;
}

.wb-image-settings-body .wb-expression-stage-content {
  grid-column: auto;
  width: 100%;
}

.wb-image-settings-body .wb-expression-stage-content > .wb-new-prompt-tabs button:has(small) {
  min-width: 0;
  padding: 4px 1px;
}

.wb-image-settings-body .wb-expression-stage-content > .wb-new-prompt-tabs button small {
  white-space: normal;
  font-size: 9px;
}

.wb-image-settings-body .wb-new-prompt-body, .wb-image-settings-body .wb-reference-plan-grid, .wb-image-settings-body .wb-trigger-stage-editor {
  grid-template-columns: 1fr;
}

.wb-image-settings-body .wb-generation-settings-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding-right: 0;
  padding-left: 0;
}

.wb-image-settings-body .wb-shared-reference > header {
  flex-wrap: wrap;
}

/* Keep the strength editor visible above the pinned generation controls. */
.wb-image-settings-body {
  padding: 10px 12px;
}

.wb-image-settings-body .wb-expression-stage-editor > header p {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
}

.wb-image-settings-body .wb-expression-stage-content > p {
  font-size: 11px;
  line-height: 1.4;
  margin: 5px 0;
}

.wb-image-settings-body .wb-expression-stage-editor {
  margin: 8px 0;
}

.wb-image-settings-body .wb-new-prompt-tabs {
  margin: 5px 0;
}

.wb-image-workspace .wb-comparison.is-expanded .wb-comparison-heading {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.wb-image-workspace .wb-comparison.is-expanded .wb-comparison-heading-copy {
  flex: 1;
  min-width: 160px;
}

.wb-image-request-progress {
  grid-column: 1/-1;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  font-size: 12px;
  color: #355d8d;
}

.wb-image-request-progress progress {
  flex: 1;
  min-width: 140px;
  align-self: center;
  height: 7px;
  accent-color: #2669d6;
}

@container wb-content (max-width: 650px) {
  .wb-new-main.is-image-studio {
    padding-inline: 12px;
  }
  .wb-workspace-nav a {
    flex: 1;
    gap: 6px;
    padding-inline: 6px;
    font-size: 14px;
  }
  .wb-workspace-nav a i, .wb-new-media-tabs i {
    font-size: 16px;
  }
  .wb-new-media-tabs button {
    gap: 6px;
    padding-inline: 6px;
    font-size: 14px;
  }
}
/* Disabled native buttons cannot receive focus; their wrapper exposes the reason. */
.wb-stage-draft-help {
  display: inline-flex;
  position: relative;
  max-width: 100%;
  border-radius: 6px;
}

.wb-stage-draft-help > button:disabled {
  pointer-events: none;
}

.wb-stage-draft-help:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 3px;
}

.wb-stage-draft-tooltip {
  position: absolute;
  z-index: 10;
  bottom: calc(100% + 8px);
  left: 0;
  width: 270px;
  max-width: min(270px, 70vw);
  padding: 9px 11px;
  border-radius: 6px;
  background: #24364d;
  color: #fff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1490196078);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.55;
  word-break: keep-all;
  overflow-wrap: anywhere;
  opacity: 0;
  visibility: hidden;
  transition: opacity 120ms ease;
  pointer-events: none;
}

.wb-stage-draft-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 16px;
  border: 5px solid transparent;
  border-top-color: #24364d;
}

.wb-stage-draft-help:hover .wb-stage-draft-tooltip, .wb-stage-draft-help:focus-within .wb-stage-draft-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

@media (prefers-reduced-motion: reduce) {
  .wb-stage-draft-tooltip {
    transition: none;
  }
}
/* Trigger editing uses the sidebar's full width; no implicit second grid column. */
.wb-image-settings-body .wb-trigger-stage-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  padding: 0;
  margin: 12px 0;
  min-width: 0;
}

.wb-image-settings-body .wb-trigger-stage-editor > header {
  grid-column: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 4px;
  min-width: 0;
}

.wb-image-settings-body .wb-trigger-stage-editor > header p {
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.wb-image-settings-body .wb-trigger-stage-editor .wb-trigger-editor {
  grid-column: 1;
  width: 100%;
  min-width: 0;
}

.wb-image-settings-body .wb-trigger-row {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 44px;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.wb-image-settings-body .wb-trigger-row > span {
  width: 24px;
}

.wb-image-settings-body .wb-trigger-row input {
  width: 100%;
  min-width: 0;
  padding-inline: 8px;
}

.wb-image-settings-body .wb-trigger-row button {
  width: 44px;
  padding-inline: 4px;
  white-space: nowrap;
}

.wb-image-settings-body .wb-trigger-add {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.wb-image-settings-body .wb-trigger-add input {
  width: 100%;
  min-width: 0;
}

.wb-image-settings-body .wb-trigger-add button {
  justify-self: start;
  min-height: 35px;
}

.wb-image-settings-body .wb-trigger-intensity-note {
  margin-inline: 0;
}

.wb-analysis-element-evidence, .wb-analysis-visual-draft {
  margin-top: 12px;
  padding: 10px;
  border: 1px solid #dbe6f3;
  border-radius: 6px;
  font-size: 12px;
}

.wb-analysis-element-evidence summary {
  cursor: pointer;
  color: #245d9e;
  font-weight: 700;
}

.wb-analysis-element-evidence article {
  display: grid;
  gap: 3px;
  padding: 8px 0;
  border-bottom: 1px solid #edf2f8;
}

.wb-analysis-element-evidence q {
  color: #526782;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.wb-analysis-element-evidence small, .wb-analysis-visual-draft small {
  display: block;
  color: #64748b;
  line-height: 1.5;
}

.wb-analysis-visual-draft button {
  margin-top: 8px;
}

.wb-analysis-warning {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 5px;
  background: #fff8e8;
  color: #805719;
  font-size: 12px;
  line-height: 1.6;
}

/* Fit settings controls to their pane, including long model names and expanded details. */
.wb-image-settings, .wb-image-settings * {
  box-sizing: border-box;
}

.wb-image-settings-body :is(input, textarea, select) {
  min-width: 0;
  max-width: 100%;
}

.wb-image-settings-body :is(.wb-new-outline-button, .wb-new-segment button, .wb-custom-expression-summary button) {
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}

.wb-image-settings-body .wb-new-stepper {
  flex-wrap: wrap;
}

.wb-image-settings-body .wb-expression-prompt-title {
  min-width: 0;
}

.wb-image-settings-body .wb-new-prompt-preview {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
}

.wb-image-settings-body .wb-new-prompt-preview > span {
  grid-column: 2/-1;
  min-width: 0;
  margin-left: 0;
}

.wb-image-settings-body .wb-new-prompt-preview > em {
  grid-column: 3;
  grid-row: 1;
}

.wb-image-settings-body .wb-new-model-chip {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  width: 100%;
  min-width: 0;
}

.wb-image-settings-body .wb-new-model-chip-label {
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.wb-image-settings-body .wb-new-dropdown-model {
  width: 100%;
  min-width: 0;
}

.wb-image-settings-body .wb-new-dropdown-model .wb-new-dropdown-menu {
  width: 100%;
  min-width: 0;
}

.wb-image-settings-body .wb-new-model-quality-inline .wb-new-dropdown-menu {
  right: 0;
  left: auto;
  min-width: 190px;
}

.wb-image-settings-body .wb-new-dropdown-menu button > span, .wb-image-settings-body .wb-new-dropdown-empty {
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.wb-image-settings-body .wb-generation-reference-summary {
  margin-inline: 0;
  flex-wrap: wrap;
}

.wb-image-settings-body .wb-generation-reference-summary > span {
  flex: 1 1 160px;
  min-width: 0;
  white-space: normal;
}

.wb-image-settings-body .wb-shared-reference-selected {
  grid-template-columns: 72px minmax(0, 1fr);
}

.wb-image-settings-body .wb-shared-reference-preview {
  width: 72px;
  height: 54px;
}

.wb-image-settings-body .wb-shared-reference-usage {
  grid-column: 1/-1;
}

.wb-image-settings-body .wb-shared-reference-selected:not(:has(.wb-shared-reference-preview)) .wb-shared-reference-info {
  grid-column: 1/-1;
}

.wb-image-settings-body .wb-reference-trait-add {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
}

.wb-image-settings-body .wb-reference-traits > span {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.wb-image-settings-body .wb-fidelity-rubric {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 150px), 1fr));
}

.wb-image-settings-body .wb-stage-draft-help {
  display: flex;
  width: 100%;
}

.wb-image-settings-body .wb-stage-draft-tooltip {
  max-width: 100%;
}

.wb-image-settings > .wb-new-prompt-footer {
  overflow-wrap: anywhere;
}

/* Keep comparison controls readable when the wider settings pane leaves less room. */
@container wb-image-results (max-width: 560px) {
  .wb-image-workspace .wb-comparison-grid,
  .wb-image-workspace .wb-comparison.is-expanded .wb-comparison-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .wb-image-workspace .wb-comparison-heading {
    display: flex;
    flex-wrap: wrap;
  }
  .wb-image-workspace .wb-comparison-heading-actions {
    flex-wrap: wrap;
  }
  .wb-image-workspace .wb-comparison-strength {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Direct actions for the displayed image, shared by focus and comparison views. */
.wb-image-result-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 130px), 1fr));
  flex: none;
  gap: 8px;
  min-width: 0;
  padding: 8px 10px;
}

.wb-image-focus > .wb-image-result-actions {
  padding: 0;
}

.wb-agent-result-image > .wb-image-result-actions {
  padding-inline: 0;
}

.wb-image-result-actions > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 36px;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid #bcd3f8;
  border-radius: 6px;
  background: #f5f9ff;
  color: #1455bf;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.wb-image-result-actions > .wb-image-delete-action {
  border-color: #edc9cb;
  background: #fff;
  color: #b43a43;
}

.wb-image-result-actions > .wb-image-delete-action:hover:not(:disabled) {
  border-color: #da8c94;
  background: #fff3f3;
}

.wb-image-result-actions > button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wb-image-result-actions > button:focus-visible {
  outline: 3px solid #93bfff;
  outline-offset: 2px;
}`],
})
export class PageContentComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public searching: boolean = false;
    public submitting: boolean = false;
    public videoSubmitting: boolean = false;
    public actionJobId: string = '';
    public accessDenied: boolean = false;
    public errorMessage: string = '';
    public csrfTokenValue: string = '';
    public searchError: string = '';
    public patients: any[] = [];
    public workbenchSourceChoice: '' | 'patient' | 'scenario' = '';
    public workbenchAdvancedOpen: boolean = false;
    public workbenchRecentWork: any[] = [];
    public workbenchWorkedScenarioIds: string[] = [];
    public readonly workbenchSourcePageSize: number = 5;
    public workbenchPatientQuery: string = '';
    public workbenchScenarioQuery: string = '';
    public workbenchPatientPage: number = 1;
    public workbenchScenarioPage: number = 1;
    public workbenchSelectedModels: string[] = [
        'openai-gpt-image-2',
        'evolink-seedream-5-lite'
    ];
    public workbenchSelectedIntensities: number[] = [1, 2, 3, 4, 5];
    public workbenchPromptOpen: boolean = false;
    public workbenchCutStageOpen: boolean = false;
    public workbenchCutResults: any[] = [];
    public workbenchCutResultsSourceId: string = '';
    public workbenchExpressionStageOpen: boolean = true;
    public workbenchImageSettingsOpen: boolean = false;
    public workbenchImageView: 'focus' | 'compare' = 'compare';
    public workbenchImageFocusKey: string = '';
    public workbenchPromptSection: 'base' | 'common' | 'intensity' | 'model' = 'common';
    public workbenchPromptEditIntensity: number = 3;
    public workbenchPromptEditModel: string = 'openai-gpt-image-2';
    public workbenchNewTriggerElement: string = '';
    public workbenchCustomExpressions: any[] = [];
    public workbenchReusableExpressions: any[] = [];
    public workbenchExpressionDialogOpen: boolean = false;
    public workbenchExpressionName: string = '';
    public workbenchExpressionDescription: string = '';
    public workbenchExpressionBusy: boolean = false;
    public workbenchExpressionError: string = '';
    public workbenchExpressionDrafting: boolean = false;
    public workbenchExpressionDeleteArmed: string = '';
    private workbenchExpressionReturnFocus: HTMLElement | null = null;
    public workbenchPromptDraft: {
        common: string;
        intensities: { [key: number]: string };
        expression_intensities: { trigger: { [key: number]: string }; blur: { [key: number]: string } };
        trigger_elements: string[];
        custom_expression_intensities: { [expressionId: string]: { [key: number]: string } };
        custom_expression_common?: { [expressionId: string]: string };
        analysis_seeded: boolean;
        analysis_binding?: { version: number; cut_key: string };
        models: { [key: string]: string };
        reference_plan: { kind: string; id: string; target: string; traits: string[]; scene_lock: string };
        reference_usage: { [expression: string]: boolean };
        reference_instructions: { [expression: string]: string };
    } = { common: '', intensities: {}, expression_intensities: { trigger: {}, blur: {} }, trigger_elements: [], custom_expression_intensities: {}, custom_expression_common: {}, analysis_seeded: false, models: {}, reference_plan: { kind: '', id: '', target: '', traits: [], scene_lock: '' }, reference_usage: {}, reference_instructions: {} };
    public workbenchNewReferenceTrait: string = '';
    public workbenchPromptSaved: boolean = true;
    public workbenchPromptSaveError: string = '';
    private workbenchPromptSaveTimer: ReturnType<typeof setTimeout> | null = null;
    private workbenchPromptPendingSave: { scope: { scenario_id: string; memory_kind: string; cut_order: number; cut_key?: string }; key: string; draft: any } | null = null;
    private workbenchPromptSaveQueue: Promise<void> = Promise.resolve();
    private workbenchPromptLoadSequence: number = 0;
    private workbenchPromptChangeRevision: number = 0;
    public workbenchAgentHighlightPhase: 'idle' | 'working' | 'complete' = 'idle';
    public workbenchAgentHighlightMode: 'reading' | 'editing' = 'editing';
    public workbenchAgentReadExpressions: Array<'realistic' | 'trigger' | 'blur'> = [];
    public workbenchAgentHighlightTargets: Array<{ section: 'common' | 'intensity' | 'trigger_elements' | 'expression_common' | 'model' | 'reference_plan'; key: string }> = [];
    private workbenchAgentHighlightTimer: ReturnType<typeof setTimeout> | null = null;
    private readonly workbenchModelStorageKey: string = 'ptsd.contentWorkbenchModels.v1';
    private readonly workbenchImageQualityStorageKey: string = 'ptsd.contentWorkbenchOpenAIImageQuality.v1';
    public workbenchModelPickerOpen: boolean = false;
    public workbenchImageQualityPickerOpen: boolean = false;
    public workbenchCountPickerOpen: boolean = false;
    public workbenchCutPickerOpen: boolean = false;
    public workbenchVideoModelPickerOpen: boolean = false;
    public workbenchVideoDurationPickerOpen: boolean = false;
    public workbenchBlurSourcePickerOpen: boolean = false;
    public workbenchComparing: boolean = false;
    public workbenchSceneMasterWaiting: boolean = false;
    private workbenchSceneMasterRevisionId: string = '';
    public workbenchExpression: string = 'realistic';
    public workbenchBlurSourceId: string = '';
    public workbenchBlurPreviewFailedId: string = '';
    public workbenchBlurPreviewReadyId: string = '';
    private workbenchBlurPreviewRefreshIds = new Set<string>();
    public workbenchBlurRegion = { x: 0, y: 0, width: 1, height: 0.55 };
    public readonly workbenchBlurLevels = [
        { value: 1, label: '강한 흐림' }, { value: 2, label: '중간보다 강한 흐림' },
        { value: 3, label: '중간 흐림' }, { value: 4, label: '약한 흐림' },
        { value: 5, label: '추가 흐림 없음' }
    ];
    private workbenchBlurDrag: { x: number; y: number } | null = null;
    public workbenchComparisonJobIds: { [key: string]: string[] } = {};
    private workbenchComparisonJobSnapshots: { [jobId: string]: any } = {};
    public workbenchComparisonError: string = '';
    public workbenchReportOpen: boolean = false;
    public workbenchResultView: 'model' | 'intensity' = 'model';
    public workbenchCompareExpression: string = 'blur';
    public workbenchCompareIntensity: number = 3;
    public workbenchCompareModel: string = '';
    public workbenchCompareExpanded: boolean = false;
    public workbenchComparisonOpen: boolean = true;
    public workbenchCompareMenu: string = '';
    private workbenchCompareCandidates: { [key: string]: number } = {};
    private workbenchCompareInitialized: string = '';
    private workbenchComparisonCacheComplete: boolean = false;
    private workbenchComparisonAutoLoadEnabled: boolean = false;
    private workbenchCompareReturnFocus: HTMLElement | null = null;
    private workbenchComparePreviousOverflow: string = '';
    public workbenchImageResultFilter: { models: string[]; scope: 'cut' | 'scenario' } | null = null;
    public workbenchImageResultLoading: boolean = false;
    public workbenchImageResultError: string = '';
    public workbenchImageArchiveBusy: boolean = false;
    public workbenchImageArchiveError: string = '';
    public workbenchImageResultPage: number = 1;
    private workbenchImageResultSelection: string = '';
    private workbenchImageResultLoadSequence: number = 0;
    private workbenchCollectedImageJobs: any[] = [];
    private workbenchCollectedImageAssets: any[] = [];
    public workbenchScenarioPhotos: any[] = [];
    public workbenchScenarioPhotoId: string = '';
    public workbenchScenarioPhotoPreviewOpen: boolean = false;
    public workbenchScenarioPhotoPreviewLoading: boolean = false;
    public workbenchScenarioPhotoPreviewPhoto: any = null;
    public workbenchScenarioPhotoPreviewIndex: number = 0;
    public workbenchScenarioPhotoPreviewError: string = '';
    private workbenchScenarioPhotoPreviewReturnFocus: HTMLElement | null = null;
    private workbenchScenarioPhotoPreviewSequence: number = 0;
    public workbenchScenarioUploadOpen: boolean = false;
    public workbenchScenarioUploadError: string = '';
    public workbenchScenarioUploading: boolean = false;
    public sourceMode: 'patient' | 'scenario' = 'patient';
    public patientMemoryMode: 'trauma' | 'resource' = 'trauma';
    public resourceMemories: any[] = [];
    public selectedResourceMemoryId: string = '';
    public resourceMemoryLoading: boolean = false;
    public scenarioSets: any[] = [];
    public scenarioCategories: any[] = [];
    public scenarioCatalogError: string = '';
    private scenarioCatalogRefreshSequence: number = 0;
    public representativeScenarioAnalyses: { [key: string]: any } = {};
    public scenarioSelection: any = { scenario_set_id: '', memory_kind: 'trauma' };
    public scenarioAnalysisState: 'idle' | 'loading' | 'complete' | 'error' = 'idle';
    public scenarioAnalysis: any = null;
    public scenarioAnalysisError: string = '';
    public scenarioAnalysisProgressCuts: any[] = [];
    public scenarioAnalysisDrafting: boolean = false;
    public scenarioAnalysisStage: 'source' | 'model' | 'cuts' | 'drafts' = 'source';
    public scenarioEvidenceOpen: boolean = false;
    public scenarioEvidenceLoading: boolean = false;
    public scenarioEvidenceLoadingMessage: string = '원문을 불러오는 중입니다.';
    public scenarioEvidenceError: string = '';
    public scenarioEvidenceWarning: string = '';
    public scenarioEvidence: any = null;
    private scenarioEvidenceReturnFocus: HTMLElement | null = null;
    private scenarioEvidenceSequence: number = 0;
    public selectedScenarioCutOrder: number = 0;
    private requestedImageAgentCutOrder: number = 0;
    public readonly scenarioAnalysisContractVersion: number = 8;
    public scenarioAnalysisNeedsUpgrade: boolean = false;
    private scenarioAnalysisRecoveryAttempts: Set<string> = new Set<string>();
    public templates: any[] = [];
    public jobs: any[] = [];
    public assets: any[] = [];
    public selectedAsset: any = null;
    public selectedReviewAssetId: string = '';
    public confirmedReviewAssetId: string = '';
    public downloadingAssetId: string = '';
    public progressJobId: string = '';
    public selectedVideoSource: any = null;
    public selectedAudioSource: any = null;
    private workbenchAudioRequest: { scope: string; pending: boolean; error: string; model: string } | null = null;
    private workbenchAudioJobSnapshots: { [id: string]: any } = {};
    private workbenchVideoRequest: { scope: string; pending: boolean; error: string; model: string; jobIds: string[] } | null = null;
    private workbenchVideoJobSnapshots: { [id: string]: any } = {};
    public panoramaDialogOpen: boolean = false;
    public panoramaStage: 'setup' | 'generating' | 'complete' | 'error' = 'setup';
    public panoramaSource: any = null;
    public panoramaResult: any = null;
    public panoramaJobId: string = '';
    public panoramaErrorMessage: string = '';
    public panoramaSubmitting: boolean = false;
    public panoramaDownloading: boolean = false;
    public panoramaDownloadFormat: '' | 'sphere' | 'horizontal' = '';
    public panoramaBackDescription: string = '';
    public panoramaProgressIndex: number = 0;
    public panoramaViewMode: 'immersive' | 'flat' = 'immersive';
    public panoramaViewPosition: number = 50;
    public readonly panoramaStages: any[] = [
        {
            label: '원본 이미지 분석',
            description: '시야각, 수평선과 공간 구조를 확인합니다.'
        },
        {
            label: '주변 공간 생성',
            description: '좌우·뒤·위·아래의 보이지 않는 영역을 구성합니다.'
        },
        {
            label: '연결부 보정',
            description: '360° 경계와 천정·바닥의 왜곡을 정리합니다.'
        },
        {
            label: 'VR 이미지 최적화',
            description: '2:1 equirectangular 출력 형식으로 준비합니다.'
        }
    ];
    public selectedReferenceCondition: any = null;
    public referenceUsageMode: 'none' | 'metadata' | 'visual' = 'none';
    public referenceStrength: 'low' | 'medium' | 'high' = 'medium';
    public referenceRoles: string[] = ['background_architecture'];
    public readonly referenceUsageModeOptions: any[] = [
        { value: 'none', label: '사용하지 않음', description: '시나리오와 컷 명세만 사용합니다.' },
        { value: 'metadata', label: '환경 정보만 참고', description: '승인된 시대·지역·환경 태그만 프롬프트에 반영합니다.' },
        { value: 'visual', label: '이미지 요소 참고', description: '선택한 요소에 한해 원본 이미지를 모델에 함께 전달합니다.' }
    ];
    public readonly referenceRoleOptions: any[] = [
        { value: 'background_architecture', label: '배경·건축' },
        { value: 'person_appearance', label: '인물 외형' },
        { value: 'wardrobe', label: '복장' },
        { value: 'vehicle_props', label: '차량·소품' },
        { value: 'color_style', label: '색감·스타일' },
        { value: 'weather_lighting', label: '날씨·조명' }
    ];
    public readonly referenceStrengthOptions: any[] = [
        { value: 'low', label: '낮음' },
        { value: 'medium', label: '중간' },
        { value: 'high', label: '높음' }
    ];
    public referenceConditionPreviewOpen: boolean = false;
    public referenceRecommendations: any[] = [];
    public referenceRecommendationPreviewOpen: boolean = false;
    public referenceRecommendationPreviewIndex: number = 0;
    public referenceRecommendationState: string = 'idle';
    public referenceRecommendationLoading: boolean = false;
    public referenceRecommendationError: string = '';
    public patientSourceImages: any[] = [];
    public selectedPatientSource: any = null;
    public patientSourcePreview: string = '';
    public patientSourceEncoded: string = '';
    public patientSourceMasks: any[] = [];
    public patientSourceMaskDraft: any = null;
    public patientSourceMaskEditorOpen: boolean = false;
    public patientSourceFaceInspectionStatus: 'idle' | 'checking' | 'passed' | 'faces_detected' | 'failed' = 'idle';
    public patientSourceDetectedFaceCount: number = 0;
    public patientSourceIdentifierStatus: '' | 'no_identifiers' | 'masked' = '';
    public patientSourceConsentConfirmed: boolean = false;
    public patientSourceRightsConfirmed: boolean = false;
    public patientSourceSubmitting: boolean = false;
    public patientSourceLoading: boolean = false;
    public capabilities: any = { image_to_video: false };
    public runtime: any = {};
    public generationModelAvailability: any = {};
    public imagePromptValidations: any = {};
    public imageCandidateCount: number = 3;
    public selectedImageQuality: string = 'low';
    public imageGenerationScope: 'single' | 'all' = 'single';
    public imagePromptStrategy: 'legacy' | 'model_specific' = 'legacy';
    public latestImageCostBatchId: string = '';
    public latestIntensityBatchId: string = '';
    public latestImageCostModelKey: string = '';
    public latestImageCostCandidateCount: number = 0;
    public readonly imageCandidateCountOptions: number[] = [1, 2, 3, 4, 5];
    public readonly openAIImageQualityOptions: any[] = [
        { value: 'low', label: 'Low · 낮음' },
        { value: 'medium', label: 'Medium · 보통' },
        { value: 'high', label: 'High · 높음' },
        { value: 'auto', label: 'Auto · 자동' },
        { value: 'xhigh', label: 'XHigh · 매우 높음' },
        { value: 'max', label: 'Max · 최대' }
    ];
    public readonly intensityOptions: number[] = [1, 2, 3, 4, 5];
    public intensityBatchAction: boolean = false;
    public videoIdempotencyKey: string = '';
    public videoGenerationScope: 'single' | 'all' = 'single';
    public selectedIntensityVideoSources: { [key: number]: any } = {};
    public latestVideoBatchId: string = '';
    public videoBatchAction: boolean = false;
    public videoDurationSeconds: number = 3;
    public readonly videoDurationOptions: number[] = [3, 5, 7, 10, 15, 20];
    public readonly generationModelOptions: any = {
        image: [
            { value: 'openai-gpt-image-2', label: 'OpenAI · GPT Image 2.5 Sunburst' },
            { value: 'evolink-seedream-5-lite', label: 'Seedream 5.0 Lite' },
            { value: 'evolink-gemini-3-1-flash-image', label: 'Gemini 3.1 Flash Image' },
            { value: 'evolink-qwen-image-3', label: 'Qwen Image 3.0' },
            { value: 'evolink-grok-imagine-image-2', label: 'Grok Imagine Image 2.0' }
        ],
        audio: [
            { value: 'evolink-qwen-tts', label: 'Qwen Audio 3.1 TTS Flash · 나레이션' },
            { value: 'evolink-seed-audio', label: 'Seed Audio 1.0 · 효과음·환경음' },
            { value: 'evolink-suno', label: 'Suno 5.5 · 배경음악' }
        ],
        video: [
            { value: 'kling-video-3', label: 'Kling AI · Video 3.0' },
            { value: 'evolink-seedance-2-5', label: 'Seedance 2.5' },
            { value: 'evolink-seedance-2-0-fast', label: 'Seedance 2.0 Fast' },
            { value: 'evolink-minimax-h3-max', label: 'MiniMax H3 Max' },
            { value: 'evolink-veo-3-1-fast', label: 'Veo 3.1 Fast' },
            { value: 'wan-2-2', label: 'Wan 2.2' }
        ]
    };
    public readonly imageModelUiProfiles: any = {
        'openai-gpt-image-2': {
            summary: '정밀 편집과 후속 컷 일관성을 위해 Sunburst를 사용합니다.',
            promptRule: '장면 요청을 구조화하고, 요청하지 않은 요소는 유지하도록 안내합니다.',
            settings: ['GPT Image 2.5 Sunburst', '1024 × 1024', 'PNG', '단일 Prompt 전송']
        },
        'evolink-seedream-5-lite': {
            summary: '재질·색·빛·공간 관계를 더 분명하게 전달합니다.',
            promptRule: '표면 질감, 색상, 조명 방향과 분위기 표현 지침을 보강합니다.',
            settings: ['2K', 'PNG', '단일 Prompt 전송']
        },
        'evolink-gemini-3-1-flash-image': {
            summary: '공간 배치·인물 수·촬영 구도와 조명을 명확하게 전달합니다.',
            promptRule: '위치와 구도를 유지하고 요청한 변경만 적용하도록 안내합니다.',
            settings: ['2K', '단일 Prompt 전송']
        },
        'evolink-qwen-image-3': {
            summary: '문서형 표식 없이 실제로 보여야 할 장면만 자연어로 전달합니다.',
            promptRule: '컷 번호·제목·섹션명을 제거하고 시각 묘사만 전송하며 Negative Prompt를 별도 필드로 보냅니다.',
            settings: ['1920 × 1080', 'Negative Prompt 분리', 'Prompt Extend 끔', '워터마크 끔']
        },
        'evolink-grok-imagine-image-2': {
            summary: '자연어 장면 설명과 구도·조명 지시를 간결하게 전달합니다.',
            promptRule: '명시한 피사체, 구도, 조명과 유지 조건을 그대로 따르도록 안내합니다.',
            settings: ['2K', '품질 medium', '단일 Prompt 전송']
        }
    };
    public selectedGenerationModelKeys: any = {
        image: 'openai-gpt-image-2',
        audio: 'evolink-seed-audio',
        video: 'kling-video-3'
    };
    public audioPromptText: string = '';
    public audioDurationSeconds: number = 30;
    public readonly audioDurationOptions: number[] = [10, 20, 30, 60];

    public audioPromptRequired() {
        return this.selectedGenerationModelKeys.audio !== 'evolink-seed-audio';
    }

    public audioPromptLimit() {
        if (this.selectedGenerationModelKeys.audio === 'evolink-suno') return 1000;
        if (this.selectedGenerationModelKeys.audio === 'evolink-seed-audio') return 1500;
        return 5000;
    }

    public audioPromptLabel() {
        if (this.selectedGenerationModelKeys.audio === 'evolink-qwen-tts') return '읽을 나레이션 대본';
        if (this.selectedGenerationModelKeys.audio === 'evolink-suno') return '생성할 배경음악 설명';
        return '추가할 효과음·환경음 설명 (선택)';
    }

    public audioPromptPlaceholder() {
        if (this.selectedGenerationModelKeys.audio === 'evolink-qwen-tts') return '예: 지금은 조용한 방입니다. 편안하게 주변의 소리를 들어봅니다.';
        if (this.selectedGenerationModelKeys.audio === 'evolink-suno') return '예: 느린 템포의 잔잔한 피아노 연주곡. 부드러운 음색, 보컬 없음.';
        return '예: 차 안에서 규칙적으로 들리는 방향지시등 소리와 창밖의 약한 빗소리.';
    }

    public audioInputReady() {
        const length = this.audioPromptText.trim().length;
        return length <= this.audioPromptLimit() && (!this.audioPromptRequired() || length > 0);
    }

    public audioJobOptions() {
        return { audio_prompt: this.audioPromptText.trim(), audio_duration_seconds: this.audioDurationSeconds };
    }

    public onAudioModelChange() {
        this.audioPromptText = '';
        this.form.idempotency_key = this.newIdempotencyKey();
    }

    public actualPromptPreviewOpen: boolean = false;
    public actualPromptPreviewLoading: boolean = false;
    public actualPromptPreviewError: string = '';
    public actualPromptPreview: any = null;
    public actualPromptPreviewStrategy: 'legacy' | 'model_specific' = 'legacy';
    public actualPromptPreviewModelKey: string = '';
    public actualPromptPreviewIntensity: number = 1;
    public referenceAdherenceLoadingJobId: string = '';
    public referenceAdherenceErrorJobId: string = '';
    public referenceAdherenceErrorMessage: string = '';
    public shotConsistencyLoadingJobId: string = '';
    public shotConsistencyErrorJobId: string = '';
    public shotConsistencyErrorMessage: string = '';
    private shotConsistencyAutoPending: { [key: string]: boolean } = {};
    public selectedVideoResultModelKey: string = 'all';
    public metrics: any = {};
    public videoMetrics: any = {};
    public imagePricing: any = { currency: 'USD', estimated: true, models: {} };
    public videoPricing: any = { currency: 'USD', estimated: true, models: {} };
    public filters: any = { text: '', status: '', media_type: '' };
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public form: any = { patient_id: '', scenario_type: '', media_type: 'image', intensity: 1, idempotency_key: '' };
    public promptSelectionMode: 'auto' | 'manual' | 'source' | '' = '';
    public promptMismatchAcknowledged: boolean = false;
    public settingsAccordion: 'prompt' | 'reference' | 'intensity' | 'generation' | '' = 'prompt';
    public mediaTypes: any[] = [
        { value: 'image', label: '이미지', help: '정지 장면과 단계별 시각 노출 자료를 생성합니다.' },
        { value: 'audio', label: '오디오', help: '환경음과 공간 음향 기반 노출 자료를 생성합니다.' },
        { value: 'video', label: '비디오', help: '시간 흐름이 있는 짧은 장면 기반 노출 자료를 생성합니다.' }
    ];
    public scenarios: any[] = [];
    public statusOptions: any[] = [
        { value: '', label: '전체 상태' },
        { value: 'queued', label: '대기' },
        { value: 'running', label: '생성 중' },
        { value: 'postprocessing', label: '후처리' },
        { value: 'review_pending', label: '생성 완료' },
        { value: 'approved', label: '승인' },
        { value: 'rejected', label: '반려' },
        { value: 'failed', label: '실패' },
        { value: 'cancelled', label: '취소' },
        { value: 'quarantined', label: '격리' }
    ];

    private pollTimer: any = null;
    private destroyed: boolean = false;
    private polling: boolean = false;
    private lastEmptyScenarioRefreshAt: number = 0;
    private previewRefreshAttempts: { [key: string]: number } = {};
    private referenceImageErrors: { [key: string]: boolean } = {};
    private previewReturnFocus: HTMLElement | null = null;
    private referencePreviewReturnFocus: HTMLElement | null = null;
    private referenceRecommendationPreviewReturnFocus: HTMLElement | null = null;
    private patientSourceMaskReturnFocus: HTMLElement | null = null;
    private progressReturnFocus: HTMLElement | null = null;
    private panoramaReturnFocus: HTMLElement | null = null;
    private actualPromptPreviewReturnFocus: HTMLElement | null = null;
    private actualPromptPreviewSequence: number = 0;
    private routeSub: any = null;
    private requestedPatientId: string = '';
    private requestedPatientParameterPresent: boolean = false;
    private searchSequence: number = 0;
    private readonly generationReferenceStorageKey = 'ptsd.referenceGenerationCondition.v1';
    private readonly contentPatientStorageKey = 'ptsd.contentPatientSelection.v1';
    private readonly scenarioAnalysisStorageKey = 'ptsd.scenarioCutAnalysis.v1';
    private scenarioAnalysisAbort: AbortController | null = null;
    private scenarioAnalysisSequence: number = 0;
    private readonly workbenchOutsideClickHandler = (event: MouseEvent) => {
        const target = event.target;
        if (!(target instanceof Element) || target.closest('.wb-new-dropdown')) return;
        if (!this.workbenchDropdownOpen()) return;
        this.workbenchCloseDropdowns();
        this.changeDetector.detectChanges();
    };
    private readonly agentPromptContextHandler = (event: Event) => {
        const respond = (event as CustomEvent).detail?.respond;
        if (typeof respond === 'function') respond(this.workbenchAgentPromptContext());
    };
    private readonly agentPromptApplyHandler = (event: Event) => {
        const detail = (event as CustomEvent).detail;
        if (typeof detail?.respond === 'function') {
            detail.respond(this.workbenchExecuteAgentAction(detail.action, detail.context,
                detail.files, detail.isCancelled, detail.onProgress, detail.request));
        }
    };
    private readonly agentPromptActivityHandler = (event: Event) => {
        const detail = (event as CustomEvent).detail;
        if (detail?.phase === 'working' && typeof detail.request === 'string') {
            this.workbenchAgentStartHighlight(detail.request);
        } else if (detail?.phase === 'inspected' && this.workbenchAgentHighlightPhase === 'working'
            && this.workbenchAgentHighlightMode === 'reading') {
            this.workbenchAgentCompleteReadHighlight();
        } else if (detail?.phase === 'clear' && this.workbenchAgentHighlightPhase === 'working') {
            this.workbenchAgentClearHighlight();
            this.changeDetector.detectChanges();
        }
    };
    private readonly agentDataRefreshHandler = (event?: Event) => {
        const scope = (event as CustomEvent)?.detail?.image_agent_scope;
        if (scope && (this.sourceMode !== 'scenario'
            || String(this.scenarioSelection?.scenario_set_id || '').toUpperCase() !== scope.scenario_id
            || (scope.memory_kind && this.scenarioSelection?.memory_kind !== scope.memory_kind)
            || Number(this.selectedScenarioCutOrder) !== Number(scope.cut_order))) return;
        void this.search(false, false);
        if (this.workbenchSourceChoice === 'scenario') void this.refreshScenarioCatalog();
    };
    private readonly scenarioLibraryChangedHandler = () => {
        void this.refreshScenarioCatalog();
    };
    private readonly scenarioCatalogVisibilityHandler = () => {
        if (!document.hidden && this.workbenchSourceChoice === 'scenario') {
            void this.refreshScenarioCatalog();
        }
    };

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef    )         private changeDetector: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');

        if (!this.can('content.read')) {
            this.accessDenied = true;
            this.loading = false;
            await this.service.render();
            return;
        }
        document.addEventListener('click', this.workbenchOutsideClickHandler);
        this.workbenchRestoreComparisonOpen();

        this.routeSub = this.route.queryParamMap.subscribe((params) => {
            if (params.get('reference_condition') === '1') {
                this.consumeReferenceGenerationCondition();
            }
            const previousSourceMode = this.sourceMode;
            const previousPatientId = String(this.form.patient_id || '');
            const previousPatientMemoryMode = this.patientMemoryMode;
            const previousResourceMemoryId = this.selectedResourceMemoryId;
            const previousScenarioSetId = String(
                this.scenarioSelection.scenario_set_id || ''
            );
            const previousMemoryKind = String(
                this.scenarioSelection.memory_kind || ''
            );
            const routeScenarioSetId = this.normalizeScenarioRouteId(
                params.get('scenario')
            );
            if (params.get('reference_condition') === '1' && routeScenarioSetId) {
                try {
                    window.sessionStorage.removeItem(
                        `ptsd.workbenchScenarioPhoto.${routeScenarioSetId}`
                    );
                } catch (_error) {
                }
            }
            const routeScenarioMode = params.get('source') === 'scenario'
                || !!routeScenarioSetId;
            const routeMemoryKind = this.normalizeScenarioMemoryKind(
                params.get('memory')
            );
            const requestedCut = String(params.get('cut') || '');
            this.requestedImageAgentCutOrder = /^(?:[1-9]|1[0-2])$/.test(requestedCut)
                ? Number(requestedCut) : 0;
            this.sourceMode = routeScenarioMode ? 'scenario' : 'patient';
            if (routeScenarioMode) {
                this.scenarioSelection.scenario_set_id = routeScenarioSetId;
                this.scenarioSelection.memory_kind = routeMemoryKind;
                this.patientMemoryMode = 'trauma';
                this.selectedResourceMemoryId = '';
            } else {
                this.patientMemoryMode = params.get('memory_mode') === 'resource'
                    ? 'resource'
                    : 'trauma';
                this.selectedResourceMemoryId = this.normalizeRequestedPatientId(
                    params.get('resource_memory_id')
                );
            }
            const routePatientParameterPresent = !routeScenarioMode
                && params.has('patient_id');
            if (routeScenarioSetId) this.workbenchSourceChoice = 'scenario';
            else if (routePatientParameterPresent && params.get('patient_id')) {
                this.workbenchSourceChoice = 'patient';
            }
            const routePatientId = this.normalizeRequestedPatientId(
                params.get('patient_id')
            );
            const rememberedPatientId = routeScenarioMode
                ? ''
                : routePatientParameterPresent
                ? ''
                : this.rememberedContentPatientId();
            this.requestedPatientId = routePatientId || rememberedPatientId;
            this.requestedPatientParameterPresent = (
                routePatientParameterPresent || !!rememberedPatientId
            );
            if (routePatientParameterPresent) {
                this.rememberContentPatientId(routePatientId);
            }
            if (this.loading) return;
            this.applyDefaults();
            const sourceChanged = previousSourceMode !== this.sourceMode;
            const patientChanged = previousPatientId !== String(
                this.form.patient_id || ''
            );
            const scenarioChanged = previousScenarioSetId !== String(
                this.scenarioSelection.scenario_set_id || ''
            );
            const memoryChanged = previousMemoryKind !== String(
                this.scenarioSelection.memory_kind || ''
            );
            const patientMemoryChanged = (
                previousPatientMemoryMode !== this.patientMemoryMode
                || previousResourceMemoryId !== this.selectedResourceMemoryId
            );
            if (sourceChanged || patientChanged || scenarioChanged || memoryChanged || patientMemoryChanged) {
                this.form.idempotency_key = this.newIdempotencyKey();
                this.videoIdempotencyKey = this.newIdempotencyKey();
                this.resetScenarioAnalysis();
                this.clearPatientContent();
                this.settingsAccordion = 'prompt';
                if (this.sourceMode === 'scenario') {
                    this.form.scenario_type = '';
                    this.promptSelectionMode = '';
                    this.promptMismatchAcknowledged = false;
                    this.selectedReferenceCondition = null;
                    this.referenceUsageMode = 'none';
                    this.restoreScenarioAnalysis();
                    void this.workbenchLoadCustomExpressions();
                } else {
                    if (this.patientMemoryMode === 'resource') {
                        this.form.media_type = 'image';
                        this.form.scenario_type = 'resource_memory';
                    } else {
                        this.syncScenarioForSelectedPatient();
                    }
                }
                void this.search(true);
                if (this.sourceMode === 'patient') {
                    void this.loadResourceMemories();
                    if (this.patientMemoryMode === 'trauma') {
                        void this.loadPatientSourceImages();
                    }
                }
                void this.loadReferenceRecommendations();
            }
            if (this.sourceMode === 'scenario' && this.scenarioAnalysisState === 'complete'
                && this.requestedImageAgentCutOrder) {
                const requested = this.scenarioAnalysisCuts().find((cut: any) =>
                    Number(cut.order) === this.requestedImageAgentCutOrder);
                this.requestedImageAgentCutOrder = 0;
                if (requested) this.selectScenarioCut(requested);
            }
            void this.service.render();
        });
        await this.bootstrap();
        if (this.sourceMode === 'scenario' && this.selectedScenarioSet()) {
            await this.workbenchLoadCustomExpressions();
            await this.workbenchLoadPromptDraft();
        }
        window.addEventListener('ptsd:agent:prompt-context', this.agentPromptContextHandler);
       window.addEventListener('ptsd:agent:prompt-apply', this.agentPromptApplyHandler);
        window.addEventListener('ptsd:agent:prompt-activity', this.agentPromptActivityHandler);
        window.addEventListener('ptsd:agent:refresh-data', this.agentDataRefreshHandler);
        window.addEventListener('ptsd:scenario:library-changed', this.scenarioLibraryChangedHandler);
        document.addEventListener('visibilitychange', this.scenarioCatalogVisibilityHandler);
        window.addEventListener('focus', this.scenarioCatalogVisibilityHandler);
        this.workbenchComparisonAutoLoadEnabled = true;
        void this.workbenchEnsureComparisonResults();
        this.startPolling();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.workbenchComparisonAutoLoadEnabled = false;
        this.workbenchImageResultLoadSequence = (this.workbenchImageResultLoadSequence || 0) + 1;
        if (this.workbenchCompareExpanded) document.body.style.overflow = this.workbenchComparePreviousOverflow;
        void this.workbenchFlushPromptSave();
        document.removeEventListener('click', this.workbenchOutsideClickHandler);
        window.removeEventListener('ptsd:agent:prompt-context', this.agentPromptContextHandler);
       window.removeEventListener('ptsd:agent:prompt-apply', this.agentPromptApplyHandler);
        window.removeEventListener('ptsd:agent:prompt-activity', this.agentPromptActivityHandler);
        window.removeEventListener('ptsd:agent:refresh-data', this.agentDataRefreshHandler);
        window.removeEventListener('ptsd:scenario:library-changed', this.scenarioLibraryChangedHandler);
        document.removeEventListener('visibilitychange', this.scenarioCatalogVisibilityHandler);
        window.removeEventListener('focus', this.scenarioCatalogVisibilityHandler);
        this.workbenchAgentClearHighlight();
        this.scenarioAnalysisAbort?.abort();
        if (this.pollTimer) {
            window.clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
        if (this.routeSub) {
            this.routeSub.unsubscribe();
            this.routeSub = null;
        }
        this.referencePreviewReturnFocus = null;
        this.referenceRecommendationPreviewReturnFocus = null;
        this.patientSourceMaskReturnFocus = null;
        this.panoramaReturnFocus = null;
        this.actualPromptPreviewReturnFocus = null;
        this.scenarioEvidenceReturnFocus = null;
        this.workbenchExpressionReturnFocus = null;
        document.body.style.overflow = '';
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    private normalizedReferenceCondition(value: any) {
        if (!value || typeof value !== 'object') return null;
        const referenceId = String(value?.reference_id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(referenceId)) return null;
        return {
            schema_version: 1,
            reference_id: referenceId,
            title: String(value?.title || '').slice(0, 255),
            source_label: String(value?.source_label || '').slice(0, 120),
            era_bucket: String(value?.era_bucket || '').slice(0, 32),
            era_label: String(value?.era_label || '').slice(0, 80),
            region: String(value?.region || '').slice(0, 80),
            district: String(value?.district || '').slice(0, 80),
            category: String(value?.category || '').slice(0, 120),
            tags: Array.isArray(value?.tags)
                ? value.tags.map((item: any) => String(item || '').slice(0, 80)).filter(Boolean).slice(0, 30)
                : [],
            semantic_tags: Array.isArray(value?.semantic_tags)
                ? value.semantic_tags.map((item: any) => String(item || '').slice(0, 80)).filter(Boolean).slice(0, 32)
                : [],
            preview_thumbnail_url: this.publicReferenceImageUrl(
                value?.preview_thumbnail_url
            ),
            preview_image_url: this.publicReferenceImageUrl(
                value?.preview_image_url
            ),
            original_image_transmitted: false
        };
    }

    private consumeReferenceGenerationCondition() {
        let parsed: any = null;
        try {
            const raw = window.sessionStorage.getItem(
                this.generationReferenceStorageKey
            );
            parsed = raw ? JSON.parse(raw) : null;
            window.sessionStorage.removeItem(this.generationReferenceStorageKey);
        } catch (_error) {
            try {
                window.sessionStorage.removeItem(this.generationReferenceStorageKey);
            } catch (_ignored) {
            }
        }
        const condition = this.normalizedReferenceCondition(parsed);
        if (!condition) return;
        this.selectedReferenceCondition = condition;
        this.workbenchScenarioPhotoId = '';
        this.referenceUsageMode = 'metadata';
        this.referenceRoles = ['background_architecture'];
        this.referenceStrength = 'medium';
        this.selectedPatientSource = null;
        this.form.media_type = 'image';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
    }

    public async clearReferenceGenerationCondition() {
        if (this.referenceConditionPreviewOpen) {
            await this.closeReferenceConditionPreview();
        }
        this.selectedReferenceCondition = null;
        this.referenceUsageMode = 'none';
        this.referenceRoles = ['background_architecture'];
        this.referenceStrength = 'medium';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        try {
            window.sessionStorage.removeItem(this.generationReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    public patientSourceRequestId(mediaType: string = this.form.media_type) {
        if (!['image', 'video'].includes(this.normalizeMediaType(mediaType))) return '';
        const sourceId = String(
            this.selectedPatientSource?.patient_source_image_id
            || this.selectedPatientSource?.id
            || ''
        ).trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(sourceId) ? sourceId : '';
    }

    public patientSourceStatusLabel(source: any) {
        const labels: any = {
            pending: '승인 대기', approved: '승인', rejected: '반려', archived: '보관 종료'
        };
        return labels[String(source?.review_status || '').toLowerCase()] || '상태 확인 필요';
    }

    public patientSourceSelectable(source: any) {
        return String(source?.review_status || '').toLowerCase() === 'approved'
            && String(source?.scenario_type || '') === String(this.form.scenario_type || '');
    }

    public patientSourceSelected(source: any) {
        return this.patientSourceRequestId() === String(
            source?.patient_source_image_id || source?.id || ''
        );
    }

    public async selectPatientSource(source: any) {
        if (!this.patientSourceSelectable(source)) return;
        this.selectedPatientSource = this.patientSourceSelected(source) ? null : source;
        if (this.selectedPatientSource) {
            this.selectedReferenceCondition = null;
            this.referenceUsageMode = 'none';
            if (this.form.media_type === 'image') {
                this.selectedGenerationModelKeys.image = 'openai-gpt-image-2';
            }
            this.selectedVideoSource = null;
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public async loadPatientSourceImages() {
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        if (!patientId || !this.can('content.read')) {
            this.patientSourceImages = [];
            this.selectedPatientSource = null;
            return;
        }
        this.patientSourceLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('patient_source_images', {
                patient_id: patientId
            });
            if (code === 200) {
                this.patientSourceImages = this.extractList(data, ['items']);
                const selectedId = this.patientSourceRequestId();
                this.selectedPatientSource = this.patientSourceImages.find(
                    (item: any) => String(item?.id || '') === selectedId
                        && this.patientSourceSelectable(item)
                ) || null;
            }
        } finally {
            this.patientSourceLoading = false;
            await this.service.render();
        }
    }

    public async onPatientSourceFile(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        this.resetPatientSourceUpload(false);
        if (!file) return;
        if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
            input.value = '';
            await this.service.modal.error('PNG, JPEG 또는 WebP 사진만 첨부할 수 있습니다.');
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            input.value = '';
            await this.service.modal.error('사진은 10MB 이하만 첨부할 수 있습니다.');
            return;
        }
        const encoded = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });
        this.patientSourcePreview = encoded;
        this.patientSourceEncoded = encoded;
        this.patientSourceFaceInspectionStatus = 'checking';
        await this.service.render();
        try {
            const response: any = await wiz.call('inspect_patient_source_image', {
                image_base64: encoded,
                csrf_token: this.csrfToken()
            });
            const result = response?.responseJSON || response || {};
            const data = result?.data || {};
            if (result?.code !== 200) {
                this.patientSourceFaceInspectionStatus = 'failed';
                await this.service.modal.error(
                    data?.message || '사진의 자동 얼굴 검사를 완료하지 못했습니다.'
                );
                return;
            }
            const faceRegions = Array.isArray(data?.face_regions)
                ? data.face_regions
                : [];
            this.patientSourceDetectedFaceCount = Math.max(
                0,
                Number(data?.face_count || faceRegions.length) || 0
            );
            if (this.patientSourceDetectedFaceCount > 0) {
                this.patientSourceFaceInspectionStatus = 'faces_detected';
                this.patientSourceIdentifierStatus = 'masked';
                this.patientSourceMasks = faceRegions.slice(0, 16);
                await this.service.render();
                await this.service.modal.warning(
                    `얼굴 ${this.patientSourceDetectedFaceCount}개를 감지해 자동으로 가렸습니다. 큰 화면에서 모든 얼굴과 추가 식별정보를 확인해주세요.`,
                    false,
                    '확인'
                );
                await this.openPatientSourceMaskEditor();
            } else {
                this.patientSourceFaceInspectionStatus = 'passed';
            }
        } catch (_error) {
            this.patientSourceFaceInspectionStatus = 'failed';
            await this.service.modal.error(
                '사진의 자동 얼굴 검사를 완료하지 못해 저장과 생성을 차단했습니다.'
            );
        } finally {
            await this.service.render();
        }
    }

    public resetPatientSourceUpload(render: boolean = false) {
        if (this.patientSourceMaskEditorOpen) document.body.style.overflow = '';
        this.patientSourceMaskEditorOpen = false;
        this.patientSourceMaskReturnFocus = null;
        this.patientSourcePreview = '';
        this.patientSourceEncoded = '';
        this.patientSourceMasks = [];
        this.patientSourceMaskDraft = null;
        this.patientSourceFaceInspectionStatus = 'idle';
        this.patientSourceDetectedFaceCount = 0;
        this.patientSourceIdentifierStatus = '';
        this.patientSourceConsentConfirmed = false;
        this.patientSourceRightsConfirmed = false;
        if (render) void this.service.render();
    }

    public async openPatientSourceMaskEditor() {
        if (!this.patientSourcePreview) return;
        this.patientSourceMaskReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.patientSourceMaskEditorOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            document.getElementById('patient-source-mask-editor-close')?.focus();
        }, 0);
    }

    public async closePatientSourceMaskEditor() {
        this.patientSourceMaskEditorOpen = false;
        this.patientSourceMaskDraft = null;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.patientSourceMaskReturnFocus;
        this.patientSourceMaskReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onPatientSourceMaskEditorKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closePatientSourceMaskEditor();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'patient-source-mask-editor-dialog');
    }

    private patientSourcePoint(event: PointerEvent) {
        const target = event.currentTarget as HTMLElement;
        const rect = target.getBoundingClientRect();
        return {
            x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)),
            y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height))
        };
    }

    public onPatientSourceMaskStart(event: PointerEvent) {
        if (!this.patientSourcePreview || this.patientSourceIdentifierStatus !== 'masked') return;
        event.preventDefault();
        (event.currentTarget as HTMLElement).setPointerCapture?.(event.pointerId);
        const point = this.patientSourcePoint(event);
        this.patientSourceMaskDraft = { startX: point.x, startY: point.y, x: point.x, y: point.y, width: 0, height: 0 };
    }

    public onPatientSourceMaskMove(event: PointerEvent) {
        if (!this.patientSourceMaskDraft) return;
        const point = this.patientSourcePoint(event);
        const startX = this.patientSourceMaskDraft.startX;
        const startY = this.patientSourceMaskDraft.startY;
        this.patientSourceMaskDraft = {
            startX, startY,
            x: Math.min(startX, point.x),
            y: Math.min(startY, point.y),
            width: Math.abs(point.x - startX),
            height: Math.abs(point.y - startY)
        };
        this.changeDetector.detectChanges();
    }

    public onPatientSourceMaskEnd(event: PointerEvent) {
        if (!this.patientSourceMaskDraft) return;
        event.preventDefault();
        const region = this.patientSourceMaskDraft;
        this.patientSourceMaskDraft = null;
        if (region.width > 0.005 && region.height > 0.005 && this.patientSourceMasks.length < 16) {
            const { x, y, width, height } = region;
            this.patientSourceMasks = [...this.patientSourceMasks, { x, y, width, height }];
        }
        this.changeDetector.detectChanges();
    }

    public patientSourceMaskRows() {
        return this.patientSourceMaskDraft
            ? [...this.patientSourceMasks, this.patientSourceMaskDraft]
            : this.patientSourceMasks;
    }

    public async clearPatientSourceMasks() {
        this.patientSourceMasks = [];
        this.patientSourceMaskDraft = null;
        await this.service.render();
    }

    public async uploadPatientSourceImage() {
        if (this.patientSourceSubmitting || !this.can('content.write')) return;
        if (!this.patientSourceEncoded) {
            await this.service.modal.error('첨부할 사진을 선택해주세요.');
            return;
        }
        if (
            this.patientSourceFaceInspectionStatus === 'checking'
            || this.patientSourceFaceInspectionStatus === 'failed'
            || this.patientSourceFaceInspectionStatus === 'idle'
        ) {
            await this.service.modal.error('자동 얼굴 검사를 완료한 뒤 저장해주세요.');
            return;
        }
        if (!this.patientSourceIdentifierStatus) {
            await this.service.modal.error(
                '자동 검사 결과와 별개로 사진 전체를 직접 확인하고 식별정보 검토 결과를 선택해주세요.'
            );
            return;
        }
        if (this.patientSourceIdentifierStatus === 'masked' && !this.patientSourceMasks.length) {
            await this.service.modal.error('사진에서 식별정보 영역을 드래그해 가려주세요.');
            return;
        }
        if (!this.patientSourceConsentConfirmed || !this.patientSourceRightsConfirmed) {
            await this.service.modal.error('치료 목적 생성 동의와 사진 사용 권한을 모두 확인해주세요.');
            return;
        }
        this.patientSourceSubmitting = true;
        await this.service.render();
        try {
            const response: any = await wiz.call('upload_patient_source_image', {
                patient_id: this.form.patient_id,
                scenario_type: this.form.scenario_type,
                image_base64: this.patientSourceEncoded,
                identifier_review_status: this.patientSourceIdentifierStatus,
                mask_regions: JSON.stringify(this.patientSourceMasks),
                consent_confirmed: this.patientSourceConsentConfirmed,
                rights_confirmed: this.patientSourceRightsConfirmed,
                csrf_token: this.csrfToken()
            });
            const result = response?.responseJSON || response || {};
            const code = result?.code;
            const data = result?.data || {};
            if (code !== 201) {
                await this.service.modal.error(data?.message || '환자 제공 사진을 저장하지 못했습니다.');
                return;
            }
            this.resetPatientSourceUpload();
            await this.loadPatientSourceImages();
            await this.service.modal.success('비식별 사본을 저장했습니다. 치료자 승인 후 생성에 사용할 수 있습니다.');
        } finally {
            this.patientSourceSubmitting = false;
            await this.service.render();
        }
    }

    public async reviewPatientSource(source: any, decision: 'approved' | 'rejected' | 'archived') {
        if (!this.can('content.write')) return;
        let comment = '';
        if (decision === 'rejected') {
            comment = String(window.prompt('반려 사유를 입력해주세요.') || '').trim();
            if (!comment) return;
        }
        const { code, data } = await wiz.call('review_patient_source_image', {
            patient_source_image_id: source?.id,
            decision,
            comment,
            csrf_token: this.csrfToken()
        });
        if (code !== 200) {
            await this.service.modal.error(data?.message || '사진 검토 상태를 변경하지 못했습니다.');
            return;
        }
        if (this.patientSourceSelected(source) && decision !== 'approved') {
            this.selectedPatientSource = null;
        }
        await this.loadPatientSourceImages();
    }

    private publicReferenceImageUrl(value: any) {
        const url = String(value || '').trim().slice(0, 1000);
        if (!/^https?:\/\//i.test(url)) return '';
        try {
            const parsed = new URL(url);
            return ['http:', 'https:'].includes(parsed.protocol) ? url : '';
        } catch (_error) {
            return '';
        }
    }

    private referenceImageAvailable(url: string) {
        return !!url && this.referenceImageErrors[url] !== true;
    }

    public referenceConditionThumbnailUrl() {
        const thumbnail = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_thumbnail_url
        );
        const image = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_image_url
        );
        if (this.referenceImageAvailable(thumbnail)) return thumbnail;
        return this.referenceImageAvailable(image) ? image : '';
    }

    public referenceConditionFullImageUrl() {
        const image = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_image_url
        );
        const thumbnail = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_thumbnail_url
        );
        if (this.referenceImageAvailable(image)) return image;
        return this.referenceImageAvailable(thumbnail) ? thumbnail : '';
    }

    public async onReferenceConditionImageError(url: string) {
        const normalized = this.publicReferenceImageUrl(url);
        if (normalized) this.referenceImageErrors[normalized] = true;
        if (!this.referenceConditionFullImageUrl()) {
            this.referenceConditionPreviewOpen = false;
            document.body.style.overflow = '';
        }
        await this.service.render();
    }

    public async openReferenceConditionPreview() {
        if (!this.referenceConditionFullImageUrl()) return;
        this.referencePreviewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.referenceConditionPreviewOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            document.getElementById('content-reference-preview-close')?.focus();
        }, 0);
    }

    public async closeReferenceConditionPreview() {
        this.referenceConditionPreviewOpen = false;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.referencePreviewReturnFocus;
        this.referencePreviewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onReferenceConditionPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeReferenceConditionPreview();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-reference-preview-dialog');
    }

    public referenceConditionRequestId(mediaType: string = this.form.media_type) {
        const normalizedMediaType = this.normalizeMediaType(mediaType);
        if (!['image', 'video'].includes(normalizedMediaType)) return '';
        if (this.referenceUsageMode === 'none') return '';
        const referenceId = String(
            this.selectedReferenceCondition?.reference_id || ''
        ).trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(referenceId) ? referenceId : '';
    }

    public referencePolicyRequest(mediaType: string = this.form.media_type) {
        const normalizedMediaType = this.normalizeMediaType(mediaType);
        if (normalizedMediaType === 'image' && !this.workbenchReferenceEnabled()) {
            return { reference_id: '', reference_usage_mode: 'none', reference_roles: '[]', reference_strength: this.referenceStrength };
        }
        const hasReference = !!this.referenceConditionRequestId(normalizedMediaType);
        const mode = !hasReference
            ? 'none'
            : (
                normalizedMediaType === 'image'
                    ? this.referenceUsageMode
                    : 'metadata'
            );
        return {
            reference_id: this.referenceConditionRequestId(mediaType),
            reference_usage_mode: mode,
            reference_roles: JSON.stringify(
                mode === 'visual' ? this.referenceRoles.slice(0, 2) : []
            ),
            reference_strength: this.referenceStrength
        };
    }

    public referenceUsageModeForMedia(mediaType: string = this.form.media_type) {
        if (!this.selectedReferenceCondition || this.referenceUsageMode === 'none') {
            return 'none';
        }
        return this.normalizeMediaType(mediaType) === 'image'
            ? this.referenceUsageMode
            : 'metadata';
    }

    public referenceUsageDescription() {
        return String(
            this.referenceUsageModeOptions.find(
                (item: any) => item.value === this.referenceUsageMode
            )?.description || ''
        );
    }

    public async setReferenceUsageMode(value: any) {
        const mode = String(value || '').trim().toLowerCase();
        if (!['none', 'metadata', 'visual'].includes(mode)) return;
        if (mode !== 'none' && !this.selectedReferenceCondition) {
            await this.service.modal.error('먼저 레퍼런스 자료를 선택해주세요.');
            return;
        }
        this.referenceUsageMode = mode as 'none' | 'metadata' | 'visual';
        if (mode === 'visual' && !this.referenceRoles.length) {
            this.referenceRoles = ['background_architecture'];
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.resetActualPromptPreview();
        await this.service.render();
    }

    public referenceRoleSelected(value: string) {
        return this.referenceRoles.includes(String(value || ''));
    }

    public async toggleReferenceRole(value: string) {
        value = String(value || '').trim();
        if (!this.referenceRoleOptions.some((item: any) => item.value === value)) return;
        if (this.referenceRoleSelected(value)) {
            if (this.referenceRoles.length === 1) {
                await this.service.modal.error('직접 참고할 시각 요소를 하나 이상 선택해주세요.');
                return;
            }
            this.referenceRoles = this.referenceRoles.filter((item: string) => item !== value);
        } else {
            if (this.referenceRoles.length >= 2) {
                await this.service.modal.error('직접 참고할 시각 요소는 최대 2개까지 선택할 수 있습니다.');
                return;
            }
            this.referenceRoles = [...this.referenceRoles, value];
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.resetActualPromptPreview();
        await this.service.render();
    }

    public async setReferenceStrength(value: any) {
        const strength = String(value || '').trim().toLowerCase();
        if (!['low', 'medium', 'high'].includes(strength)) return;
        this.referenceStrength = strength as 'low' | 'medium' | 'high';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.resetActualPromptPreview();
        await this.service.render();
    }

    public referenceConditionSummary(value: any = this.selectedReferenceCondition) {
        if (!value) return '';
        return [
            String(value?.era_label || '').trim(),
            String(value?.region || '').trim(),
            String(value?.district || '').trim(),
            String(value?.category || '').trim()
        ].filter((item: string, index: number, items: string[]) =>
            !!item && item !== '연대 미상' && items.indexOf(item) === index
        ).join(' · ');
    }

    public assetReferenceCondition(record: any) {
        return this.referenceConditionFromRecord(record);
    }

    public referenceAdherence(record: any) {
        const candidates = [
            record?.reference_adherence,
            record?.asset?.reference_adherence,
            this.primaryMetadata(record)?.reference_adherence
        ];
        return candidates.find((value: any) => (
            value && typeof value === 'object' && !Array.isArray(value)
        )) || null;
    }

    public referenceAdherenceEligible(record: any) {
        const status = String(record?.job_status || record?.status || '').toLowerCase();
        return this.mediaType(record) === 'image'
            && !!this.jobId(record)
            && !!this.assetId(record)
            && !!this.assetReferenceCondition(record)
            && !['queued', 'running', 'postprocessing', 'failed', 'cancelled'].includes(status);
    }

    public referenceAdherenceStatusLabel(value: any) {
        const labels: any = {
            passed: '통과',
            warning: '검토 필요',
            failed: '미달',
            unavailable: '검사 불가'
        };
        return labels[String(value || '').toLowerCase()] || '미검사';
    }

    public referenceAdherenceStatusClass(value: any) {
        const status = String(value || '').toLowerCase();
        if (status === 'passed') return 'is-passed';
        if (status === 'warning') return 'is-warning';
        if (status === 'failed') return 'is-failed';
        return 'is-unavailable';
    }

    public referenceAdherenceScore(value: any, field: string) {
        const score = Number(value?.[field]);
        if (!Number.isFinite(score)) return '-';
        if (
            field !== 'request_inclusion_score'
            && String(value?.visual_similarity_status || '') === 'unavailable'
        ) return '-';
        return `${Math.max(0, Math.min(100, Math.round(score)))}점`;
    }

    public referenceAdherenceMode(value: any) {
        const mode = String(
            value?.metrics?.request_evidence?.usage_mode || 'metadata'
        ).toLowerCase();
        return mode === 'visual' ? '이미지 요소 참고' : '환경 정보 참고';
    }

    public referenceAdherenceRoleScores(value: any) {
        const scores = value?.metrics?.visual?.role_scores;
        if (!scores || typeof scores !== 'object' || Array.isArray(scores)) return [];
        return Object.entries(scores).map(([key, score]: [string, any]) => ({
            key,
            label: String(
                this.referenceRoleOptions.find((item: any) => item.value === key)?.label
                || key
            ),
            score: `${Math.max(0, Math.min(100, Math.round(Number(score || 0))))}점`
        }));
    }

    public referenceAdherenceComparisons(record: any) {
        const referenceId = String(
            this.assetReferenceCondition(record)?.reference_id || ''
        );
        if (!referenceId) return [];
        return this.allReviewAssets('image')
            .filter((candidate: any) => (
                String(this.assetReferenceCondition(candidate)?.reference_id || '') === referenceId
                && !!this.referenceAdherence(candidate)
            ))
            .sort((left: any, right: any) => (
                Number(this.referenceAdherence(right)?.reflection_score || -1)
                - Number(this.referenceAdherence(left)?.reflection_score || -1)
            ));
    }

    public async evaluateReferenceAdherence(record: any, force: boolean = false) {
        const jobId = this.jobId(record);
        if (!this.can('content.write') || !this.referenceAdherenceEligible(record) || !jobId) return;
        this.referenceAdherenceLoadingJobId = jobId;
        this.referenceAdherenceErrorJobId = '';
        this.referenceAdherenceErrorMessage = '';
        this.changeDetector.detectChanges();
        try {
            const { code, data } = await wiz.call('evaluate_reference_adherence', {
                job_id: jobId,
                force,
                csrf_token: this.csrfToken()
            });
            if (code !== 200 || !data?.evaluation) {
                this.referenceAdherenceErrorJobId = jobId;
                this.referenceAdherenceErrorMessage = data?.message || '레퍼런스 반영도를 검사하지 못했습니다.';
                return;
            }
            const evaluation = data.evaluation;
            this.jobs = this.jobs.map((item: any) => (
                this.jobId(item) === jobId
                    ? { ...item, reference_adherence: evaluation }
                    : item
            ));
            this.assets = this.assets.map((item: any) => (
                this.jobId(item) === jobId
                    ? { ...item, reference_adherence: evaluation }
                    : item
            ));
            if (this.selectedAsset && this.jobId(this.selectedAsset) === jobId) {
                this.selectedAsset = {
                    ...this.selectedAsset,
                    reference_adherence: evaluation
                };
            }
        } catch (_error) {
            this.referenceAdherenceErrorJobId = jobId;
            this.referenceAdherenceErrorMessage = '레퍼런스 반영도를 검사하지 못했습니다.';
        } finally {
            this.referenceAdherenceLoadingJobId = '';
            this.changeDetector.detectChanges();
        }
    }

    public firstTraumaScenarioCut() {
        return this.scenarioAnalysisCuts().find(
            (cut: any) => this.scenarioCutMemoryKind(cut) === 'trauma'
        ) || null;
    }

    public scenarioCutOrder(record: any) {
        const value = Number(
            record?.scenario_cut_order
            || this.primaryMetadata(record)?.scenario_cut_order
            || 0
        );
        return Number.isFinite(value) && value >= 1 && value <= 12
            ? Math.floor(value)
            : 0;
    }

    public scenarioCutTitle(record: any) {
        return String(
            record?.scenario_cut_title
            || this.primaryMetadata(record)?.scenario_cut_title
            || ''
        ).trim();
    }

    public recordScenarioMemoryKind(record: any): 'trauma' | 'positive' {
        return String(
            record?.scenario_cut_memory_kind
            || this.primaryMetadata(record)?.scenario_cut_memory_kind
            || record?.memory_kind
            || ''
        ).trim().toLowerCase() === 'positive' ? 'positive' : 'trauma';
    }

    public scenarioAnalysisSnapshot(record: any) {
        const value = String(
            record?.scenario_analysis_snapshot_sha256
            || this.primaryMetadata(record)?.scenario_analysis_snapshot_sha256
            || ''
        ).trim().toLowerCase();
        return /^[a-f0-9]{64}$/.test(value) ? value : '';
    }

    public shotConsistency(record: any) {
        const candidates = [
            record?.shot_consistency,
            record?.asset?.shot_consistency,
            this.primaryMetadata(record)?.shot_consistency
        ];
        return candidates.find((value: any) => (
            value && typeof value === 'object' && !Array.isArray(value)
        )) || null;
    }

    public shotConsistencyEligible(record: any) {
        const status = String(record?.job_status || record?.status || '').toLowerCase();
        return this.mediaType(record) === 'image'
            && String(record?.generation_mode || '') === 'continuity_image_to_image'
            && !!String(record?.source_asset_revision_id || '')
            && !!this.jobId(record)
            && !!this.assetId(record)
            && !['queued', 'running', 'postprocessing', 'failed', 'cancelled'].includes(status);
    }

    public shotConsistencyStatusLabel(value: any) {
        const labels: any = {
            passed: '일관성 통과',
            warning: '검토 필요',
            failed: '일관성 미달'
        };
        return labels[String(value || '').toLowerCase()] || '미검사';
    }

    public shotConsistencyMetricRows(consistency: any) {
        const threshold = Math.max(
            0,
            Math.min(100, Number(consistency?.element_warning_threshold ?? 60))
        );
        const expectedChanges = new Set(
            Array.isArray(consistency?.metrics?.expected_change_elements)
                ? consistency.metrics.expected_change_elements.map(
                    (value: any) => String(value || '')
                )
                : []
        );
        return [
            { element: 'subject', field: 'subject_score', label: '인물·피사체' },
            { element: 'wardrobe', field: 'wardrobe_score', label: '복장' },
            { element: 'background', field: 'background_score', label: '배경·공간' },
            { element: 'vehicle', field: 'vehicle_score', label: '차량·소품' },
            { element: 'weather', field: 'weather_score', label: '날씨·대기' },
            { element: 'lighting', field: 'lighting_score', label: '조명·명암' },
            { element: 'style', field: 'style_score', label: '색감·스타일' }
        ].map((item: any) => {
            const raw = consistency?.[item.field];
            const numeric = raw === null || raw === undefined || raw === ''
                ? null
                : Number(raw);
            const score = numeric !== null && Number.isFinite(numeric)
                ? Math.max(0, Math.min(100, Math.round(numeric)))
                : null;
            const expectedChange = expectedChanges.has(item.element);
            return {
                ...item,
                score,
                scoreLabel: score === null ? '-' : `${score}점`,
                threshold,
                expectedChange,
                warning: !expectedChange && score !== null && score < threshold
            };
        });
    }

    public shotConsistencyWarningCount(consistency: any) {
        return Array.isArray(consistency?.warnings)
            ? consistency.warnings.length
            : this.shotConsistencyMetricRows(consistency).filter(
                (metric: any) => metric.warning
            ).length;
    }

    public scenarioCutConsistency(cut: any) {
        return this.shotConsistency(this.scenarioCutAsset(cut));
    }

    private shotConsistencyNeedsEvaluation(record: any) {
        const consistency = this.shotConsistency(record);
        if (!consistency) return true;
        return String(consistency?.algorithm_version || '') !== 'sfr003-cv-v3'
            || ['wardrobe_score', 'vehicle_score', 'weather_score'].some(
                (field: string) => !Number.isFinite(Number(consistency?.[field]))
            );
    }

    public async evaluateShotConsistency(
        record: any,
        force: boolean = false,
        automatic: boolean = false
    ) {
        const jobId = this.jobId(record);
        if (
            !this.can('content.write')
            || !this.shotConsistencyEligible(record)
            || !jobId
            || this.shotConsistencyAutoPending[jobId]
        ) return;
        this.shotConsistencyAutoPending[jobId] = true;
        if (!automatic) {
            this.shotConsistencyLoadingJobId = jobId;
            this.shotConsistencyErrorJobId = '';
            this.shotConsistencyErrorMessage = '';
            this.changeDetector.detectChanges();
        }
        try {
            const { code, data } = await wiz.call('evaluate_shot_consistency', {
                job_id: jobId,
                force,
                csrf_token: this.csrfToken()
            });
            if (code !== 200 || !data?.evaluation) {
                if (!automatic) {
                    this.shotConsistencyErrorJobId = jobId;
                    this.shotConsistencyErrorMessage = data?.message
                        || '컷 간 시각 일관성을 검사하지 못했습니다.';
                }
                return;
            }
            const evaluation = data.evaluation;
            this.jobs = this.jobs.map((item: any) => (
                this.jobId(item) === jobId
                    ? { ...item, shot_consistency: evaluation }
                    : item
            ));
            this.assets = this.assets.map((item: any) => (
                this.jobId(item) === jobId
                    ? { ...item, shot_consistency: evaluation }
                    : item
            ));
        } catch (_error) {
            if (!automatic) {
                this.shotConsistencyErrorJobId = jobId;
                this.shotConsistencyErrorMessage = '컷 간 시각 일관성을 검사하지 못했습니다.';
            }
        } finally {
            delete this.shotConsistencyAutoPending[jobId];
            if (!automatic) this.shotConsistencyLoadingJobId = '';
            if (!this.destroyed) this.changeDetector.detectChanges();
        }
    }

    private async autoEvaluateMissingShotConsistency(records: any[] = []) {
        if (!this.can('content.write') || this.destroyed) return;
        const candidates = records.length > 0
            ? records
            : [...this.assets, ...this.jobs];
        const seen = new Set<string>();
        const pending = candidates.filter((record: any) => {
            const id = this.jobId(record);
            if (!id || seen.has(id)) return false;
            seen.add(id);
            return this.shotConsistencyEligible(record)
                && this.shotConsistencyNeedsEvaluation(record)
                && !this.shotConsistencyAutoPending[id];
        }).slice(0, 4);
        if (pending.length === 0) return;
        await Promise.all(pending.map((record: any) => (
            this.evaluateShotConsistency(record, false, true)
        )));
    }

    private referenceConditionFromRecord(record: any) {
        const candidates = [
            record?.reference_condition,
            record?.asset?.reference_condition,
            this.primaryMetadata(record)?.reference_condition
        ];
        for (const candidate of candidates) {
            const normalized = this.normalizedReferenceCondition(candidate);
            if (normalized) return normalized;
        }
        return null;
    }

    public async bootstrap() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('bootstrap', {
                patient_id: this.requestedPatientId,
                memory_mode: this.patientMemoryMode,
                resource_memory_id: this.patientMemoryMode === 'resource'
                    ? this.selectedResourceMemoryId
                    : ''
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '콘텐츠 워크벤치를 불러오지 못했습니다.';
                return;
            }

            const payload = data || {};
            this.csrfTokenValue = payload.csrf_token || this.csrfTokenValue;
            this.metrics = {};
            this.videoMetrics = {};
            this.imagePricing = payload?.image_pricing || { currency: 'USD', estimated: true, models: {} };
            this.videoPricing = payload?.video_pricing || { currency: 'USD', estimated: true, models: {} };
            await this.loadImagePricing();
            this.selectedImageQuality = this.normalizeImageQuality(
                this.workbenchSavedImageQuality()
                || this.imagePricing?.models?.['openai-gpt-image-2']?.quality
                || this.selectedImageQuality
            );
            this.capabilities = payload?.capabilities || { image_to_video: false };
            this.runtime = payload?.runtime || {};
            this.generationModelAvailability = payload?.generation_model_availability || {};
            const savedModels = this.workbenchSavedModels();
            this.workbenchSelectedModels = (savedModels === null
                ? this.workbenchSelectedModels : savedModels).filter(
                (key: string) => this.generationModelAvailable(key, 'image')
            );
            if (savedModels === null && this.workbenchSelectedModels.length === 0) {
                this.workbenchSelectedModels = this.generationModelOptions.image
                    .filter((item: any) => this.generationModelAvailable(item.value, 'image'))
                    .slice(0, 3)
                    .map((item: any) => item.value);
            }
            this.imagePromptValidations = payload?.image_prompt_validations || {};
            this.patients = this.extractList(payload, ['patients', 'patient_options']);
            this.workbenchWorkedScenarioIds = Array.isArray(payload?.worked_scenario_ids)
                ? payload.worked_scenario_ids.map((id: any) => String(id || '').toUpperCase())
                : [];
            const recentKeys = new Set<string>();
            this.workbenchRecentWork = this.extractList(payload, ['recent_work'])
                .filter((job: any) => {
                    const key = String(
                        job?.intensity_batch_id
                        || job?.candidate_batch_id
                        || job?.id
                        || ''
                    );
                    if (!key || recentKeys.has(key)) return false;
                    recentKeys.add(key);
                    return true;
                })
                .slice(0, 8);
            this.resourceMemories = this.extractList(payload, ['resource_memories']);
            const scenarioLibrary = payload?.scenario_sets || {};
            this.scenarioSets = this.extractList(scenarioLibrary, ['rows', 'scenarios']);
            this.scenarioCategories = this.extractList(
                scenarioLibrary,
                ['categories']
            );
            this.representativeScenarioAnalyses = (
                scenarioLibrary?.analyses
                && typeof scenarioLibrary.analyses === 'object'
                && !Array.isArray(scenarioLibrary.analyses)
            ) ? scenarioLibrary.analyses : {};
            this.templates = this.extractList(payload, ['templates', 'prompt_templates']);
            this.patientSourceImages = this.extractList(
                payload,
                ['patient_source_images']
            );
            const scenarios = this.extractList(payload, ['scenarios', 'scenario_options']);
            if (scenarios.length > 0) this.scenarios = scenarios;
            else if (this.templates.length > 0) this.scenarios = this.scenarioOptionsFromTemplates();

            this.applyDefaults();
            if (this.sourceMode === 'scenario') this.restoreScenarioAnalysis();
            if (
                this.patientMemoryMode === 'resource'
                && !this.resourceMemories.some((item: any) =>
                    String(item?.id || '') === this.selectedResourceMemoryId
                )
            ) this.selectedResourceMemoryId = '';
            if (
                payload?.patient_scoped === true
                && this.normalizeRequestedPatientId(this.form.patient_id)
            ) {
                const bootstrapJobs = this.extractList(
                    payload,
                    ['jobs', 'generation_jobs']
                ).filter((item: any) => this.recordMatchesSelectedSource(item));
                const bootstrapAssets = this.extractList(
                    payload,
                    ['assets', 'artifacts', 'media_assets']
                ).filter((item: any) => this.recordMatchesSelectedSource(item));
                this.jobs = bootstrapJobs;
                this.assets = bootstrapAssets.length > 0
                    ? bootstrapAssets
                    : this.assetsFromJobs(bootstrapJobs);
                const bootstrapMetrics = this.metricPayload(payload?.metrics);
                this.metrics = String(bootstrapMetrics?.scope || '').toLowerCase() === 'patient'
                    ? bootstrapMetrics
                    : {};
                const bootstrapVideoMetrics = this.metricPayload(payload?.video_metrics);
                this.videoMetrics = String(bootstrapVideoMetrics?.scope || '').toLowerCase() === 'patient'
                    ? bootstrapVideoMetrics
                    : {};
                this.total = this.jobs.length;
            } else {
                this.clearPatientContent();
            }
            await this.search(false);
            await this.loadReferenceRecommendations();
            if (this.sourceMode === 'scenario' && this.selectedScenarioSet()) {
                await this.workbenchLoadScenarioPhotos();
            }
        } catch (error) {
            this.errorMessage = '콘텐츠 워크벤치를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
            void this.workbenchEnsureComparisonResults();
        }
    }

    public async refreshScenarioCatalog() {
        const sequence = ++this.scenarioCatalogRefreshSequence;
        try {
            const { code, data } = await wiz.call('scenario_catalog', {});
            if (this.destroyed || sequence !== this.scenarioCatalogRefreshSequence) return;
            if (code !== 200 || !Array.isArray(data?.rows)) {
                this.scenarioCatalogError = data?.message || '시나리오 목록을 갱신하지 못했습니다.';
            } else {
                const previousIds = new Set(this.scenarioSets.map((item: any) => String(item?.id || '')));
                const added = data.rows.some((item: any) => !previousIds.has(String(item?.id || '')));
                this.scenarioSets = data.rows;
                this.scenarioCategories = Array.isArray(data.categories) ? data.categories : [];
                this.scenarioCatalogError = '';
                if (added && this.workbenchSourceChoice === 'scenario' && !this.workbenchHasSelection()) {
                    this.workbenchScenarioPage = 1;
                }
            }
        } catch (_error) {
            if (this.destroyed || sequence !== this.scenarioCatalogRefreshSequence) return;
            this.scenarioCatalogError = '시나리오 목록을 갱신하지 못했습니다.';
        }
        await this.service.render();
    }

    private async loadImagePricing() {
        try {
            const { code, data } = await wiz
                .app('component.content_pricing_v2')
                .call('pricing');
            const pricing = data?.image_pricing;
            if (
                code === 200
                && pricing?.models
                && typeof pricing.models === 'object'
            ) this.imagePricing = pricing;
        } catch (_error) {
            // Keep the bootstrap pricing when the cache-busting API is unavailable.
        }
    }

    public async search(showLoading: boolean = true, resetPage: boolean = true) {
        if (!this.can('content.read')) return;
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        const scenarioSetId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        const memoryKind = String(
            this.scenarioSelection.memory_kind || ''
        ).trim().toLowerCase();
        const patientMemoryMode = this.patientMemoryMode;
        const resourceMemoryId = patientMemoryMode === 'resource'
            ? this.normalizeRequestedPatientId(this.selectedResourceMemoryId)
            : '';
        const requestSequence = ++this.searchSequence;
        if (resetPage) this.page = 1;
        if (showLoading) {
            this.searching = true;
            this.searchError = '';
            await this.service.render();
        }

        if (
            (this.sourceMode === 'patient' && (
                !patientId || (patientMemoryMode === 'resource' && !resourceMemoryId)
            ))
            || (this.sourceMode === 'scenario' && (!scenarioSetId || !memoryKind))
        ) {
            this.jobs = [];
            this.assets = [];
            this.metrics = {};
            this.videoMetrics = {};
            this.total = 0;
            this.searching = false;
            await this.service.render();
            return;
        }

        try {
            const { code, data } = await wiz.call('search', {
                source_mode: this.sourceMode,
                patient_id: patientId,
                memory_mode: this.sourceMode === 'patient' ? patientMemoryMode : 'trauma',
                resource_memory_id: this.sourceMode === 'patient' ? resourceMemoryId : '',
                scenario_set_id: this.sourceMode === 'scenario' ? scenarioSetId : '',
                memory_kind: this.sourceMode === 'scenario' ? memoryKind : '',
                text: String(this.filters.text || '').trim(),
                status: this.filters.status || '',
                media_type: this.filters.media_type || '',
                page: this.page,
                dump: this.dump
            });
            if (
                requestSequence !== this.searchSequence
                || !this.currentSourceMatches(
                    patientId,
                    scenarioSetId,
                    memoryKind,
                    patientMemoryMode,
                    resourceMemoryId
                )
            ) return;

            if (code !== 200) {
                this.searchError = data?.message || '작업과 자산 목록을 불러오지 못했습니다.';
                return;
            }

            this.applySearchPayload(data);
            await this.recoverMissingScenarioAnalysis();
        } catch (error) {
            if (
                requestSequence !== this.searchSequence
                || !this.currentSourceMatches(
                    patientId,
                    scenarioSetId,
                    memoryKind,
                    patientMemoryMode,
                    resourceMemoryId
                )
            ) return;
            this.searchError = '작업과 자산 목록을 불러오지 못했습니다.';
        } finally {
            if (
                requestSequence === this.searchSequence
                && this.currentSourceMatches(
                    patientId,
                    scenarioSetId,
                    memoryKind,
                    patientMemoryMode,
                    resourceMemoryId
                )
            ) {
                this.searching = false;
                await this.service.render();
                void this.workbenchEnsureComparisonResults();
            }
        }
    }

    public async createJob(silent: boolean = false) {
        if (!this.can('content.write') || this.submitting) return;
        if (this.sourceMode === 'scenario') {
            return await this.createScenarioJob(silent);
        }
        if (this.patientMemoryMode === 'resource') {
            return await this.createResourceMemoryImages(silent);
        }

        const patientId = String(this.form.patient_id || '').trim();
        const scenarioType = String(this.form.scenario_type || '').trim();
        const mediaType = this.normalizeMediaType(this.form.media_type);
        const intensity = this.normalizeIntensityValue(this.form.intensity);
        this.form.intensity = intensity;
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        const templateId = this.templateIdForScenario(scenarioType, mediaType);
        if (!this.form.idempotency_key) this.form.idempotency_key = this.newIdempotencyKey();

        if (!patientId) {
            await this.service.modal.error('비식별 환자 코드를 선택해주세요.');
            return;
        }
        if (!this.selectedPatientPromptReady()) {
            await this.service.modal.error(
                '환자 상세에서 AI 프롬프트 초안을 만들고 담당 임상의 승인을 완료해주세요.'
            );
            return;
        }
        if (!scenarioType) {
            await this.service.modal.error('사용할 프롬프트 세트를 선택해주세요.');
            return;
        }
        if (this.promptSelectionMismatch() && !this.promptMismatchAcknowledged) {
            await this.service.modal.error(
                '환자 유형과 다른 프롬프트 세트를 사용하려면 먼저 경고 내용을 확인해주세요.'
            );
            return;
        }
        if (!mediaType) {
            await this.service.modal.error('콘텐츠 유형을 선택해주세요.');
            return;
        }
        if (mediaType === 'video') {
            await this.service.modal.error('아래 자산에서 이미지를 선택한 뒤 영상 만들기를 진행해주세요.');
            return;
        }
        if (mediaType === 'audio' && (!this.selectedGenerationModelAvailable('audio') || !this.audioInputReady())) {
            await this.service.modal.error(this.audioInputReady()
                ? this.selectedGenerationModelUnavailableMessage('audio')
                : '선택한 모델에 사용할 대본·설명과 글자 수를 확인해주세요.');
            return;
        }
        if (mediaType === 'image' && !this.selectedGenerationModelAvailable('image')) {
            await this.service.modal.error(this.selectedGenerationModelUnavailableMessage('image'));
            return;
        }
        if (mediaType === 'image' && !this.imageGenerationRequestValid()) {
            await this.service.modal.error('이미지 모델과 프롬프트 적용 방식을 확인해주세요.');
            return;
        }
        if (
            mediaType === 'image'
            && this.workbenchReferenceEnabled()
            && this.patientSourceRequestId('image')
            && this.selectedGenerationModelKeys.image !== 'openai-gpt-image-2'
        ) {
            await this.service.modal.error('환자 제공 사진을 이용한 이미지 생성은 OpenAI Image만 지원합니다.');
            return;
        }
        if (!Number.isInteger(intensity) || intensity < 1 || intensity > 5) {
            await this.service.modal.error('강도는 1부터 5 사이에서 선택해주세요.');
            return;
        }
        if (this.templates.length > 0 && !templateId) {
            await this.service.modal.error('선택한 시나리오에 활성 Prompt 템플릿이 없습니다.');
            return;
        }

        const audioRequest = this.workbenchBeginAudioRequest(mediaType);
        const videoRequest = this.workbenchBeginVideoRequest(mediaType);
        this.submitting = true;
        this.errorMessage = '';
        await this.service.render();

        let createdJobs: any[] = [];
        try {
            const requestPayload: any = {
                patient_id: patientId,
                scenario_type: scenarioType,
                scenario: scenarioType,
                template_id: templateId,
                media_type: mediaType,
                intensity: intensity,
                idempotency_key: this.form.idempotency_key,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch()
                    && this.promptMismatchAcknowledged
                ),
                ...this.referencePolicyRequest(mediaType),
                ...(mediaType === 'audio' ? { ...this.audioJobOptions(), generation_model: this.selectedGenerationModelKeys.audio } : {}),
                patient_source_image_id: mediaType === 'image' && !this.workbenchReferenceEnabled()
                    ? '' : this.patientSourceRequestId(mediaType),
                csrf_token: this.csrfToken()
            };
            const { code, data } = mediaType === 'image'
                ? (
                    this.imageGenerationScope === 'all'
                        ? await wiz.call('create_intensity_image_batch', {
                            ...requestPayload,
                            candidate_count: this.imageCandidateCount,
                            generation_model: this.selectedGenerationModelKeys.image,
                            image_quality: this.selectedImageQualityRequest(),
                            prompt_strategy: this.imagePromptStrategy,
                            image_expression: this.workbenchServerExpression()
                        })
                        : await wiz.call('create_image_candidates', {
                            ...requestPayload,
                            candidate_count: this.imageCandidateCount,
                            generation_model: this.selectedGenerationModelKeys.image,
                            image_quality: this.selectedImageQualityRequest(),
                            prompt_strategy: this.imagePromptStrategy,
                            image_expression: this.workbenchServerExpression()
                        })
                )
                : await wiz.call('create_job', requestPayload);

            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '콘텐츠 생성 요청을 등록하지 못했습니다.';
                return;
            }

            if (mediaType === 'image') {
                const intensityBatch = this.imageGenerationScope === 'all';
                const candidateJobs = intensityBatch
                    ? this.intensityBatchJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    )
                    : this.candidateJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    );
                if (candidateJobs === null) {
                    this.errorMessage = '이미지 후보 생성 결과를 확인하지 못했습니다. 같은 요청으로 다시 시도해주세요.';
                    return;
                }
                this.latestIntensityBatchId = intensityBatch
                    ? String(data?.intensity_batch_id || '')
                    : '';
                this.latestImageCostBatchId = intensityBatch
                    ? ''
                    : String(candidateJobs[0]?.candidate_batch_id || '');
                this.latestImageCostModelKey = this.selectedImageModelKey();
                this.latestImageCostCandidateCount = candidateJobs.length;
                [...candidateJobs].reverse().forEach((job: any) => this.upsertJob(job, true));
                createdJobs = candidateJobs;
            } else {
                const job = this.jobFromPayload(data);
                if (job && this.jobId(job)) {
                    this.upsertJob(job, true);
                    createdJobs = [job];
                }
            }
            this.mergeAssets(this.assetsFromPayload(data));
            this.form.idempotency_key = this.newIdempotencyKey();
            if (!silent && mediaType === 'image') await this.service.modal.success(
                mediaType === 'image'
                    ? (
                        this.imageGenerationScope === 'all'
                            ? `강도 1~5별 이미지 후보 ${this.imageCandidateCount}개씩, 총 ${this.imageCandidateCount * 5}개의 생성 요청을 등록했습니다.`
                            : `이미지 후보 ${this.imageCandidateCount}개의 생성 요청을 등록했습니다. 진행 상태는 자동으로 갱신됩니다.`
                    )
                    : '생성 요청을 등록했습니다. 진행 상태는 자동으로 갱신됩니다.'
            );
            await this.search(false);
            return createdJobs;
        } catch (error) {
            this.errorMessage = '콘텐츠 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.workbenchFinishAudioRequest(audioRequest, createdJobs);
            this.workbenchFinishVideoRequest(videoRequest, createdJobs);
            this.submitting = false;
            await this.service.render();
        }
    }

    public async createResourceMemoryImages(silent: boolean = false) {
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        const resourceMemoryId = this.normalizeRequestedPatientId(
            this.selectedResourceMemoryId
        );
        const intensity = this.normalizeIntensityValue(this.form.intensity);
        this.form.intensity = intensity;
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        if (!patientId || !resourceMemoryId || !this.selectedResourceMemory()) {
            await this.service.modal.error('환자와 임상 승인된 자원기억을 선택해주세요.');
            return;
        }
        if (!this.selectedGenerationModelAvailable('image')) {
            await this.service.modal.error(
                this.selectedGenerationModelUnavailableMessage('image')
            );
            return;
        }
        if (!this.imageGenerationRequestValid()) {
            await this.service.modal.error('이미지 모델과 프롬프트 적용 방식을 확인해주세요.');
            return;
        }
        if (!this.form.idempotency_key) {
            this.form.idempotency_key = this.newIdempotencyKey();
        }
        this.submitting = true;
        this.errorMessage = '';
        await this.service.render();
        let createdJobs: any[] = [];
        try {
            const { code, data } = await wiz.call('create_resource_memory_images', {
                patient_id: patientId,
                memory_mode: 'resource',
                resource_memory_id: resourceMemoryId,
                intensity: intensity,
                generation_scope: this.imageGenerationScope,
                candidate_count: this.imageCandidateCount,
                generation_model: this.selectedGenerationModelKeys.image,
                image_quality: this.selectedImageQualityRequest(),
                prompt_strategy: this.imagePromptStrategy,
                image_expression: this.workbenchServerExpression(),
                template_id: this.templateIdForScenarioGeneration('image'),
                idempotency_key: this.form.idempotency_key,
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '자원기억 이미지 생성 요청을 등록하지 못했습니다.';
                return;
            }
            const intensityBatch = this.imageGenerationScope === 'all';
            const candidateJobs = intensityBatch
                ? this.intensityBatchJobsFromPayload(data, this.imageCandidateCount)
                : this.candidateJobsFromPayload(data, this.imageCandidateCount);
            if (candidateJobs === null) {
                this.errorMessage = '자원기억 이미지 후보 생성 결과를 확인하지 못했습니다.';
                return;
            }
            this.latestIntensityBatchId = intensityBatch
                ? String(data?.intensity_batch_id || '')
                : '';
            this.latestImageCostBatchId = intensityBatch
                ? ''
                : String(data?.candidate_batch_id || '');
            this.latestImageCostModelKey = this.selectedImageModelKey();
            this.latestImageCostCandidateCount = candidateJobs.length;
            [...candidateJobs].reverse().forEach((job: any) => this.upsertJob(job, true));
            createdJobs = candidateJobs;
            this.mergeAssets(this.assetsFromPayload(data));
            this.form.idempotency_key = this.newIdempotencyKey();
            if (!silent) await this.service.modal.success(
                intensityBatch
                    ? `자원기억 선명도 1~5별 이미지 ${this.imageGenerationTotalCount()}개 생성을 등록했습니다.`
                    : `자원기억 이미지 후보 ${this.imageCandidateCount}개 생성을 등록했습니다.`
            );
            await this.search(false);
            return createdJobs;
        } catch (_error) {
            this.errorMessage = '자원기억 이미지 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.submitting = false;
            await this.service.render();
        }
    }

    public async createScenarioJob(silent: boolean = false) {
        if (!this.can('content.write') || this.submitting) return;
        const scenarioSetId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        const mediaType = this.normalizeMediaType(this.form.media_type);
        if (mediaType === 'image' && this.scenarioAnalysisState === 'complete') {
            this.ensureScenarioCutSelection();
        }
        const memoryKind = String(
            this.scenarioSelection.memory_kind || ''
        ).trim().toLowerCase();
        const intensity = this.normalizeIntensityValue(this.form.intensity);
        const scenarioCutSpec = ['image', 'audio', 'video'].includes(mediaType)
            ? this.scenarioCutRequestSpec()
            : null;
        this.form.intensity = intensity;
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        if (!scenarioSetId || !this.selectedScenarioSet()) {
            await this.service.modal.error('시나리오를 선택해주세요.');
            return;
        }
        if (!['trauma', 'positive'].includes(memoryKind)) {
            await this.service.modal.error('외상 기억 또는 행복 기억을 선택해주세요.');
            return;
        }
        if (mediaType === 'video') {
            const reason = this.scenarioVideoGenerationBlockReason();
            if (reason) {
                await this.service.modal.error(reason);
                return;
            }
        }
        if (
            !this.selectedScenarioPrompt()
            && !(['image', 'audio', 'video'].includes(mediaType) && scenarioCutSpec)
        ) {
            await this.service.modal.error('선택한 미디어의 시나리오 프롬프트가 없습니다.');
            return;
        }
        if (
            ['image', 'audio', 'video'].includes(mediaType)
            && (this.selectedScenarioCompletedRaw() || this.selectedScenarioDemoReady()
                || this.selectedScenarioAnalysisOnly() || this.scenarioAnalysisState === 'complete')
            && !scenarioCutSpec
        ) {
            await this.service.modal.error(
                this.scenarioAnalysisCuts().length > 0
                    ? '분석 결과의 원본 연결 정보를 확인하지 못했습니다. 시나리오를 다시 분석해주세요.'
                    : '시나리오 분석 결과에서 생성할 컷을 확인하지 못했습니다. 다시 분석해주세요.'
            );
            return;
        }
        if (mediaType === 'audio' && (!this.selectedGenerationModelAvailable('audio') || !this.audioInputReady())) {
            await this.service.modal.error(this.audioInputReady()
                ? this.selectedGenerationModelUnavailableMessage('audio')
                : '선택한 모델에 사용할 대본·설명과 글자 수를 확인해주세요.');
            return;
        }
        if (mediaType === 'image' && !this.selectedGenerationModelAvailable('image')) {
            await this.service.modal.error(
                this.selectedGenerationModelUnavailableMessage('image')
            );
            return;
        }
        if (mediaType === 'image' && !this.imageGenerationRequestValid()) {
            await this.service.modal.error('이미지 모델과 프롬프트 적용 방식을 확인해주세요.');
            return;
        }
        const templateId = this.templateIdForScenarioGeneration(mediaType);
        if (!templateId) {
            await this.service.modal.error('선택한 미디어의 생성 템플릿이 없습니다.');
            return;
        }
        if (!this.form.idempotency_key) {
            this.form.idempotency_key = this.newIdempotencyKey();
        }

        const audioRequest = this.workbenchBeginAudioRequest(mediaType);
        const videoRequest = this.workbenchBeginVideoRequest(mediaType);
        this.submitting = true;
        this.errorMessage = '';
        await this.service.render();
        let createdJobs: any[] = [];
        try {
            const generationModel = ['image', 'audio', 'video'].includes(mediaType)
                ? String(this.selectedGenerationModelKeys[mediaType] || '')
                : '';
            const { code, data } = await wiz.call('create_scenario_job', {
                ...(mediaType === 'audio' ? this.audioJobOptions() : {}),
                scenario_set_id: scenarioSetId,
                memory_kind: memoryKind,
                media_type: mediaType,
                intensity: intensity,
                duration_seconds: this.scenarioVideoDuration(),
                generation_scope: this.imageGenerationScope,
                candidate_count: this.imageCandidateCount,
                generation_model: generationModel,
                image_quality: mediaType === 'image'
                    ? this.selectedImageQualityRequest()
                    : '',
                prompt_strategy: mediaType === 'image'
                    ? this.imagePromptStrategy
                    : 'legacy',
                image_expression: mediaType === 'image'
                    ? this.workbenchServerExpression()
                    : 'realistic',
                prompt_adjustments: mediaType === 'image' && this.sourceMode === 'scenario'
                    ? JSON.stringify(this.workbenchPromptAdjustments(intensity, generationModel))
                    : '',
                scenario_photo_id: mediaType === 'image' && this.workbenchReferenceEnabled()
                    ? this.workbenchScenarioPhotoId
                    : '',
                continuity_master_revision_id: mediaType === 'image'
                    ? this.workbenchSceneMasterRevisionId
                    : '',
                source_revision_id: mediaType === 'video'
                    ? this.assetId(this.selectedVideoSource)
                    : '',
                scenario_cut_spec: scenarioCutSpec
                    ? JSON.stringify(scenarioCutSpec)
                    : '',
                ...this.referencePolicyRequest(mediaType),
                template_id: templateId,
                idempotency_key: this.form.idempotency_key,
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message
                    || '시나리오 콘텐츠 생성 요청을 등록하지 못했습니다.';
                return;
            }
            if (mediaType === 'image') {
                const intensityBatch = this.imageGenerationScope === 'all';
                const candidateJobs = intensityBatch
                    ? this.intensityBatchJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    )
                    : this.candidateJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    );
                if (candidateJobs === null) {
                    this.errorMessage = '시나리오 이미지 후보 생성 결과를 확인하지 못했습니다. 같은 요청으로 다시 시도해주세요.';
                    return;
                }
                this.latestIntensityBatchId = intensityBatch
                    ? String(data?.intensity_batch_id || '')
                    : '';
                this.latestImageCostBatchId = intensityBatch
                    ? ''
                    : String(data?.candidate_batch_id || '');
                this.latestImageCostModelKey = this.selectedImageModelKey();
                this.latestImageCostCandidateCount = candidateJobs.length;
                [...candidateJobs].reverse().forEach(
                    (job: any) => this.upsertJob(job, true)
                );
                createdJobs = candidateJobs;
            } else {
                const job = this.jobFromPayload(data);
                if (!job || !this.jobId(job)) {
                    this.errorMessage = '시나리오 생성 작업 정보를 확인하지 못했습니다.';
                    return;
                }
                this.upsertJob(job, true);
                createdJobs = [job];
            }
            this.mergeAssets(this.assetsFromPayload(data));
            if (!this.workbenchWorkedScenarioIds.includes(scenarioSetId)) {
                this.workbenchWorkedScenarioIds = [
                    ...this.workbenchWorkedScenarioIds, scenarioSetId
                ];
            }
            this.form.idempotency_key = this.newIdempotencyKey();
            if (!silent && mediaType === 'image') await this.service.modal.success(
                mediaType === 'image'
                    ? (
                        scenarioCutSpec
                            ? (
                                this.imageGenerationScope === 'all'
                                    ? `컷 ${scenarioCutSpec.order} · ${scenarioCutSpec.title}의 ${this.intensityScaleLabel()} 1~5 후보를 ${this.imageCandidateCount}개씩, 총 ${this.imageGenerationTotalCount()}개 등록했습니다.`
                                    : `컷 ${scenarioCutSpec.order} · ${scenarioCutSpec.title} 이미지 후보 ${this.imageCandidateCount}개의 생성 요청을 등록했습니다.`
                            )
                            : this.imageGenerationScope === 'all'
                            ? `${scenarioSetId} 강도 1~5별 이미지 후보 ${this.imageCandidateCount}개씩, 총 ${this.imageGenerationTotalCount()}개의 생성 요청을 등록했습니다.`
                            : `${scenarioSetId} 이미지 후보 ${this.imageCandidateCount}개의 생성 요청을 등록했습니다.`
                    )
                    : `${this.selectedScenarioSet()?.id || scenarioSetId} ${this.modalityLabel(mediaType)} 생성 요청을 등록했습니다.`
            );
            await this.search(false);
            return createdJobs;
        } catch (_error) {
            this.errorMessage = '시나리오 콘텐츠 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.workbenchFinishAudioRequest(audioRequest, createdJobs);
            this.workbenchFinishVideoRequest(videoRequest, createdJobs);
            this.submitting = false;
            await this.service.render();
        }
    }

    public selectVideoSource(asset: any) {
        if (!this.can('content.write') || !this.videoSourceEligible(asset)) return;
        const changed = !this.isSelectedVideoSource(asset);
        this.selectedVideoSource = asset;
        const inheritedReference = this.referenceConditionFromRecord(asset);
        if (inheritedReference) {
            this.selectedReferenceCondition = inheritedReference;
        }
        if (this.form.media_type === 'video') this.syncScenarioForSelectedPatient();
        if (changed) this.videoIdempotencyKey = this.newIdempotencyKey();
        this.workbenchRememberVideoSource();
        this.selectedVideoResultModelKey = 'all';
        this.changeDetector.detectChanges();
    }

    private workbenchVideoSourceStorageKey() {
        const account = String(this.service?.auth?.session?.id || '');
        if (!account) return '';
        if (this.sourceMode === 'scenario') {
            const source = this.selectedScenarioSourceKey();
            const cut = Number(this.selectedScenarioCutOrder || 0);
            return source && cut ? `ptsd.videoSource.v1.${account}.scenario.${source}.${cut}` : '';
        }
        const patient = String(this.form.patient_id || '');
        return patient && this.patientMemoryMode === 'trauma'
            ? `ptsd.videoSource.v1.${account}.patient.${patient}` : '';
    }

    private workbenchRememberVideoSource() {
        const key = this.workbenchVideoSourceStorageKey();
        const id = this.assetId(this.selectedVideoSource);
        if (!key || !id) return;
        try { window.localStorage.setItem(key, id); } catch (_error) { }
    }

    private workbenchForgetVideoSource() {
        const key = this.workbenchVideoSourceStorageKey();
        if (!key) return;
        try { window.localStorage.removeItem(key); } catch (_error) { }
    }

    private workbenchRestoreVideoSource() {
        const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
        const inScope = (asset: any) => this.recordMatchesSelectedSource(asset)
            && (!cut || this.scenarioCutRecordMatches(asset, cut));
        if (this.selectedVideoSource && inScope(this.selectedVideoSource)) return;
        this.selectedVideoSource = null;
        const key = this.workbenchVideoSourceStorageKey();
        if (!key) return;
        let id = '';
        try { id = String(window.localStorage.getItem(key) || ''); } catch (_error) { return; }
        if (!id) return;
        const assets = [
            ...(this.assets || []),
            ...(this.workbenchCollectedImageAssets || []),
            ...(this.workbenchCollectedImageJobs || []),
            ...(this.jobs || [])
        ];
        const source = assets.find((asset: any) => this.assetId(asset) === id
            && inScope(asset) && this.videoSourceEligible(asset));
        if (source) this.selectedVideoSource = source;
    }

    public toggleIntensityVideoSource(asset: any) {
        if (!this.can('content.write') || !this.videoSourceEligible(asset)) return;
        const intensity = this.jobIntensity(asset);
        if (!this.intensityOptions.includes(intensity)) return;
        const current = this.selectedIntensityVideoSources[intensity];
        const next = { ...this.selectedIntensityVideoSources };
        if (current && this.assetId(current) === this.assetId(asset)) {
            delete next[intensity];
        } else {
            next[intensity] = asset;
        }
        this.selectedIntensityVideoSources = next;
        this.latestVideoBatchId = '';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public isIntensityVideoSource(asset: any) {
        const intensity = this.jobIntensity(asset);
        return !!this.assetId(asset)
            && this.assetId(this.selectedIntensityVideoSources[intensity]) === this.assetId(asset);
    }

    public intensityVideoSourceRows() {
        return this.intensityOptions.map((intensity: number) => ({
            intensity,
            source: this.selectedIntensityVideoSources[intensity] || null
        }));
    }

    public intensityVideoSourceRevisionIds() {
        return this.intensityOptions.map(
            (intensity: number) => this.assetId(
                this.selectedIntensityVideoSources[intensity]
            )
        );
    }

    public async onVideoGenerationScopeChange(value: any) {
        this.videoGenerationScope = value === 'all' ? 'all' : 'single';
        this.latestVideoBatchId = '';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectAudioSource(asset: any) {
        if (!this.can('content.write') || !this.audioSourceEligible(asset)) return;
        this.selectedAudioSource = this.isSelectedAudioSource(asset) ? null : asset;
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public isSelectedAudioSource(asset: any) {
        const selectedId = this.assetId(this.selectedAudioSource);
        return !!selectedId && selectedId === this.assetId(asset);
    }

    public audioSourceEligible(asset: any) {
        if (!asset || this.mediaType(asset) !== 'audio') return false;
        const data = this.primaryMetadata(asset);
        return String(data?.safety_status || asset?.safety_status || '').toLowerCase() === 'passed'
            && ['pending', 'approved'].includes(
                String(data?.review_status || asset?.review_status || '').toLowerCase()
            );
    }

    public isSelectedVideoSource(asset: any) {
        const selectedId = this.assetId(this.selectedVideoSource);
        return !!selectedId && selectedId === this.assetId(asset);
    }

    public videoSourceEligible(asset: any) {
        if (asset?.patient_source_image_id || asset?.consent_basis) {
            return this.patientSourceSelectable(asset);
        }
        if (!asset || this.mediaType(asset) !== 'image') return false;
        if (
            this.panoramaGenerationMode(asset) === 'image_to_panorama'
            && !this.validPanoramaResult(asset)
        ) return false;
        if (
            asset.video_source_eligible === true
            || asset?.asset?.video_source_eligible === true
        ) return true;
        const data = this.primaryMetadata(asset);
        return String(data?.safety_status || asset?.safety_status || '').toLowerCase() === 'passed'
            && ['pending', 'approved'].includes(
                String(data?.review_status || asset?.review_status || '').toLowerCase()
            );
    }

    public videoSourceReason(asset: any) {
        if (
            this.panoramaGenerationMode(asset) === 'image_to_panorama'
            && !this.validPanoramaResult(asset)
        ) {
            return '2048×1024 형식 검증을 통과한 360° 이미지만 영상 원본으로 사용할 수 있습니다.';
        }
        const reason = String(asset?.video_source_reason || '');
        const labels: any = {
            source_not_eligible: '안전성 검사를 통과한 생성 완료 이미지만 선택할 수 있습니다.'
        };
        return labels[reason] || '이 이미지는 영상 소스로 사용할 수 없습니다.';
    }

    public canCreateVideoFromSource() {
        if (!this.generationModelAvailable(this.selectedVideoModelKey(), 'video')) return false;
        const generatedSourceEligible = this.videoSourceEligible(this.selectedVideoSource);
        const patientSourceEligible = this.videoSourceEligible(this.selectedPatientSource);
        if (!generatedSourceEligible && !patientSourceEligible) return false;
        const source = patientSourceEligible
            ? this.selectedPatientSource
            : this.selectedVideoSource;
        if (this.promptSelectionMismatch() && !this.promptMismatchAcknowledged) return false;
        const scenario = String(
            source?.scenario_type
            || source?.scenario
            || this.form.scenario_type
            || ''
        );
        return !!this.templateIdForScenario(scenario, 'video');
    }

    public selectedVideoModelKey() {
        return String(this.selectedGenerationModelKeys?.video || '');
    }

    public evolinkImageModelKey(value: any) {
        const model = String(value || '').trim().toLowerCase();
        const compactModel = model.replace(/[^a-z0-9]+/g, '');
        if (
            model.includes('doubao-seedream-5.0-lite')
            || model.includes('evolink-seedream-5-lite')
            || compactModel.includes('seedream50lite')
            || compactModel.includes('seedream5lite')
        ) {
            return 'evolink-seedream-5-lite';
        }
        if (
            model.includes('gemini-3.1-flash-image')
            || model.includes('evolink-gemini-3-1-flash-image')
            || compactModel.includes('gemini31flashimage')
        ) {
            return 'evolink-gemini-3-1-flash-image';
        }
        if (
            model.includes('qwen-image-3.0')
            || model.includes('evolink-qwen-image-3')
            || compactModel.includes('qwenimage30')
            || compactModel.includes('qwenimage3')
        ) {
            return 'evolink-qwen-image-3';
        }
        if (
            model.includes('grok-imagine-image-2.0')
            || model.includes('evolink-grok-imagine-image-2')
            || compactModel.includes('grokimagineimage20')
            || compactModel.includes('grokimagineimage2')
        ) {
            return 'evolink-grok-imagine-image-2';
        }
        return '';
    }

    public evolinkVideoModelKey(value: any) {
        const model = String(value || '').trim().toLowerCase();
        if (model.includes('seedance-2.5')) return 'evolink-seedance-2-5';
        if (model.includes('seedance-2.0-fast')) {
            return 'evolink-seedance-2-0-fast';
        }
        if (model.includes('minimax-h3-max')) {
            return 'evolink-minimax-h3-max';
        }
        if (model.includes('veo3.1-fast') || model.includes('veo-3.1-fast')) {
            return 'evolink-veo-3-1-fast';
        }
        return '';
    }

    public generationModelAvailable(modelKey: string, mediaType: string) {
        const availability = this.generationModelAvailability?.[mediaType]?.[modelKey];
        return availability?.available === true;
    }

    public selectableGenerationModelOptions(mediaType: string) {
        const options = this.generationModelOptions?.[mediaType] || [];
        return options.filter((model: any) => {
            const modelKey = String(model?.value || '');
            return !modelKey.startsWith('kolbo-')
                || this.generationModelAvailable(modelKey, mediaType);
        });
    }

    public selectedGenerationModelAvailable(mediaType: string) {
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        return this.generationModelAvailable(modelKey, mediaType);
    }

    public selectedGenerationModelStatusLabel(mediaType: string) {
        if (this.selectedGenerationModelAvailable(mediaType)) return '연결됨';
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        const status = String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.status || ''
        );
        return status === 'permission_required' ? '권한 필요' : '연결 안 됨';
    }

    public selectedGenerationModelStatusClass(mediaType: string) {
        return this.selectedGenerationModelAvailable(mediaType)
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-red-50 text-red-700';
    }

    public generationModelOptionLabel(model: any, mediaType: string) {
        const label = String(model?.label || '');
        const modelKey = String(model?.value || '');
        if (this.generationModelAvailable(modelKey, mediaType)) return label;
        const status = String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.status || ''
        );
        return status === 'permission_required'
            ? `${label} (권한 필요)`
            : `${label} (연결 안 됨)`;
    }

    public selectedGenerationModelUnavailableMessage(mediaType: string) {
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        return String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.message
            || '선택한 생성 모델의 연결 상태를 확인해주세요.'
        );
    }

    public jobGenerationModelKey(job: any) {
        const mediaType = this.normalizeMediaType(job?.media_type || '');
        const provider = String(
            job?.provider_name || job?.provider || ''
        ).trim().toLowerCase();
        const model = String(job?.model_name || job?.model || '').trim().toLowerCase();
        if (
            mediaType === 'image'
            && provider === 'kolbo'
            && (this.generationModelOptions.image || []).some(
                (candidate: any) => candidate.value === model
            )
        ) return model;
        if (mediaType === 'image' && provider === 'evolink') {
            return this.evolinkImageModelKey(model) || 'evolink-seedream-5-lite';
        }
        if (mediaType === 'video' && provider === 'evolink') {
            return this.evolinkVideoModelKey(model) || 'evolink-seedance-2-5';
        }
        const routes: any = {
            'image:openai': 'openai-gpt-image-2',
            'image:kling': 'kling-image-2-1',
            'video:kling': 'kling-video-3',
            'video:comfyui': 'wan-2-2'
        };
        return routes[`${mediaType}:${provider}`] || '';
    }

    public jobGenerationModelAvailable(job: any) {
        const mediaType = this.normalizeMediaType(job?.media_type || '');
        const modelKey = this.jobGenerationModelKey(job);
        return !modelKey || this.generationModelAvailable(modelKey, mediaType);
    }

    public videoDurationOptionsForSelectedModel() {
        const modelKey = this.selectedVideoModelKey();
        if (modelKey === 'evolink-seedance-2-5') return [5, 7, 10, 15, 20];
        if (
            modelKey === 'evolink-seedance-2-0-fast'
            || modelKey === 'evolink-minimax-h3-max'
        ) return [5, 7, 10, 15];
        if (modelKey === 'evolink-veo-3-1-fast') return [4, 6, 8];
        if (modelKey === 'kling-video-3') return [3, 5, 7, 10, 15];
        return [3, 5, 7];
    }

    public selectedImageModelLabel() {
        const modelKey = String(this.selectedGenerationModelKeys?.image || '');
        const option = (this.generationModelOptions.image || []).find(
            (candidate: any) => candidate.value === modelKey
        );
        return String(option?.label || '선택한 이미지 모델');
    }

    public selectedImageModelProfile() {
        return this.imageModelUiProfiles?.[this.selectedImageModelKey()] || null;
    }

    public selectedImagePromptValidation() {
        return this.imagePromptValidations?.[this.selectedImageModelKey()]?.[
            this.imagePromptStrategy
        ] || null;
    }

    public imagePromptValidationReasons(validation: any) {
        const reasons = Array.isArray(validation?.reasons)
            ? validation.reasons.map((item: any) => String(item || '').trim()).filter(Boolean)
            : [];
        return reasons.join(' ');
    }

    public selectedImageModelSettings() {
        const settings = Array.from(this.selectedImageModelProfile()?.settings || []);
        if (this.openAIImageQualitySelectable()) {
            settings.splice(2, 0, `품질 ${this.selectedImageQuality}`);
        }
        return settings;
    }

    public selectedImageModelDisplaySettings() {
        const modelLabel = this.selectedImageModelLabel().toLowerCase();
        return this.selectedImageModelSettings().filter((setting: any) => {
            const normalized = String(setting || '').trim().toLowerCase();
            return normalized && !modelLabel.includes(normalized);
        });
    }

    public openAIImageQualitySelectable() {
        return this.selectedImageModelKey() === 'openai-gpt-image-2';
    }

    public selectedImageQualityRequest() {
        if (!this.openAIImageQualitySelectable()) return '';
        return this.normalizeImageQuality(this.selectedImageQuality);
    }

    public imageQualityDescription() {
        const labels: any = {
            low: '빠른 생성과 낮은 비용에 적합합니다.',
            medium: '속도와 세부 묘사의 균형을 맞춥니다.',
            high: '더 정교한 세부 묘사를 우선합니다.',
            auto: '모델이 장면에 맞는 품질을 자동으로 선택합니다.',
            xhigh: '복잡한 장면과 후속 컷의 높은 디테일을 우선합니다.',
            max: '지원되는 최고 품질로 생성하며 시간과 비용이 가장 커질 수 있습니다.'
        };
        return labels[this.normalizeImageQuality(this.selectedImageQuality)] || labels.low;
    }

    public async onImageQualityChange() {
        this.selectedImageQuality = this.normalizeImageQuality(
            this.selectedImageQuality
        );
        this.workbenchSaveImageQuality();
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    private normalizeImageQuality(value: any) {
        const quality = String(value || '').trim().toLowerCase();
        return this.openAIImageQualityOptions.some(
            (option: any) => option.value === quality
        ) ? quality : 'low';
    }

    public imagePromptStrategyLabel(strategy: string = this.imagePromptStrategy) {
        return strategy === 'model_specific' ? '모델 맞춤 최적화' : '기존 방식';
    }

    public imagePromptStrategyDescription() {
        return this.imagePromptStrategy === 'model_specific'
            ? '장면 사실은 유지하고, 선택한 모델별 검증 템플릿의 순서와 필드 구조로 전체 프롬프트를 재조립합니다.'
            : 'Qwen의 Negative 분리만 제외하고 모든 이미지 모델에 동일한 공통 프롬프트를 전송합니다.';
    }

    public imageGenerationRequestValid() {
        return ['legacy', 'model_specific'].includes(this.imagePromptStrategy)
            && !!this.selectedImageModelProfile();
    }

    public async setImagePromptStrategy(strategy: 'legacy' | 'model_specific') {
        if (!['legacy', 'model_specific'].includes(strategy)) return;
        this.imagePromptStrategy = strategy;
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public imageGenerationRequestNote() {
        const total = this.imageGenerationTotalCount();
        const scope = this.imageGenerationScope === 'all'
            ? `${this.intensityScaleLabel()} 1~5별 ${this.imageCandidateCount}개`
            : `현재 강도 ${this.imageCandidateCount}개`;
        return `${scope}, 총 ${total}건의 ${this.selectedImageModelLabel()} 요청을 ${this.imagePromptStrategyLabel()}으로 실행하며 요청별 사용 비용이 발생합니다.`;
    }

    public imageGenerationTotalCount() {
        const count = this.normalizeCandidateCount(this.imageCandidateCount);
        if (this.imageGenerationScope !== 'all') return count;
        return count * 5;
    }

    private actualPromptTemplateId() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        if (!['image', 'video'].includes(mediaType)) return '';
        if (
            this.sourceMode === 'scenario'
            || this.patientMemoryMode === 'resource'
        ) {
            return this.templateIdForScenarioGeneration(mediaType);
        }
        return this.templateIdForScenario(
            String(this.form.scenario_type || ''),
            mediaType
        );
    }

    public actualPromptPreviewAvailable() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        const baseAvailable = this.can('content.write')
            && ['image', 'video'].includes(mediaType)
            && this.contentSettingsReady()
            && this.selectedGenerationModelAvailable(mediaType)
            && !!this.actualPromptTemplateId();
        if (!baseAvailable) return false;
        if (mediaType === 'video') {
            return this.sourceMode === 'scenario'
                ? this.canCreateScenarioVideoFromSource()
                : this.canCreateVideoFromSource();
        }
        return true;
    }

    public async openActualPromptPreview() {
        await this.openActualPromptPreviewFor(this.selectedImageModelKey(), this.form.intensity);
    }

    public async openActualPromptPreviewFor(modelKey?: string, intensity?: number) {
        if (!this.actualPromptPreviewAvailable()) return;
        this.actualPromptPreviewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.actualPromptPreviewOpen = true;
        this.actualPromptPreviewStrategy = this.imagePromptStrategy;
        this.actualPromptPreviewModelKey = modelKey || this.selectedImageModelKey();
        this.actualPromptPreviewIntensity = this.normalizeIntensityValue(
            intensity === undefined ? this.form.intensity : intensity
        );
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            document.getElementById('content-actual-prompt-preview-close')?.focus();
        }, 0);
        await this.loadActualPromptPreview();
    }

    public async loadActualPromptPreview() {
        if (!this.actualPromptPreviewOpen || !this.actualPromptPreviewAvailable()) {
            return;
        }
        const sequence = ++this.actualPromptPreviewSequence;
        this.actualPromptPreviewLoading = true;
        this.actualPromptPreviewError = '';
        await this.service.render();
        try {
            const mediaType = this.normalizeMediaType(this.form.media_type);
            const scenarioCutSpec = (
                ['image', 'video'].includes(mediaType) && this.sourceMode === 'scenario'
            ) ? this.scenarioCutRequestSpec() : null;
            const patientSource = this.videoSourceEligible(this.selectedPatientSource)
                ? this.selectedPatientSource
                : null;
            const source = patientSource ? null : this.selectedVideoSource;
            const { code, data } = await wiz.call('generation_prompt_preview', {
                media_type: mediaType,
                source_mode: this.sourceMode,
                patient_id: this.normalizeRequestedPatientId(this.form.patient_id),
                memory_mode: this.patientMemoryMode,
                resource_memory_id: this.patientMemoryMode === 'resource'
                    ? this.normalizeRequestedPatientId(this.selectedResourceMemoryId)
                    : '',
                scenario_type: String(this.form.scenario_type || ''),
                scenario_set_id: String(
                    this.scenarioSelection.scenario_set_id || ''
                ).toUpperCase(),
                memory_kind: String(
                    this.scenarioSelection.memory_kind || ''
                ).toLowerCase(),
                template_id: this.actualPromptTemplateId(),
                intensity: this.actualPromptPreviewIntensity,
                candidate_count: mediaType === 'image'
                    ? this.normalizeCandidateCount(this.imageCandidateCount)
                    : 1,
                duration_seconds: this.videoDurationSeconds,
                generation_model: mediaType === 'image'
                    ? this.actualPromptPreviewModelKey
                    : this.selectedVideoModelKey(),
                prompt_adjustments: mediaType === 'image' && this.sourceMode === 'scenario'
                    ? JSON.stringify(this.workbenchPromptAdjustments(
                        this.actualPromptPreviewIntensity,
                        this.actualPromptPreviewModelKey
                    ))
                    : '',
                image_quality: mediaType === 'image'
                    ? this.actualPromptPreviewImageQualityRequest()
                    : '',
                prompt_strategy: mediaType === 'image'
                    ? this.actualPromptPreviewStrategy
                    : 'legacy',
                image_expression: mediaType === 'image'
                    ? this.workbenchServerExpression()
                    : 'realistic',
                scenario_photo_id: mediaType === 'image' && this.sourceMode === 'scenario' && this.workbenchReferenceEnabled()
                    ? this.workbenchScenarioPhotoId
                    : '',
                scenario_cut_spec: scenarioCutSpec
                    ? JSON.stringify(scenarioCutSpec)
                    : '',
                ...this.referencePolicyRequest(mediaType),
                source_revision_id: mediaType === 'video' && source
                    ? this.assetId(source)
                    : '',
                patient_source_image_id: mediaType === 'image' && !this.workbenchReferenceEnabled()
                    ? '' : this.patientSourceRequestId(mediaType),
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch()
                    && this.promptMismatchAcknowledged
                ),
                csrf_token: this.csrfToken()
            });
            if (sequence !== this.actualPromptPreviewSequence) return;
            if (code !== 200 || !data?.preview) {
                this.actualPromptPreview = null;
                this.actualPromptPreviewError = data?.message
                    || '실제 전송 프롬프트를 계산하지 못했습니다.';
                return;
            }
            this.actualPromptPreview = data.preview;
        } catch (_error) {
            if (sequence !== this.actualPromptPreviewSequence) return;
            this.actualPromptPreview = null;
            this.actualPromptPreviewError = '실제 전송 프롬프트를 계산하지 못했습니다.';
        } finally {
            if (sequence === this.actualPromptPreviewSequence) {
                this.actualPromptPreviewLoading = false;
                await this.service.render();
            }
        }
    }

    public async setActualPromptPreviewStrategy(
        strategy: 'legacy' | 'model_specific'
    ) {
        if (!['legacy', 'model_specific'].includes(strategy)) return;
        if (this.normalizeMediaType(this.form.media_type) !== 'image') return;
        if (
            this.actualPromptPreviewStrategy === strategy
            && this.actualPromptPreview
            && !this.actualPromptPreviewError
        ) return;
        this.actualPromptPreviewStrategy = strategy;
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        await this.service.render();
        await this.loadActualPromptPreview();
    }

    public actualPromptPreviewModelLabel() {
        const option = (this.generationModelOptions.image || []).find(
            (candidate: any) => candidate.value === this.actualPromptPreviewModelKey
        );
        return String(option?.label || '선택한 이미지 모델');
    }

    public actualPromptPreviewImageQualityRequest() {
        if (this.actualPromptPreviewModelKey !== 'openai-gpt-image-2') return '';
        return this.normalizeImageQuality(this.selectedImageQuality);
    }

    private resetActualPromptPreview() {
        this.actualPromptPreviewSequence += 1;
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        this.actualPromptPreviewLoading = false;
    }

    public async setActualPromptPreviewModel(modelKey: any) {
        modelKey = String(modelKey || '').trim();
        const supported = (this.generationModelOptions.image || []).some(
            (candidate: any) => candidate.value === modelKey
        );
        if (!supported || !this.generationModelAvailable(modelKey, 'image')) return;
        if (
            this.actualPromptPreviewModelKey === modelKey
            && this.actualPromptPreview
            && !this.actualPromptPreviewError
        ) return;
        this.actualPromptPreviewModelKey = modelKey;
        this.actualPromptPreview = null;
        this.actualPromptPreviewError = '';
        await this.service.render();
        await this.loadActualPromptPreview();
    }

    public async closeActualPromptPreview() {
        this.actualPromptPreviewSequence += 1;
        this.actualPromptPreviewOpen = false;
        this.actualPromptPreviewLoading = false;
        this.actualPromptPreviewError = '';
        this.actualPromptPreview = null;
        this.actualPromptPreviewStrategy = this.imagePromptStrategy;
        this.actualPromptPreviewModelKey = this.selectedImageModelKey();
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.actualPromptPreviewReturnFocus;
        this.actualPromptPreviewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onActualPromptPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeActualPromptPreview();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-actual-prompt-preview-dialog');
    }

    public actualPromptPreviewFields() {
        const fields = this.actualPromptPreview?.fields;
        return Array.isArray(fields)
            ? fields.filter((field: any) => String(field?.value || '').trim())
            : [];
    }

    public actualPromptPreviewModeLabel() {
        return this.actualPromptPreview?.prompt_mode === 'split'
            ? 'Prompt · Negative 분리 전송'
            : '단일 Prompt로 결합 전송';
    }

    public actualPromptPreviewLanguageLabel() {
        return this.actualPromptPreview?.input_language === 'en'
            ? '영어 최종 입력'
            : '한국어·영어 혼합 최종 입력';
    }

    public actualPromptPreviewSourceLabel() {
        const labels: any = {
            patient_trauma_memory: '환자별 승인 외상기억',
            patient_resource_memory: '임상 승인 자원기억',
            scenario_set: '시나리오 세트'
        };
        return labels[String(this.actualPromptPreview?.source_kind || '')]
            || '선택 콘텐츠 출처';
    }

    public async onImageGenerationScopeChange(value: any) {
        const nextScope = value === 'all' ? 'all' : 'single';
        this.imageGenerationScope = nextScope;
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public selectedImageModelKey() {
        return String(this.selectedGenerationModelKeys?.image || '');
    }

    public selectedImagePricing() {
        const models = this.imagePricing?.models;
        if (!models || typeof models !== 'object') return null;
        const pricing = models[this.selectedImageModelKey()];
        return pricing && typeof pricing === 'object' ? pricing : null;
    }

    public imageAssetModelKey(item: any) {
        const data = this.primaryMetadata(item);
        const usage = this.generationUsage(item);
        const provider = String(
            usage?.provider_name
            || data?.provider_name
            || item?.provider_name
            || ''
        ).toLowerCase();
        const model = String(
            usage?.model_name
            || data?.model_name
            || item?.model_name
            || ''
        ).toLowerCase();
        const requestedModel = String(
            item?.model_name
            || data?.generation_model
            || data?.requested_model
            || ''
        ).toLowerCase();
        if (
            provider.includes('kolbo')
            && requestedModel.startsWith('kolbo-')
            && (this.generationModelOptions.image || []).some(
                (candidate: any) => candidate.value === requestedModel
            )
        ) return requestedModel;
        if (provider.includes('openai') || model.includes('gpt-image')) {
            return 'openai-gpt-image-2';
        }
        if (provider.includes('kling') || model.includes('kling-v2-1') || model.includes('kling-v3')) {
            return 'kling-image-2-1';
        }
        const evolinkModelKey = this.evolinkImageModelKey(`${model} ${requestedModel}`);
        if (provider.includes('evolink') || evolinkModelKey) {
            return evolinkModelKey || 'evolink-seedream-5-lite';
        }
        return '';
    }

    public latestSelectedImageCostPerRequest() {
        const modelKey = this.selectedImageModelKey();
        const row = (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => (
                this.mediaType(job) === 'image'
                && this.imageAssetModelKey(job) === modelKey
                && this.generationUsageAvailable(job)
                && Number(this.generationUsage(job)?.cost_micros) > 0
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || ''
                ) || 0;
                return rightTime - leftTime;
            })[0];
        const cost = Number(this.generationUsage(row)?.cost_micros);
        return Number.isFinite(cost) && cost > 0 ? cost : null;
    }

    public selectedImageEstimatedCostMicros() {
        const pricing = this.selectedImagePricing();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        const count = this.imageGenerationTotalCount();
        const configuredRate = Number(pricing?.cost_micros_per_image);
        if (
            status === 'configured'
            && Number.isFinite(configuredRate)
            && configuredRate > 0
        ) return configuredRate * count;

        const observedRate = this.latestSelectedImageCostPerRequest();
        if (observedRate) return observedRate * count;

        const estimateRate = Number(pricing?.estimate_micros_per_image);
        return Number.isFinite(estimateRate) && estimateRate > 0
            ? estimateRate * count
            : null;
    }

    public selectedImageActualCostMicros() {
        const batchId = String(this.latestImageCostBatchId || '');
        const intensityBatchId = String(this.latestIntensityBatchId || '');
        const modelKey = String(this.latestImageCostModelKey || '');
        const expectedCount = Number(this.latestImageCostCandidateCount || 0);
        if (
            (!batchId && !intensityBatchId)
            || modelKey !== this.selectedImageModelKey()
            || !Number.isInteger(expectedCount)
            || expectedCount < 1
        ) return null;

        const batch = (Array.isArray(this.jobs) ? this.jobs : []).filter(
            (job: any) => intensityBatchId
                ? String(job?.intensity_batch_id || '') === intensityBatchId
                : String(job?.candidate_batch_id || '') === batchId
        );
        if (batch.length !== expectedCount) return null;
        const actualCosts = batch.map((job: any) => {
            const usage = this.generationUsage(job);
            const status = String(usage?.pricing_status || '').toLowerCase();
            const cost = Number(usage?.cost_micros);
            if (
                !this.generationUsageAvailable(job)
                || ['unpriced', 'unpriced_legacy'].includes(status)
                || !Number.isFinite(cost)
                || cost <= 0
            ) return null;
            return cost;
        });
        if (actualCosts.some((cost: number | null) => cost === null)) return null;
        return actualCosts.reduce(
            (total: number, cost: number | null) => total + Number(cost || 0),
            0
        );
    }

    public selectedImageCostTitle() {
        return this.selectedImageActualCostMicros() !== null
            ? '이번 생성 실제 비용'
            : '선택 기준 예상 비용';
    }

    public selectedImageEstimatedCostLabel() {
        const actualMicros = this.selectedImageActualCostMicros();
        if (actualMicros !== null) return this.formatCost(actualMicros);

        const micros = this.selectedImageEstimatedCostMicros();
        if (micros !== null) {
            const prefix = this.selectedImageModelKey() === 'kling-image-2-1'
                ? '약 '
                : '';
            return prefix + this.formatCost(micros);
        }

        const status = String(
            this.selectedImagePricing()?.pricing_status || ''
        ).toLowerCase();
        if (status === 'usage_based') return '토큰 사용량 기준';
        if (status === 'provider_reported') return '공급사 응답 후 계산';
        return '요금 확인 필요';
    }

    public panoramaPricing() {
        const pricing = this.imagePricing?.models?.['openai-gpt-image-2']?.panorama;
        return pricing && typeof pricing === 'object' ? pricing : null;
    }

    public panoramaEstimatedCostMicros() {
        const value = Number(this.panoramaPricing()?.estimate_micros_per_image);
        return Number.isFinite(value) && value > 0 ? value : null;
    }

    public panoramaEstimatedCostLabel() {
        const value = this.panoramaEstimatedCostMicros();
        return value === null ? '토큰 사용량 기준' : `약 ${this.formatCost(value)}`;
    }

    public selectedImageEstimatedCostDetail() {
        const pricing = this.selectedImagePricing();
        const count = this.imageGenerationTotalCount();
        const model = this.selectedImageModelLabel();
        const patientSourceEdit = (
            this.selectedImageModelKey() === 'openai-gpt-image-2'
            && !!this.selectedPatientSource
        );
        const resolution = String(
            patientSourceEdit
                ? (pricing?.patient_source_resolution || pricing?.resolution || '')
                : (pricing?.resolution || '')
        ).trim();
        const quality = String(
            this.openAIImageQualitySelectable()
                ? this.selectedImageQualityRequest()
                : (
                    patientSourceEdit
                        ? (pricing?.patient_source_quality || pricing?.quality || '')
                        : (pricing?.quality || '')
                )
        ).trim();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        const configuredRate = Number(pricing?.cost_micros_per_image);
        const observedRate = this.latestSelectedImageCostPerRequest();
        const estimateRate = Number(pricing?.estimate_micros_per_image);
        const actualMicros = this.selectedImageActualCostMicros();
        const parts = [model, resolution, quality].filter(
            (value: string) => !!value
        );

        if (actualMicros !== null) {
            parts.push(`${this.latestImageCostCandidateCount}개 실제 청구 합계`);
            parts.push('공급사 청구 응답 기준');
        } else if (
            status === 'configured'
            && Number.isFinite(configuredRate)
            && configuredRate > 0
        ) {
            parts.push(`1개당 ${this.formatCost(configuredRate)} × ${count}개`);
        } else if (observedRate) {
            parts.push(`최근 동일 모델 1건 비용 × ${count}개`);
            parts.push('실제 청구액은 달라질 수 있음');
        } else if (Number.isFinite(estimateRate) && estimateRate > 0) {
            parts.push(`예상 1개당 ${this.formatCost(estimateRate)} × ${count}개`);
            parts.push('작업 완료 후 실제 청구액으로 교체');
        } else if (status === 'usage_based') {
            parts.push('실제 입력·출력 토큰 사용량으로 확정');
        } else if (status === 'provider_reported') {
            parts.push('작업 완료 후 공급사 청구 응답으로 확정');
        } else {
            parts.push('운영 요율 설정 필요');
        }
        return parts.join(' · ');
    }

    private clearLatestImageCostBatch() {
        this.latestImageCostBatchId = '';
        this.latestIntensityBatchId = '';
        this.latestImageCostModelKey = '';
        this.latestImageCostCandidateCount = 0;
    }

    public async onImageCandidateCountChange() {
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onGenerationModelChange(mediaType: string) {
        if (mediaType === 'image') {
            if (this.openAIImageQualitySelectable()) {
                this.selectedImageQuality = this.normalizeImageQuality(
                    this.selectedImagePricing()?.quality || this.selectedImageQuality
                );
            }
            this.clearLatestImageCostBatch();
            this.actualPromptPreview = null;
            this.actualPromptPreviewError = '';
            this.form.idempotency_key = this.newIdempotencyKey();
            await this.service.render();
            return;
        }
        if (mediaType !== 'video') return;
        const options = this.videoDurationOptionsForSelectedModel();
        if (!options.includes(this.videoDurationSeconds)) {
            this.videoDurationSeconds = options[0];
        }
        this.selectedVideoResultModelKey = 'all';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onVideoDurationChange() {
        const options = this.videoDurationOptionsForSelectedModel();
        if (!options.includes(this.videoDurationSeconds)) {
            this.videoDurationSeconds = options[0];
        }
        this.selectedVideoResultModelKey = 'all';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectedVideoPricing() {
        const models = this.videoPricing?.models;
        if (!models || typeof models !== 'object') return null;
        const pricing = models[this.selectedVideoModelKey()];
        return pricing && typeof pricing === 'object' ? pricing : null;
    }

    public selectedVideoEstimatedCostLabel() {
        const pricing = this.selectedVideoPricing();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        if (status === 'no_charge') return '별도 API 과금 없음';
        if (status !== 'configured') return '요금 확인 필요';
        const estimates = pricing?.estimated_costs_micros;
        const micros = Number(estimates?.[String(this.videoDurationSeconds)]);
        const total = micros * (this.videoGenerationScope === 'all' ? 5 : 1);
        return Number.isFinite(total) ? this.formatCost(total) : '요금 확인 필요';
    }

    public selectedVideoEstimatedCostDetail() {
        const pricing = this.selectedVideoPricing();
        const model = (this.generationModelOptions.video || []).find(
            (option: any) => option.value === this.selectedVideoModelKey()
        );
        const parts = [
            String(model?.label || '').trim(),
            String(pricing?.resolution || '').trim(),
            `${this.videoDurationSeconds}초 기준`,
            this.videoGenerationScope === 'all' ? '강도별 5건 합계' : '단일 영상'
        ].filter((value: string) => !!value);
        return parts.join(' · ');
    }

    public selectedVideoModelSupportsUploadedAudio() {
        return this.selectedVideoModelKey() === 'wan-2-2';
    }

    public canCreateIntensityVideoBatch() {
        if (!this.can('content.write') || this.videoSubmitting) return false;
        if (!this.selectedGenerationModelAvailable('video')) return false;
        const sources = this.intensityVideoSourceRows().map((row: any) => row.source);
        if (sources.some((source: any) => !this.videoSourceEligible(source))) return false;
        const ids = sources.map((source: any) => this.assetId(source));
        if (ids.some((id: string) => !id) || new Set(ids).size !== 5) return false;
        const scenarios = new Set(sources.map((source: any) => String(
            source?.scenario_type || source?.scenario || ''
        ).trim()));
        if (scenarios.size !== 1 || scenarios.has('')) return false;
        const scenario = String(sources[0]?.scenario_type || sources[0]?.scenario || '');
        if (!this.templateIdForScenario(scenario, 'video')) return false;
        if (this.promptSelectionMismatch(scenario) && !this.promptMismatchAcknowledged) return false;
        return !(this.selectedAudioSource && !this.selectedVideoModelSupportsUploadedAudio());
    }

    public canCreateSelectedVideo() {
        return this.videoGenerationScope === 'all'
            ? this.canCreateIntensityVideoBatch()
            : this.canCreateVideoFromSource();
    }

    public async createSelectedVideo() {
        if (this.videoGenerationScope === 'all') {
            await this.createIntensityVideoBatch();
            return;
        }
        await this.createVideoFromSelectedImage();
    }

    public async createIntensityVideoBatch() {
        if (!this.can('content.write') || this.videoSubmitting) return;
        if (!this.canCreateIntensityVideoBatch()) {
            await this.service.modal.error(
                '강도 1~5에서 영상으로 만들 이미지 후보를 하나씩 선택해주세요.'
            );
            return;
        }
        const sources = this.intensityVideoSourceRows().map((row: any) => row.source);
        const scenario = String(
            sources[0]?.scenario_type || sources[0]?.scenario || ''
        ).trim();
        const templateId = this.templateIdForScenario(scenario, 'video');
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();

        this.videoSubmitting = true;
        const videoRequest = this.workbenchBeginVideoRequest('video');
        this.errorMessage = '';
        await this.service.render();
        let createdJobs: any[] = [];
        try {
            const { code, data } = await wiz.call('create_intensity_video_batch', {
                source_revision_ids: this.intensityVideoSourceRevisionIds(),
                audio_source_revision_id: this.assetId(this.selectedAudioSource),
                duration_seconds: this.videoDurationSeconds,
                generation_model: this.selectedVideoModelKey(),
                template_id: templateId,
                idempotency_key: this.videoIdempotencyKey,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch(scenario)
                    && this.promptMismatchAcknowledged
                ),
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '강도별 영상 생성 요청을 등록하지 못했습니다.';
                return;
            }
            const jobs = this.extractList(data, ['jobs', 'generation_jobs'])
                .map((job: any) => this.jobFromPayload(job));
            const batchId = String(data?.video_batch_id || '');
            const intensities = new Set(jobs.map((job: any) => this.jobIntensity(job)));
            if (
                jobs.length !== 5
                || !/^[0-9a-f]{32}$/.test(batchId)
                || jobs.some((job: any) => String(job?.video_batch_id || '') !== batchId)
                || intensities.size !== 5
            ) {
                this.errorMessage = '강도별 영상 배치 결과를 확인하지 못했습니다. 같은 요청으로 다시 시도해주세요.';
                return;
            }
            this.latestVideoBatchId = batchId;
            createdJobs = jobs;
            [...jobs].reverse().forEach((job: any) => this.upsertJob(job, true));
            this.mergeAssets(this.assetsFromPayload(data));
            this.videoIdempotencyKey = this.newIdempotencyKey();
            await this.search(false);
        } catch (_error) {
            this.errorMessage = '강도별 영상 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.workbenchFinishVideoRequest(videoRequest, createdJobs);
            this.videoSubmitting = false;
            await this.service.render();
        }
    }

    public async createVideoFromSelectedImage() {
        if (!this.can('content.write') || this.videoSubmitting) return;
        if (!this.selectedGenerationModelAvailable('video')) {
            await this.service.modal.error(this.selectedGenerationModelUnavailableMessage('video'));
            return;
        }
        const patientSource = this.selectedPatientSource;
        const source = patientSource || this.selectedVideoSource;
        if (!this.videoSourceEligible(source)) {
            await this.service.modal.error('승인된 환자 사진 또는 안전성 검사를 통과한 이미지 후보를 먼저 선택해주세요.');
            return;
        }
        const sourceRevisionId = patientSource ? '' : this.assetId(source);
        const scenario = String(
            source?.scenario_type
            || source?.scenario
            || this.form.scenario_type
            || ''
        );
        const templateId = this.templateIdForScenario(scenario, 'video');
        if ((!sourceRevisionId && !this.patientSourceRequestId('video')) || !templateId) {
            await this.service.modal.error('선택한 이미지에 맞는 비디오 템플릿이 없습니다.');
            return;
        }
        if (this.promptSelectionMismatch(scenario) && !this.promptMismatchAcknowledged) {
            await this.service.modal.error(
                '환자 유형과 다른 프롬프트 세트를 사용하려면 먼저 경고 내용을 확인해주세요.'
            );
            return;
        }
        if (this.selectedAudioSource && !this.selectedVideoModelSupportsUploadedAudio()) {
            await this.service.modal.error(
                '선택한 외부 영상 모델은 업로드 오디오 입력을 지원하지 않습니다. 오디오를 제거하거나 Wan 2.2를 선택해주세요.'
            );
            return;
        }
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();

        this.videoSubmitting = true;
        const videoRequest = this.workbenchBeginVideoRequest('video');
        this.errorMessage = '';
        await this.service.render();
        let createdJobs: any[] = [];
        try {
            const { code, data } = await wiz.call('create_video_from_image', {
                source_revision_id: sourceRevisionId,
                patient_source_image_id: this.patientSourceRequestId('video'),
                scenario_type: scenario,
                intensity: this.form.intensity,
                audio_source_revision_id: this.assetId(this.selectedAudioSource),
                duration_seconds: this.videoDurationSeconds,
                generation_model: this.selectedVideoModelKey(),
                template_id: templateId,
                idempotency_key: this.videoIdempotencyKey,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch(scenario)
                    && this.promptMismatchAcknowledged
                ),
                reference_id: patientSource ? '' : this.referenceConditionRequestId('video'),
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '선택한 이미지의 영상 생성 요청을 등록하지 못했습니다.';
                return;
            }
            const job = this.jobFromPayload(data);
            if (job && this.jobId(job)) {
                this.upsertJob(job, true);
                createdJobs = [job];
            }
            this.videoIdempotencyKey = this.newIdempotencyKey();
            await this.search(false);
        } catch (error) {
            this.errorMessage = '선택한 이미지의 영상 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.workbenchFinishVideoRequest(videoRequest, createdJobs);
            this.videoSubmitting = false;
            await this.service.render();
        }
    }

    public canLinkToTherapySession(asset: any) {
        if (!this.can('sessions.operate') || !this.assetId(asset)) return false;
        const reviewStatus = this.assetReviewStatus(asset);
        return ['pending', 'review_pending', 'approved'].includes(reviewStatus)
            && this.assetSafetyStatus(asset) === 'passed';
    }

    public therapySessionLinkReason(asset: any) {
        if (this.assetSafetyStatus(asset) !== 'passed') {
            return '안전성 검사를 통과한 자산만 치료 세션에 연결할 수 있습니다.';
        }
        if (!['pending', 'review_pending', 'approved'].includes(this.assetReviewStatus(asset))) {
            return '격리·반려된 자산은 치료 세션에 연결할 수 없습니다.';
        }
        return '치료 세션에 연결할 수 없는 자산입니다.';
    }

    public async linkToTherapySession(asset: any) {
        if (!this.canLinkToTherapySession(asset)) {
            await this.service.modal.error(this.therapySessionLinkReason(asset));
            return;
        }
        const patientId = this.normalizeRequestedPatientId(
            asset?.patient_id
            || asset?.patient?.id
            || this.primaryMetadata(asset)?.patient_id
            || this.form.patient_id
        );
        const revisionId = this.assetId(asset);
        const metadata = this.primaryMetadata(asset);
        const sourceKind = String(
            asset?.source_kind || metadata?.source_kind || 'patient'
        );
        const sourceKey = String(
            asset?.source_key || metadata?.source_key || ''
        );
        if (!patientId || !revisionId) {
            await this.service.modal.error('연결할 환자와 자산 정보를 확인해주세요.');
            return;
        }
        await this.router.navigate(['/sessions'], {
            queryParams: {
                patient_id: patientId,
                asset_revision_id: revisionId,
                media_type: this.mediaType(asset),
                memory_kind: sourceKind === 'resource'
                    ? 'resource'
                    : 'trauma',
                resource_memory_id: sourceKind === 'resource'
                    ? sourceKey
                    : ''
            }
        });
    }

    public async cancelJob(job: any) {
        const id = this.jobId(job);
        if (!this.can('content.write') || !id || !this.canCancel(job) || this.actionJobId) return;

        const confirmed = await this.service.modal.show({
            title: '생성 작업 취소',
            message: '대기 또는 처리 중인 작업을 취소하시겠습니까?',
            action: '작업 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('cancel_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (![200, 202].includes(code)) {
                await this.service.modal.error(data?.message || '작업을 취소하지 못했습니다.');
                return;
            }
            const updated = this.jobFromPayload(data);
            if (updated && this.jobId(updated)) this.upsertJob(updated);
            else await this.refreshJob(id);
        } catch (error) {
            await this.service.modal.error('작업을 취소하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async retryJob(job: any) {
        const id = this.jobId(job);
        if (!this.can('content.write') || !id || !this.canRetry(job) || this.actionJobId) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('retry_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                await this.service.modal.error(data?.message || '작업을 다시 시도하지 못했습니다.');
                return;
            }
            const updated = this.jobFromPayload(data);
            if (updated && this.jobId(updated)) this.upsertJob(updated, true);
            if (this.mediaType(job) !== 'video') {
                await this.service.modal.success('재시도 요청을 등록했습니다.');
            }
            await this.search(false);
        } catch (error) {
            await this.service.modal.error('작업을 다시 시도하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public canRegenerateCandidate(item: any) {
        const reviewDecision = item?.review_decision
            || this.primaryMetadata(item)?.review_decision
            || {};
        const regenerationRequested = String(
            reviewDecision?.decision || ''
        ).toLowerCase() === 'regeneration_requested';
        const reviewStatus = String(
            item?.review_status
            || this.primaryMetadata(item)?.review_status
            || 'pending'
        ).toLowerCase();
        return ['image', 'video'].includes(this.mediaType(item))
            && !!this.jobId(item)
            && String(
                item?.job_status || item?.status || 'review_pending'
            ).toLowerCase() !== 'approved'
            && (
                ['pending', 'review_pending'].includes(reviewStatus)
                || (reviewStatus === 'rejected' && regenerationRequested)
            );
    }

    public canRegenerateImage(item: any) {
        return this.mediaType(item) === 'image'
            && this.canRegenerateCandidate(item);
    }

    public async regenerateCandidate(asset: any) {
        const id = this.jobId(asset);
        const mediaType = this.mediaType(asset);
        if (
            !this.can('content.write')
            || !id
            || !this.canRegenerateCandidate(asset)
            || this.actionJobId
        ) return;

        const scenario = String(
            mediaType === 'image'
                ? (this.form.scenario_type || asset?.scenario_type || asset?.scenario || '')
                : (asset?.scenario_type || asset?.scenario || '')
        ).trim();
        const intensity = mediaType === 'image'
            ? this.normalizeIntensityValue(this.form.intensity)
            : Number(asset?.intensity || asset?.prompt_snapshot?.intensity || 0);
        const templateId = this.templateIdForScenario(scenario, mediaType);
        const generationModel = String(
            this.selectedGenerationModelKeys?.[mediaType] || ''
        );
        if (!templateId || !scenario || intensity < 1 || intensity > 5) {
            await this.service.modal.error('선택한 조건에 맞는 생성 템플릿을 확인해주세요.');
            return;
        }
        if (!this.generationModelAvailable(generationModel, mediaType)) {
            await this.service.modal.error(
                this.selectedGenerationModelUnavailableMessage(mediaType)
            );
            return;
        }
        if (mediaType === 'image' && !this.imageGenerationRequestValid()) {
            await this.service.modal.error('이미지 모델과 프롬프트 적용 방식을 확인해주세요.');
            return;
        }
        if (
            mediaType === 'video'
            && this.selectedAudioSource
            && !this.selectedVideoModelSupportsUploadedAudio()
        ) {
            await this.service.modal.error(
                '선택한 영상 모델은 업로드 오디오 입력을 지원하지 않습니다.'
            );
            return;
        }
        const modelOption = (this.generationModelOptions?.[mediaType] || []).find(
            (option: any) => option.value === generationModel
        );
        const conditionSummary = [
            String(modelOption?.label || generationModel),
            mediaType === 'image' ? this.workbenchImageConditionLabel(intensity) : `강도 ${intensity}`,
            mediaType === 'video' ? `${this.videoDurationSeconds}초` : '',
            mediaType === 'video'
                ? '원본 이미지 레퍼런스 유지'
                : (this.selectedReferenceCondition ? '선택 레퍼런스 적용' : '레퍼런스 없음'),
            mediaType === 'video' && this.selectedAudioSource
                ? '선택 오디오 적용'
                : ''
        ].filter((value: string) => !!value).join(' · ');

        const confirmed = await this.service.modal.show({
            title: `${this.modalityLabel(mediaType)} 후보 조건 변경 재생성`,
            message: `${conditionSummary} 조건으로 새 후보를 생성합니다. 새 결과가 성공하기 전까지 현재 후보는 유지되며 API 사용 비용이 발생합니다.`,
            action: '다시 생성',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(
                'regenerate_candidate',
                {
                    job_id: id,
                    template_id: templateId,
                    scenario_type: scenario,
                    intensity,
                    generation_model: generationModel,
                    prompt_strategy: mediaType === 'image'
                        ? this.imagePromptStrategy
                        : 'legacy',
                    ...this.referencePolicyRequest(mediaType),
                    inherit_reference_condition: mediaType === 'video',
                    duration_seconds: mediaType === 'video'
                        ? this.videoDurationSeconds
                        : null,
                    audio_source_revision_id: mediaType === 'video'
                        ? this.assetId(this.selectedAudioSource)
                        : null,
                    acknowledge_scenario_mismatch: (
                        this.promptSelectionMismatch(scenario)
                        && this.promptMismatchAcknowledged
                    ),
                    idempotency_key: this.newIdempotencyKey(),
                    csrf_token: this.csrfToken()
                }
            );
            if (![200, 201, 202].includes(code)) {
                await this.service.modal.error(
                    data?.message || '후보를 다시 생성하지 못했습니다.'
                );
                return;
            }
            const job = this.jobFromPayload(data);
            if (job && this.jobId(job)) this.upsertJob(job, true);
            this.mergeAssets(this.assetsFromPayload(data));
            await this.service.modal.success(
                '선택 조건으로 재생성을 시작했습니다. 새 결과가 완료되면 현재 후보를 자동으로 교체합니다.'
            );
            await this.search(false);
        } catch (error) {
            await this.service.modal.error(
                '후보를 다시 생성하지 못했습니다.'
            );
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async regenerateImageCandidate(asset: any) {
        await this.regenerateCandidate(asset);
    }

    public panoramaSourceEligible(asset: any) {
        return !!asset
            && this.mediaType(asset) === 'image'
            && this.hasPlayablePreview(asset)
            && !this.isQuarantinedAsset(asset)
            && this.videoSourceEligible(asset)
            && this.panoramaGenerationMode(asset) !== 'image_to_panorama';
    }

    public panoramaSourceReason(asset: any) {
        if (!asset || this.mediaType(asset) !== 'image') {
            return '이미지 후보에서만 360° 미리보기를 만들 수 있습니다.';
        }
        if (this.isQuarantinedAsset(asset)) {
            return '격리된 이미지는 360° 미리보기 원본으로 사용할 수 없습니다.';
        }
        if (!this.hasPlayablePreview(asset)) {
            return '이미지 미리보기가 준비된 후 사용할 수 있습니다.';
        }
        if (this.panoramaGenerationMode(asset) === 'image_to_panorama') {
            return '이미 360°로 생성된 이미지입니다.';
        }
        return this.videoSourceReason(asset);
    }

    public panoramaActionLabel(asset: any) {
        if (this.isPanoramaVideoSource(asset)) return '360° 영상 원본 선택됨';
        if (this.isPanoramaResultReady(asset)) return '360° 결과 보기';
        return '이 이미지로 360° 만들기';
    }

    public isPanoramaResultReady(asset: any) {
        return this.panoramaResultsForSource(asset).length > 0;
    }

    public isPanoramaVideoSource(asset: any) {
        return this.panoramaResultsForSource(asset).some(
            (result: any) => this.isSelectedVideoSource(result)
        );
    }

    public panoramaGenerationMode(item: any) {
        const data = this.primaryMetadata(item);
        const provenance = data?.provenance || item?.provenance || {};
        return String(
            item?.generation_mode
            || data?.generation_mode
            || provenance?.generation_mode
            || ''
        ).trim().toLowerCase();
    }

    public panoramaResultsForSource(asset: any) {
        const sourceId = this.assetId(asset);
        if (!sourceId) return [];
        return (Array.isArray(this.assets) ? this.assets : []).filter(
            (candidate: any) =>
                this.panoramaGenerationMode(candidate) === 'image_to_panorama'
                && this.videoSourceRevisionId(candidate) === sourceId
                && this.validPanoramaResult(candidate)
                && ['pending', 'approved'].includes(
                    String(
                        candidate?.review_status
                        || candidate?.asset?.review_status
                        || ''
                    ).toLowerCase()
                )
        ).sort((left: any, right: any) => {
            const leftTime = Date.parse(
                left?.completed_at || left?.created_at || left?.created || ''
            ) || 0;
            const rightTime = Date.parse(
                right?.completed_at || right?.created_at || right?.created || ''
            ) || 0;
            return rightTime - leftTime;
        });
    }

    public panoramaResultForSource(asset: any) {
        return this.panoramaResultsForSource(asset)[0] || null;
    }

    public panoramaResultCount(asset: any) {
        return this.panoramaResultsForSource(asset).length;
    }

    private selectedPanoramaResultForSource(asset: any) {
        const sourceId = this.assetId(asset);
        if (
            sourceId
            && this.panoramaResult
            && this.videoSourceRevisionId(this.panoramaResult) === sourceId
            && this.validPanoramaResult(this.panoramaResult)
        ) return this.panoramaResult;
        return this.panoramaResultForSource(asset);
    }

    public validPanoramaResult(item: any) {
        if (!item || this.panoramaGenerationMode(item) !== 'image_to_panorama') {
            return false;
        }
        const data = this.primaryMetadata(item);
        const master = this.artifacts(item).find(
            (artifact: any) => this.artifactRole(artifact) === 'master'
        );
        const width = Number(data?.width || item?.width || master?.width || 0);
        const height = Number(data?.height || item?.height || master?.height || 0);
        const projection = String(
            item?.output_projection
            || data?.output_projection
            || data?.provenance?.output_projection
            || item?.provenance?.output_projection
            || ''
        ).trim().toLowerCase();
        const projectionContract = String(
            data?.projection_contract
            || data?.provenance?.projection_contract
            || item?.provenance?.projection_contract
            || ''
        ).trim().toLowerCase();
        return width === 2048
            && height === 1024
            && projection === 'equirectangular'
            && projectionContract === 'direct-equirectangular-v2';
    }

    public panoramaJobForSource(asset: any) {
        const sourceId = this.assetId(asset);
        if (!sourceId) return null;
        return (Array.isArray(this.jobs) ? this.jobs : []).find(
            (job: any) =>
                this.panoramaGenerationMode(job) === 'image_to_panorama'
                && this.videoSourceRevisionId(job) === sourceId
                && ['queued', 'running', 'postprocessing'].includes(
                    String(job?.status || '').toLowerCase()
                )
        ) || null;
    }

    public async openPanoramaDialog(asset: any, preferredResult: any = null) {
        if (!this.panoramaSourceEligible(asset)) return;
        this.panoramaReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.panoramaSource = asset;
        this.panoramaResult = (
            preferredResult
            && this.videoSourceRevisionId(preferredResult) === this.assetId(asset)
            && this.validPanoramaResult(preferredResult)
        ) ? preferredResult : this.panoramaResultForSource(asset);
        const activeJob = this.panoramaJobForSource(asset);
        this.panoramaJobId = activeJob ? this.jobId(activeJob) : '';
        this.panoramaStage = activeJob
            ? 'generating'
            : (this.panoramaResult ? 'complete' : 'setup');
        this.panoramaProgressIndex = this.panoramaStage === 'complete'
            ? this.panoramaStages.length
            : 0;
        this.panoramaErrorMessage = '';
        this.panoramaViewMode = 'immersive';
        this.panoramaViewPosition = 50;
        this.panoramaDialogOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => document.getElementById('content-panorama-close')?.focus(), 0);
    }

    public async openPanoramaGenerationSetup(asset: any) {
        await this.openPanoramaDialog(asset);
        if (!this.panoramaDialogOpen || this.panoramaJobForSource(asset)) return;
        this.resetPanoramaGeneration();
    }

    public async closePanoramaDialog() {
        this.panoramaDialogOpen = false;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.panoramaReturnFocus;
        this.panoramaReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public async startPanoramaGeneration() {
        if (
            !this.panoramaSourceEligible(this.panoramaSource)
            || this.panoramaSubmitting
        ) return;
        if (!this.generationModelAvailable('openai-gpt-image-2', 'image')) {
            this.panoramaErrorMessage = String(
                this.generationModelAvailability?.image?.['openai-gpt-image-2']?.message
                || '360° 생성에 필요한 OpenAI 이미지 모델의 연결 상태를 확인해주세요.'
            );
            this.panoramaStage = 'error';
            await this.service.render();
            return;
        }
        this.panoramaSubmitting = true;
        this.panoramaResult = null;
        this.panoramaErrorMessage = '';
        this.panoramaStage = 'generating';
        this.panoramaProgressIndex = 0;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(
                'create_panorama_from_image',
                {
                    source_revision_id: this.assetId(this.panoramaSource),
                    back_description: this.panoramaBackDescription.trim(),
                    idempotency_key: this.newIdempotencyKey(),
                    csrf_token: this.csrfToken()
                }
            );
            if (![200, 201, 202].includes(code)) {
                this.panoramaErrorMessage = data?.message
                    || '360° 이미지 생성 요청을 등록하지 못했습니다.';
                this.panoramaStage = 'error';
                return;
            }
            const job = this.jobFromPayload(data);
            if (!job || !this.jobId(job)) {
                this.panoramaErrorMessage = '360° 이미지 작업 정보를 확인하지 못했습니다.';
                this.panoramaStage = 'error';
                return;
            }
            this.panoramaJobId = this.jobId(job);
            this.upsertJob(job, true);
            const incomingAssets = this.assetsFromPayload(data);
            this.mergeAssets(incomingAssets);
            this.syncPanoramaJob(job, incomingAssets);
        } catch (error: any) {
            const serverMessage = String(
                error?.data?.message
                || error?.response?.data?.message
                || ''
            ).trim();
            this.panoramaErrorMessage = serverMessage.slice(0, 500)
                || '360° 이미지 생성 요청을 등록하지 못했습니다.';
            this.panoramaStage = 'error';
        } finally {
            this.panoramaSubmitting = false;
            await this.service.render();
        }
    }

    public resetPanoramaGeneration() {
        this.panoramaStage = 'setup';
        this.panoramaProgressIndex = 0;
        this.panoramaJobId = '';
        this.panoramaErrorMessage = '';
        this.panoramaViewMode = 'immersive';
        this.panoramaViewPosition = 50;
        this.changeDetector.detectChanges();
    }

    public panoramaStageRows() {
        return this.panoramaStages.map((stage: any, index: number) => ({
            ...stage,
            state: this.panoramaStage === 'complete'
                || index < this.panoramaProgressIndex
                ? 'complete'
                : (index === this.panoramaProgressIndex ? 'current' : 'pending')
        }));
    }

    public setPanoramaViewMode(mode: 'immersive' | 'flat') {
        this.panoramaViewMode = mode;
        this.changeDetector.detectChanges();
    }

    public rotatePanoramaPreview(delta: number) {
        this.panoramaViewPosition = Math.max(
            0,
            Math.min(100, this.panoramaViewPosition + delta)
        );
        this.changeDetector.detectChanges();
    }

    public resetPanoramaPreview() {
        this.panoramaViewPosition = 50;
        this.changeDetector.detectChanges();
    }

    public async choosePanoramaVideoSource(
        source: any = this.panoramaSource,
        preferredResult: any = null
    ) {
        const result = (
            preferredResult
            && this.videoSourceRevisionId(preferredResult) === this.assetId(source)
            && this.validPanoramaResult(preferredResult)
        ) ? preferredResult : this.selectedPanoramaResultForSource(source);
        if (!result || !this.videoSourceEligible(result)) return;
        if (!this.isSelectedVideoSource(result)) {
            this.selectVideoSource(result);
        }
        await this.closePanoramaDialog();
    }

    public async downloadPanoramaResult() {
        await this.downloadPanoramaFile('sphere');
    }

    public async downloadHorizontalPanoramaResult() {
        await this.downloadPanoramaFile('horizontal');
    }

    private async refreshDownloadAsset(asset: any) {
        const revisionId = this.assetId(asset);
        const generationJobId = String(
            asset?.generation_job_id || asset?.job_id || ''
        ).trim().toLowerCase();
        if (!revisionId || !/^[0-9a-f]{32}$/.test(generationJobId)) {
            return asset;
        }

        try {
            const { code, data } = await wiz.call('job_status', {
                job_id: generationJobId
            });
            if (code !== 200) return null;
            const incomingAssets = this.assetsFromPayload(data);
            const refreshed = incomingAssets.find(
                (item: any) => this.assetId(item) === revisionId
            );
            if (!refreshed || !this.masterUrl(refreshed)) return null;
            this.mergeAssets(incomingAssets);
            if (this.assetId(this.panoramaResult) === revisionId) {
                this.panoramaResult = refreshed;
            }
            return refreshed;
        } catch (_error) {
            return null;
        }
    }

    private async downloadPanoramaFile(format: 'sphere' | 'horizontal') {
        const selectedResult = this.selectedPanoramaResultForSource(
            this.panoramaSource
        );
        if (
            !this.validPanoramaResult(selectedResult)
            || this.panoramaDownloading
        ) return;
        this.panoramaDownloading = true;
        this.panoramaDownloadFormat = format;
        this.changeDetector.detectChanges();
        try {
            const result = await this.refreshDownloadAsset(selectedResult);
            const url = this.masterUrl(result);
            if (!url || !this.validPanoramaResult(result)) {
                throw new Error('panorama_download_url_refresh_failed');
            }
            const separator = url.includes('?') ? '&' : '?';
            const exportQuery = format === 'horizontal'
                ? 'vr=1&download=1&panorama_format=horizontal'
                : 'vr=1&download=1';
            const response = await fetch(url + separator + exportQuery, {
                credentials: 'same-origin',
                cache: 'no-store'
            });
            if (!response.ok) throw new Error('panorama_download_failed');
            const contentType = String(
                response.headers.get('Content-Type') || ''
            ).toLowerCase();
            if (!contentType.startsWith('image/jpeg')) {
                throw new Error('panorama_download_invalid_type');
            }
            const blob = await response.blob();
            const header = new Uint8Array(await blob.slice(0, 3).arrayBuffer());
            if (
                header.length < 3
                || header[0] !== 255
                || header[1] !== 216
                || header[2] !== 255
            ) {
                throw new Error('panorama_download_invalid_jpeg');
            }
            const expectedWidth = format === 'horizontal' ? 2742 : 4096;
            const expectedHeight = format === 'horizontal' ? 640 : 2048;
            const bitmap = await createImageBitmap(blob);
            const validDimensions = (
                bitmap.width === expectedWidth
                && bitmap.height === expectedHeight
            );
            bitmap.close();
            if (!validDimensions) {
                throw new Error('panorama_download_invalid_dimensions');
            }
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = format === 'horizontal'
                ? `panorama-${this.assetId(result).slice(0, 8)}-2742x640_horizontal.jpg`
                : `panorama-${this.assetId(result).slice(0, 8)}-4096x2048_360.jpg`;
            anchor.rel = 'noopener';
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
        } catch (_error) {
            await this.service.modal.error(
                'VR 테스트용 360° 이미지를 내려받지 못했습니다. 새로고침 후 다시 시도해주세요.'
            );
        } finally {
            this.panoramaDownloading = false;
            this.panoramaDownloadFormat = '';
            this.changeDetector.detectChanges();
        }
    }

    public async downloadImageAsset(asset: any) {
        const assetId = this.assetId(asset);
        if (
            this.mediaType(asset) !== 'image'
            || !assetId
            || !!this.downloadingAssetId
        ) return;

        this.downloadingAssetId = assetId;
        this.changeDetector.detectChanges();
        try {
            const refreshedAsset = await this.refreshDownloadAsset(asset);
            const url = this.masterUrl(refreshedAsset);
            if (!url) throw new Error('image_download_url_refresh_failed');
            const separator = url.includes('?') ? '&' : '?';
            const response = await fetch(url + separator + 'download=1', {
                credentials: 'same-origin',
                cache: 'no-store'
            });
            if (!response.ok) throw new Error('image_download_failed');

            const contentType = String(
                response.headers.get('Content-Type') || ''
            ).toLowerCase();
            if (!contentType.startsWith('image/png')) {
                throw new Error('image_download_invalid_type');
            }

            const blob = await response.blob();
            const header = new Uint8Array(await blob.slice(0, 24).arrayBuffer());
            const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10];
            if (
                header.length < 24
                || pngSignature.some((value, index) => header[index] !== value)
            ) {
                throw new Error('image_download_invalid_png');
            }

            const dimensions = new DataView(
                header.buffer,
                header.byteOffset,
                header.byteLength
            );
            const width = dimensions.getUint32(16);
            const height = dimensions.getUint32(20);
            if (width < 1 || height < 1) {
                throw new Error('image_download_invalid_dimensions');
            }

            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = `image-${assetId.slice(0, 8)}-${width}x${height}.png`;
            anchor.rel = 'noopener';
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
        } catch (_error) {
            await this.service.modal.error(
                '사진을 내려받지 못했습니다. 새로고침 후 다시 시도해주세요.'
            );
        } finally {
            this.downloadingAssetId = '';
            this.changeDetector.detectChanges();
        }
    }

    private syncPanoramaJob(job: any, incomingAssets: any[] = []) {
        if (!job || this.jobId(job) !== this.panoramaJobId) return;
        const status = String(job?.status || '').toLowerCase();
        const progressByStatus: any = {
            queued: 0,
            running: 1,
            postprocessing: 3
        };
        if (progressByStatus[status] !== undefined) {
            this.panoramaStage = 'generating';
            this.panoramaProgressIndex = progressByStatus[status];
            return;
        }
        if (['review_pending', 'approved'].includes(status)) {
            const resultId = String(
                job?.asset_revision_id || job?.revision_id || ''
            );
            const result = [...incomingAssets, ...this.assets].find(
                (asset: any) => this.assetId(asset) === resultId
            ) || this.panoramaResultForSource(this.panoramaSource);
            if (result && this.validPanoramaResult(result)) {
                this.panoramaResult = result;
                this.panoramaStage = 'complete';
                this.panoramaProgressIndex = this.panoramaStages.length;
                this.panoramaErrorMessage = '';
                return;
            }
            this.panoramaErrorMessage = '생성 결과가 2048×1024 360° 이미지 형식이 아닙니다. 다시 생성해주세요.';
            this.panoramaStage = 'error';
            return;
        }
        if (['failed', 'cancelled', 'quarantined', 'rejected'].includes(status)) {
            this.panoramaStage = 'error';
            this.panoramaErrorMessage = this.jobErrorMessage(job);
        }
    }

    public onPanoramaKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closePanoramaDialog();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-panorama-dialog');
    }

    private clearPanoramaUiState() {
        this.panoramaDialogOpen = false;
        this.panoramaStage = 'setup';
        this.panoramaSource = null;
        this.panoramaResult = null;
        this.panoramaJobId = '';
        this.panoramaErrorMessage = '';
        this.panoramaSubmitting = false;
        this.panoramaDownloading = false;
        this.panoramaDownloadFormat = '';
        this.panoramaBackDescription = '';
        this.panoramaProgressIndex = 0;
        this.panoramaViewMode = 'immersive';
        this.panoramaViewPosition = 50;
        this.panoramaReturnFocus = null;
        document.body.style.overflow = '';
    }

    public async deleteJob(item: any) {
        const id = this.jobId(item);
        if (!this.can('content.write') || !id || !this.canDeleteJob(item) || this.actionJobId) return;

        const hasAsset = !!(
            item?.generation_job_id
            || item?.asset_revision_id
            || item?.revision_id
            || item?.asset?.id
        );
        const confirmed = await this.service.modal.show({
            title: hasAsset ? '생성 결과 삭제' : '생성 작업 삭제',
            message: hasAsset
                ? '이 생성 작업과 연결된 자산을 삭제하시겠습니까? 후속 작업이 있으면 연결 계보를 보존한 채 작업 화면에서 제거됩니다.'
                : '이 생성 작업 기록을 삭제하시겠습니까? 삭제한 기록은 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '생성 결과를 삭제하지 못했습니다.');
                return;
            }

            if (this.jobId(this.selectedAsset) === id) {
                this.selectedAsset = null;
                this.previewReturnFocus = null;
            }
            if (this.progressJobId === id) {
                this.progressJobId = '';
                this.progressReturnFocus = null;
            }
            if (this.jobId(this.selectedVideoSource) === id) {
                this.selectedVideoSource = null;
                this.workbenchForgetVideoSource();
                this.videoIdempotencyKey = this.newIdempotencyKey();
            }
            this.jobs = this.jobs.filter((job: any) => this.jobId(job) !== id);
            this.assets = this.assets.filter((asset: any) => this.jobId(asset) !== id);
            this.workbenchCollectedImageJobs = (this.workbenchCollectedImageJobs || []).filter((job: any) => this.jobId(job) !== id);
            this.workbenchCollectedImageAssets = (this.workbenchCollectedImageAssets || []).filter((asset: any) => this.jobId(asset) !== id);
            delete this.workbenchComparisonJobSnapshots[id];
            if (this.workbenchAudioJobSnapshots) delete this.workbenchAudioJobSnapshots[id];
            if (this.workbenchVideoJobSnapshots) delete this.workbenchVideoJobSnapshots[id];
            Object.keys(this.workbenchComparisonJobIds).forEach((key: string) => {
                this.workbenchComparisonJobIds[key] = this.workbenchComparisonJobIds[key]
                    .filter((jobId: string) => jobId !== id);
            });
            this.workbenchRecentWork = this.workbenchRecentWork.filter(
                (job: any) => this.jobId(job) !== id
            );
            this.total = Math.max(0, this.total - 1);
            this.page = Math.min(this.page, this.pageCount());

            await this.service.modal.success(
                data?.archived_for_lineage
                    ? '후속 작업의 연결을 유지한 채 목록에서 삭제했습니다.'
                    : '생성 결과를 삭제했습니다.'
            );
            await this.search(false, false);
        } catch (error) {
            await this.service.modal.error('생성 결과를 삭제하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async openPreview(asset: any) {
        if (!this.hasPlayablePreview(asset)) return;
        this.workbenchCompareMenu = '';
        this.previewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.selectedAsset = asset;
        await this.service.render();
        setTimeout(() => document.getElementById('content-preview-close')?.focus(), 0);
    }

    public async closePreview() {
        this.selectedAsset = null;
        await this.service.render();
        const target = this.previewReturnFocus;
        this.previewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closePreview();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-preview-dialog');
    }

    private trapDialogFocus(event: KeyboardEvent, dialogId: string) {
        const dialog = document.getElementById(dialogId);
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), audio[controls], video[controls], [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async openProgressModal(job: any = this.activeJob()) {
        const id = this.jobId(job);
        if (!id) return;
        this.progressReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.progressJobId = id;
        await this.service.render();
        setTimeout(() => document.getElementById('content-progress-close')?.focus(), 0);
    }

    public async closeProgressModal() {
        this.progressJobId = '';
        await this.service.render();
        const target = this.progressReturnFocus;
        this.progressReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onProgressKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeProgressModal();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('content-progress-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async onPreviewError(asset: any, failedUrl: string = '') {
        const id = this.assetId(asset) || this.jobId(asset);
        const retryKey = this.previewRefreshKey(asset, failedUrl);
        asset.preview_failed = true;
        await this.service.render();

        if (!id) return;
        if ((this.previewRefreshAttempts[retryKey] || 0) >= 1) return;
        this.previewRefreshAttempts[retryKey] = 1;

        const jobId = this.jobId(asset);
        if (jobId) await this.refreshJob(jobId, false);
        else await this.search(false, false);

        const refreshed = this.assets.find((item: any) => this.assetId(item) === this.assetId(asset));
        if (refreshed) {
            refreshed.preview_failed = false;
            if (this.selectedAsset && this.assetId(this.selectedAsset) === this.assetId(refreshed)) {
                this.selectedAsset = refreshed;
            }
        }
        await this.service.render();
    }

    public onPreviewLoaded(asset: any, loadedUrl: string = '') {
        const retryKey = this.previewRefreshKey(asset, loadedUrl);
        if (retryKey) delete this.previewRefreshAttempts[retryKey];
        if (asset) delete asset.preview_failed;
    }

    public jobId(job: any) {
        return String(job?.job_id || job?.generation_job_id || job?.id || '');
    }

    public candidateLabel(item: any) {
        const data = this.primaryMetadata(item);
        const index = Number(item?.candidate_index || data?.candidate_index || 0);
        const count = Number(item?.candidate_count || data?.candidate_count || 0);
        const baseLabel = (
            Number.isInteger(index)
            && Number.isInteger(count)
            && index >= 1
            && count >= 1
            && index <= count
        ) ? `후보 ${index}/${count}` : '';
        const intensity = this.jobIntensity(item);
        if (this.mediaType(item) === 'image' && intensity !== '-') {
            return `${baseLabel || '이미지 후보'} · ${this.imageResultConditionLabel(item)}`;
        }
        return baseLabel;
    }

    public selectedAssetIntensityLabel(item: any) {
        if (this.mediaType(item) === 'image') return this.imageResultConditionLabel(item);
        const intensity = this.jobIntensity(item);
        const levelLabel = this.intensityScaleLabel();
        return intensity === '-' ? '정보 없음' : `${levelLabel} ${intensity} / 5`;
    }

    public selectedAssetPromptStrategyLabel(item: any) {
        const data = this.primaryMetadata(item);
        const strategy = String(
            item?.image_prompt_strategy
            || data?.image_prompt_strategy
            || 'legacy'
        ).trim().toLowerCase();
        return this.imagePromptStrategyLabel(
            strategy === 'model_specific' ? 'model_specific' : 'legacy'
        );
    }

    public assetId(asset: any) {
        return String(asset?.asset_revision_id || asset?.revision_id || asset?.id || asset?.asset_id || asset?.artifact_id || '');
    }

    public normalizeMediaType(value: any) {
        const mediaType = String(value || '').trim().toLowerCase();
        return ['image', 'audio', 'video'].includes(mediaType) ? mediaType : '';
    }

    public mediaType(item: any) {
        const asset = item?.asset || item?.media_asset || {};
        const artifact = this.artifacts(item)[0] || {};
        return this.normalizeMediaType(
            item?.media_type || asset?.media_type || artifact?.media_type || 'image'
        ) || 'image';
    }

    public modalityLabel(value: any) {
        const mediaType = this.normalizeMediaType(
            typeof value === 'object' ? this.mediaType(value) : value
        );
        const option = this.mediaTypes.find((item: any) => item.value === mediaType);
        return option?.label || '콘텐츠';
    }

    public mediaTypeIcon(value: any) {
        const mediaType = this.normalizeMediaType(
            typeof value === 'object' ? this.mediaType(value) : value
        );
        switch (mediaType) {
            case 'audio': return 'fa-solid fa-wave-square';
            case 'video': return 'fa-solid fa-film';
            default: return 'fa-regular fa-image';
        }
    }

    public modalityHelp(value: any) {
        const option = this.mediaTypes.find((item: any) => item.value === this.normalizeMediaType(value));
        return option?.help || '';
    }

    public modalityClass(value: any) {
        switch (this.normalizeMediaType(typeof value === 'object' ? this.mediaType(value) : value)) {
            case 'audio': return 'border-cyan-200 bg-cyan-50 text-cyan-700';
            case 'video': return 'border-violet-200 bg-violet-50 text-violet-700';
            default: return 'border-blue-200 bg-blue-50 text-blue-700';
        }
    }

    public async onMediaTypeChange() {
        this.syncScenarioForSelectedPatient();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onPatientChange() {
        this.audioPromptText = '';
        this.settingsAccordion = 'prompt';
        this.resourceMemories = [];
        this.selectedResourceMemoryId = '';
        if (this.patientMemoryMode === 'resource') {
            this.form.media_type = 'image';
            this.form.scenario_type = 'resource_memory';
        } else {
            this.syncScenarioForSelectedPatient();
        }
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedVideoSource = null;
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.clearPatientContent();
        this.requestedPatientId = this.normalizeRequestedPatientId(
            this.form.patient_id
        );
        this.rememberContentPatientId(this.requestedPatientId);
        await this.loadResourceMemories();
        if (this.patientMemoryMode === 'resource' && !this.selectedResourceMemoryId) {
            this.selectedResourceMemoryId = String(this.resourceMemories[0]?.id || '');
        }
        await this.syncContentRouteState();
        await this.search(true);
        if (this.patientMemoryMode === 'trauma') {
            await this.loadPatientSourceImages();
            await this.loadReferenceRecommendations();
        }
    }

    public selectedResourceMemory() {
        return this.resourceMemories.find((item: any) =>
            String(item?.id || '') === String(this.selectedResourceMemoryId || '')
        ) || null;
    }

    public async loadResourceMemories() {
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        if (!patientId || !this.can('content.read')) {
            this.resourceMemories = [];
            this.selectedResourceMemoryId = '';
            return;
        }
        this.resourceMemoryLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('resource_memories', {
                patient_id: patientId
            });
            if (code === 200) {
                this.resourceMemories = this.extractList(data, ['resource_memories']);
                if (!this.selectedResourceMemory()) this.selectedResourceMemoryId = '';
            }
        } finally {
            this.resourceMemoryLoading = false;
            await this.service.render();
        }
    }

    public async selectPatientMemoryMode(mode: 'trauma' | 'resource') {
        if (this.patientMemoryMode === mode) return;
        this.patientMemoryMode = mode;
        this.settingsAccordion = 'prompt';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.clearPatientContent();
        if (mode === 'resource') {
            this.form.media_type = 'image';
            this.form.scenario_type = 'resource_memory';
            this.selectedReferenceCondition = null;
            await this.loadResourceMemories();
            if (!this.selectedResourceMemoryId) {
                this.selectedResourceMemoryId = String(this.resourceMemories[0]?.id || '');
            }
        } else {
            this.selectedResourceMemoryId = '';
            this.syncScenarioForSelectedPatient();
            await this.loadPatientSourceImages();
            await this.loadReferenceRecommendations();
        }
        await this.syncContentRouteState();
        await this.search(true);
    }

    public async onResourceMemoryChange() {
        this.form.idempotency_key = this.newIdempotencyKey();
        this.clearPatientContent();
        await this.syncContentRouteState();
        await this.search(true);
    }

    public async selectSourceMode(mode: 'patient' | 'scenario') {
        if (mode === this.sourceMode) return;
        this.sourceMode = mode;
        this.imageGenerationScope = 'single';
        this.settingsAccordion = 'prompt';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.resetScenarioAnalysis();
        this.clearPatientContent();
        if (mode === 'patient') {
            if (this.patientMemoryMode === 'resource') {
                this.form.media_type = 'image';
                this.form.scenario_type = 'resource_memory';
                await this.loadResourceMemories();
            } else {
                this.syncScenarioForSelectedPatient();
            }
        } else {
            this.form.scenario_type = '';
            this.promptSelectionMode = '';
            this.promptMismatchAcknowledged = false;
            this.selectedReferenceCondition = null;
        }
        await this.syncContentRouteState();
        await this.search(true);
        if (mode === 'patient') {
            if (this.patientMemoryMode === 'trauma') {
                await this.loadPatientSourceImages();
            }
        }
        await this.loadReferenceRecommendations();
        await this.service.render();
    }

    public scenarioGroups() {
        const categories = this.scenarioCategories.length > 0
            ? this.scenarioCategories
            : Array.from(new Set(this.scenarioSets.map(
                (item: any) => String(item?.category_key || '')
            ))).map((key: string) => ({ key, label: key }));
        return categories.map((category: any) => ({
            key: String(category?.key || ''),
            label: String(category?.label || category?.short_label || ''),
            rows: this.scenarioSets.filter(
                (item: any) => String(item?.category_key || '') === String(category?.key || '')
            )
        })).filter((group: any) => group.rows.length > 0);
    }

    public selectedScenarioSet() {
        const id = String(this.scenarioSelection.scenario_set_id || '').toUpperCase();
        return this.scenarioSets.find(
            (item: any) => String(item?.id || '').toUpperCase() === id
        ) || null;
    }

    public scenarioSetLibraryQueryParams() {
        const uploadedId = String(this.selectedScenarioSet()?.uploaded_id || '');
        return {
            scenario: String(
                this.scenarioSelection.scenario_set_id || ''
            ).trim().toUpperCase(),
            source: 'raw',
            from: 'content',
            ...(uploadedId ? { upload: uploadedId } : {})
        };
    }

    public selectedScenarioAnalysisOnly() {
        return this.selectedScenarioSet()?.analysis_only === true;
    }

    public selectedScenarioCompletedRaw() {
        return this.selectedScenarioSet()?.completed_raw === true;
    }

    public selectedScenarioDemoReady() {
        return this.selectedScenarioSet()?.demo_ready === true;
    }

    public resetScenarioAnalysis() {
        this.scenarioAnalysisAbort?.abort();
        this.scenarioAnalysisAbort = null;
        this.scenarioAnalysisSequence += 1;
        this.scenarioAnalysisState = 'idle';
        this.scenarioAnalysis = null;
        this.scenarioAnalysisError = '';
        this.scenarioAnalysisProgressCuts = [];
        this.scenarioAnalysisDrafting = false;
        this.scenarioAnalysisStage = 'source';
        this.selectedScenarioCutOrder = 0;
        this.scenarioAnalysisNeedsUpgrade = false;
    }

    private scenarioAnalysisMap() {
        try {
            const parsed = JSON.parse(
                window.sessionStorage.getItem(this.scenarioAnalysisStorageKey) || '{}'
            );
            return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
                ? parsed
                : {};
        } catch (_error) {
            return {};
        }
    }

    private rememberScenarioAnalysis() {
        const scenarioId = String(
            this.scenarioAnalysis?.scenario_id || ''
        ).trim().toUpperCase();
        const snapshot = String(
            this.scenarioAnalysis?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        if (
            !scenarioId
            || scenarioId !== String(
                this.scenarioSelection.scenario_set_id || ''
            ).trim().toUpperCase()
            || !/^[a-f0-9]{64}$/.test(snapshot)
            || !Array.isArray(this.scenarioAnalysis?.cuts)
        ) return;
        try {
            const remembered = this.scenarioAnalysisMap();
            remembered[scenarioId] = {
                analysis: this.scenarioAnalysis,
                selected_cut_order: Number(this.selectedScenarioCutOrder || 0),
                saved_at: new Date().toISOString()
            };
            window.sessionStorage.setItem(
                this.scenarioAnalysisStorageKey,
                JSON.stringify(remembered)
            );
        } catch (_error) {
        }
    }

    private forgetScenarioAnalysis(scenarioId: string) {
        if (!scenarioId) return;
        try {
            const remembered = this.scenarioAnalysisMap();
            delete remembered[scenarioId];
            window.sessionStorage.setItem(
                this.scenarioAnalysisStorageKey,
                JSON.stringify(remembered)
            );
        } catch (_error) {
        }
    }

    private restoreScenarioAnalysis() {
        if (this.sourceMode !== 'scenario') return false;
        const scenarioId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        if (!scenarioId || !this.selectedScenarioSet()) return false;
        const sessionCached = this.scenarioAnalysisMap()?.[scenarioId];
        const representative = this.representativeScenarioAnalyses?.[scenarioId];
        const representativeCached = (
            representative && typeof representative === 'object'
                ? {
                    analysis: representative,
                    selected_cut_order: Number(representative?.cuts?.[0]?.order || 0)
                }
                : null
        );
        const expectedSnapshot = String(
            this.selectedScenarioSet()?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        const isUsableCache = (candidate: any) => {
            const candidateAnalysis = candidate?.analysis;
            const candidateSnapshot = String(
                candidateAnalysis?.source_snapshot_sha256 || ''
            ).trim().toLowerCase();
            return (
                String(candidateAnalysis?.scenario_id || '').trim().toUpperCase()
                    === scenarioId
                && Number(candidateAnalysis?.version || 0)
                    >= this.scenarioAnalysisContractVersion
                && /^[a-f0-9]{64}$/.test(candidateSnapshot)
                && (!expectedSnapshot || candidateSnapshot === expectedSnapshot)
                && Array.isArray(candidateAnalysis?.cuts)
                && candidateAnalysis.cuts.length > 0
            );
        };
        const sessionCacheIsUsable = isUsableCache(sessionCached);
        if (sessionCached && !sessionCacheIsUsable) {
            this.forgetScenarioAnalysis(scenarioId);
        }
        const cached = sessionCacheIsUsable
            ? sessionCached
            : (isUsableCache(representativeCached) ? representativeCached : null);
        const analysis = cached?.analysis;
        const snapshot = String(
            analysis?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        const cuts = Array.isArray(analysis?.cuts) ? analysis.cuts : [];
        if (
            String(analysis?.scenario_id || '').trim().toUpperCase() !== scenarioId
            || !/^[a-f0-9]{64}$/.test(snapshot)
            || (expectedSnapshot && snapshot !== expectedSnapshot)
            || cuts.length === 0
        ) {
            return false;
        }
        this.scenarioAnalysis = analysis;
        this.scenarioAnalysisState = 'complete';
        this.scenarioAnalysisError = '';
        this.scenarioAnalysisNeedsUpgrade = Number(
            analysis?.version || 0
        ) < this.scenarioAnalysisContractVersion || !analysis?.prompt_draft_status;
        const rememberedOrder = Number(this.requestedImageAgentCutOrder || cached?.selected_cut_order || 0);
        this.selectedScenarioCutOrder = cuts.some(
            (cut: any) => Number(cut?.order || 0) === rememberedOrder
        ) ? rememberedOrder : Number(cuts[0]?.order || 0);
        this.requestedImageAgentCutOrder = 0;
        this.imageGenerationScope = 'single';
        this.form.media_type = 'image';
        const selectedCut = this.selectedScenarioCut();
        if (selectedCut) {
            this.scenarioSelection.memory_kind = this.scenarioCutMemoryKind(selectedCut);
            this.form.intensity = 3;
        }
        return true;
    }

    private async recoverMissingScenarioAnalysis() {
        const scenarioId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        if (
            this.sourceMode !== 'scenario'
            || !scenarioId
            || !(this.selectedScenarioCompletedRaw() || this.selectedScenarioDemoReady())
            || this.scenarioAnalysisState !== 'idle'
            || this.scenarioAnalysisRecoveryAttempts.has(scenarioId)
        ) return;
        const hasCutHistory = [...this.assets, ...this.jobs].some(
            (record: any) => this.scenarioCutOrder(record) > 0
        );
        if (!hasCutHistory) return;
        this.scenarioAnalysisRecoveryAttempts.add(scenarioId);
        await this.analyzeSelectedScenario();
    }

    public async analyzeSelectedScenario() {
        const scenarioId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        if (!scenarioId || !this.selectedScenarioSet()) {
            await this.service.modal.error('분석할 시나리오를 선택해주세요.');
            return;
        }
        if (this.scenarioAnalysisState === 'loading') return;
        this.scenarioAnalysisAbort?.abort();
        const controller = new AbortController();
        this.scenarioAnalysisAbort = controller;
        const sequence = ++this.scenarioAnalysisSequence;
        this.scenarioAnalysisState = 'loading';
        this.scenarioAnalysisError = '';
        this.scenarioAnalysis = null;
        this.scenarioAnalysisProgressCuts = [];
        this.scenarioAnalysisStage = 'source';
        await this.service.render();
        try {
            const response = await fetch(wiz.url('analyze_scenario_stream'), {
                method: 'POST',
                credentials: 'same-origin',
                cache: 'no-store',
                signal: controller.signal,
                headers: {
                    'Accept': 'application/x-ndjson',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: new URLSearchParams({ scenario_set_id: scenarioId })
            });
            if (!response.ok || !response.body) {
                throw new Error('scenario_analysis_stream_unavailable');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let analysis: any = null;
            const receive = async (line: string) => {
                if (!line.trim() || sequence !== this.scenarioAnalysisSequence) return;
                const event = JSON.parse(line);
                if (event.code === 401) throw new Error('로그인이 필요합니다.');
                if (event.code === 403) throw new Error('콘텐츠 열람 권한이 없습니다.');
                if (event.type === 'reset') {
                    this.scenarioAnalysisProgressCuts = [];
                    this.scenarioAnalysisStage = 'model';
                } else if (event.type === 'stage') {
                    this.scenarioAnalysisStage = 'model';
                } else if (event.type === 'cut') {
                    this.scenarioAnalysisStage = 'cuts';
                    const nextOrder = this.scenarioAnalysisProgressCuts.length + 1;
                    if (Number(event.cut?.order) !== nextOrder) {
                        throw new Error('scenario_analysis_cut_order_invalid');
                    }
                    this.scenarioAnalysisProgressCuts = [
                        ...this.scenarioAnalysisProgressCuts, event.cut
                    ];
                    await this.service.render();
                    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                        await new Promise<void>((resolve) => window.setTimeout(resolve, 120));
                    }
                    return;
                } else if (event.type === 'drafting') {
                    this.scenarioAnalysisDrafting = true;
                    this.scenarioAnalysisStage = 'drafts';
                } else if (event.type === 'complete') {
                    analysis = event.analysis;
                } else if (event.type === 'error') {
                    throw new Error(String(event.message || 'scenario_analysis_stream_failed'));
                }
                await this.service.render();
            };
            while (true) {
                const { value, done } = await reader.read();
                if (sequence !== this.scenarioAnalysisSequence) {
                    await reader.cancel();
                    return;
                }
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                let lineEnd = buffer.indexOf('\n');
                while (lineEnd >= 0) {
                    await receive(buffer.slice(0, lineEnd));
                    buffer = buffer.slice(lineEnd + 1);
                    lineEnd = buffer.indexOf('\n');
                }
            }
            buffer += decoder.decode();
            if (buffer.trim()) await receive(buffer);
            if (
                !analysis
                || String(analysis.scenario_id || '').toUpperCase() !== scenarioId
                || String(analysis.source_snapshot_sha256 || '').toLowerCase()
                    !== String(this.selectedScenarioSet()?.source_snapshot_sha256 || '').toLowerCase()
                || sequence !== this.scenarioAnalysisSequence
            ) {
                throw new Error('scenario_analysis_result_invalid');
            }
            this.scenarioAnalysis = analysis;
            this.scenarioAnalysisState = 'complete';
            this.scenarioAnalysisNeedsUpgrade = false;
            this.selectedScenarioCutOrder = Number(
                this.scenarioAnalysisCuts()[0]?.order || 0
            );
            this.imageGenerationScope = 'single';
            this.form.media_type = 'image';
            const firstCut = this.selectedScenarioCut();
            if (firstCut) {
                const firstMemoryKind = this.scenarioCutMemoryKind(firstCut);
                const memoryChanged = this.scenarioSelection.memory_kind
                    !== firstMemoryKind;
                this.scenarioSelection.memory_kind = firstMemoryKind;
                this.form.intensity = 3;
                if (memoryChanged) {
                    this.clearPatientContent();
                    void this.syncContentRouteState();
                    void this.search(true);
                    void this.loadReferenceRecommendations();
                }
            }
            this.rememberScenarioAnalysis();
            let seedError = '';
            if (analysis.prompt_draft_status === 'ready') {
                try {
                    const seed: any = await this.service.request.post(wiz.url('seed_scenario_prompt_drafts'), {
                        scenario_set_id: scenarioId,
                        analysis: JSON.stringify({
                            scenario_id: analysis.scenario_id,
                            version: analysis.version,
                            source_snapshot_sha256: analysis.source_snapshot_sha256,
                            prompt_draft_status: analysis.prompt_draft_status,
                            cuts: analysis.cuts.map((cut: any) => ({
                                order: cut.order, memory_kind: cut.memory_kind,
                                cut_key: cut.cut_key, visual_targets: cut.visual_targets
                            })),
                            prompt_drafts: analysis.prompt_drafts
                        }),
                        csrf_token: this.service.auth.session?.csrf_token || ''
                    });
                    if (seed.code !== 200) throw new Error(seed.data?.message || '초안 저장 실패');
                } catch (_error) {
                    seedError = '분석 초안을 저장하지 못했습니다. 저장 상태를 확인한 뒤 다시 시도해주세요.';
                }
            }
            await this.workbenchLoadPromptDraft();
            if (seedError) this.workbenchPromptSaveError = seedError;
        } catch (_error) {
            if (controller.signal.aborted || sequence !== this.scenarioAnalysisSequence) return;
            this.scenarioAnalysisState = 'error';
            this.scenarioAnalysisError = _error instanceof Error && /^(시나리오|근거가|로그인이|콘텐츠 열람)/.test(_error.message)
                ? _error.message
                : '시나리오 사건 흐름과 컷 명세를 생성하지 못했습니다.';
        } finally {
            if (this.scenarioAnalysisAbort === controller) this.scenarioAnalysisAbort = null;
            this.scenarioAnalysisDrafting = false;
            await this.service.render();
        }
    }

    public scenarioAnalysisProgression() {
        return Array.isArray(this.scenarioAnalysis?.progression)
            ? this.scenarioAnalysis.progression
            : [];
    }

    public scenarioAnalysisCuts() {
        return Array.isArray(this.scenarioAnalysis?.cuts)
            ? this.scenarioAnalysis.cuts
            : [];
    }

    public scenarioAnalysisProgressLabel() {
        if (this.scenarioAnalysisStage === 'model') {
            return 'Codex가 전체 대화에서 사건·자원기억 장면을 찾고 있습니다.';
        }
        if (this.scenarioAnalysisStage === 'cuts') {
            return `${this.scenarioAnalysisProgressCuts.length}개 컷의 근거를 확인했습니다.`;
        }
        if (this.scenarioAnalysisStage === 'drafts') {
            return '선택할 컷과 강도별 표현 초안을 정리하고 있습니다.';
        }
        return '원문과 시나리오 정보를 준비하고 있습니다.';
    }

    public scenarioAnalysisProgressPercent() {
        if (this.scenarioAnalysisStage === 'model') return 34;
        if (this.scenarioAnalysisStage === 'cuts') {
            return Math.min(80, 48 + (this.scenarioAnalysisProgressCuts.length * 8));
        }
        if (this.scenarioAnalysisStage === 'drafts') return 92;
        return 12;
    }

    public scenarioAnalysisProgressStepLabel() {
        if (this.scenarioAnalysisStage === 'model') return '2/4 · 장면 분석';
        if (this.scenarioAnalysisStage === 'cuts') return '3/4 · 컷 구성';
        if (this.scenarioAnalysisStage === 'drafts') return '4/4 · 프롬프트 초안 정리';
        return '1/4 · 원문 준비';
    }

    public scenarioCutObjectNames(cut: any) {
        return (Array.isArray(cut?.visual_targets) ? cut.visual_targets : [])
            .map((item: any) => String(item.text || '')).filter(Boolean).join(' · ');
    }

    public scenarioCutMemoryCardLabel(cut: any) {
        return this.scenarioCutMemoryLabel(cut);
    }

    public scenarioEvidenceRows() {
        const cut = this.selectedScenarioCut();
        if (!cut || !this.scenarioEvidence) return [];
        const turns = new Set<number>(cut.evidence?.turns || []);
        const questions = new Set<string>(cut.evidence?.questions || []);
        return [
            ...(this.scenarioEvidence.dialogue || [])
                .filter((item: any) => turns.has(Number(item.turn)) && item.scene_evidence_allowed)
                .map((item: any) => ({ label: `대화 ${item.turn}`, text: item.text })),
            ...(this.scenarioEvidence.supplements || [])
                .filter((item: any) => questions.has(String(item.question_id)))
                .map((item: any) => ({ label: `보충 ${item.question_id}`, text: item.note }))
        ];
    }

    public async openScenarioEvidence() {
        const sequence = ++this.scenarioEvidenceSequence;
        this.scenarioEvidenceReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement : null;
        this.scenarioEvidenceOpen = true;
        this.scenarioEvidenceLoading = true;
        this.scenarioEvidenceLoadingMessage = '원문을 불러오는 중입니다.';
        this.scenarioEvidenceError = '';
        this.scenarioEvidenceWarning = '';
        this.scenarioEvidence = null;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        window.setTimeout(() => document.getElementById('scenario-evidence-close')?.focus(), 0);
        try {
            const scenarioId = String(
                this.scenarioSelection.scenario_set_id || ''
            ).toUpperCase();
            const loadEvidence = async () => {
                const query = new URLSearchParams({ scenario_set_id: scenarioId });
                const response = await fetch(`${wiz.url('scenario_analysis_evidence')}?${query}`, {
                    credentials: 'same-origin', cache: 'no-store'
                });
                return response.json();
            };
            let result = await loadEvidence();
            if (sequence !== this.scenarioEvidenceSequence || !this.scenarioEvidenceOpen) return;
            if (result.code !== 200) {
                throw new Error(result.data?.message || '원문을 불러오지 못했습니다.');
            }
            const snapshot = (value: any) => String(value || '').trim().toLowerCase();
            if (snapshot(result.data?.source_snapshot_sha256)
                    !== snapshot(this.scenarioAnalysis?.source_snapshot_sha256)) {
                this.scenarioEvidenceWarning = '분석 이후 원문 상태가 변경되어 현재 저장된 원문을 표시합니다.';
            }
            this.scenarioEvidence = result.data;
        } catch (error) {
            if (sequence === this.scenarioEvidenceSequence && this.scenarioEvidenceOpen) {
                this.scenarioEvidenceError = error instanceof Error ? error.message : '원문을 불러오지 못했습니다.';
            }
        } finally {
            if (sequence === this.scenarioEvidenceSequence && this.scenarioEvidenceOpen) {
                this.scenarioEvidenceLoading = false;
                await this.service.render();
            }
        }
    }

    public async closeScenarioEvidence() {
        ++this.scenarioEvidenceSequence;
        this.scenarioEvidenceOpen = false;
        this.scenarioEvidence = null;
        this.scenarioEvidenceError = '';
        this.scenarioEvidenceWarning = '';
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.scenarioEvidenceReturnFocus;
        this.scenarioEvidenceReturnFocus = null;
        window.setTimeout(() => target?.focus(), 0);
    }

    public onScenarioEvidenceKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeScenarioEvidence();
        } else if (event.key === 'Tab') {
            this.trapDialogFocus(event, 'scenario-evidence-dialog');
        }
    }

    public scenarioAnalysisSidebarActive() {
        return this.sourceMode === 'scenario'
            && this.form.media_type === 'image'
            && !!this.selectedScenarioSet();
    }

    public scenarioConsoleActive() {
        return this.sourceMode === 'scenario'
            && this.form.media_type === 'image'
            && this.scenarioAnalysisState === 'complete'
            && !!this.scenarioAnalysis
            && this.scenarioAnalysisCuts().length > 0;
    }

    public scenarioCutAsset(cut: any) {
        const order = Number(cut?.order || 0);
        if (!order) return null;
        const snapshot = String(
            this.scenarioAnalysis?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        const seen = new Set<string>();
        return [
            ...(Array.isArray(this.jobs) ? this.jobs : []),
            ...(Array.isArray(this.assets) ? this.assets : [])
        ].filter((record: any) => {
            const key = this.assetId(record) || this.jobId(record);
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return this.recordMatchesSelectedSource(record)
                && this.mediaType(record) === 'image'
                && this.scenarioCutRecordMatches(record, cut, snapshot);
        }).sort((left: any, right: any) => {
            const leftPlayable = this.visualUrl(left) ? 1 : 0;
            const rightPlayable = this.visualUrl(right) ? 1 : 0;
            if (leftPlayable !== rightPlayable) return rightPlayable - leftPlayable;
            const leftTime = Date.parse(
                left?.completed_at || left?.updated_at || left?.created_at || left?.created || ''
            ) || 0;
            const rightTime = Date.parse(
                right?.completed_at || right?.updated_at || right?.created_at || right?.created || ''
            ) || 0;
            return rightTime - leftTime;
        })[0] || null;
    }

    public scenarioCutRecordMatches(record: any, cut: any, analysisSnapshot: string = '') {
        const order = Number(cut?.order || 0);
        if (!order || this.scenarioCutOrder(record) !== order) return false;

        const expectedTitle = String(cut?.title || '').trim();
        const recordTitle = this.scenarioCutTitle(record);
        if (expectedTitle && recordTitle && recordTitle !== expectedTitle) return false;

        const expectedSnapshot = String(
            analysisSnapshot
            || this.scenarioAnalysis?.source_snapshot_sha256
            || ''
        ).trim().toLowerCase();
        const recordSnapshot = this.scenarioAnalysisSnapshot(record);
        if (
            expectedSnapshot
            && recordSnapshot
            && recordSnapshot !== expectedSnapshot
        ) return false;

        // Intensity generation deliberately rewrites the visual specification
        // for each level. Those values describe how the same cut is rendered,
        // so order, title and the source-analysis snapshot define cut identity.
        return true;
    }

    public scenarioCutStatusLabel(cut: any) {
        const record = this.scenarioCutAsset(cut);
        if (record) {
            const status = String(record?.job_status || record?.status || '').toLowerCase();
            if (['queued', 'running', 'postprocessing'].includes(status)) {
                return this.statusLabel(status);
            }
            if (['failed', 'cancelled', 'quarantined'].includes(status)) {
                return status === 'failed' ? '생성 실패' : this.statusLabel(status);
            }
            if (this.visualUrl(record) || status === 'completed') return '생성 완료';
        }
        return '생성 대기';
    }

    public workbenchCutResultState(cut: any) {
        const scenarioId = String(this.scenarioSelection.scenario_set_id || '').trim().toUpperCase();
        const counts = { result_count: 0, pending_count: 0, failed_count: 0, cancelled_count: 0, excluded_count: 0 };
        const sourceKey = `${scenarioId}:${this.scenarioCutMemoryKind(cut)}`;
        (this.workbenchCutResults || []).filter((row: any) =>
            row.source_key === sourceKey && this.scenarioCutRecordMatches(row, cut)
        ).forEach((row: any) => {
            (Object.keys(counts) as (keyof typeof counts)[]).forEach(key => {
                counts[key] += Math.max(0, Number(row[key]) || 0);
            });
        });
        let state = 'empty';
        let label = '생성 전';
        let icon = 'fa-regular fa-circle';
        if (this.workbenchCutResultsSourceId !== scenarioId) {
            state = 'loading'; label = '확인 중';
        } else if (counts.result_count > 0) {
            state = 'ready'; label = `결과 ${counts.result_count}장`; icon = 'fa-solid fa-circle-check';
        } else if (counts.pending_count > 0) {
            state = 'running'; label = `생성 중 ${counts.pending_count}개`; icon = 'fa-solid fa-spinner fa-spin';
        } else if (counts.failed_count > 0) {
            state = 'failed'; label = '생성 실패'; icon = 'fa-solid fa-triangle-exclamation';
        } else if (counts.excluded_count > 0) {
            state = 'failed'; label = '검수 제외'; icon = 'fa-solid fa-circle-exclamation';
        } else if (counts.cancelled_count > 0) {
            label = '생성 취소';
        }
        const description = [
            counts.result_count ? `생성 결과 ${counts.result_count}장` : '',
            counts.pending_count ? `생성 중 ${counts.pending_count}개` : '',
            counts.failed_count ? `생성 실패 ${counts.failed_count}개` : '',
            counts.excluded_count ? `검수 제외 ${counts.excluded_count}개` : '',
            counts.cancelled_count ? `취소 ${counts.cancelled_count}개` : ''
        ].filter(Boolean).join(' · ') || label;
        return { state, label, icon, description: `전체 모델 기준 · ${description}`, resultCount: counts.result_count };
    }

    public scenarioCutStatusClass(cut: any) {
        const label = this.scenarioCutStatusLabel(cut);
        if (label === '생성 완료') return 'is-complete';
        if (['대기', '생성 중', '후처리'].includes(label)) return 'is-progress';
        if (label === '생성 실패' || label === '취소' || label === '격리') return 'is-error';
        return 'is-pending';
    }

    public scenarioCutStatusIcon(cut: any) {
        const statusClass = this.scenarioCutStatusClass(cut);
        if (statusClass === 'is-complete') return 'fa-solid fa-circle-check';
        if (statusClass === 'is-progress') return 'fa-solid fa-spinner fa-spin';
        if (statusClass === 'is-locked') return 'fa-solid fa-lock';
        if (statusClass === 'is-error') return 'fa-solid fa-triangle-exclamation';
        return 'fa-regular fa-clock';
    }

    public selectedScenarioCut() {
        const order = Number(this.selectedScenarioCutOrder || 0);
        return this.scenarioAnalysisCuts().find(
            (cut: any) => Number(cut?.order || 0) === order
        ) || null;
    }

    private ensureScenarioCutSelection() {
        const current = this.selectedScenarioCut();
        if (current) return current;
        const firstCut = this.scenarioAnalysisCuts().find(
            (cut: any) => Number(cut?.order || 0) >= 1
        ) || null;
        if (!firstCut) return null;
        this.selectedScenarioCutOrder = Math.floor(Number(firstCut.order));
        this.scenarioSelection.memory_kind = this.scenarioCutMemoryKind(firstCut);
        this.form.media_type = 'image';
        this.form.intensity = 3;
        this.rememberScenarioAnalysis();
        return firstCut;
    }

    public isScenarioCutSelected(cut: any) {
        return Number(cut?.order || 0) === Number(this.selectedScenarioCutOrder || 0);
    }

    public selectScenarioCut(cut: any) {
        const order = Number(cut?.order || 0);
        if (!Number.isFinite(order) || order < 1 || order > 12) return;
        this.workbenchClearImageResultFilter();
        this.selectedScenarioCutOrder = Math.floor(order);
        const memoryKind = this.scenarioCutMemoryKind(cut);
        const memoryChanged = this.scenarioSelection.memory_kind !== memoryKind;
        this.scenarioSelection.memory_kind = memoryKind;
        this.form.media_type = 'image';
        this.imageGenerationScope = 'single';
        this.form.intensity = 3;
        this.workbenchPromptOpen = false;
        this.workbenchPromptSection = 'common';
        this.settingsAccordion = 'generation';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.clearLatestImageCostBatch();
        if (memoryChanged) {
            this.clearPatientContent();
            void this.syncContentRouteState();
            void this.search(true);
            void this.loadReferenceRecommendations();
        }
        const existingAsset = memoryChanged ? null : this.scenarioCutAsset(cut);
        if (existingAsset && this.assetId(existingAsset)) {
            this.selectedReviewAssetId = this.assetId(existingAsset);
        }
        this.rememberScenarioAnalysis();
        this.changeDetector.detectChanges();
        void this.workbenchLoadPromptDraft();
        void this.workbenchEnsureComparisonResults();
    }

    public hasAdjacentScenarioCut(offset: number) {
        const cuts = this.scenarioAnalysisCuts();
        const currentIndex = cuts.findIndex(
            (cut: any) => this.isScenarioCutSelected(cut)
        );
        const target = cuts[currentIndex + Number(offset || 0)];
        return !!target;
    }

    public selectAdjacentScenarioCut(offset: number) {
        const cuts = this.scenarioAnalysisCuts();
        const currentIndex = cuts.findIndex(
            (cut: any) => this.isScenarioCutSelected(cut)
        );
        const target = cuts[currentIndex + Number(offset || 0)];
        if (target) this.selectScenarioCut(target);
    }

    public scenarioGenerationActionLabel() {
        const cutSpec = this.scenarioCutRequestSpec();
        if (this.form.media_type === 'image' && cutSpec) {
            if (this.imageGenerationScope === 'all') {
                return `${this.intensityScaleLabel()} 1~5 이미지 ${this.imageGenerationTotalCount()}개 일괄 생성`;
            }
            return `${this.intensityScaleLabel()} ${this.form.intensity} 이미지 ${this.imageCandidateCount}개 생성`;
        }
        if (this.form.media_type === 'image') {
            return this.imageGenerationScope === 'all'
                ? `강도 1~5 이미지 ${this.imageGenerationTotalCount()}개 일괄 생성`
                : `설정 반영 후 이미지 ${this.imageCandidateCount}개 생성`;
        }
        return `${this.selectedScenarioSet()?.id || ''} · ${this.scenarioMemoryLabel()} ${this.modalityLabel(this.form.media_type)} 생성`;
    }

    public scenarioCutMemoryKind(cut: any): 'trauma' | 'positive' {
        return String(cut?.memory_kind || '').toLowerCase() === 'positive'
            ? 'positive'
            : 'trauma';
    }

    public scenarioCutMemoryLabel(cut: any) {
        return this.scenarioCutMemoryKind(cut) === 'positive'
            ? '행복 기억'
            : '외상 기억';
    }

    public scenarioCutMemoryBadgeLabel(cut: any) {
        return this.scenarioCutMemoryLabel(cut);
    }

    public scenarioCutRequestSpec() {
        const cuts = this.scenarioAnalysisCuts();
        const cut = this.selectedScenarioCut() || cuts.find(
            (candidate: any) => Number(candidate?.order || 0) >= 1
        ) || null;
        const analysisSnapshot = String(
            this.scenarioAnalysis?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        const sourceSnapshot = String(
            this.selectedScenarioSet()?.source_snapshot_sha256 || ''
        ).trim().toLowerCase();
        const validAnalysisSnapshot = /^[a-f0-9]{64}$/.test(analysisSnapshot);
        const validSourceSnapshot = /^[a-f0-9]{64}$/.test(sourceSnapshot);
        const snapshotsConflict = validAnalysisSnapshot
            && validSourceSnapshot
            && analysisSnapshot !== sourceSnapshot;
        const snapshot = validAnalysisSnapshot
            ? analysisSnapshot
            : (validSourceSnapshot ? sourceSnapshot : '');
        if (
            !cut
            || this.scenarioAnalysisState !== 'complete'
        ) return null;
        return {
            analysis_scenario_id: String(
                this.scenarioAnalysis?.scenario_id
                || this.scenarioSelection.scenario_set_id
                || ''
            ).trim().toUpperCase(),
            analysis_contract_version: Number(
                this.scenarioAnalysis?.version || 0
            ),
            analysis_snapshot_conflict: snapshotsConflict,
            order: Number(cut.order),
            memory_kind: this.scenarioCutMemoryKind(cut),
            trauma_anchor_order: Number(this.firstTraumaScenarioCut()?.order || 0),
            title: String(cut.title || ''),
            phase: String(cut.phase || ''),
            event: String(cut.event || ''),
            time_place: String(cut.time_place || ''),
            characters_actions: String(cut.characters_actions || ''),
            sensory_cues: Array.isArray(cut.sensory_cues)
                ? cut.sensory_cues.map((value: any) => String(value || ''))
                : [],
            ptsd_trigger: String(cut.ptsd_trigger || ''),
            patient_response: String(cut.patient_response || ''),
            production: {
                shot: String(cut.production?.shot || ''),
                camera: String(cut.production?.camera || ''),
                composition: String(cut.production?.composition || ''),
                lighting: String(cut.production?.lighting || ''),
                sound: String(cut.production?.sound || '')
            },
            visual_spec: {
                people: String(cut.visual_spec?.people || ''),
                wardrobe: String(cut.visual_spec?.wardrobe || ''),
                background: String(cut.visual_spec?.background || ''),
                vehicles: String(cut.visual_spec?.vehicles || ''),
                weather: String(cut.visual_spec?.weather || ''),
                lighting: String(cut.visual_spec?.lighting || '')
            },
            analysis_snapshot_sha256: snapshot
        };
    }

    public scenarioCutEvidenceLabel(cut: any) {
        const turns = Array.isArray(cut?.evidence?.turns)
            ? cut.evidence.turns.map((value: any) => `대화 ${value}턴`)
            : [];
        const questions = Array.isArray(cut?.evidence?.questions)
            ? cut.evidence.questions.map((value: any) => `보완 ${value}`)
            : [];
        return [...turns, ...questions].join(' · ') || '근거 확인 필요';
    }

    public selectedScenarioContent() {
        const kind = String(this.scenarioSelection.memory_kind || '').toLowerCase();
        const rows = this.selectedScenarioSet()?.content_sets;
        return (Array.isArray(rows) ? rows : []).find(
            (item: any) => String(item?.key || '').toLowerCase() === kind
        ) || null;
    }

    public selectedScenarioPrompt() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        const prompts = this.selectedScenarioContent()?.prompts;
        return prompts?.[mediaType]
            || (mediaType === 'video' ? prompts?.image : null)
            || null;
    }

    public selectedScenarioAvoidPrompt() {
        return String(
            this.selectedScenarioPrompt()?.['negative_' + 'prompt'] || ''
        );
    }

    public scenarioMemoryLabel() {
        return this.scenarioSelection.memory_kind === 'positive'
            ? '행복 기억'
            : '외상 기억';
    }

    public positiveMemoryIntensityActive() {
        return (
            this.sourceMode === 'scenario'
            && this.scenarioSelection.memory_kind === 'positive'
        ) || (
            this.sourceMode === 'patient'
            && this.patientMemoryMode === 'resource'
        );
    }

    public intensityControlLabel() {
        if (this.positiveMemoryIntensityActive()) return '행복 기억 선명도';
        if (this.workbenchExpression === 'realistic' && this.workbenchReferenceEnabled() && this.workbenchReproductionReference()) return '참고 이미지 재현 단계';
        return this.sourceMode === 'scenario' ? '외상 기억 재현도' : '노출 강도';
    }

    public intensityScaleLabel() {
        if (this.positiveMemoryIntensityActive()) return '선명도';
        if (this.workbenchExpression === 'realistic' && this.workbenchReferenceEnabled() && this.workbenchReproductionReference()) return '재현 단계';
        return this.sourceMode === 'scenario' ? '재현도' : '강도';
    }

    public contentSourceSelected() {
        return this.sourceMode === 'patient'
            ? !!this.normalizeRequestedPatientId(this.form.patient_id)
                && (
                    this.patientMemoryMode === 'trauma'
                    || !!this.selectedResourceMemory()
                )
            : !!this.selectedScenarioSet() && !!this.selectedScenarioContent();
    }

    public contentSourceLoadingLabel() {
        return this.sourceMode === 'scenario'
            ? '선택한 시나리오의 콘텐츠를 불러오는 중입니다.'
            : '선택한 환자의 콘텐츠를 불러오는 중입니다.';
    }

    public async onScenarioSetChange() {
        this.audioPromptText = '';
        this.scenarioSelection.scenario_set_id = this.normalizeScenarioRouteId(
            this.scenarioSelection.scenario_set_id
        );
        this.imageGenerationScope = 'single';
        this.settingsAccordion = 'prompt';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        this.selectedReferenceCondition = null;
        this.resetScenarioAnalysis();
        if (this.selectedScenarioAnalysisOnly() || this.selectedScenarioCompletedRaw() || this.selectedScenarioDemoReady()) {
            this.scenarioSelection.memory_kind = 'trauma';
        }
        this.restoreScenarioAnalysis();
        this.clearPatientContent();
        await this.syncContentRouteState();
        await this.search(true);
        await this.loadReferenceRecommendations();
        await this.workbenchLoadCustomExpressions();
    }

    public async selectScenarioMemory(kind: 'trauma' | 'positive') {
        if (this.scenarioSelection.memory_kind === kind) return;
        if (
            this.selectedScenarioAnalysisOnly()
            || this.selectedScenarioCompletedRaw()
            || this.selectedScenarioDemoReady()
        ) return;
        this.scenarioSelection.memory_kind = kind;
        this.imageGenerationScope = 'single';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        this.selectedReferenceCondition = null;
        this.resetScenarioAnalysis();
        this.restoreScenarioAnalysis();
        this.clearPatientContent();
        await this.syncContentRouteState();
        await this.search(true);
        await this.loadReferenceRecommendations();
    }

    public templateIdForScenarioGeneration(mediaType: string) {
        const normalized = this.normalizeMediaType(mediaType);
        const candidates = this.templates.filter(
            (item: any) => this.normalizeMediaType(item?.media_type || 'image') === normalized
        );
        const selected = candidates.find(
            (item: any) => String(item?.scenario_type || '') === 'other'
        ) || candidates[0];
        return String(selected?.id || selected?.template_id || '');
    }

    public canCreateScenarioVideoFromSource() {
        return !this.scenarioVideoGenerationBlockReason();
    }

    public scenarioVideoGenerationBlockReason() {
        if (this.sourceMode !== 'scenario' || !this.selectedScenarioSet()) {
            return '영상을 만들 시나리오를 선택해주세요.';
        }
        if (!this.selectedGenerationModelAvailable('video')) {
            return this.selectedGenerationModelUnavailableMessage('video');
        }
        const cut = this.selectedScenarioCut();
        const cutSpec = this.scenarioCutRequestSpec();
        if (cutSpec?.analysis_snapshot_conflict) {
            return '시나리오 대화가 변경되었습니다. 다시 분석한 뒤 원본 이미지를 선택해주세요.';
        }
        if (!cut || !cutSpec || !/^[a-f0-9]{64}$/.test(cutSpec.analysis_snapshot_sha256)) {
            return '시나리오 분석을 완료한 뒤 영상을 만들 컷을 선택해주세요.';
        }
        if (!this.templateIdForScenarioGeneration('video')) {
            return '사용 가능한 영상 생성 템플릿이 없습니다.';
        }
        if (!this.selectedVideoSource) {
            return '이미지 결과에서 ‘영상 원본으로 사용’을 눌러 원본 이미지를 선택해주세요.';
        }
        if (!this.videoSourceEligible(this.selectedVideoSource)) {
            return this.videoSourceReason(this.selectedVideoSource);
        }
        if (!this.recordMatchesSelectedSource(this.selectedVideoSource)
            || !this.scenarioCutRecordMatches(this.selectedVideoSource, cut)) {
            return '현재 시나리오와 선택한 컷에 해당하는 원본 이미지를 다시 선택해주세요.';
        }
        return '';
    }

    public scenarioVideoDuration() {
        const options = this.videoDurationOptionsForSelectedModel();
        const duration = Number(this.videoDurationSeconds || options[0]);
        return options.includes(duration) ? duration : options[0];
    }

    public availableScenarios() {
        const mediaType = this.normalizeMediaType(this.form.media_type) || 'image';
        return this.scenarios.filter((item: any) => {
            const itemType = this.normalizeMediaType(item?.media_type || 'image') || 'image';
            return itemType === mediaType;
        });
    }

    public selectedPatientScenarioType() {
        return String(this.selectedPatientOption()?.scenario_type || '').trim();
    }

    public selectedPromptOption() {
        return this.availableScenarios().find(
            (item: any) => this.scenarioValue(item) === String(this.form.scenario_type || '')
        ) || null;
    }

    public selectedPromptTemplate() {
        const templateId = this.templateIdForScenario(
            String(this.form.scenario_type || ''),
            this.form.media_type
        );
        return this.templates.find((item: any) =>
            String(item?.id || item?.template_id || '') === String(templateId || '')
        ) || null;
    }

    public promptSelectionMismatch(value: string = this.form.scenario_type) {
        const patientScenario = this.selectedPatientScenarioType();
        const selectedScenario = String(value || '').trim();
        return !!patientScenario
            && !!selectedScenario
            && patientScenario !== selectedScenario;
    }

    public promptSelectionStatusLabel() {
        if (this.promptSelectionMode === 'source') return '원본 이미지 기준';
        if (this.promptSelectionMode === 'manual') return '직접 선택';
        return this.form.scenario_type ? '자동 권장' : '선택 필요';
    }

    public promptSetOptionLabel(option: any) {
        const label = this.scenarioOptionLabel(option);
        const version = option?.template_version || option?.version;
        const recommended = this.scenarioValue(option) === this.selectedPatientScenarioType();
        return [
            label,
            version ? `v${version}` : '',
            recommended ? '(권장)' : ''
        ].filter((value: string) => !!value).join(' · ');
    }

    public selectedPromptPositivePreview() {
        return String(
            this.selectedPromptTemplate()?.positive_prompt_preview
            || this.selectedPromptOption()?.positive_prompt_preview
            || ''
        ).trim();
    }

    public selectedPromptNegativePreview() {
        return String(
            this.selectedPromptTemplate()?.negative_prompt_preview
            || this.selectedPromptOption()?.negative_prompt_preview
            || ''
        ).trim();
    }

    public referenceControlsAvailable() {
        if (this.sourceMode === 'scenario') {
            return !!this.selectedScenarioSet() && !this.selectedScenarioAnalysisOnly();
        }
        return this.patientMemoryMode === 'trauma'
            && !!this.normalizeRequestedPatientId(this.form.patient_id);
    }

    public referenceRecommendationSourceReady() {
        if (this.sourceMode === 'scenario') {
            return !!this.selectedScenarioSet()
                && !!this.selectedScenarioContent()?.prompts?.image;
        }
        return this.patientMemoryMode === 'trauma'
            && this.selectedPatientPromptReady();
    }

    public referenceRecommendationTitle() {
        return this.sourceMode === 'scenario'
            ? '시나리오 프롬프트 기반 추천'
            : '환자 프롬프트 기반 추천';
    }

    public referenceRecommendationDescription() {
        return this.sourceMode === 'scenario'
            ? `대화에서 추출한 ${this.scenarioMemoryLabel()}의 장소·환경과 시대를 구분해 추천합니다.`
            : '승인된 환자 시나리오 프롬프트와 가까운 승인 레퍼런스입니다.';
    }

    public referenceLibraryQueryParams() {
        if (this.sourceMode === 'scenario') {
            return {
                from: 'content',
                source: 'scenario',
                scenario: String(
                    this.scenarioSelection.scenario_set_id || ''
                ).trim().toUpperCase(),
                memory: String(
                    this.scenarioSelection.memory_kind || 'trauma'
                ).trim().toLowerCase()
            };
        }
        return {
            from: 'content',
            patient_id: this.normalizeRequestedPatientId(this.form.patient_id)
        };
    }

    private referenceRecommendationSourceKey() {
        if (this.sourceMode === 'scenario') {
            if (this.selectedScenarioAnalysisOnly()) return '';
            const scenarioSetId = String(
                this.scenarioSelection.scenario_set_id || ''
            ).trim().toUpperCase();
            const memoryKind = String(
                this.scenarioSelection.memory_kind || ''
            ).trim().toLowerCase();
            return scenarioSetId && memoryKind
                ? `scenario:${scenarioSetId}:${memoryKind}`
                : '';
        }
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        return this.patientMemoryMode === 'trauma' && patientId
            ? `patient:${patientId}`
            : '';
    }

    public async loadReferenceRecommendations() {
        const sourceKey = this.referenceRecommendationSourceKey();
        if (this.referenceRecommendationPreviewOpen) {
            await this.closeReferenceRecommendationPreview();
        }
        this.referenceRecommendations = [];
        this.referenceRecommendationError = '';
        if (!sourceKey) {
            this.referenceRecommendationState = 'idle';
            this.referenceRecommendationLoading = false;
            return;
        }

        this.referenceRecommendationLoading = true;
        this.referenceRecommendationState = 'loading';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('recommended_references', {
                source_mode: this.sourceMode,
                source: this.sourceMode,
                patient_id: this.sourceMode === 'patient'
                    ? this.normalizeRequestedPatientId(this.form.patient_id)
                    : '',
                scenario_set_id: this.sourceMode === 'scenario'
                    ? String(this.scenarioSelection.scenario_set_id || '')
                    : '',
                memory_kind: this.sourceMode === 'scenario'
                    ? String(this.scenarioSelection.memory_kind || '')
                    : ''
            });
            if (sourceKey !== this.referenceRecommendationSourceKey()) {
                return;
            }
            if (code !== 200) {
                this.referenceRecommendationState = 'error';
                this.referenceRecommendationError = data?.message
                    || '추천 레퍼런스를 불러오지 못했습니다.';
                return;
            }
            this.referenceRecommendationState = String(data?.state || 'ready');
            const recommendations = Array.isArray(data?.items)
                ? data.items.slice(0, 5)
                : [];
            if (
                recommendations.length > 0
                && Number(data?.recommendation_schema_version || 0) < 2
            ) {
                this.referenceRecommendationState = 'error';
                this.referenceRecommendationError = (
                    '추천 분류 기준이 갱신되었습니다. 페이지를 새로고침해주세요.'
                );
                this.referenceRecommendations = [];
                return;
            }
            this.referenceRecommendations = recommendations;
        } catch (_error) {
            if (sourceKey !== this.referenceRecommendationSourceKey()) {
                return;
            }
            this.referenceRecommendationState = 'error';
            this.referenceRecommendationError = '추천 레퍼런스를 불러오지 못했습니다.';
        } finally {
            if (sourceKey === this.referenceRecommendationSourceKey()) {
                this.referenceRecommendationLoading = false;
                await this.service.render();
            }
        }
    }

    public recommendedReferenceCondition(item: any) {
        return this.normalizedReferenceCondition({
            ...item,
            reference_id: item?.reference_id || item?.id
        });
    }

    public recommendedReferenceThumbnail(item: any) {
        const thumbnail = this.publicReferenceImageUrl(
            item?.preview_thumbnail_url
        );
        const image = this.publicReferenceImageUrl(
            item?.preview_image_url
        );
        if (this.referenceImageAvailable(thumbnail)) return thumbnail;
        return this.referenceImageAvailable(image) ? image : '';
    }

    public recommendedReferenceFullImage(item: any) {
        const image = this.publicReferenceImageUrl(
            item?.preview_image_url
        );
        const thumbnail = this.publicReferenceImageUrl(
            item?.preview_thumbnail_url
        );
        if (this.referenceImageAvailable(image)) return image;
        return this.referenceImageAvailable(thumbnail) ? thumbnail : '';
    }

    public referenceRecommendationPreviewItems() {
        return this.referenceRecommendations.filter(
            (item: any) => !!this.recommendedReferenceFullImage(item)
        );
    }

    public referenceRecommendationPreviewItem() {
        const items = this.referenceRecommendationPreviewItems();
        if (!items.length) return null;
        const index = Math.min(
            Math.max(Number(this.referenceRecommendationPreviewIndex || 0), 0),
            items.length - 1
        );
        return items[index] || null;
    }

    public referenceRecommendationPreviewCounter() {
        const items = this.referenceRecommendationPreviewItems();
        if (!items.length) return '';
        const index = Math.min(
            Math.max(Number(this.referenceRecommendationPreviewIndex || 0), 0),
            items.length - 1
        );
        return `${index + 1} / ${items.length}`;
    }

    public async openReferenceRecommendationPreview(item: any) {
        const items = this.referenceRecommendationPreviewItems();
        const index = items.indexOf(item);
        if (index < 0) return;
        this.referenceRecommendationPreviewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.referenceRecommendationPreviewIndex = index;
        this.referenceRecommendationPreviewOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            document.getElementById('content-reference-recommendation-preview-close')?.focus();
        }, 0);
    }

    public async closeReferenceRecommendationPreview() {
        this.referenceRecommendationPreviewOpen = false;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.referenceRecommendationPreviewReturnFocus;
        this.referenceRecommendationPreviewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public async moveReferenceRecommendationPreview(offset: number) {
        const items = this.referenceRecommendationPreviewItems();
        if (items.length < 2) return;
        const current = Math.min(
            Math.max(Number(this.referenceRecommendationPreviewIndex || 0), 0),
            items.length - 1
        );
        this.referenceRecommendationPreviewIndex = (
            current + Number(offset || 0) + items.length
        ) % items.length;
        await this.service.render();
    }

    public async onRecommendedReferenceImageError(item: any, url: string) {
        const previewedItem = this.referenceRecommendationPreviewOpen
            ? this.referenceRecommendationPreviewItem()
            : null;
        const normalized = this.publicReferenceImageUrl(url);
        if (normalized) this.referenceImageErrors[normalized] = true;

        if (this.referenceRecommendationPreviewOpen) {
            const items = this.referenceRecommendationPreviewItems();
            if (!items.length) {
                await this.closeReferenceRecommendationPreview();
                return;
            }
            const preservedIndex = items.indexOf(previewedItem);
            if (preservedIndex >= 0) {
                this.referenceRecommendationPreviewIndex = preservedIndex;
            } else if (!items.includes(item)) {
                this.referenceRecommendationPreviewIndex = Math.min(
                    this.referenceRecommendationPreviewIndex,
                    items.length - 1
                );
            }
        }
        await this.service.render();
    }

    public onReferenceRecommendationPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeReferenceRecommendationPreview();
            return;
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            void this.moveReferenceRecommendationPreview(-1);
            return;
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            void this.moveReferenceRecommendationPreview(1);
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-reference-recommendation-preview-dialog');
    }

    public referenceRecommendationSummary(item: any) {
        return [
            String(item?.era_label || '').trim(),
            String(item?.region || '').trim(),
            String(item?.district || '').trim(),
            String(item?.category || '').trim()
        ].filter((value: string, index: number, values: string[]) =>
            !!value && values.indexOf(value) === index
        ).join(' · ');
    }

    public referenceRecommendationGroups() {
        const definitions = [
            {
                key: 'overall',
                label: '종합 일치',
                description: '장소·환경과 시대가 모두 맞는 후보'
            },
            {
                key: 'place',
                label: '장소·환경 참고',
                description: '장소·환경만 맞아 시대 확인이 필요한 후보'
            },
            {
                key: 'era',
                label: '시대 참고',
                description: '시대만 맞아 장소 확인이 필요한 후보'
            },
            {
                key: 'unclassified',
                label: '분류 확인 필요',
                description: '새 추천 기준으로 다시 확인해야 하는 후보'
            }
        ];
        return definitions.map((definition: any) => ({
            ...definition,
            items: this.referenceRecommendations.filter((item: any) => {
                const group = String(
                    item?.recommendation_group || 'unclassified'
                ).trim().toLowerCase();
                return (
                    ['overall', 'place', 'era'].includes(group)
                        ? group
                        : 'unclassified'
                ) === definition.key;
            })
        })).filter((group: any) => group.items.length > 0);
    }

    public referenceRecommendationReason(item: any) {
        const reasons = Array.isArray(item?.match_reasons)
            ? item.match_reasons.map((value: any) => String(value || '').trim()).filter(Boolean)
            : [];
        return reasons.join(' · ') || String(item?.match_note || '').trim();
    }

    public async useRecommendedReference(item: any) {
        const condition = this.recommendedReferenceCondition(item);
        if (!condition) {
            await this.service.modal.error('추천 레퍼런스 정보를 확인해주세요.');
            return;
        }
        this.selectedReferenceCondition = condition;
        this.referenceUsageMode = 'metadata';
        this.referenceRoles = ['background_architecture'];
        this.referenceStrength = 'medium';
        this.selectedPatientSource = null;
        this.form.media_type = 'image';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectedPatientPositivePreview() {
        return String(
            this.selectedPatientOption()?.approved_positive_prompt_preview || ''
        ).trim();
    }

    public selectedPatientNegativePreview() {
        return String(
            this.selectedPatientOption()?.approved_negative_prompt_preview || ''
        ).trim();
    }

    public async onPromptSetChange(value: any) {
        const next = String(value || '').trim();
        const previous = String(this.form.scenario_type || '').trim();
        if (next === previous) return;

        const available = this.availableScenarios().some(
            (item: any) => this.scenarioValue(item) === next
        );
        if (next && !available) {
            await this.service.modal.error('현재 콘텐츠 유형에 사용할 수 없는 프롬프트 세트입니다.');
            await this.service.render();
            return;
        }

        const sourceScenario = this.form.media_type === 'video'
            ? String(
                this.selectedVideoSource?.scenario_type
                || this.selectedVideoSource?.scenario
                || ''
            ).trim()
            : '';
        if (next && sourceScenario && next !== sourceScenario) {
            await this.service.modal.warning(
                '영상 프롬프트 세트는 선택한 원본 이미지의 생성 계보와 같아야 합니다. 다른 세트를 사용하려면 먼저 해당 세트로 이미지를 생성해주세요.',
                false,
                '확인'
            );
            await this.service.render();
            return;
        }

        const mismatch = this.promptSelectionMismatch(next);
        if (mismatch) {
            const confirmed = await this.service.modal.show({
                title: '환자 유형과 다른 프롬프트 세트',
                message: `환자 유형은 '${this.scenarioLabel(this.selectedPatientScenarioType())}'이지만 '${this.scenarioLabel(next)}' 세트를 선택했습니다. 환자별 승인 프롬프트에 다른 공통 생성 규칙이 결합되며, 이 선택은 감사 기록에 남습니다. 계속하시겠습니까?`,
                action: '다른 세트 사용',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'warning'
            });
            if (!confirmed) {
                await this.service.render();
                return;
            }
        }

        this.form.scenario_type = next;
        if (
            this.selectedPatientSource
            && String(this.selectedPatientSource?.scenario_type || '') !== next
        ) this.selectedPatientSource = null;
        this.promptSelectionMode = next ? 'manual' : '';
        this.promptMismatchAcknowledged = mismatch;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        await this.service.render();
    }

    public async useRecommendedPromptSet() {
        const recommended = this.selectedPatientScenarioType();
        const available = this.availableScenarios().some(
            (item: any) => this.scenarioValue(item) === recommended
        );
        this.form.scenario_type = available ? recommended : '';
        this.promptSelectionMode = this.form.scenario_type ? 'auto' : '';
        this.promptMismatchAcknowledged = false;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public patientLabel(patient: any) {
        return patient?.patient_code || patient?.code || patient?.pseudonym || '비식별 코드';
    }

    public selectedPatientOption() {
        const patientId = String(this.form.patient_id || '');
        return this.patients.find((patient: any) =>
            String(patient?.id || patient?.patient_id || '') === patientId
        ) || null;
    }

    private patientStatusFlag(value: any) {
        return value === true || value === 1 || value === '1'
            || String(value || '').trim().toLowerCase() === 'true';
    }

    public selectedPatientHasScenarioDescription() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.has_scenario_description
        );
    }

    public selectedPatientScenarioDescriptionReady() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.scenario_description_ready
        );
    }

    public selectedPatientPromptReady() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.scenario_prompt_ready
        );
    }

    public selectedPatientSetupState() {
        if (!this.form.patient_id || !this.selectedPatientOption()) return 'idle';
        if (!this.selectedPatientHasScenarioDescription()) return 'scenario_required';
        if (!this.selectedPatientScenarioDescriptionReady()) {
            return 'scenario_review_required';
        }
        if (!this.selectedPatientPromptReady()) return 'prompt_review_required';
        return 'ready';
    }

    public selectedPatientSetupTitle() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '환자 시나리오가 작성되지 않았습니다.';
            case 'scenario_review_required': return '환자 시나리오 검토가 필요합니다.';
            case 'prompt_review_required': return '환자별 승인 프롬프트가 없습니다.';
            default: return '';
        }
    }

    public selectedPatientSetupMessage() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required':
                return '환자 상세에서 시나리오를 작성해주세요. 작성 후 맞춤 프롬프트와 레퍼런스를 준비할 수 있습니다.';
            case 'scenario_review_required':
                return '작성한 시나리오의 비식별·전송 적합성 검토를 완료해주세요.';
            case 'prompt_review_required':
                return '시나리오 프롬프트를 생성하고 담당 임상의 승인을 완료해주세요.';
            default: return '';
        }
    }

    public selectedPatientSetupActionLabel() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '환자 시나리오 작성하기';
            case 'scenario_review_required': return '환자 시나리오 검토하기';
            case 'prompt_review_required': return '프롬프트 생성·승인하기';
            default: return '환자 상세 확인';
        }
    }

    public contentSettingsReady() {
        if (this.sourceMode === 'scenario') {
            if (['audio', 'video'].includes(this.form.media_type) && /^(?:[A-Z][0-9]{2}|IM[0-9A-F]{14})$/.test(
                String(this.scenarioSelection.scenario_set_id || '').toUpperCase()
            )) {
                const cut = this.scenarioCutRequestSpec();
                return !!this.selectedScenarioSet() && !!cut
                    && !cut.analysis_snapshot_conflict
                    && /^[a-f0-9]{64}$/.test(cut.analysis_snapshot_sha256)
                    && !!this.templateIdForScenarioGeneration(this.form.media_type);
            }
            if (
                this.form.media_type === 'image'
                && !!this.selectedScenarioSet()
                && !!this.scenarioCutRequestSpec()
                && !!this.templateIdForScenarioGeneration('image')
            ) return true;
            return !!this.selectedScenarioSet()
                && !!this.selectedScenarioContent()
                && !!this.selectedScenarioPrompt();
        }
        if (this.patientMemoryMode === 'resource') {
            return !!this.normalizeRequestedPatientId(this.form.patient_id)
                && !!this.selectedResourceMemory();
        }
        return this.selectedPatientSetupState() === 'ready';
    }

    public settingsLockedStatusLabel() {
        if (this.sourceMode === 'scenario') return '시나리오 선택 후 설정';
        if (this.patientMemoryMode === 'resource') {
            return this.selectedResourceMemory()
                ? '자원기억 준비 완료'
                : '승인 자원기억 선택 후 설정';
        }
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '시나리오 작성 후 설정';
            case 'scenario_review_required': return '시나리오 검토 후 설정';
            case 'prompt_review_required': return '프롬프트 승인 후 설정';
            default: return '환자 준비 후 설정';
        }
    }

    public settingsAccordionOpen(section: string) {
        return this.contentSettingsReady() && this.settingsAccordion === section;
    }

    public settingsAccordionSummary(section: string) {
        switch (section) {
            case 'prompt':
                if (this.sourceMode === 'scenario') {
                    return this.selectedScenarioSet()
                        ? `${this.selectedScenarioSet().id} · ${this.scenarioMemoryLabel()}`
                        : '시나리오를 선택해주세요';
                }
                if (this.patientMemoryMode === 'resource') {
                    return this.selectedResourceMemory()?.title
                        || '승인 자원기억을 선택해주세요';
                }
                return this.form.scenario_type
                    ? this.scenarioLabel(this.form.scenario_type)
                    : '프롬프트 세트를 선택해주세요';
            case 'reference':
                return this.selectedPatientSource
                    ? '환자 제공 사진 적용'
                    : (
                        this.referenceUsageModeForMedia() === 'none'
                            ? '레퍼런스 사용 안 함'
                            : `${this.selectedReferenceCondition?.title || '선택된 레퍼런스 없음'} · ${
                                this.referenceUsageModeForMedia() === 'visual'
                                    ? '이미지 요소 참고'
                                    : '환경 정보 참고'
                            }`
                    );
            case 'intensity':
                return this.positiveMemoryIntensityActive()
                    ? `선명도 ${Number(this.form.intensity || 1)} / 5`
                    : `현재 ${Number(this.form.intensity || 1)} / 5`;
            case 'generation':
                if (this.sourceMode === 'scenario') {
                    if (this.form.media_type === 'image') {
                        const quality = this.selectedImageQualityRequest();
                        return `${this.selectedImageModelLabel()}${quality ? ` · ${quality}` : ''} · 후보 ${this.imageCandidateCount}개`;
                    }
                    if (this.form.media_type === 'video') {
                        const selected = (this.generationModelOptions.video || []).find(
                            (item: any) => item.value === this.selectedVideoModelKey()
                        );
                        return `${String(selected?.label || '영상 모델 선택')} · ${this.videoDurationSeconds}초`;
                    }
                    return `${this.scenarioMemoryLabel()} · ${this.modalityLabel(this.form.media_type)}`;
                }
                return this.form.media_type === 'image'
                    ? `${this.selectedImageModelLabel()}${this.selectedImageQualityRequest() ? ` · ${this.selectedImageQualityRequest()}` : ''} · 후보 ${this.imageCandidateCount}개`
                    : `${this.modalityLabel(this.form.media_type)} 생성 옵션`;
            default:
                return '';
        }
    }

    public toggleSettingsAccordion(section: 'prompt' | 'reference' | 'intensity' | 'generation') {
        if (!this.contentSettingsReady()) return;
        this.settingsAccordion = this.settingsAccordion === section ? '' : section;
        // The click event already runs inside Angular. Updating the local view
        // synchronously prevents a route/search render in scenario mode from
        // restoring the previous accordion state before the body is painted.
        this.changeDetector.detectChanges();
    }

    public selectedPatientPromptStatus() {
        return String(
            this.selectedPatientOption()?.scenario_prompt_status || 'source_not_ready'
        );
    }

    public jobPatientCode(job: any) {
        return job?.patient_code || job?.patient?.patient_code || job?.patient?.code || '비식별 환자';
    }

    public scenarioValue(option: any) {
        return typeof option === 'string' ? option : (option?.value || option?.key || option?.scenario_type || '');
    }

    public scenarioOptionLabel(option: any) {
        return typeof option === 'string' ? option : (option?.label || option?.title || option?.name || option?.key || option?.scenario_type || option?.value || '시나리오');
    }

    public scenarioDescription(option: any) {
        if (typeof option === 'string') return '';
        if (option?.description || option?.note) return option.description || option.note;
        const version = option?.version || option?.template_version;
        return version ? 'Prompt 템플릿 v' + version : '';
    }

    public selectedScenarioDescription() {
        const option = this.availableScenarios().find((item: any) => this.scenarioValue(item) === this.form.scenario_type);
        return option ? this.scenarioDescription(option) : '';
    }

    public templateIdForScenario(value: string, mediaType: string = this.form.media_type) {
        const normalizedType = this.normalizeMediaType(mediaType) || 'image';
        const option = this.scenarios.find((item: any) =>
            this.scenarioValue(item) === value &&
            (this.normalizeMediaType(item?.media_type || 'image') || 'image') === normalizedType
        );
        const direct = option?.template_id || option?.id;
        if (direct) return direct;
        const template = this.templates.find((item: any) =>
            item?.scenario_type === value &&
            (this.normalizeMediaType(item?.media_type || 'image') || 'image') === normalizedType &&
            (!item?.status || item.status === 'active')
        );
        return template?.id || template?.template_id || '';
    }

    public scenarioLabel(value: string) {
        const option = this.scenarios.find((item: any) => this.scenarioValue(item) === value);
        return option ? this.scenarioOptionLabel(option) : (value || '시나리오 미지정');
    }

    public jobScenario(job: any) {
        return this.scenarioLabel(job?.scenario_type || job?.scenario || job?.prompt_snapshot?.scenario_type || '');
    }

    public jobIntensity(job: any) {
        const value = Number(job?.intensity || job?.prompt_snapshot?.intensity || 0);
        return value > 0 ? value : '-';
    }

    public artifacts(item: any) {
        const asset = item?.asset || item?.media_asset || {};
        if (Array.isArray(item?.artifacts)) return item.artifacts;
        if (Array.isArray(asset?.artifacts)) return asset.artifacts;
        return [];
    }

    public artifactRole(artifact: any) {
        return String(artifact?.role || artifact?.kind || '').trim().toLowerCase();
    }

    public safeSignedUrl(value: any) {
        const url = String(value || '').trim();
        if (!url.startsWith('/api/ptsd/assets/file?') || url.includes('\\') || /[\r\n]/.test(url)) return '';
        return url;
    }

    public artifactUrl(artifact: any) {
        return this.safeSignedUrl(artifact?.signed_url);
    }

    public masterUrl(item: any) {
        if (item?.preview_failed) return '';
        const asset = item?.asset || item?.media_asset || {};
        return this.safeSignedUrl(item?.signed_url || item?.preview_url || asset?.signed_url || asset?.preview_url);
    }

    public derivative(item: any, roles: string[], mimePrefix: string = '') {
        return this.artifacts(item).find((artifact: any) => {
            const role = this.artifactRole(artifact);
            const mime = String(artifact?.mime_type || '').toLowerCase();
            return roles.includes(role) && (!mimePrefix || mime.startsWith(mimePrefix)) && !!this.artifactUrl(artifact);
        }) || null;
    }

    public visualUrl(item: any) {
        if (item?.preview_failed) return '';
        const mediaType = this.mediaType(item);
        if (mediaType === 'audio') {
            const waveform = this.derivative(item, ['waveform'], 'image/');
            return waveform ? this.artifactUrl(waveform) : '';
        }
        const thumbnail = this.derivative(item, ['thumbnail', 'preview'], 'image/');
        if (thumbnail) return this.artifactUrl(thumbnail);
        return mediaType === 'image' ? this.masterUrl(item) : '';
    }

    public playerUrl(item: any) {
        const mediaType = this.mediaType(item);
        if (mediaType === 'image') return this.visualUrl(item);
        const preview = this.derivative(item, ['preview'], mediaType + '/');
        return preview ? this.artifactUrl(preview) : this.masterUrl(item);
    }

    public posterUrl(item: any) {
        const poster = this.derivative(item, ['thumbnail'], 'image/');
        return poster ? this.artifactUrl(poster) : '';
    }

    public videoCandidateThumbnailUrl(item: any) {
        if (this.mediaType(item) !== 'video') return '';
        const sourceRevisionId = this.videoSourceRevisionId(item);
        if (sourceRevisionId) {
            const source = (Array.isArray(this.assets) ? this.assets : []).find(
                (asset: any) => this.assetId(asset) === sourceRevisionId
            );
            const sourceUrl = source ? this.visualUrl(source) : '';
            if (sourceUrl) return sourceUrl;
        }
        return this.posterUrl(item);
    }

    public hasPlayablePreview(item: any) {
        return !!(this.mediaType(item) === 'image' ? this.masterUrl(item) : this.playerUrl(item));
    }

    public isQuarantinedAsset(item: any) {
        const asset = this.primaryMetadata(item);
        const safetyStatus = String(asset?.safety_status || item?.safety_status || '').toLowerCase();
        const reviewStatus = String(asset?.review_status || item?.review_status || item?.status || '').toLowerCase();
        return safetyStatus === 'quarantined' || reviewStatus === 'quarantined';
    }

    public previewUrl(item: any) {
        return this.mediaType(item) === 'image' ? this.visualUrl(item) : this.playerUrl(item);
    }

    public primaryMetadata(item: any) {
        return item?.asset || item?.media_asset || item || {};
    }

    public dimensions(item: any) {
        const data = this.primaryMetadata(item);
        if (data?.width && data?.height) return data.width + ' × ' + data.height;
        const candidate = this.artifacts(item).find((artifact: any) => artifact?.width && artifact?.height);
        return candidate ? candidate.width + ' × ' + candidate.height : '-';
    }

    public duration(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.duration_ms) > 0);
        const milliseconds = Number(data?.duration_ms || artifact?.duration_ms || 0);
        if (!milliseconds) return '-';
        const seconds = Math.round(milliseconds / 100) / 10;
        return seconds.toFixed(seconds >= 10 ? 0 : 1) + '초';
    }

    public codec(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.codec || value?.container_format);
        const codec = data?.codec || artifact?.codec || '-';
        const container = data?.container_format || artifact?.container_format || '';
        return container && container !== codec ? codec + ' · ' + container : codec;
    }

    public audioSpec(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.sample_rate_hz || value?.channels || value?.bit_depth);
        const sampleRate = Number(data?.sample_rate_hz || artifact?.sample_rate_hz || 0);
        const channels = Number(data?.channels || artifact?.channels || 0);
        const bits = Number(data?.bit_depth || artifact?.bit_depth || 0);
        const values = [];
        if (sampleRate) values.push((sampleRate / 1000).toFixed(sampleRate % 1000 ? 1 : 0) + 'kHz');
        if (channels) values.push(channels + 'ch');
        if (bits) values.push(bits + 'bit');
        return values.join(' · ') || '-';
    }

    public frameRate(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.frame_rate_milli || value?.fps);
        const milli = Number(data?.frame_rate_milli || artifact?.frame_rate_milli || 0);
        const fps = Number(data?.fps || artifact?.fps || (milli ? milli / 1000 : 0));
        return fps ? (Math.round(fps * 10) / 10) + 'fps' : '-';
    }

    public bitrate(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.bitrate_bps) > 0);
        const bitsPerSecond = Number(data?.bitrate_bps || artifact?.bitrate_bps || 0);
        return bitsPerSecond ? Math.round(bitsPerSecond / 1000) + 'kbps' : '-';
    }

    public technicalSummary(item: any) {
        const mediaType = this.mediaType(item);
        if (mediaType === 'image') return this.dimensions(item);
        const values = mediaType === 'audio'
            ? [this.duration(item), this.audioSpec(item), this.codec(item), this.bitrate(item)]
            : [this.duration(item), this.dimensions(item), this.frameRate(item), this.codec(item), this.bitrate(item)];
        return values.filter((value: string) => value !== '-').join(' · ') || '-';
    }

    public metricPayload(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
        return value?.last_24h && typeof value.last_24h === 'object' ? value.last_24h : value;
    }

    public todayLabel() {
        const date = new Date();
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            weekday: 'short'
        }).format(date);
    }

    public closeIntensityHelpDetails(event: Event) {
        const target = event.currentTarget as HTMLElement | null;
        const details = target?.tagName === 'DETAILS'
            ? target as HTMLDetailsElement
            : target?.closest('details') as HTMLDetailsElement | null;
        if (!details) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
    }

    public onIntensityInput(event: Event) {
        const input = event.target as HTMLInputElement | null;
        if (!input) return;
        const intensity = this.normalizeIntensityValue(input.value);
        if (this.form.media_type === 'image' && this.imageGenerationScope === 'all') {
            this.imageGenerationScope = 'single';
        }
        this.form.intensity = intensity;
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public setIntensity(value: number) {
        if (this.form.media_type === 'image' && this.imageGenerationScope === 'all') {
            this.imageGenerationScope = 'single';
        }
        this.form.intensity = this.normalizeIntensityValue(value);
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public intensityDescription() {
        if (this.positiveMemoryIntensityActive()) {
            const positiveLabels: any = {
                1: '1 (안정적인 장소와 부드러운 빛 중심)',
                2: '2 (익숙한 일상과 은은한 편안함)',
                3: '3 (사람 사이의 연결감과 자연스러운 미소)',
                4: '4 (따뜻한 표정·몸짓·감각 단서를 선명하게)',
                5: '5 (안도·애정·기쁨이 가장 생생한 기억)'
            };
            return positiveLabels[Number(this.form.intensity)] || '-';
        }
        if (this.sourceMode === 'scenario') {
            const fidelityLabels: any = {
                1: '1 (기억 윤곽과 낮은 정보 밀도)',
                2: '2 (초기 단서와 기본 묘사)',
                3: '3 (핵심 기억과 표준 묘사)',
                4: '4 (기억 대부분과 높은 묘사 밀도)',
                5: '5 (확인된 기억을 가장 정밀하게 재현)'
            };
            return fidelityLabels[Number(this.form.intensity)] || '-';
        }
        const labels: any = {
            1: '1 (배경 맥락 중심)',
            2: '2 (승인 단서 일부 반영)',
            3: '3 (핵심 단서 반영)',
            4: '4 (구체 단서 대부분 반영)',
            5: '5 (승인 진술 최대 충실 반영)'
        };
        return labels[Number(this.form.intensity)] || '-';
    }

    public contentSummaryRows() {
        const assets = Array.isArray(this.assets) ? this.assets : [];
        const imageAssets = assets.filter((asset: any) =>
            this.mediaType(asset) === 'image'
            && this.panoramaGenerationMode(asset) !== 'image_to_panorama'
        );
        const videoAssets = assets.filter((asset: any) => this.mediaType(asset) === 'video');
        return [
            {
                label: '이미지 후보',
                value: imageAssets.length + '개',
                icon: 'fa-regular fa-images text-blue-600'
            },
            {
                label: '오디오 자산',
                value: assets.filter((asset: any) => this.mediaType(asset) === 'audio').length + '개',
                icon: 'fa-solid fa-wave-square text-emerald-600'
            },
            {
                label: '영상 클립',
                value: videoAssets.length + '개',
                icon: 'fa-solid fa-film text-violet-600'
            }
        ];
    }

    public allReviewAssets(mediaType: string = this.form.media_type) {
        const targetType = this.normalizeMediaType(mediaType) || 'image';
        const completedReplacementTargets = new Set(
            (Array.isArray(this.jobs) ? this.jobs : [])
                .filter((job: any) =>
                    !!String(job?.replaces_job_id || '')
                    && !!String(job?.asset_revision_id || job?.asset?.id || '')
                    && ['review_pending', 'approved'].includes(
                        String(job?.status || '').toLowerCase()
                    )
                )
                .map((job: any) => String(job.replaces_job_id))
        );
        return (Array.isArray(this.assets) ? [...this.assets] : [])
            .filter((asset: any) =>
                this.mediaType(asset) === targetType
                && (
                    targetType !== 'image'
                    || this.panoramaGenerationMode(asset) !== 'image_to_panorama'
                )
                && !completedReplacementTargets.has(this.jobId(asset))
            )
            .sort((left: any, right: any) => {
                const leftBatch = String(left?.candidate_batch_id || '');
                const rightBatch = String(right?.candidate_batch_id || '');
                if (leftBatch && rightBatch && leftBatch === rightBatch) {
                    return Number(left?.candidate_index || 0) - Number(right?.candidate_index || 0);
                }
                const leftTime = new Date(left?.created_at || left?.created || 0).getTime();
                const rightTime = new Date(right?.created_at || right?.created || 0).getTime();
                return rightTime - leftTime;
            });
    }

    public reviewAssets() {
        const targetType = this.normalizeMediaType(this.form.media_type) || 'image';
        const rows = this.allReviewAssets(targetType);
        if (targetType !== 'video') {
            if (!this.scenarioConsoleActive()) return rows;
            const cut = this.selectedScenarioCut();
            return cut
                ? rows.filter((asset: any) => this.scenarioCutRecordMatches(asset, cut))
                : [];
        }
        const modelKey = this.effectiveVideoResultModelKey();
        const sourceRows = this.videoComparisonAssets();
        return modelKey === 'all'
            ? sourceRows
            : sourceRows.filter((asset: any) => this.videoAssetModelKey(asset) === modelKey);
    }

    public videoSourceRevisionId(asset: any) {
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        return String(
            asset?.source_asset_revision_id
            || asset?.source_revision_id
            || data?.source_asset_revision_id
            || provenance?.source_asset_revision_id
            || ''
        );
    }

    public videoComparisonAssets() {
        return this.allReviewAssets('video');
    }

    public videoComparisonSourceCount() {
        const sourceIds = this.videoComparisonAssets()
            .map((asset: any) => this.videoSourceRevisionId(asset))
            .filter((value: string) => !!value);
        return new Set(sourceIds).size;
    }

    public videoAssetModelKey(asset: any) {
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        const provider = String(
            asset?.provider_name
            || asset?.provider
            || data?.provider_name
            || data?.provider
            || provenance?.provider_name
            || provenance?.provider
            || ''
        ).toLowerCase();
        const model = String(
            asset?.model_name
            || asset?.model
            || data?.model_name
            || provenance?.model_name
            || data?.engine_name
            || ''
        ).toLowerCase();
        if (provider.includes('kling') || model.includes('kling')) return 'kling-video-3';
        const evolinkModelKey = this.evolinkVideoModelKey(model);
        if (evolinkModelKey) return evolinkModelKey;
        if (provider.includes('evolink')) return 'evolink-seedance-2-5';
        if (provider.includes('comfy') || model.includes('wan2.2') || model.includes('wan-2')) return 'wan-2-2';
        if (provider === 'mock' || model.includes('fixture')) return 'mock';
        return 'other';
    }

    public videoAssetModelLabel(asset: any) {
        const key = this.videoAssetModelKey(asset);
        const option = this.generationModelOptions.video.find((item: any) => item.value === key);
        if (option) return option.label;
        if (key === 'mock') return '테스트용 mock 영상';
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        return String(asset?.model_name || data?.model_name || provenance?.model_name || '기타 모델');
    }

    public videoAssetModelClass(asset: any) {
        const classes: any = {
            'kling-video-3': 'border-cyan-200 bg-cyan-50 text-cyan-800',
            'evolink-seedance-2-5': 'border-rose-200 bg-rose-50 text-rose-800',
            'evolink-seedance-2-0-fast': 'border-orange-200 bg-orange-50 text-orange-800',
            'evolink-minimax-h3-max': 'border-amber-200 bg-amber-50 text-amber-800',
            'evolink-veo-3-1-fast': 'border-blue-200 bg-blue-50 text-blue-800',
            'wan-2-2': 'border-violet-200 bg-violet-50 text-violet-800',
            mock: 'border-slate-200 bg-slate-100 text-slate-600'
        };
        return classes[this.videoAssetModelKey(asset)] || 'border-slate-200 bg-white text-slate-700';
    }

    public videoGenerationElapsedLabel(asset: any) {
        const started = new Date(asset?.started_at || 0).getTime();
        const completed = new Date(
            asset?.completed_at || asset?.updated_at || asset?.updated || 0
        ).getTime();
        if (
            !Number.isFinite(started)
            || !Number.isFinite(completed)
            || started <= 0
            || completed < started
        ) return '기록 없음';

        const seconds = Math.max(0, Math.round((completed - started) / 1000));
        if (seconds < 1) return '1초 미만';
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const secondRemainder = seconds % 60;
        if (minutes < 60) {
            return secondRemainder > 0
                ? `${minutes}분 ${secondRemainder}초`
                : `${minutes}분`;
        }
        const hours = Math.floor(minutes / 60);
        const minuteRemainder = minutes % 60;
        return minuteRemainder > 0
            ? `${hours}시간 ${minuteRemainder}분`
            : `${hours}시간`;
    }

    public videoResultModelOptions() {
        const rows = this.videoComparisonAssets();
        const options = [
            { value: 'all', label: '전체' },
            { value: 'kling-video-3', label: 'Kling' },
            { value: 'evolink-seedance-2-5', label: 'Seedance 2.5' },
            { value: 'evolink-seedance-2-0-fast', label: 'Seedance 2.0 Fast' },
            { value: 'evolink-minimax-h3-max', label: 'MiniMax H3 Max' },
            { value: 'evolink-veo-3-1-fast', label: 'Veo 3.1 Fast' },
            { value: 'wan-2-2', label: 'Wan 2.2' }
        ];
        return options.map((option: any) => ({
            ...option,
            count: option.value === 'all'
                ? rows.length
                : rows.filter((asset: any) => this.videoAssetModelKey(asset) === option.value).length
        }));
    }

    public effectiveVideoResultModelKey() {
        const selected = String(this.selectedVideoResultModelKey || 'all');
        if (selected === 'all') return selected;
        const option = this.videoResultModelOptions().find((item: any) => item.value === selected);
        return option && option.count > 0 ? selected : 'all';
    }

    public selectVideoResultModel(modelKey: string) {
        const option = this.videoResultModelOptions().find((item: any) => item.value === modelKey);
        if (!option || option.count < 1) return;
        this.selectedVideoResultModelKey = option.value;
        this.changeDetector.detectChanges();
    }

    public setContentTab(mediaType: string) {
        const next = this.normalizeMediaType(mediaType);
        if (!next || this.form.media_type === next) return;
        if (
            this.sourceMode === 'patient'
            && this.patientMemoryMode === 'resource'
            && next !== 'image'
        ) return;
        this.workbenchAdvancedOpen = false;
        this.form.media_type = next;
        this.filters.status = '';
        this.syncScenarioForSelectedPatient();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        this.changeDetector.detectChanges();
    }

    public selectReviewAsset(asset: any) {
        this.selectedReviewAssetId = this.assetId(asset);
        this.changeDetector.detectChanges();
    }

    public currentReviewAsset() {
        const rows = this.reviewAssets();
        if (rows.length === 0) return null;
        const selectedId = String(this.selectedReviewAssetId || '');
        const selected = rows.find((asset: any) => this.assetId(asset) === selectedId);
        if (selected) return selected;

        const source = this.form.media_type === 'image'
            ? this.selectedVideoSource
            : (this.form.media_type === 'audio' ? this.selectedAudioSource : null);
        const sourceId = this.assetId(source);
        return rows.find((asset: any) => this.assetId(asset) === sourceId) || rows[0];
    }

    public isReviewAssetSelected(asset: any) {
        return this.assetId(this.currentReviewAsset()) === this.assetId(asset);
    }

    public isConfirmedReviewAsset(asset: any) {
        const assetId = this.assetId(asset);
        const type = this.mediaType(asset);
        const isVideoCandidate = type === 'image' && (
            this.sourceMode === 'scenario'
            || (
                this.sourceMode === 'patient'
                && this.patientMemoryMode === 'trauma'
            )
        );
        if (isVideoCandidate) return this.isSelectedVideoSource(asset);
        const independentlyReviewed = (
            this.sourceMode === 'scenario'
            || this.patientMemoryMode === 'resource'
        );
        if (independentlyReviewed) {
            return !!this.confirmedReviewAssetId
                && this.confirmedReviewAssetId === assetId;
        }
        if (type === 'audio') return this.isSelectedAudioSource(asset);
        return !!this.confirmedReviewAssetId
            && this.confirmedReviewAssetId === assetId;
    }

    public chooseReviewAsset(asset: any) {
        if (!asset) return;
        const assetId = this.assetId(asset);
        this.selectedReviewAssetId = assetId;
        const type = this.mediaType(asset);
        const imageVideoSourceSelection = (
            this.sourceMode === 'scenario'
            || (
                this.sourceMode === 'patient'
                && this.patientMemoryMode === 'trauma'
            )
        );
        if (
            imageVideoSourceSelection
            && type === 'image'
            && this.videoSourceEligible(asset)
        ) {
            this.confirmedReviewAssetId = assetId;
            this.selectVideoSource(asset);
            void this.workbenchSetMediaTab('video');
            return;
        }
        this.confirmedReviewAssetId = assetId;
        if (
            this.sourceMode === 'patient'
            && this.patientMemoryMode === 'trauma'
            && type === 'audio'
            && !this.isSelectedAudioSource(asset)
        ) {
            this.selectAudioSource(asset);
            return;
        }
        this.changeDetector.detectChanges();
    }

    public reviewSelectionLabel(asset: any) {
        const isVideoCandidate = this.mediaType(asset) === 'image' && (
            this.sourceMode === 'scenario'
            || (
                this.sourceMode === 'patient'
                && this.patientMemoryMode === 'trauma'
            )
        );
        if (isVideoCandidate) {
            return this.isSelectedVideoSource(asset)
                ? '영상 후보 선택됨'
                : '영상 후보 선택';
        }
        return this.isConfirmedReviewAsset(asset) ? '선택됨' : '후보 선택';
    }

    public audioAssetModelLabel(item: any) {
        if (!item) return '-';
        const data = this.primaryMetadata(item);
        const usage = this.generationUsage(item);
        const provenance = data?.provenance || item?.provenance || {};
        const model = String(usage?.model_name || item?.model_name || data?.model_name
            || item?.model || data?.model || provenance?.model_name
            || data?.engine_name || item?.engine_name || provenance?.engine_name
            || data?.generation_model || item?.generation_model || provenance?.generation_model || '').trim();
        const audioModels: any = { 'qwen-audio-3.1-tts-flash': 'evolink-qwen-tts',
            'doubao-seed-audio-1-0': 'evolink-seed-audio', 'suno-v5.5-beta': 'evolink-suno' };
        const key = audioModels[model.toLowerCase()] || model.toLowerCase();
        return this.generationModelOptions.audio.find((option: any) => option.value === key)?.label
            || model || '오디오 모델 정보 없음';
    }

    public selectedAssetGenerationModelLabel(item: any) {
        if (!item) return '-';
        if (this.mediaType(item) === 'video') return this.videoAssetModelLabel(item);
        if (this.mediaType(item) === 'audio') return this.audioAssetModelLabel(item);
        const data = this.primaryMetadata(item);
        const usage = this.generationUsage(item);
        const provider = String(
            usage?.provider_name
            || data?.provider_name
            || item?.provider_name
            || ''
        ).toLowerCase();
        const model = String(
            usage?.model_name
            || data?.model_name
            || item?.model_name
            || ''
        );
        if (provider.includes('kolbo') || provider.includes('evolink')) {
            const modelKey = this.imageAssetModelKey(item);
            const option = (this.generationModelOptions.image || []).find(
                (candidate: any) => candidate.value === modelKey
            );
            if (option) return option.label;
        }
        if (provider.includes('openai') || model.toLowerCase().includes('gpt-image')) {
            return model.toLowerCase().includes('gpt-image-2.5')
                ? 'OpenAI · GPT Image 2.5 Sunburst'
                : 'OpenAI · GPT Image 2';
        }
        if (provider.includes('kling') || model.toLowerCase().includes('kling-v2-1') || model.toLowerCase().includes('kling-v3')) {
            return 'Kling AI · Image 2.1';
        }
        const evolinkModelKey = this.evolinkImageModelKey(model);
        if (evolinkModelKey) {
            const option = (this.generationModelOptions.image || []).find(
                (candidate: any) => candidate.value === evolinkModelKey
            );
            if (option) return option.label;
        }
        if (model) return model;
        const key = String(this.selectedGenerationModelKeys?.image || '');
        const option = (this.generationModelOptions.image || []).find(
            (candidate: any) => candidate.value === key
        );
        return option?.label || '-';
    }

    public selectedAssetStatusLabel(item: any) {
        if (!item) return '-';
        const data = this.primaryMetadata(item);
        return this.statusLabel(
            data?.review_status || item?.review_status || item?.status || ''
        );
    }

    public selectedAssetCostLabel(item: any) {
        return this.generationUsageAvailable(item)
            ? this.generationCostLabel(item)
            : '-';
    }

    public currentGenerationCostLabel() {
        if (this.form.media_type === 'audio') return '사용량에 따라 과금';
        const item = this.visibleGenerationCostItem();
        return item ? this.generationCostLabel(item) : '요청 후 계산';
    }

    public isSelectedSource(asset: any) {
        return this.isSelectedVideoSource(asset) || this.isSelectedAudioSource(asset);
    }

    public intensityBatchJobs() {
        const batchId = String(this.latestIntensityBatchId || '');
        if (!batchId) return [];
        return (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => String(job?.intensity_batch_id || '') === batchId)
            .sort((left: any, right: any) => {
                const intensityDiff = this.jobIntensity(left) - this.jobIntensity(right);
                if (intensityDiff) return intensityDiff;
                return Number(left?.candidate_index || 0) - Number(right?.candidate_index || 0);
            });
    }

    public intensityBatchModelLabel() {
        const job = this.intensityBatchJobs()[0];
        return job ? this.progressModelLabel(job) : '이미지';
    }

    public imageCandidateBatchJobs() {
        const batchId = String(this.latestImageCostBatchId || '');
        if (!batchId || this.latestIntensityBatchId) return [];
        return (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => (
                this.mediaType(job) === 'image'
                && String(job?.candidate_batch_id || '') === batchId
                && !String(job?.intensity_batch_id || '')
            ))
            .sort((left: any, right: any) => (
                Number(left?.candidate_index || 0)
                - Number(right?.candidate_index || 0)
            ));
    }

    public imageCandidateBatchModelLabel() {
        const job = this.imageCandidateBatchJobs()[0];
        return job ? this.progressModelLabel(job) : '이미지';
    }

    public imageCandidateBatchProgress() {
        const jobs = this.imageCandidateBatchJobs();
        if (jobs.length === 0) return 0;
        return Math.round(
            jobs.reduce(
                (total: number, job: any) => total + this.jobProgress(job),
                0
            ) / jobs.length
        );
    }

    public imageCandidateBatchRetryableJobs() {
        return this.imageCandidateBatchJobs().filter(
            (job: any) => this.canRetry(job)
        );
    }

    public intensityBatchProgress() {
        const jobs = this.intensityBatchJobs();
        if (jobs.length === 0) return 0;
        return Math.round(
            jobs.reduce((total: number, job: any) => total + this.jobProgress(job), 0)
            / jobs.length
        );
    }

    public intensityBatchRows() {
        const jobs = this.intensityBatchJobs();
        return this.intensityOptions.map((intensity: number) => {
            const rows = jobs.filter((job: any) => this.jobIntensity(job) === intensity);
            const completed = rows.filter((job: any) => [
                'review_pending', 'approved', 'rejected', 'quarantined'
            ].includes(String(job?.status || '').toLowerCase())).length;
            const failed = rows.filter((job: any) =>
                String(job?.status || '').toLowerCase() === 'failed'
            ).length;
            const cancelled = rows.filter((job: any) =>
                String(job?.status || '').toLowerCase() === 'cancelled'
            ).length;
            const progress = rows.length
                ? Math.round(rows.reduce(
                    (total: number, job: any) => total + this.jobProgress(job),
                    0
                ) / rows.length)
                : 0;
            return {
                intensity,
                total: rows.length,
                completed,
                failed,
                cancelled,
                progress
            };
        });
    }

    public canCancelIntensityBatch() {
        return this.intensityBatchJobs().some((job: any) => [
            'queued', 'running', 'postprocessing'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public canRetryIntensityBatch() {
        const retryable = this.intensityBatchJobs().filter((job: any) => [
            'failed', 'cancelled'
        ].includes(String(job?.status || '').toLowerCase()));
        return retryable.length > 0 && retryable.every(
            (job: any) => this.jobGenerationModelAvailable(job)
        );
    }

    public async cancelIntensityBatch() {
        if (!this.can('content.write') || !this.canCancelIntensityBatch() || this.intensityBatchAction) return;
        const confirmed = await this.service.modal.show({
            title: '강도별 이미지 생성 취소',
            message: '아직 완료되지 않은 강도 1~5 이미지 생성 작업을 모두 취소합니다.',
            action: '일괄 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.intensityBatchAction = true;
        try {
            const { code, data } = await wiz.call('cancel_intensity_batch', {
                intensity_batch_id: this.latestIntensityBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 생성을 취소하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.intensityBatchAction = false;
            await this.service.render();
        }
    }

    public async retryIntensityBatch() {
        if (!this.can('content.write') || !this.canRetryIntensityBatch() || this.intensityBatchAction) return;
        this.intensityBatchAction = true;
        try {
            const { code, data } = await wiz.call('retry_intensity_batch', {
                intensity_batch_id: this.latestIntensityBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 생성을 다시 시도하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.intensityBatchAction = false;
            await this.service.render();
        }
    }

    public videoBatchJobs() {
        const batchId = String(this.latestVideoBatchId || '');
        if (!batchId) return [];
        return (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => String(job?.video_batch_id || '') === batchId)
            .sort((left: any, right: any) => this.jobIntensity(left) - this.jobIntensity(right));
    }

    public videoBatchProgress() {
        const jobs = this.videoBatchJobs();
        if (jobs.length === 0) return 0;
        return Math.round(jobs.reduce(
            (total: number, job: any) => total + this.jobProgress(job),
            0
        ) / jobs.length);
    }

    public canCancelVideoBatch() {
        return this.videoBatchJobs().some((job: any) => [
            'queued', 'running', 'postprocessing'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public canRetryVideoBatch() {
        return this.videoBatchJobs().some((job: any) => [
            'failed', 'cancelled'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public async cancelVideoBatch() {
        if (!this.can('content.write') || !this.canCancelVideoBatch() || this.videoBatchAction) return;
        const confirmed = await this.service.modal.show({
            title: '강도별 영상 생성 취소',
            message: '아직 완료되지 않은 강도별 영상 작업을 모두 취소합니다.',
            action: '일괄 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.videoBatchAction = true;
        try {
            const { code, data } = await wiz.call('cancel_video_batch', {
                video_batch_id: this.latestVideoBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 영상 생성을 취소하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.videoBatchAction = false;
            await this.service.render();
        }
    }

    public async retryVideoBatch() {
        if (!this.can('content.write') || !this.canRetryVideoBatch() || this.videoBatchAction) return;
        this.videoBatchAction = true;
        try {
            const { code, data } = await wiz.call('retry_video_batch', {
                video_batch_id: this.latestVideoBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 영상 생성을 다시 시도하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.videoBatchAction = false;
            await this.service.render();
        }
    }

    public activeJob() {
        const targetType = this.normalizeMediaType(this.form.media_type) || 'image';
        return (Array.isArray(this.jobs) ? this.jobs : []).find((job: any) =>
            this.mediaType(job) === targetType
            &&
            ['queued', 'running', 'postprocessing'].includes(
                String(job?.status || '').toLowerCase()
            )
        ) || null;
    }

    public progressJob() {
        if (!this.progressJobId) return null;
        return (Array.isArray(this.jobs) ? this.jobs : []).find(
            (job: any) => this.jobId(job) === this.progressJobId
        ) || null;
    }

    public activeJobSummary() {
        const job = this.activeJob();
        if (!job) {
            if (!this.contentSourceSelected()) {
                return this.sourceMode === 'scenario'
                    ? '시나리오를 선택하면 작업 상태가 표시됩니다.'
                    : '환자를 선택하면 작업 상태가 표시됩니다.';
            }
            return '현재 진행 중인 생성 작업이 없습니다.';
        }
        const model = this.progressModelLabel(job);
        const candidate = this.candidateLabel(job);
        const label = candidate
            || this.modalityLabel(job) + ' · 강도 ' + this.jobIntensity(job);
        return model + ' · ' + label + ' · ' + this.statusLabel(job.status);
    }

    public progressStatusDescription(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (job?.cancel_requested && ['queued', 'running', 'postprocessing'].includes(status)) {
            return '취소 요청을 전달했습니다. worker가 안전하게 작업을 중단한 뒤 상태가 갱신됩니다.';
        }
        const descriptions: any = {
            queued: '요청이 등록되어 worker 대기열에서 실행 순서를 기다리고 있습니다.',
            running: 'worker가 원본 자산을 확인하고 선택한 AI 모델로 생성을 진행하고 있습니다.',
            postprocessing: '생성 결과의 형식과 무결성을 확인한 뒤 안전한 저장소에 보관하고 있습니다.',
            review_pending: '생성이 완료되어 콘텐츠 자산으로 저장되었습니다.',
            approved: '생성이 완료되고 안전 검토를 통과했습니다.',
            rejected: '생성 결과가 검토에서 반려되었습니다.',
            quarantined: '외부 모델 생성은 완료됐으며 안전 검토 전까지 격리되어 있습니다.',
            cancelled: '사용자 요청으로 생성 작업이 취소되었습니다.'
        };
        if (status === 'failed') return this.jobErrorMessage(job);
        return descriptions[status] || '서버에서 최신 작업 상태를 확인하고 있습니다.';
    }

    public progressStageRows(job: any) {
        const status = String(job?.status || '').toLowerCase();
        const success = ['review_pending', 'approved', 'rejected', 'quarantined'].includes(status);
        const stageIndex: any = { queued: 1, running: 2, postprocessing: 3 };
        const current = stageIndex[status];
        const errorIndex = job?.started_at ? 2 : 1;
        const stages = [
            { label: '요청 등록', description: '생성 요청과 설정을 안전하게 등록했습니다.' },
            { label: '대기열 배정', description: 'worker가 실행할 작업 순서를 확인합니다.' },
            { label: 'AI 모델 생성', description: '선택한 모델이 원본 자산으로 결과를 생성합니다.' },
            { label: '결과 검증·저장', description: '결과 형식과 무결성을 검사하고 저장합니다.' },
            { label: '생성 완료', description: '콘텐츠 자산으로 등록하고 검토 상태를 반영합니다.' }
        ];
        return stages.map((stage: any, index: number) => {
            let state = 'pending';
            if (success) state = 'complete';
            else if (status === 'failed' || status === 'cancelled') {
                if (index < errorIndex) state = 'complete';
                else if (index === errorIndex) state = 'error';
            } else if (Number.isInteger(current)) {
                if (index < current) state = 'complete';
                else if (index === current) state = 'current';
            }
            return { ...stage, state };
        });
    }

    public progressModelLabel(job: any) {
        const model = String(job?.model_name || job?.model || '').toLowerCase();
        const provider = String(job?.provider_name || job?.provider || '').toLowerCase();
        if (this.mediaType(job) === 'audio') {
            return this.audioAssetModelLabel(job);
        }
        const evolinkImageLabels: any = {
            'doubao-seedream-5.0-lite': 'Seedream 5.0 Lite',
            'gemini-3.1-flash-image': 'Gemini 3.1 Flash Image',
            'qwen-image-3.0': 'Qwen Image 3.0',
            'grok-imagine-image-2.0': 'Grok Imagine Image 2.0'
        };
        if (evolinkImageLabels[model]) return evolinkImageLabels[model];
        if (model.includes('kling') || provider.includes('kling')) return 'Kling AI · Video 3.0';
        const evolinkVideoKey = this.evolinkVideoModelKey(model);
        const evolinkVideoOption = (this.generationModelOptions.video || []).find(
            (item: any) => item.value === evolinkVideoKey
        );
        if (evolinkVideoOption) return evolinkVideoOption.label;
        if (provider.includes('evolink')) return 'Seedance 2.5';
        if (model.includes('wan') || provider.includes('comfy')) return 'Wan 2.2';
        if (model.includes('gpt-image-2.5')) return 'OpenAI · GPT Image 2.5 Sunburst';
        if (model.includes('gpt-image') || provider.includes('openai')) return 'OpenAI · GPT Image 2';
        return String(job?.model_name || job?.model || job?.provider_name || job?.provider || '-');
    }

    public progressDetailRows(job: any) {
        const rows: any[] = [
            { label: '생성 모델', value: this.progressModelLabel(job) },
            { label: '현재 상태', value: this.statusLabel(job?.status) }
        ];
        if (this.mediaType(job) === 'video') {
            rows.push({ label: '영상 길이', value: `${this.videoDurationForJob(job)}초` });
        }
        rows.push(
            { label: '요청 시각', value: this.formatDate(job?.created_at || job?.created) },
            { label: '시작 시각', value: this.formatDate(job?.started_at) },
            { label: '경과 시간', value: this.progressElapsedLabel(job) },
            { label: '시도 횟수', value: `${Math.max(0, Number(job?.attempt_count || 0))} / ${Math.max(1, Number(job?.max_attempts || 3))}회` }
        );
        return rows;
    }

    public progressElapsedLabel(job: any) {
        const started = new Date(job?.started_at || job?.created_at || job?.created || 0).getTime();
        if (!Number.isFinite(started) || started <= 0) return '-';
        const status = String(job?.status || '').toLowerCase();
        const terminal = ['review_pending', 'approved', 'rejected', 'failed', 'cancelled', 'quarantined'].includes(status);
        const finished = terminal
            ? new Date(job?.completed_at || job?.updated_at || job?.updated || Date.now()).getTime()
            : Date.now();
        const seconds = Math.max(0, Math.floor((finished - started) / 1000));
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const remainder = seconds % 60;
        if (minutes < 60) return remainder > 0 ? `${minutes}분 ${remainder}초` : `${minutes}분`;
        const hours = Math.floor(minutes / 60);
        const minuteRemainder = minutes % 60;
        return minuteRemainder > 0 ? `${hours}시간 ${minuteRemainder}분` : `${hours}시간`;
    }

    public progressEstimateLabel(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (['review_pending', 'approved', 'rejected', 'failed', 'cancelled', 'quarantined'].includes(status)) {
            return '작업 종료';
        }
        if (this.mediaType(job) === 'video') return this.videoEstimateLabel(job);
        return '3초마다 최신 상태 자동 갱신';
    }

    public videoEstimateLabel(job: any = null) {
        const estimate = this.videoEstimateSeconds(job);
        const prefix = job ? '예상 완료까지' : '예상 소요 시간';
        return `${prefix} 약 ${this.durationRangeLabel(estimate.low, estimate.high)}`;
    }

    public videoEstimateBasisLabel() {
        const distribution = this.videoLatencyDistribution();
        return distribution.count > 0
            ? `최근 완료된 영상 ${distribution.count}건의 실제 처리시간 기준입니다.`
            : '완료 이력이 부족해 영상 길이 기준 범위로 안내합니다.';
    }

    public latestActivityDate() {
        const values = [
            ...(Array.isArray(this.jobs) ? this.jobs : []),
            ...(Array.isArray(this.assets) ? this.assets : [])
        ];
        if (values.length === 0) return '-';
        const latest = [...values].sort((left: any, right: any) => {
            const leftTime = new Date(
                left?.updated_at || left?.created_at || left?.created || 0
            ).getTime();
            const rightTime = new Date(
                right?.updated_at || right?.created_at || right?.created || 0
            ).getTime();
            return rightTime - leftTime;
        })[0];
        return this.formatDate(
            latest?.updated_at || latest?.created_at || latest?.created
        );
    }

    public assetReviewStatusLabel(asset: any) {
        const status = this.assetReviewStatus(asset);
        const labels: any = {
            approved: '승인',
            pending: '생성 완료',
            review_pending: '생성 완료',
            rejected: '반려',
            quarantined: '격리'
        };
        return {
            status: status || 'pending',
            label: labels[status] || '확인 필요'
        };
    }

    public patientOverviewCards() {
        const patient = this.selectedPatientOption();
        const jobs = Array.isArray(this.jobs) ? this.jobs : [];
        const assets = Array.isArray(this.assets) ? this.assets : [];
        const activeStatuses = ['queued', 'running', 'postprocessing'];
        const inProgress = jobs.filter((job: any) =>
            activeStatuses.includes(String(job?.status || '').toLowerCase())
        ).length;
        const restricted = assets.filter((asset: any) =>
            ['rejected', 'quarantined'].includes(this.assetReviewStatus(asset))
            || this.assetSafetyStatus(asset) !== 'passed'
        ).length;
        const readyToUse = assets.filter((asset: any) =>
            ['pending', 'review_pending', 'approved'].includes(
                this.assetReviewStatus(asset)
            )
            && this.assetSafetyStatus(asset) === 'passed'
        ).length;
        const mediaCounts = ['image', 'audio', 'video'].reduce(
            (result: any, mediaType: string) => {
                result[mediaType] = assets.filter(
                    (asset: any) => this.mediaType(asset) === mediaType
                ).length;
                return result;
            },
            {}
        );
        const mediaSummary = [
            mediaCounts.image ? '이미지 ' + this.formatCount(mediaCounts.image) : '',
            mediaCounts.audio ? '오디오 ' + this.formatCount(mediaCounts.audio) : '',
            mediaCounts.video ? '영상 ' + this.formatCount(mediaCounts.video) : ''
        ].filter(Boolean).join(' · ') || '생성 자산 없음';
        const prompt = this.selectedPatientPromptSummary();

        return [
            {
                label: '선택 환자',
                value: this.patientLabel(patient),
                note: '현재 작업 범위',
                tone: 'bg-indigo-500'
            },
            {
                label: '승인 프롬프트',
                value: prompt.value,
                note: prompt.note,
                tone: prompt.tone
            },
            {
                label: '생성 진행',
                value: this.formatCount(inProgress) + '건',
                note: '대기·생성·후처리',
                tone: inProgress > 0 ? 'bg-blue-500' : 'bg-gray-300'
            },
            {
                label: '생성 완료',
                value: this.formatCount(assets.length) + '개',
                note: mediaSummary,
                tone: assets.length > 0 ? 'bg-cyan-500' : 'bg-gray-300'
            },
            {
                label: '사용 제한',
                value: this.formatCount(restricted) + '건',
                note: '안전 미통과·격리',
                tone: restricted > 0 ? 'bg-amber-500' : 'bg-emerald-500'
            },
            {
                label: '사용 가능',
                value: this.formatCount(readyToUse) + '개',
                note: '생성 완료·안전 통과',
                tone: readyToUse > 0 ? 'bg-emerald-500' : 'bg-gray-300'
            }
        ];
    }

    public selectedPatientPromptSummary() {
        if (this.selectedPatientPromptReady()) {
            return {
                value: '승인 완료',
                note: '생성에 사용 가능',
                tone: 'bg-emerald-500'
            };
        }
        const status = this.selectedPatientPromptStatus();
        const values: any = {
            review_required: {
                value: '검토 필요',
                note: '임상의 승인 대기',
                tone: 'bg-amber-500'
            },
            stale: {
                value: '재생성 필요',
                note: '상황 설명 변경됨',
                tone: 'bg-orange-500'
            },
            draft_missing: {
                value: '초안 필요',
                note: 'AI 초안 미생성',
                tone: 'bg-blue-500'
            }
        };
        return values[status] || {
            value: '준비 필요',
            note: '상황 설명 확인',
            tone: 'bg-gray-300'
        };
    }

    private assetReviewStatus(item: any) {
        const data = this.primaryMetadata(item);
        return String(
            data?.review_status || item?.review_status || item?.status || ''
        ).toLowerCase();
    }

    private assetSafetyStatus(item: any) {
        const data = this.primaryMetadata(item);
        return String(
            data?.safety_status || item?.safety_status || ''
        ).toLowerCase();
    }

    public metricCards() {
        const metrics = this.metricPayload(this.metrics);
        const queue = metrics?.queue_depth || metrics?.queue || {};
        const outcomes = metrics?.outcomes || {};
        const dlq = metrics?.dlq || {};
        const latency = metrics?.latency_ms?.total || metrics?.latency?.total || metrics?.latency_ms || {};
        const cost = metrics?.cost_micros || metrics?.cost || {};
        const queueTotal = Number(queue?.total ?? queue?.queued ?? metrics?.queued ?? 0);
        const generated = Number(outcomes?.generated ?? outcomes?.succeeded ?? metrics?.success ?? 0);
        const failed = Number(outcomes?.failed ?? metrics?.failure ?? metrics?.failed ?? 0);
        const p95 = Number(latency?.p95 ?? latency?.p95_ms ?? latency?.max ?? 0);
        const costMicros = Number(cost?.total ?? metrics?.cost_total_micros ?? 0);
        return [
            { label: '처리 대기', value: this.formatCount(queueTotal), note: 'Queue 대기·진행', tone: 'bg-blue-50 text-blue-700' },
            { label: '오류 보류', value: this.formatCount(Number(dlq?.open ?? metrics?.open_dlq ?? 0)), note: 'DLQ 운영 확인 필요', tone: 'bg-orange-50 text-orange-700' },
            { label: '24시간 성공', value: this.formatCount(generated), note: '생성 완료', tone: 'bg-emerald-50 text-emerald-700' },
            { label: '24시간 실패', value: this.formatCount(failed), note: '최종 실패', tone: 'bg-red-50 text-red-700' },
            { label: 'P95 처리시간', value: p95 > 0 ? this.formatLatency(p95) : '-', note: '전체 처리 지연', tone: 'bg-violet-50 text-violet-700' },
            { label: '추정 비용', value: this.formatCost(costMicros), note: '최근 24시간 누적', tone: 'bg-cyan-50 text-cyan-700' }
        ];
    }

    public metricsScopeLabel() {
        const scope = String(this.metrics?.scope || '').toLowerCase();
        if (scope === 'patient') return '선택 환자 범위';
        if (scope === 'assigned') return '담당 환자 범위';
        if (scope === 'review') return '검수 가능 범위';
        return '전체 운영 범위';
    }

    public formatCount(value: number) {
        return Number.isFinite(value) ? new Intl.NumberFormat('ko-KR').format(value) : '0';
    }

    public formatLatency(milliseconds: number) {
        if (!Number.isFinite(milliseconds) || milliseconds <= 0) return '-';
        if (milliseconds >= 1000) return (milliseconds / 1000).toFixed(milliseconds >= 10000 ? 0 : 1) + '초';
        return Math.round(milliseconds) + 'ms';
    }

    public formatCost(micros: number) {
        if (!Number.isFinite(micros) || micros <= 0) return 'US$0.0000';
        return 'US$' + (micros / 1000000).toFixed(4);
    }

    public generationUsage(item: any) {
        const usage = item?.generation_usage || item?.asset?.generation_usage;
        return usage && typeof usage === 'object' ? usage : {};
    }

    public generationUsageAvailable(item: any) {
        return this.generationUsage(item)?.available === true;
    }

    public generationCostLabel(item: any) {
        const usage = this.generationUsage(item);
        const pricingStatus = String(usage?.pricing_status || '').toLowerCase();
        if (pricingStatus === 'no_charge') return '과금 없음';
        if (pricingStatus === 'unpriced' || pricingStatus === 'unpriced_legacy') {
            return '요금 미설정';
        }
        return this.formatCost(Number(usage?.cost_micros || 0));
    }

    public generationUsageDetail(item: any) {
        const usage = this.generationUsage(item);
        const provider = String(usage?.provider_name || '').trim();
        const model = String(usage?.model_name || '').trim();
        const tokens = Number(usage?.total_tokens || 0);
        const requests = Number(usage?.requests || 0);
        const parts = [provider, model].filter((value: string) => !!value);
        if (tokens > 0) parts.push(this.formatCount(tokens) + ' tokens');
        if (requests > 1) parts.push(this.formatCount(requests) + '회 시도');
        return parts.join(' · ') || '사용량 기록 완료';
    }

    public latestGenerationCostJob() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        return this.jobs
            .filter((job: any) => (
                this.mediaType(job) === mediaType
                && this.generationUsageAvailable(job)
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || ''
                ) || 0;
                return rightTime - leftTime;
            })[0] || null;
    }

    public visibleGenerationCostItem() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        if (mediaType !== 'video') return this.latestGenerationCostJob();

        const modelKey = this.effectiveVideoResultModelKey();
        if (modelKey === 'all') return null;
        return this.videoComparisonAssets()
            .filter((asset: any) => (
                this.videoAssetModelKey(asset) === modelKey
                && this.generationUsageAvailable(asset)
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || left?.created || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || right?.created || ''
                ) || 0;
                return rightTime - leftTime;
            })[0] || null;
    }

    public generationCostCardTitle() {
        return this.normalizeMediaType(this.form.media_type) === 'video'
            ? '선택 영상 생성 비용'
            : '이번 생성 예상 비용';
    }

    public statusLabel(status: string) {
        const labels: any = {
            queued: '대기',
            running: '생성 중',
            postprocessing: '후처리',
            review_pending: '생성 완료',
            pending: '생성 완료',
            approved: '승인',
            rejected: '반려',
            failed: '실패',
            cancelled: '취소',
            quarantined: '격리'
        };
        return labels[String(status || '').toLowerCase()] || status || '상태 확인 중';
    }

    public jobErrorMessage(job: any) {
        const messages: any = {
            generation_context_unavailable: '생성 조건 확인 중 작업이 중단됐습니다. 실패한 작업을 재시도해주세요.',
            scenario_context_unavailable: '원본 시나리오 또는 생성 프롬프트를 확인할 수 없습니다. 시나리오를 다시 선택해주세요.',
            scenario_context_changed: '시나리오의 생성 기준이 변경되었습니다. 현재 컷에서 새로 생성해주세요.',
            scenario_cut_analysis_stale: '분석 이후 원문이 변경되었습니다. 다시 분석한 뒤 새로 생성해주세요.',
            openai_not_configured: 'OpenAI API 설정을 확인해주세요.',
            openai_auth_failed: 'OpenAI API 인증에 실패했습니다.',
            openai_permission_denied: 'OpenAI 이미지 모델 사용 권한이 없습니다.',
            openai_model_unavailable: '설정된 OpenAI 이미지 모델을 사용할 수 없습니다.',
            openai_request_rejected: 'OpenAI가 이미지 생성 요청을 거부했습니다.',
            openai_quota_exhausted: 'OpenAI 사용 한도 또는 크레딧을 확인해주세요.',
            openai_rate_limited: 'OpenAI 요청이 많습니다. 잠시 후 재시도해주세요.',
            openai_unavailable: 'OpenAI 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            openai_generation_failed: 'OpenAI 이미지 생성 중 일시적 오류가 발생했습니다.',
            kling_image_not_configured: 'Kling 이미지 API 설정을 확인해주세요.',
            kling_image_auth_failed: 'Kling 이미지 API 인증에 실패했습니다.',
            kling_image_permission_denied: 'Kling Image 2.1 사용 권한이 없습니다.',
            kling_image_quota_exhausted: 'Kling 이미지 사용 한도 또는 크레딧을 확인해주세요.',
            kling_image_rate_limited: 'Kling 이미지 요청이 많습니다. 잠시 후 재시도해주세요.',
            kling_image_request_rejected: 'Kling이 이미지 생성 요청을 거부했습니다.',
            kling_image_unavailable: 'Kling 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            kling_image_timed_out: 'Kling 이미지 생성 대기 시간이 초과되었습니다.',
            kling_image_generation_failed: 'Kling 이미지 생성에 실패했습니다.',
            kling_image_output_invalid: 'Kling 이미지 결과를 검증하지 못했습니다.',
            evolink_image_not_configured: 'EvoLink 이미지 API 설정을 확인해주세요.',
            evolink_image_auth_failed: 'EvoLink 이미지 API 인증에 실패했습니다.',
            evolink_image_permission_denied: '선택한 EvoLink 이미지 모델 사용 권한이 없습니다.',
            evolink_image_model_unavailable: '선택한 EvoLink 이미지 모델을 현재 사용할 수 없습니다.',
            evolink_image_quota_exhausted: 'EvoLink 이미지 사용 한도 또는 크레딧을 확인해주세요.',
            evolink_image_rate_limited: 'EvoLink 이미지 요청이 많습니다. 잠시 후 재시도해주세요.',
            evolink_image_request_rejected: 'EvoLink가 이미지 생성 요청을 거부했습니다.',
            evolink_image_unavailable: 'EvoLink 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            evolink_image_timed_out: 'EvoLink 이미지 생성 대기 시간이 초과되었습니다.',
            evolink_image_generation_failed: 'EvoLink 이미지 생성에 실패했습니다.',
            evolink_image_output_invalid: 'EvoLink 이미지 결과를 검증하지 못했습니다.',
            comfyui_unavailable: 'Wan 2.2 영상 서버에 연결할 수 없습니다. GPU 연결 상태를 확인해주세요.',
            generation_runtime_error: '이미지 생성 중 일시적 오류가 발생했습니다. 재시도해주세요.',
            invalid_generation_result: '생성 결과를 검증하지 못했습니다.'
        };
        const code = String(job?.error_code || job?.last_error_code || '').toLowerCase();
        if (messages[code]) return messages[code];
        const raw = String(job?.error_message || job?.last_error_message || '').trim();
        if (raw === 'generation context is no longer eligible') return messages.generation_context_unavailable;
        if (raw && raw !== 'media generation failed' && raw !== 'media generation validation failed') return raw;
        return '이미지 생성에 실패했습니다. 재시도해주세요.';
    }

    public statusClass(status: string) {
        switch (String(status || '').toLowerCase()) {
            case 'approved':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'running':
            case 'postprocessing':
                return 'border-indigo-200 bg-indigo-50 text-indigo-700';
            case 'review_pending':
            case 'pending':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'rejected':
            case 'failed':
                return 'border-red-200 bg-red-50 text-red-700';
            case 'quarantined':
                return 'border-orange-200 bg-orange-50 text-orange-700';
            case 'cancelled':
                return 'border-gray-200 bg-gray-50 text-gray-600';
            default:
                return 'border-blue-200 bg-blue-50 text-blue-700';
        }
    }

    public jobProgress(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (['review_pending', 'approved', 'rejected', 'quarantined'].includes(status)) {
            return 100;
        }
        const explicit = Number(job?.progress_percent ?? job?.progress);
        if (Number.isFinite(explicit)) return Math.max(0, Math.min(100, explicit));
        const values: any = {
            queued: 5,
            running: 45,
            postprocessing: 80,
            review_pending: 100,
            approved: 100,
            rejected: 100,
            failed: 100,
            cancelled: 100,
            quarantined: 100
        };
        return values[String(job?.status || '').toLowerCase()] ?? 0;
    }

    public canCancel(job: any) {
        if (job?.cancel_requested) return false;
        return ['queued', 'running', 'postprocessing'].includes(String(job?.status || '').toLowerCase());
    }

    public canDeleteJob(item: any) {
        const data = this.primaryMetadata(item);
        const status = String(
            item?.status || data?.review_status || item?.review_status || ''
        ).toLowerCase();
        return [
            'review_pending',
            'pending',
            'approved',
            'rejected',
            'failed',
            'cancelled',
            'quarantined'
        ].includes(status);
    }

    public canRetry(job: any) {
        return ['failed', 'cancelled'].includes(String(job?.status || '').toLowerCase())
            && this.jobGenerationModelAvailable(job);
    }

    public pageCount() {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public async changePage(nextPage: number) {
        const target = Math.max(1, Math.min(this.pageCount(), nextPage));
        if (target === this.page || this.searching) return;
        this.page = target;
        await this.search(true, false);
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return new Intl.DateTimeFormat('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    private normalizeCandidateCount(value: any) {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 3;
        return Math.max(1, Math.min(5, Math.round(numeric)));
    }

    private normalizeIntensityValue(value: any) {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 1;
        return Math.max(1, Math.min(5, Math.round(numeric)));
    }

    private normalizeScenarioRouteId(value: any) {
        const scenarioSetId = String(value || '').trim().toUpperCase();
        return /^(?:[A-Z]{2}-\d{2}|[A-Z]\d{2}|IM[0-9A-F]{14})$/.test(scenarioSetId)
            ? scenarioSetId
            : '';
    }

    private normalizeScenarioMemoryKind(value: any): 'trauma' | 'positive' {
        return String(value || '').trim().toLowerCase() === 'positive'
            ? 'positive'
            : 'trauma';
    }

    private async syncContentRouteState() {
        const scenarioMode = this.sourceMode === 'scenario';
        const patientId = scenarioMode
            ? ''
            : this.normalizeRequestedPatientId(this.form.patient_id);
        const scenarioSetId = scenarioMode
            ? this.normalizeScenarioRouteId(
                this.scenarioSelection.scenario_set_id
            )
            : '';
        const memoryKind = scenarioMode
            ? this.normalizeScenarioMemoryKind(
                this.scenarioSelection.memory_kind
            )
            : '';
        const patientMemoryMode = scenarioMode ? '' : this.patientMemoryMode;
        const resourceMemoryId = (
            !scenarioMode && this.patientMemoryMode === 'resource'
        ) ? this.normalizeRequestedPatientId(this.selectedResourceMemoryId) : '';

        this.requestedPatientId = patientId;
        this.requestedPatientParameterPresent = !!patientId;
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                patient_id: patientId || null,
                source: scenarioMode ? 'scenario' : null,
                scenario: scenarioSetId || null,
                memory: memoryKind || null,
                memory_mode: patientMemoryMode === 'resource' ? 'resource' : null,
                resource_memory_id: resourceMemoryId || null
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private csrfToken() {
        return this.csrfTokenValue || this.service.auth?.session?.csrf_token || '';
    }

    private previewRefreshKey(item: any, signedUrl: string = '') {
        const fallbackId = this.assetId(item) || this.jobId(item);
        const url = this.safeSignedUrl(signedUrl);
        if (!url) return fallbackId ? fallbackId + ':master' : '';
        const query = url.slice(url.indexOf('?') + 1);
        const params = new URLSearchParams(query);
        const revisionId = params.get('id') || fallbackId;
        const artifactId = params.get('artifact') || 'master';
        return revisionId ? revisionId + ':' + artifactId : '';
    }

    private newIdempotencyKey() {
        return 'ui-' + Date.now() + '-' + this.service.random(32);
    }

    private extractList(payload: any, keys: string[]) {
        if (Array.isArray(payload)) return payload;
        for (const key of keys) {
            const value = payload?.[key];
            if (Array.isArray(value)) return value;
            if (Array.isArray(value?.items)) return value.items;
        }
        return [];
    }

    private hasListKey(payload: any, keys: string[]) {
        if (!payload || Array.isArray(payload)) return false;
        return keys.some((key: string) => Object.prototype.hasOwnProperty.call(payload, key));
    }

    private scenarioOptionsFromTemplates() {
        const seen: { [key: string]: boolean } = {};
        return this.templates
            .filter((template: any) => !template?.status || template.status === 'active')
            .filter((template: any) => {
                const value = String(template?.scenario_type || '');
                const mediaType = this.normalizeMediaType(template?.media_type || 'image') || 'image';
                const identity = mediaType + ':' + value;
                if (!value || seen[identity]) return false;
                seen[identity] = true;
                return true;
            })
            .map((template: any) => ({
                value: template.scenario_type,
                label: template.name || template.key || template.scenario_type,
                description: template.description || ('Prompt 템플릿 v' + (template.version || '-')),
                template_id: template.id || template.template_id,
                media_type: this.normalizeMediaType(template?.media_type || 'image') || 'image',
                version: template.version,
                positive_prompt_preview: template.positive_prompt_preview || '',
                negative_prompt_preview: template.negative_prompt_preview || ''
            }));
    }

    private applyDefaults() {
        if (!this.form.idempotency_key) this.form.idempotency_key = this.newIdempotencyKey();
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();
        this.selectedImageQuality = this.normalizeImageQuality(
            this.selectedImageQuality || this.selectedImagePricing()?.quality || 'low'
        );
        const patientIds = this.patients.map((patient: any) =>
            String(patient?.id || patient?.patient_id || '')
        );
        if (this.requestedPatientParameterPresent) {
            this.form.patient_id = this.requestedPatientId
                && patientIds.includes(this.requestedPatientId)
                ? this.requestedPatientId
                : '';
        } else if (!patientIds.includes(String(this.form.patient_id || ''))) {
            this.form.patient_id = '';
        }
        this.syncScenarioForSelectedPatient();
    }

    private syncScenarioForSelectedPatient() {
        if (this.sourceMode === 'scenario') return;
        if (this.patientMemoryMode === 'resource') {
            this.form.media_type = 'image';
            this.form.scenario_type = 'resource_memory';
            return;
        }
        const available = this.availableScenarios();
        const selectedPatient = this.selectedPatientOption();
        if (selectedPatient) {
            const sourceScenario = this.form.media_type === 'video'
                ? String(
                    this.selectedVideoSource?.scenario_type
                    || this.selectedVideoSource?.scenario
                    || ''
                ).trim()
                : '';
            if (sourceScenario && available.some(
                (item: any) => this.scenarioValue(item) === sourceScenario
            )) {
                this.form.scenario_type = sourceScenario;
                this.promptSelectionMode = 'source';
                this.promptMismatchAcknowledged = this.promptSelectionMismatch(
                    sourceScenario
                );
                return;
            }
            const configuredScenario = String(
                selectedPatient?.scenario_type || ''
            );
            this.form.scenario_type = configuredScenario && available.some(
                (item: any) => this.scenarioValue(item) === configuredScenario
            )
                ? configuredScenario
                : '';
            this.promptSelectionMode = this.form.scenario_type ? 'auto' : '';
            this.promptMismatchAcknowledged = false;
            return;
        }
        this.form.scenario_type = '';
        this.promptSelectionMode = '';
        this.promptMismatchAcknowledged = false;
    }

    private normalizeRequestedPatientId(value: any) {
        const requestedPatientId = String(value || '').trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(requestedPatientId)
            ? requestedPatientId
            : '';
    }

    private rememberedContentPatientId() {
        try {
            return this.normalizeRequestedPatientId(
                window.sessionStorage.getItem(this.contentPatientStorageKey)
            );
        } catch (_error) {
            return '';
        }
    }

    private rememberContentPatientId(value: any) {
        const patientId = this.normalizeRequestedPatientId(value);
        try {
            if (patientId) {
                window.sessionStorage.setItem(
                    this.contentPatientStorageKey,
                    patientId
                );
            } else {
                window.sessionStorage.removeItem(this.contentPatientStorageKey);
            }
        } catch (_error) {
        }
    }

    private selectedPatientCode() {
        const patient = this.selectedPatientOption();
        return String(
            patient?.patient_code || patient?.code || patient?.pseudonym || ''
        ).trim();
    }

    private recordMatchesSelectedPatient(record: any) {
        const selectedPatientId = this.normalizeRequestedPatientId(
            this.form.patient_id
        );
        if (!selectedPatientId || !record || typeof record !== 'object') {
            return false;
        }
        const recordPatientId = this.normalizeRequestedPatientId(
            record?.patient_id
            || record?.patient?.id
            || record?.patient?.patient_id
        );
        if (recordPatientId) return recordPatientId === selectedPatientId;

        const selectedPatientCode = this.selectedPatientCode();
        const recordPatientCode = String(
            record?.patient_code
            || record?.patient?.patient_code
            || record?.patient?.code
            || ''
        ).trim();
        return !!selectedPatientCode && recordPatientCode === selectedPatientCode;
    }

    private selectedScenarioSourceKey() {
        const scenarioSetId = String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase();
        const memoryKind = String(
            this.scenarioSelection.memory_kind || ''
        ).trim().toLowerCase();
        return scenarioSetId && ['trauma', 'positive'].includes(memoryKind)
            ? `${scenarioSetId}:${memoryKind}`
            : '';
    }

    private recordMatchesSelectedSource(record: any) {
        if (this.sourceMode === 'patient') {
            if (!this.recordMatchesSelectedPatient(record)) return false;
            const sourceKind = String(record?.source_kind || 'patient');
            if (this.patientMemoryMode === 'resource') {
                return sourceKind === 'resource'
                    && String(record?.source_key || '') === this.selectedResourceMemoryId;
            }
            return sourceKind !== 'resource';
        }
        const sourceKey = this.selectedScenarioSourceKey();
        return !!sourceKey
            && String(record?.source_kind || '') === 'scenario'
            && String(record?.source_key || '') === sourceKey;
    }

    private currentSourceMatches(
        patientId: string,
        scenarioSetId: string,
        memoryKind: string,
        patientMemoryMode: 'trauma' | 'resource',
        resourceMemoryId: string
    ) {
        if (this.sourceMode === 'patient') {
            return patientId === this.normalizeRequestedPatientId(this.form.patient_id)
                && patientMemoryMode === this.patientMemoryMode
                && resourceMemoryId === (
                    this.patientMemoryMode === 'resource'
                        ? this.normalizeRequestedPatientId(this.selectedResourceMemoryId)
                        : ''
                );
        }
        return scenarioSetId === String(
            this.scenarioSelection.scenario_set_id || ''
        ).trim().toUpperCase()
            && memoryKind === String(
                this.scenarioSelection.memory_kind || ''
            ).trim().toLowerCase();
    }

    private clearPatientContent() {
        if (this.workbenchCompareExpanded) void this.workbenchCloseComparison();
        this.workbenchClearImageResultFilter();
        this.jobs = [];
        this.assets = [];
        this.metrics = {};
        this.videoMetrics = {};
        this.total = 0;
        this.selectedAsset = null;
        this.selectedReviewAssetId = '';
        this.confirmedReviewAssetId = '';
        this.progressJobId = '';
        this.progressReturnFocus = null;
        this.clearPanoramaUiState();
        this.selectedVideoSource = null;
        this.selectedVideoResultModelKey = 'all';
        this.selectedAudioSource = null;
        this.workbenchAudioRequest = null;
        this.workbenchAudioJobSnapshots = {};
        this.workbenchVideoRequest = null;
        this.workbenchVideoJobSnapshots = {};
        this.patientSourceImages = [];
        this.selectedPatientSource = null;
        this.resetPatientSourceUpload();
        this.selectedIntensityVideoSources = {};
        this.latestVideoBatchId = '';
        this.clearLatestImageCostBatch();
    }

    private applySearchPayload(payload: any) {
        const patientScopeInvalid = this.sourceMode === 'patient' && (
            payload?.patient_scoped !== true
            || !this.normalizeRequestedPatientId(this.form.patient_id)
        );
        const scenarioScopeInvalid = this.sourceMode === 'scenario' && (
            payload?.scenario_scoped !== true
            || !this.selectedScenarioSourceKey()
        );
        if (patientScopeInvalid || scenarioScopeInvalid) {
            this.clearPatientContent();
            this.searchError = this.sourceMode === 'scenario'
                ? '선택한 시나리오의 콘텐츠 범위를 확인하지 못했습니다. 다시 시도해주세요.'
                : '선택한 환자의 콘텐츠 범위를 확인하지 못했습니다. 다시 시도해주세요.';
            return;
        }

        this.workbenchCutResults = this.sourceMode === 'scenario' && Array.isArray(payload?.scenario_cut_results)
            ? payload.scenario_cut_results : [];
        this.workbenchCutResultsSourceId = this.sourceMode === 'scenario'
            ? String(payload?.scenario_set_id || this.scenarioSelection.scenario_set_id || '').trim().toUpperCase() : '';

        const jobKeys = ['jobs', 'generation_jobs'];
        const assetKeys = ['assets', 'artifacts', 'media_assets'];
        const rawJobs = this.extractList(payload, jobKeys);
        const jobs = rawJobs.filter(
            (item: any) => this.recordMatchesSelectedSource(item)
        );
        const assets = this.extractList(payload, assetKeys)
            .filter((item: any) => this.recordMatchesSelectedSource(item));
        jobs.forEach((job: any) => {
            this.workbenchTrackAudioJob(job);
            this.workbenchTrackVideoJob(job);
        });
        this.page = Number(payload?.page || this.page || 1);
        this.dump = Number(payload?.dump || this.dump || 20);
        const metrics = this.metricPayload(payload?.metrics);
        this.metrics = this.sourceMode === 'patient'
            && String(metrics?.scope || '').toLowerCase() === 'patient'
            ? metrics
            : {};
        const videoMetrics = this.metricPayload(payload?.video_metrics);
        this.videoMetrics = this.sourceMode === 'patient'
            && String(videoMetrics?.scope || '').toLowerCase() === 'patient'
            ? videoMetrics
            : {};

        const retainedPanoramaJobs = this.jobs.filter((item: any) =>
            this.panoramaGenerationMode(item) === 'image_to_panorama'
            && this.recordMatchesSelectedSource(item)
        );
        const retainedPanoramaAssets = this.assets.filter((item: any) =>
            this.panoramaGenerationMode(item) === 'image_to_panorama'
            && this.recordMatchesSelectedSource(item)
        );
        if (this.hasListKey(payload, jobKeys)) {
            const incomingIds = new Set(jobs.map((item: any) => this.jobId(item)));
            this.jobs = [
                ...jobs,
                ...retainedPanoramaJobs.filter(
                    (item: any) => !incomingIds.has(this.jobId(item))
                )
            ];
        }
        if (this.hasListKey(payload, assetKeys)) {
            const incomingIds = new Set(assets.map((item: any) => this.assetId(item)));
            this.assets = [
                ...assets,
                ...retainedPanoramaAssets.filter(
                    (item: any) => !incomingIds.has(this.assetId(item))
                )
            ];
        }
        else if (this.hasListKey(payload, jobKeys)) {
            const incomingAssets = this.assetsFromJobs(jobs);
            const incomingIds = new Set(
                incomingAssets.map((item: any) => this.assetId(item))
            );
            this.assets = [
                ...incomingAssets,
                ...retainedPanoramaAssets.filter(
                    (item: any) => !incomingIds.has(this.assetId(item))
                )
            ];
        }

        if (!Array.isArray(payload) && Array.isArray(payload?.items)) {
            const items = payload.items.filter(
                (item: any) => this.recordMatchesSelectedSource(item)
            );
            const looksLikeAssets = items.some((item: any) =>
                !!(item?.asset_id || item?.artifact_id || item?.preview_url || item?.review_status)
            );
            if (looksLikeAssets && !this.hasListKey(payload, assetKeys)) this.assets = items;
            if (!looksLikeAssets && !this.hasListKey(payload, jobKeys)) this.jobs = items;
        }
        this.total = jobs.length === rawJobs.length
            ? Number(payload?.total ?? jobs.length)
            : jobs.length;
        if (this.workbenchImageResultSelection === this.workbenchImageResultSelectionKey()) {
            const cachedJobs = new Map((this.workbenchCollectedImageJobs || []).map((job: any) => [this.jobId(job), job]));
            const cachedAssets = new Map((this.workbenchCollectedImageAssets || []).map((asset: any) => [this.jobId(asset), asset]));
            jobs.forEach((job: any) => cachedJobs.set(this.jobId(job), job));
            this.assets.forEach((asset: any) => cachedAssets.set(this.jobId(asset), asset));
            this.workbenchCollectedImageJobs = [...cachedJobs.values()];
            this.workbenchCollectedImageAssets = [...cachedAssets.values()];
        }
        this.searchError = '';
        // Restore the most recent image run after a page reload. A newly
        // submitted single-intensity candidate batch deliberately keeps its
        // own id here, so the post-submit search cannot resurrect a historic
        // 1~5 progress card.
        if (!this.latestIntensityBatchId && !this.latestImageCostBatchId) {
            const latestBatchJob = [...this.jobs]
                .filter((job: any) => (
                    this.mediaType(job) === 'image'
                    && (
                        /^[0-9a-f]{32}$/.test(String(job?.intensity_batch_id || ''))
                        || /^[0-9a-f]{32}$/.test(String(job?.candidate_batch_id || ''))
                    )
                ))
                .sort((left: any, right: any) => {
                    const leftTime = Date.parse(left?.created_at || left?.created || '') || 0;
                    const rightTime = Date.parse(right?.created_at || right?.created || '') || 0;
                    return rightTime - leftTime;
                })[0];
            const intensityBatchId = String(
                latestBatchJob?.intensity_batch_id || ''
            );
            if (intensityBatchId) {
                this.latestIntensityBatchId = intensityBatchId;
            } else if (latestBatchJob) {
                this.latestImageCostBatchId = String(
                    latestBatchJob.candidate_batch_id || ''
                );
                this.latestImageCostModelKey = this.imageAssetModelKey(
                    latestBatchJob
                );
                this.latestImageCostCandidateCount = Math.max(
                    1,
                    Number(latestBatchJob.candidate_count || 1)
                );
            }
        }
        if (!this.latestVideoBatchId) {
            const latestVideoBatchJob = [...this.jobs]
                .filter((job: any) => /^[0-9a-f]{32}$/.test(
                    String(job?.video_batch_id || '')
                ))
                .sort((left: any, right: any) => {
                    const leftTime = Date.parse(left?.created_at || left?.created || '') || 0;
                    const rightTime = Date.parse(right?.created_at || right?.created || '') || 0;
                    return rightTime - leftTime;
                })[0];
            this.latestVideoBatchId = String(
                latestVideoBatchJob?.video_batch_id || ''
            );
        }
        const selectedId = this.assetId(this.selectedVideoSource);
        if (selectedId) {
            const refreshed = this.assets.find((item: any) => this.assetId(item) === selectedId);
            if (refreshed) this.selectedVideoSource = refreshed;
        }
        this.workbenchRestoreVideoSource();
        const selectedAudioId = this.assetId(this.selectedAudioSource);
        if (selectedAudioId) {
            const refreshedAudio = this.assets.find((item: any) => this.assetId(item) === selectedAudioId);
            if (refreshedAudio) this.selectedAudioSource = refreshedAudio;
            else if (this.normalizeMediaType(this.form.media_type) === 'audio') {
                this.selectedAudioSource = null;
            }
        }
        const refreshedIntensitySources: { [key: number]: any } = {};
        this.intensityOptions.forEach((intensity: number) => {
            const selected = this.selectedIntensityVideoSources[intensity];
            const selectedSourceId = this.assetId(selected);
            if (!selectedSourceId) return;
            const refreshedSource = this.assets.find(
                (item: any) => this.assetId(item) === selectedSourceId
            );
            if (refreshedSource) refreshedIntensitySources[intensity] = refreshedSource;
        });
        this.selectedIntensityVideoSources = refreshedIntensitySources;
        window.setTimeout(() => {
            void this.autoEvaluateMissingShotConsistency();
        }, 0);
    }

    private jobFromPayload(payload: any) {
        const candidate = payload?.job || payload?.generation_job || payload?.data || payload;
        if (!candidate || Array.isArray(candidate) || typeof candidate !== 'object') return null;
        if (!candidate.id && candidate.job_id) return { ...candidate, id: candidate.job_id };
        return candidate;
    }

    private videoEstimateSeconds(job: any = null) {
        const distribution = this.videoLatencyDistribution();
        let low = distribution.count > 0 ? distribution.avgSeconds : 0;
        let high = distribution.count > 0 ? distribution.p95Seconds : 0;
        if (low <= 0 || high <= 0) {
            const duration = this.videoDurationForJob(job);
            const fallback: any = {
                3: { low: 120, high: 300 },
                4: { low: 180, high: 420 },
                5: { low: 240, high: 480 },
                6: { low: 300, high: 600 },
                7: { low: 360, high: 720 },
                8: { low: 420, high: 780 },
                10: { low: 480, high: 900 },
                15: { low: 720, high: 1200 },
                20: { low: 900, high: 1500 }
            };
            const estimate = fallback[duration] || fallback[3];
            low = estimate.low;
            high = estimate.high;
        }

        const status = String(job?.status || '').toLowerCase();
        if (status === 'postprocessing') return { low: 30, high: 90 };
        if (job && status === 'running') {
            const startedAt = new Date(job?.started_at || job?.created_at || job?.created || 0).getTime();
            if (Number.isFinite(startedAt) && startedAt > 0) {
                const elapsed = Math.max(0, (Date.now() - startedAt) / 1000);
                low = Math.max(30, low - elapsed);
                high = Math.max(60, high - elapsed);
            }
        }
        return {
            low: Math.max(30, Math.min(low, high)),
            high: Math.max(60, Math.max(low, high))
        };
    }

    private videoLatencyDistribution() {
        const latency = this.videoMetrics?.latency_ms?.total || {};
        const count = Math.max(0, Number(latency?.count || 0));
        const avgSeconds = Math.max(0, Number(latency?.avg || 0) / 1000);
        const p95Seconds = Math.max(avgSeconds, Number(latency?.p95 || 0) / 1000);
        return {
            count: Number.isFinite(count) ? count : 0,
            avgSeconds: Number.isFinite(avgSeconds) ? avgSeconds : 0,
            p95Seconds: Number.isFinite(p95Seconds) ? p95Seconds : 0
        };
    }

    private videoDurationForJob(job: any) {
        const value = Number(job?.video_duration_seconds || this.videoDurationSeconds || 3);
        return [3, 4, 5, 6, 7, 8, 10, 15, 20].includes(value) ? value : 3;
    }

    private durationRangeLabel(lowSeconds: number, highSeconds: number) {
        const lowMinutes = Math.max(1, Math.ceil(lowSeconds / 60));
        const highMinutes = Math.max(lowMinutes, Math.ceil(highSeconds / 60));
        return lowMinutes === highMinutes
            ? `${lowMinutes}분`
            : `${lowMinutes}~${highMinutes}분`;
    }

    private candidateJobsFromPayload(payload: any, expectedCount: number): any[] | null {
        if (!Number.isInteger(expectedCount) || expectedCount < 1) return null;
        if (Number(payload?.candidate_count) !== expectedCount) return null;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length !== expectedCount) return null;

        const normalized = jobs.map((job: any) => this.jobFromPayload(job));
        if (normalized.some((job: any) => !job || !this.jobId(job))) return null;
        const ids = normalized.map((job: any) => this.jobId(job));
        if (new Set(ids).size !== expectedCount) return null;

        const batchIds = normalized.map((job: any) => String(job?.candidate_batch_id || ''));
        if (batchIds.some((batchId: string) => !batchId) || new Set(batchIds).size !== 1) return null;
        if (normalized.some((job: any) => Number(job?.candidate_count) !== expectedCount)) return null;
        const indexes = normalized.map((job: any) => Number(job?.candidate_index));
        if (
            new Set(indexes).size !== expectedCount
            || ![...indexes].sort((left: number, right: number) => left - right)
                .every((value: number, index: number) => value === index + 1)
        ) return null;
        return normalized;
    }

    private intensityBatchJobsFromPayload(payload: any, candidateCount: number): any[] | null {
        const expectedCandidateCount = this.normalizeCandidateCount(candidateCount);
        const requestedIntensities = Array.isArray(payload?.intensities)
            ? payload.intensities.map((value: any) => Number(value))
            : [...this.intensityOptions];
        const expectedIntensities = [...this.intensityOptions];
        if (
            requestedIntensities.length !== expectedIntensities.length
            || requestedIntensities.some(
                (value: number, index: number) => value !== expectedIntensities[index]
            )
        ) return null;
        const expectedTotal = expectedCandidateCount * expectedIntensities.length;
        if (Number(payload?.candidate_count) !== expectedCandidateCount) return null;
        if (Number(payload?.total_job_count) !== expectedTotal) return null;
        const intensityBatchId = String(payload?.intensity_batch_id || '');
        if (!/^[0-9a-f]{32}$/.test(intensityBatchId)) return null;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length !== expectedTotal) return null;
        const normalized = jobs.map((job: any) => this.jobFromPayload(job));
        if (normalized.some((job: any) => !job || !this.jobId(job))) return null;
        if (new Set(normalized.map((job: any) => this.jobId(job))).size !== expectedTotal) return null;
        if (normalized.some((job: any) => (
            String(job?.intensity_batch_id || '') !== intensityBatchId
            || Number(job?.candidate_count) !== expectedCandidateCount
        ))) return null;
        for (const intensity of expectedIntensities) {
            const rows = normalized.filter((job: any) => this.jobIntensity(job) === intensity);
            if (rows.length !== expectedCandidateCount) return null;
            const indexes = rows.map((job: any) => Number(job?.candidate_index)).sort(
                (left: number, right: number) => left - right
            );
            if (!indexes.every((value: number, index: number) => value === index + 1)) return null;
            if (new Set(rows.map((job: any) => String(job?.candidate_batch_id || ''))).size !== 1) return null;
        }
        return normalized;
    }

    private assetsFromPayload(payload: any) {
        const assets = this.extractList(payload, ['assets', 'artifacts', 'media_assets', 'results']);
        if (assets.length > 0) return assets;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length > 0) return this.assetsFromJobs(jobs);
        const job = this.jobFromPayload(payload);
        return job ? this.assetsFromJobs([job]) : [];
    }

    private assetsFromJobs(jobs: any[]) {
        if (!Array.isArray(jobs)) return [];
        return jobs
            .filter((job: any) => !!(job?.asset || job?.artifact || job?.asset_revision))
            .map((job: any) => ({
                ...(job.asset || job.artifact || job.asset_revision),
                job_id: this.jobId(job),
                patient_id: job.patient_id,
                patient_code: job.patient_code,
                source_kind: job.source_kind,
                source_key: job.source_key,
                scenario_set_id: job.scenario_set_id,
                scenario_title: job.scenario_title,
                memory_kind: job.memory_kind,
                memory_label: job.memory_label,
                scenario_type: job.scenario_type,
                media_type: this.mediaType(job),
                provider_name: job.provider_name,
                model_name: job.model_name,
                image_expression: job.image_expression,
                image_expression_name: job.image_expression_name,
                image_expression_uses_intensity: job.image_expression_uses_intensity,
                intensity: job.intensity,
                generation_mode: job.generation_mode,
                image_prompt_strategy: job.image_prompt_strategy,
                output_projection: job.output_projection,
                source_asset_revision_id: job.source_asset_revision_id,
                scenario_cut_order: job.scenario_cut_order,
                scenario_cut_memory_kind: job.scenario_cut_memory_kind || job.memory_kind,
                scenario_cut_title: job.scenario_cut_title,
                scenario_cut_phase: job.scenario_cut_phase,
                scenario_cut_visual_spec: job.scenario_cut_visual_spec,
                scenario_cut_production: job.scenario_cut_production,
                scenario_cut_sensory_cues: job.scenario_cut_sensory_cues,
                scenario_analysis_snapshot_sha256: job.scenario_analysis_snapshot_sha256,
                continuity_role: job.continuity_role,
                continuity_master_revision_id: job.continuity_master_revision_id,
                continuity_invariants: job.continuity_invariants,
                continuity_conditional_invariants: job.continuity_conditional_invariants,
                candidate_batch_id: job.candidate_batch_id,
                candidate_index: job.candidate_index,
                candidate_count: job.candidate_count,
                intensity_batch_id: job.intensity_batch_id,
                video_batch_id: job.video_batch_id,
                replaces_job_id: job.replaces_job_id,
                review_decision: job.review_decision,
                job_status: job.status,
                started_at: job.started_at,
                completed_at: job.completed_at,
                generation_usage: job.generation_usage,
                reference_adherence: job.reference_adherence,
                shot_consistency: job.shot_consistency,
                review_status: job.review_status || job.asset?.review_status,
                signed_url: job.signed_url || job.preview_url || job.asset?.signed_url,
                artifacts: job.artifacts || job.asset?.artifacts || []
            }));
    }

    private upsertJob(job: any, prepend: boolean = false) {
        const id = this.jobId(job);
        if (!id) return;
        if (this.workbenchComparisonJobSnapshots[id]) {
            this.workbenchComparisonJobSnapshots[id] = {
                ...this.workbenchComparisonJobSnapshots[id],
                ...job
            };
        }
        if (!this.recordMatchesSelectedSource(job)) return;
        this.workbenchTrackAudioJob(job);
        this.workbenchTrackVideoJob(job);
        const index = this.jobs.findIndex((item: any) => this.jobId(item) === id);
        if (index >= 0) {
            this.jobs[index] = { ...this.jobs[index], ...job };
            this.jobs = [...this.jobs];
            return;
        }
        this.jobs = prepend ? [job, ...this.jobs] : [...this.jobs, job];
    }

    private mergeAssets(incoming: any[]) {
        if (!Array.isArray(incoming) || incoming.length === 0) return;
        const merged = [...this.assets];
        incoming
            .filter((asset: any) => this.recordMatchesSelectedSource(asset))
            .forEach((asset: any) => {
                const id = this.assetId(asset);
                const index = merged.findIndex((item: any) => this.assetId(item) === id);
                if (id && index >= 0) {
                    const previousUrl = this.masterUrl(merged[index]);
                    merged[index] = { ...merged[index], ...asset };
                    if (this.masterUrl(merged[index]) !== previousUrl) delete merged[index].preview_failed;
                }
                else merged.unshift(asset);
            });
        this.assets = merged;
    }

    private startPolling() {
        if (this.pollTimer || this.destroyed) return;
        this.pollTimer = window.setInterval(() => {
            this.pollActiveJobs();
        }, 3000);
    }

    private async pollActiveJobs() {
        if (this.polling || this.destroyed) return;
        const comparisonIds = new Set(this.workbenchComparisonRequestedIds());
        const tracked = Object.values(this.workbenchComparisonJobSnapshots)
            .filter((job: any) => comparisonIds.has(this.jobId(job)));
        const seen = new Set<string>();
        const audioJobs = Object.values(this.workbenchAudioJobSnapshots || {})
            .filter((job: any) => this.recordMatchesSelectedSource(job));
        const videoJobs = Object.values(this.workbenchVideoJobSnapshots || {})
            .filter((job: any) => this.recordMatchesSelectedSource(job));
        const active = [...tracked, ...audioJobs, ...videoJobs, ...this.jobs]
            .filter((job: any) => ['queued', 'running', 'postprocessing'].includes(String(job?.status || '').toLowerCase()))
            .filter((job: any) => {
                const id = this.jobId(job);
                if (!id || seen.has(id)) return false;
                seen.add(id);
                return true;
            })
            .slice(0, 6);
        if (active.length === 0) {
            const now = Date.now();
            const shouldRefreshEmptyScenario = (
                this.sourceMode === 'scenario'
                && !!this.selectedScenarioSourceKey()
                && this.jobs.length === 0
                && this.assets.length === 0
                && now - this.lastEmptyScenarioRefreshAt >= 15000
            );
            if (!shouldRefreshEmptyScenario) return;
            this.lastEmptyScenarioRefreshAt = now;
            this.polling = true;
            try {
                await this.search(false, false);
                if (!this.destroyed) await this.service.render();
            } finally {
                this.polling = false;
            }
            return;
        }

        this.polling = true;
        try {
            await Promise.all(active.map((job: any) => this.refreshJob(this.jobId(job), false)));
            if (!this.destroyed) await this.service.render();
        } finally {
            this.polling = false;
        }
    }

    private async refreshJob(id: string, render: boolean = true) {
        if (!id || this.destroyed) return;
        try {
            const { code, data } = await wiz.call('job_status', { job_id: id });
            if (code !== 200) return;
            const job = this.jobFromPayload(data);
            if (job) this.upsertJob(this.jobId(job) ? job : { ...job, id: id });
            const incomingAssets = this.assetsFromPayload(data);
            this.mergeAssets(incomingAssets);
            if (job) this.syncPanoramaJob(job, incomingAssets);
            void this.autoEvaluateMissingShotConsistency();
            if (render && !this.destroyed) await this.service.render();
        } catch (error) {
            // Poll failures are intentionally silent; the next interval retries.
        }
    }

    public workbenchSourceQueryParams() {
        return this.workbenchSourceChoice === 'scenario' ? {
            source: 'scenario',
            scenario: this.scenarioSelection.scenario_set_id,
            memory: this.scenarioSelection.memory_kind || 'trauma'
        } : {
            patient_id: this.form.patient_id,
            memory_mode: this.patientMemoryMode === 'resource' ? 'resource' : null,
            resource_memory_id: this.patientMemoryMode === 'resource' ? this.selectedResourceMemoryId || null : null
        };
    }

    public workbenchHasSelection() {
        return this.workbenchSourceChoice === 'patient'
            ? !!this.selectedPatientOption()
            : this.workbenchSourceChoice === 'scenario'
            ? !!this.selectedScenarioSet()
            : false;
    }

    public workbenchFilteredPatients() {
        const query = this.workbenchPatientQuery.trim().toLocaleLowerCase();
        if (!query) return this.patients;
        return this.patients.filter((patient: any) =>
            String(patient?.patient_code || this.patientLabel(patient))
                .toLocaleLowerCase().includes(query)
        );
    }

    public workbenchFilteredScenarios() {
        const query = this.workbenchScenarioQuery.trim().toLocaleLowerCase();
        if (!query) return this.scenarioSets;
        return this.scenarioSets.filter((scenario: any) =>
            [scenario?.id, scenario?.source_id, scenario?.title, scenario?.category_label]
                .some((value: any) => String(value || '')
                    .toLocaleLowerCase().includes(query))
        );
    }

    public workbenchSourcePageCount(mode: 'patient' | 'scenario') {
        const count = mode === 'patient'
            ? this.workbenchFilteredPatients().length
            : this.workbenchFilteredScenarios().length;
        return Math.max(1, Math.ceil(count / this.workbenchSourcePageSize));
    }

    public workbenchSourcePage(mode: 'patient' | 'scenario') {
        const page = mode === 'patient'
            ? this.workbenchPatientPage : this.workbenchScenarioPage;
        return Math.min(Math.max(1, page), this.workbenchSourcePageCount(mode));
    }

    public workbenchSourceRows(mode: 'patient' | 'scenario') {
        const rows = mode === 'patient'
            ? this.workbenchFilteredPatients()
            : this.workbenchFilteredScenarios();
        const start = (this.workbenchSourcePage(mode) - 1)
            * this.workbenchSourcePageSize;
        return rows.slice(start, start + this.workbenchSourcePageSize);
    }

    public workbenchSourcePageNumbers(mode: 'patient' | 'scenario') {
        const count = this.workbenchSourcePageCount(mode);
        const current = this.workbenchSourcePage(mode);
        const start = Math.floor((current - 1) / 5) * 5 + 1;
        return Array.from(
            { length: Math.min(5, count - start + 1) },
            (_unused, index) => start + index
        );
    }

    public async workbenchSetSourcePage(mode: 'patient' | 'scenario', page: number) {
        if (!Number.isInteger(page)) return;
        const next = Math.min(Math.max(1, page), this.workbenchSourcePageCount(mode));
        if (mode === 'patient') this.workbenchPatientPage = next;
        else this.workbenchScenarioPage = next;
        await this.service.render();
    }

    public async workbenchResetSourcePage(mode: 'patient' | 'scenario') {
        await this.workbenchSetSourcePage(mode, 1);
    }

    public async workbenchMediaTabKeydown(event: KeyboardEvent) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const current = event.currentTarget as HTMLButtonElement | null;
        if (!current || current.disabled || event.altKey || event.ctrlKey || event.metaKey) return;
        const tabs = Array.from(
            current.parentElement?.querySelectorAll<HTMLButtonElement>('button[role="tab"]') || []
        ).filter(tab => !tab.disabled);
        const index = tabs.indexOf(current);
        if (index < 0) return;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
            : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        const target = tabs[next];
        const value = target.dataset.mediaType;
        if (!value || !this.mediaTypes.some(option => option.value === value)) return;
        event.preventDefault();
        await this.workbenchSetMediaTab(value);
        if (target.isConnected && !target.disabled) target.focus({ preventScroll: true });
    }

    public async workbenchSetMediaTab(value: string) {
        this.workbenchCloseDropdowns();
        this.workbenchAdvancedOpen = false;
        await this.setContentTab(value);
    }

    public workbenchOpenAdvanced(section: 'prompt' | 'reference' | 'intensity' | 'generation') {
        this.workbenchAdvancedOpen = true;
        this.settingsAccordion = section;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleAdvanced() {
        this.workbenchAdvancedOpen = !this.workbenchAdvancedOpen;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleModelPicker() {
        const next = !this.workbenchModelPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchModelPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleCountPicker() {
        const next = !this.workbenchCountPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchCountPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleImageQualityPicker() {
        const next = !this.workbenchImageQualityPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchImageQualityPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleCutPicker() {
        const next = !this.workbenchCutPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchCutPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleVideoModelPicker() {
        const next = !this.workbenchVideoModelPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchVideoModelPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleVideoDurationPicker() {
        const next = !this.workbenchVideoDurationPickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchVideoDurationPickerOpen = next;
        this.changeDetector.detectChanges();
    }

    public workbenchCloseDropdowns() {
        this.workbenchModelPickerOpen = false;
        this.workbenchImageQualityPickerOpen = false;
        this.workbenchCountPickerOpen = false;
        this.workbenchCutPickerOpen = false;
        this.workbenchVideoModelPickerOpen = false;
        this.workbenchVideoDurationPickerOpen = false;
        this.workbenchBlurSourcePickerOpen = false;
    }

    public workbenchDropdownOpen() {
        return this.workbenchModelPickerOpen
            || this.workbenchImageQualityPickerOpen
            || this.workbenchCountPickerOpen
            || this.workbenchCutPickerOpen
            || this.workbenchVideoModelPickerOpen
            || this.workbenchVideoDurationPickerOpen
            || this.workbenchBlurSourcePickerOpen;
    }

    public async workbenchSelectCandidateCount(value: number) {
        this.imageCandidateCount = value;
        this.workbenchCloseDropdowns();
        await this.onImageCandidateCountChange();
    }

    public async workbenchSelectImageQuality(value: string) {
        this.selectedImageQuality = this.normalizeImageQuality(value);
        this.workbenchCloseDropdowns();
        await this.onImageQualityChange();
    }

    public workbenchScenarioCutLabel() {
        const cut = this.selectedScenarioCut();
        return cut ? `컷 ${cut.order} · ${this.scenarioCutMemoryLabel(cut)} · ${cut.title}` : '생성할 컷을 선택하세요';
    }

    public workbenchVideoModelLabel() {
        const option = (this.generationModelOptions.video || []).find(
            (item: any) => item.value === this.selectedVideoModelKey()
        );
        return String(option?.label || '영상 모델을 선택하세요');
    }

    public async workbenchSelectVideoModel(value: string) {
        const key = String(value || '');
        const known = (this.generationModelOptions.video || []).some(
            (item: any) => item.value === key
        );
        if (!known || !this.generationModelAvailable(key, 'video')) return;
        this.selectedGenerationModelKeys.video = key;
        this.workbenchCloseDropdowns();
        await this.onGenerationModelChange('video');
    }

    public async workbenchSelectVideoDuration(value: number) {
        const duration = Number(value);
        if (!this.videoDurationOptionsForSelectedModel().includes(duration)) return;
        this.videoDurationSeconds = duration;
        this.workbenchCloseDropdowns();
        await this.onVideoDurationChange();
    }

    public workbenchVideoSource() {
        return this.selectedPatientSource || this.selectedVideoSource || null;
    }

    public workbenchVideoSourcePreviewUrl() {
        const source = this.workbenchVideoSource();
        return String(source?.preview_url || this.visualUrl(source) || '');
    }

    public workbenchVideoSourceTitle() {
        const source = this.workbenchVideoSource();
        if (!source) return '영상 원본을 선택해주세요';
        if (source === this.selectedPatientSource) return '승인된 환자 제공 사진';
        return this.candidateLabel(source) || '선택한 이미지 후보';
    }

    public async workbenchOpenVideoSourceSelection() {
        await this.workbenchSetMediaTab('image');
    }

    public async workbenchOpenAudioSourceSelection() {
        await this.workbenchSetMediaTab('audio');
        this.workbenchOpenAdvanced('generation');
    }

    public workbenchMediaResults() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        if (!['audio', 'video'].includes(mediaType)) return [];
        return this.allReviewAssets(mediaType).slice(0, 3);
    }

    private workbenchAudioScopeKey() {
        return JSON.stringify(this.sourceMode === 'scenario'
            ? ['scenario', this.selectedScenarioSourceKey(), this.selectedScenarioCutOrder,
                this.scenarioAnalysis?.source_snapshot_sha256 || '']
            : ['patient', this.form.patient_id, this.patientMemoryMode, this.selectedResourceMemoryId || '']);
    }

    private workbenchBeginAudioRequest(mediaType: string) {
        if (mediaType !== 'audio') return null;
        const request = { scope: this.workbenchAudioScopeKey(), pending: true, error: '',
            model: String(this.selectedGenerationModelKeys.audio || '') };
        this.workbenchAudioRequest = request;
        return request;
    }

    private workbenchFinishAudioRequest(request: any, jobs: any[]) {
        if (!request) return;
        request.pending = false;
        request.error = jobs.length ? '' : this.errorMessage || '오디오 생성 요청을 등록하지 못했습니다. 다시 시도해주세요.';
    }

    private workbenchTrackAudioJob(job: any) {
        const id = this.jobId(job);
        if (!id || this.mediaType(job) !== 'audio') return;
        this.workbenchAudioJobSnapshots ||= {};
        if (job.archived_at) delete this.workbenchAudioJobSnapshots[id];
        else this.workbenchAudioJobSnapshots[id] = { ...this.workbenchAudioJobSnapshots[id], ...job };
    }

    private workbenchVideoScopeKey() {
        return JSON.stringify([
            this.workbenchAudioScopeKey(),
            this.assetId(this.workbenchVideoSource()),
            this.videoGenerationScope || 'single'
        ]);
    }

    private workbenchBeginVideoRequest(mediaType: string) {
        if (mediaType !== 'video') return null;
        const request = { scope: this.workbenchVideoScopeKey(), pending: true, error: '',
            model: String(this.selectedGenerationModelKeys.video || ''), jobIds: [] as string[] };
        this.workbenchVideoRequest = request;
        return request;
    }

    private workbenchFinishVideoRequest(request: any, jobs: any[]) {
        if (!request) return;
        request.pending = false;
        request.jobIds = jobs.map((job: any) => this.jobId(job)).filter((id: string) => !!id);
        request.error = request.jobIds.length ? ''
            : this.errorMessage || '영상 생성 요청을 등록하지 못했습니다. 다시 시도해주세요.';
    }

    private workbenchTrackVideoJob(job: any) {
        const id = this.jobId(job);
        if (!id || this.mediaType(job) !== 'video') return;
        this.workbenchVideoJobSnapshots ||= {};
        if (job.archived_at) delete this.workbenchVideoJobSnapshots[id];
        else this.workbenchVideoJobSnapshots[id] = { ...this.workbenchVideoJobSnapshots[id], ...job };
    }

    public workbenchVideoProgress() {
        if (this.form.media_type !== 'video') return null;
        const request = this.workbenchVideoRequest?.scope === this.workbenchVideoScopeKey()
            ? this.workbenchVideoRequest : null;
        let job: any = null;
        let status = request?.pending ? 'submitting' : request?.error ? 'request_failed' : '';
        if (!status) {
            const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
            const sourceId = this.assetId(this.workbenchVideoSource());
            const jobs = new Map(Object.entries(this.workbenchVideoJobSnapshots || {}));
            (this.jobs || []).forEach((item: any) => jobs.set(this.jobId(item), item));
            job = [...jobs.values()].filter((item: any) => this.mediaType(item) === 'video'
                && !item.archived_at && this.recordMatchesSelectedSource(item)
                && (!cut || this.scenarioCutRecordMatches(item, cut))
                && (request?.jobIds.length
                    ? request.jobIds.includes(this.jobId(item))
                    : !!sourceId && this.videoSourceRevisionId(item) === sourceId))
                .sort((left: any, right: any) =>
                    (Date.parse(right.created_at || right.created || '') || 0)
                    - (Date.parse(left.created_at || left.created || '') || 0))[0];
            if (!job) return null;
            status = String(job.status || '').toLowerCase();
        }
        const complete = ['review_pending', 'pending', 'approved', 'rejected', 'quarantined'].includes(status);
        const failed = ['failed', 'cancelled', 'request_failed'].includes(status);
        const titles: any = { submitting: '영상 생성 요청 등록 중', queued: '영상 생성 대기 중',
            running: '영상 생성 중', postprocessing: '영상 검증·저장 중',
            failed: '영상 생성 실패', cancelled: '영상 생성 취소됨', request_failed: '영상 요청 등록 실패' };
        const descriptions: any = { submitting: '생성 요청을 서버에 전달하고 있습니다.',
            queued: '요청이 등록되었습니다. 생성 순서를 기다리고 있습니다.',
            running: '선택한 모델이 영상 원본으로 영상을 생성하고 있습니다. 완료되면 자동으로 표시됩니다.',
            postprocessing: '생성된 영상의 형식과 파일을 확인하고 저장하고 있습니다.' };
        const labels = ['요청 등록', '생성 대기', '영상 생성', '검증·저장', '완료'];
        const stages = ['submitting', 'request_failed'].includes(status)
            ? labels.map((label: string, index: number) => ({ label,
                state: index ? 'pending' : failed ? 'error' : 'current' }))
            : this.progressStageRows(job).map((stage: any, index: number) => ({
                ...stage, label: labels[index], state: complete ? 'complete' : stage.state
            }));
        const raw = job?.progress_percent ?? job?.progress;
        const percent = complete ? 100 : raw !== null && raw !== undefined && raw !== '' && Number.isFinite(Number(raw))
            ? Math.max(0, Math.min(99, Number(raw))) : null;
        const model = job ? this.progressModelLabel(job)
            : this.generationModelOptions.video.find((option: any) => option.value === request?.model)?.label || '영상';
        return { job, status, complete, failed, active: !complete && !failed, model, stages, percent,
            title: complete ? '영상 생성 완료' : titles[status] || '영상 상태 확인 중',
            detail: request?.error && status === 'request_failed' ? request.error
                : complete ? '생성된 영상을 아래 결과에서 재생하고 확인할 수 있습니다.'
                : status === 'failed' && ['kling_rate_limited', 'evolink_rate_limited'].includes(String(job?.error_code || ''))
                    ? '선택한 영상 모델의 요청 제한으로 생성하지 못했습니다. 다른 모델을 선택하거나 잠시 후 다시 시도해주세요.'
                : descriptions[status] || this.progressStatusDescription(job) };
    }

    public workbenchAudioProgress() {
        if (this.form.media_type !== 'audio') return null;
        const request = this.workbenchAudioRequest?.scope === this.workbenchAudioScopeKey()
            ? this.workbenchAudioRequest : null;
        let job: any = null;
        let status = request?.pending ? 'submitting' : request?.error ? 'request_failed' : '';
        if (!status) {
            const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
            const jobs = new Map(Object.entries(this.workbenchAudioJobSnapshots || {}));
            (this.jobs || []).forEach((item: any) => jobs.set(this.jobId(item), item));
            const active = (item: any) => ['queued', 'running', 'postprocessing'].includes(String(item?.status || '').toLowerCase());
            job = [...jobs.values()].filter((item: any) => this.mediaType(item) === 'audio'
                && !item.archived_at && this.recordMatchesSelectedSource(item)
                && (!cut || this.scenarioCutRecordMatches(item, cut)))
                .sort((left: any, right: any) => Number(active(right)) - Number(active(left))
                    || (Date.parse(right.created_at || right.created || '') || 0)
                        - (Date.parse(left.created_at || left.created || '') || 0))[0];
            if (!job) return null;
            status = String(job.status || '').toLowerCase();
        }
        const complete = ['review_pending', 'pending', 'approved', 'rejected', 'quarantined'].includes(status);
        const failed = ['failed', 'cancelled', 'request_failed'].includes(status);
        const titles: any = { submitting: '오디오 생성 요청 등록 중', queued: '오디오 생성 대기 중',
            running: '오디오 생성 중', postprocessing: '오디오 검증·저장 중',
            failed: '오디오 생성 실패', cancelled: '오디오 생성 취소됨', request_failed: '오디오 요청 등록 실패' };
        const model = job ? this.progressModelLabel(job)
            : this.generationModelOptions.audio.find((option: any) => option.value === request?.model)?.label || '오디오';
        const labels = ['요청 등록', '생성 대기', '오디오 생성', '검증·저장', '완료'];
        const descriptions: any = { submitting: '생성 요청을 서버에 전달하고 있습니다.',
            queued: '요청이 등록되었습니다. 생성 순서를 기다리고 있습니다.',
            running: '선택한 모델이 오디오를 생성하고 있습니다. 완료되면 자동으로 표시됩니다.',
            postprocessing: '생성된 오디오의 형식과 파일을 확인하고 저장하고 있습니다.',
            cancelled: '오디오 생성 작업이 취소되었습니다.' };
        const stages = ['submitting', 'request_failed'].includes(status)
            ? labels.map((label: string, index: number) => ({ label,
                state: index ? 'pending' : failed ? 'error' : 'current' }))
            : this.progressStageRows(job).map((stage: any, index: number) => ({ ...stage, label: labels[index] }));
        const raw = job?.progress_percent ?? job?.progress;
        const percent = complete ? 100 : raw !== null && raw !== undefined && raw !== '' && Number.isFinite(Number(raw))
            ? Math.max(0, Math.min(99, Number(raw))) : null;
        return { job, status, complete, failed, active: !complete && !failed, model, stages, percent,
            title: complete ? '오디오 생성 완료' : titles[status] || '오디오 상태 확인 중',
            detail: request?.error && status === 'request_failed' ? request.error
                : complete ? '생성된 오디오를 아래 결과에서 재생하고 확인할 수 있습니다.'
                : descriptions[status] || this.progressStatusDescription(job).replace(/이미지 생성/g, '오디오 생성') };
    }

    public workbenchCanGenerateCurrentMedia() {
        if (this.form.media_type === 'audio') return !this.workbenchAudioGenerationBlockReason();
        if (this.form.media_type === 'video') return !this.workbenchVideoGenerationBlockReason();
        return false;
    }

    public workbenchVideoGenerationBlockReason() {
        if (this.form.media_type !== 'video') return '';
        if (!this.can('content.write')) return '영상 생성 권한이 없습니다.';
        if (this.sourceMode === 'scenario') {
            if (this.submitting) return '영상 생성 요청을 등록하고 있습니다.';
            return this.scenarioVideoGenerationBlockReason();
        }
        if (this.videoSubmitting) return '영상 생성 요청을 등록하고 있습니다.';
        if (!this.selectedGenerationModelAvailable('video')) {
            return this.selectedGenerationModelUnavailableMessage('video');
        }
        if (!this.contentSettingsReady()) {
            return this.selectedPatientSetupMessage() || '생성할 환자와 승인된 프롬프트를 확인해주세요.';
        }
        if (this.selectedAudioSource && !this.selectedVideoModelSupportsUploadedAudio()) {
            return '선택한 모델은 오디오 입력을 지원하지 않습니다. 오디오를 제거하거나 Wan 2.2를 선택해주세요.';
        }
        if (this.canCreateSelectedVideo()) return '';
        if (this.videoGenerationScope === 'all') {
            return '같은 시나리오의 강도 1~5에서 영상으로 만들 이미지 후보를 하나씩 선택하고 템플릿·프롬프트를 확인해주세요.';
        }
        const source = this.videoSourceEligible(this.selectedPatientSource)
            ? this.selectedPatientSource : this.selectedVideoSource;
        if (!source) return '영상 원본으로 사용할 이미지 후보 또는 승인된 환자 사진을 선택해주세요.';
        if (!this.videoSourceEligible(source)) return this.videoSourceReason(source);
        if (this.promptSelectionMismatch() && !this.promptMismatchAcknowledged) {
            return '환자 유형과 다른 프롬프트 세트를 사용하려면 설정에서 경고 내용을 확인해주세요.';
        }
        return '선택한 이미지에 맞는 영상 생성 템플릿이 없습니다.';
    }

    public workbenchAudioGenerationBlockReason() {
        if (this.form.media_type !== 'audio') return '';
        if (!this.can('content.write')) return '오디오 생성 권한이 없습니다.';
        if (this.submitting) return '오디오 생성 요청을 등록하고 있습니다.';
        if (!this.selectedGenerationModelAvailable('audio')) {
            return this.selectedGenerationModelUnavailableMessage('audio');
        }
        if (!this.audioInputReady()) {
            return this.audioPromptText.trim().length > this.audioPromptLimit()
                ? `입력은 ${this.audioPromptLimit()}자 이내로 작성해주세요.`
                : `${this.audioPromptLabel()}을 입력해주세요.`;
        }
        if (this.sourceMode === 'scenario') {
            if (!this.selectedScenarioSet()) return '생성할 시나리오를 선택해주세요.';
            if (!this.templateIdForScenarioGeneration('audio')) return '사용 가능한 오디오 생성 템플릿이 없습니다.';
            const cut = this.scenarioCutRequestSpec();
            if (cut?.analysis_snapshot_conflict) return '시나리오 대화가 변경되었습니다. 다시 분석한 뒤 컷을 선택해주세요.';
            if (!this.contentSettingsReady()) return '시나리오 분석을 완료한 뒤 생성할 컷을 선택해주세요.';
        } else if (!this.contentSettingsReady()) {
            return this.patientMemoryMode === 'resource'
                ? '환자와 승인된 자원기억을 선택해주세요.'
                : this.selectedPatientSetupMessage() || '생성할 환자를 선택해주세요.';
        }
        return '';
    }

    public workbenchImageGenerationBlockReason() {
        if (this.form.media_type !== 'image') return '이미지 탭에서 생성할 수 있습니다.';
        if (!this.can('content.write')) return '이미지 생성 권한이 없습니다.';
        if (this.workbenchSceneMasterWaiting) return '기준 장면을 생성한 뒤 같은 장면에서 단계별 이미지를 편집하고 있습니다.';
        if (this.workbenchComparing) return '이미지 생성 요청을 등록하고 있습니다.';
        if (!this.workbenchHasSelection()) return '생성할 환자 또는 시나리오를 선택해주세요.';
        if (this.workbenchExpression === 'blur') {
            const source = this.workbenchBlurSource();
            if (!source) return '같은 컷의 기준 이미지를 먼저 생성해주세요.';
            if (!this.workbenchBlurPreviewAvailable(source)) return '기준 이미지를 다시 불러와 주세요.';
            if (this.workbenchBlurPreviewReadyId !== this.assetId(source)) return '기준 이미지가 표시될 때까지 기다려 주세요.';
            return this.workbenchSelectedIntensities.length ? '' : '생성할 강도를 선택해주세요.';
        }
        if (this.workbenchSelectedModels.length === 0) return '이미지 모델을 하나 이상 선택해주세요.';
        const unavailable = this.workbenchSelectedModels.find(
            (key: string) => !this.generationModelAvailable(key, 'image')
        );
        if (unavailable) {
            return `${this.workbenchModelLabel(unavailable)} 모델 연결 상태를 확인해주세요.`;
        }
        if (this.sourceMode === 'scenario' && !this.contentSettingsReady()) {
            if (this.scenarioAnalysisState !== 'complete') {
                return '시나리오 분석을 완료한 뒤 생성할 컷을 선택해주세요.';
            }
            if (!this.scenarioCutRequestSpec()) {
                return '분석 결과에서 생성할 컷을 선택해주세요.';
            }
            return '선택한 시나리오의 이미지 생성 기준을 확인해주세요.';
        }
        if (!this.contentSettingsReady()) {
            return this.patientMemoryMode === 'resource'
                ? '환자와 승인된 자원기억을 선택해주세요.'
                : '환자의 시나리오와 승인된 프롬프트를 확인해주세요.';
        }
        return '';
    }

    public workbenchCanGenerateImages() {
        return !this.workbenchImageGenerationBlockReason();
    }

    public workbenchCurrentMediaActionLabel() {
        if (this.form.media_type === 'audio') {
            return this.submitting ? '오디오 요청 등록 중...' : '설정으로 오디오 생성';
        }
        if (this.sourceMode === 'patient' && this.videoSubmitting) {
            return '영상 요청 등록 중...';
        }
        if (this.sourceMode === 'scenario' && this.submitting) {
            return '영상 요청 등록 중...';
        }
        return '선택한 원본으로 영상 생성';
    }

    public async workbenchGenerateCurrentMedia() {
        if (!this.workbenchCanGenerateCurrentMedia()) return;
        if (this.form.media_type === 'audio') {
            await this.createJob();
            return;
        }
        if (this.form.media_type === 'video') {
            if (this.sourceMode === 'patient') await this.createSelectedVideo();
            else await this.createJob();
        }
    }

    public workbenchToggleReport() {
        this.workbenchReportOpen = !this.workbenchReportOpen;
        this.changeDetector.detectChanges();
    }

    private workbenchSavedModels(): string[] | null {
        try {
            const saved = window.localStorage.getItem(this.workbenchModelStorageKey);
            if (saved === null) return null;
            const parsed = JSON.parse(saved);
            if (!Array.isArray(parsed)) return null;
            const known = new Set(this.generationModelOptions.image.map(
                (model: any) => String(model.value)
            ));
            return [...new Set(parsed.filter((key: any) =>
                typeof key === 'string' && known.has(key)
            ))] as string[];
        } catch (_error) {
            return null;
        }
    }

    private workbenchSaveModels() {
        try {
            window.localStorage.setItem(
                this.workbenchModelStorageKey,
                JSON.stringify(this.workbenchSelectedModels)
            );
        } catch (_error) {
            // Browser storage can be disabled; current selection still works.
        }
    }

    private workbenchSavedImageQuality(): string | null {
        try {
            const saved = window.localStorage.getItem(
                this.workbenchImageQualityStorageKey
            );
            if (saved === null) return null;
            const normalized = this.normalizeImageQuality(saved);
            return this.workbenchImageQualityOptions().some(
                (option: any) => option.value === normalized
            ) ? normalized : null;
        } catch (_error) {
            return null;
        }
    }

    private workbenchSaveImageQuality() {
        try {
            window.localStorage.setItem(
                this.workbenchImageQualityStorageKey,
                this.normalizeImageQuality(this.selectedImageQuality)
            );
        } catch (_error) {
            // Browser storage can be disabled; current selection still works.
        }
    }

    public workbenchComparisonHasRequests() {
        return this.workbenchComparisonRequestedCount() > 0;
    }

    private workbenchComparisonRequestedIds(key: string = '') {
        const ids = key
            ? (this.workbenchComparisonJobIds[key] || [])
            : Object.values(this.workbenchComparisonJobIds).flat();
        const hasCurrentRequests = Object.values(this.workbenchComparisonJobIds)
            .some((values: string[]) => values.length > 0);
        if (hasCurrentRequests || this.workbenchComparing) {
            return [...new Set(ids.filter((id: string) => !!id))];
        }
        const models = key ? [key] : this.workbenchSelectedModels;
        return [...new Set(models.flatMap((model: string) =>
            this.workbenchImageResultJobs(model).map((job: any) => this.jobId(job))
        ))];
    }

    public workbenchComparisonRequestedCount(key: string = '') {
        return this.workbenchComparisonRequestedIds(key).length;
    }

    public workbenchComparisonJobsForModel(key: string) {
        return this.workbenchComparisonRequestedIds(key)
            .map((id: string) => (
                this.jobs.find((job: any) => this.jobId(job) === id)
                || this.workbenchComparisonJobSnapshots[id]
                || null
            ))
            .filter((job: any) => !!job);
    }

    public workbenchComparisonJobs() {
        return this.workbenchComparisonRequestedIds()
            .map((id: string) => (
                this.jobs.find((job: any) => this.jobId(job) === id)
                || this.workbenchComparisonJobSnapshots[id]
                || null
            ))
            .filter((job: any) => !!job);
    }

    private workbenchComparisonCompletedStatus(status: string) {
        return ['review_pending', 'pending', 'approved', 'rejected', 'quarantined']
            .includes(String(status || '').toLowerCase());
    }

    private workbenchComparisonFailedStatus(status: string) {
        return ['failed', 'cancelled'].includes(String(status || '').toLowerCase());
    }

    public workbenchComparisonCompletedCount(key: string = '') {
        const jobs = key
            ? this.workbenchComparisonJobsForModel(key)
            : this.workbenchComparisonJobs();
        return jobs.filter((job: any) =>
            this.workbenchComparisonCompletedStatus(job?.status)
        ).length;
    }

    public workbenchComparisonFailedCount(key: string = '') {
        const jobs = key
            ? this.workbenchComparisonJobsForModel(key)
            : this.workbenchComparisonJobs();
        return jobs.filter((job: any) =>
            this.workbenchComparisonFailedStatus(job?.status)
        ).length;
    }

    public workbenchComparisonProgress(key: string = '') {
        const requested = this.workbenchComparisonRequestedCount(key);
        const jobs = key
            ? this.workbenchComparisonJobsForModel(key)
            : this.workbenchComparisonJobs();
        if (this.workbenchComparing && requested === 0) return 8;
        if (requested === 0) return 0;
        const knownProgress = jobs.reduce(
            (total: number, job: any) => total + this.jobProgress(job),
            0
        );
        return Math.max(5, Math.round(knownProgress / requested));
    }

    public workbenchComparisonPhase(key: string = '') {
        if (this.workbenchComparing && !key) return 'submitting';
        const requested = this.workbenchComparisonRequestedCount(key);
        if (requested === 0) return 'idle';
        const jobs = key
            ? this.workbenchComparisonJobsForModel(key)
            : this.workbenchComparisonJobs();
        if (jobs.length < requested) return 'loading';
        const failed = this.workbenchComparisonFailedCount(key);
        const completed = this.workbenchComparisonCompletedCount(key);
        if (failed + completed === requested) {
            if (failed === requested) return 'failed';
            if (failed > 0) return 'partial';
            return 'complete';
        }
        if (jobs.some((job: any) => ['running', 'postprocessing'].includes(
            String(job?.status || '').toLowerCase()
        ))) return 'running';
        return 'queued';
    }

    public workbenchComparisonStatusTitle() {
        const phase = this.workbenchComparisonPhase();
        const labels: any = {
            submitting: '이미지 생성 요청을 등록하고 있습니다',
            loading: '등록한 작업 상태를 확인하고 있습니다',
            queued: '이미지 생성 순서를 기다리고 있습니다',
            running: '이미지를 생성하고 있습니다',
            complete: '이미지 생성이 완료되었습니다',
            partial: '일부 이미지 생성에 실패했습니다',
            failed: '이미지 생성에 실패했습니다'
        };
        return labels[phase] || '이미지 생성 준비 중';
    }

    public workbenchComparisonStatusDetail() {
        if (this.workbenchComparing && !this.workbenchComparisonHasRequests()) {
            return '설정한 조건을 확인한 뒤 생성 작업을 등록합니다.';
        }
        const requested = this.workbenchComparisonRequestedCount();
        const completed = this.workbenchComparisonCompletedCount();
        const failed = this.workbenchComparisonFailedCount();
        const processing = Math.max(0, requested - completed - failed);
        const parts = [`전체 ${requested}개`, `완료 ${completed}개`];
        if (processing > 0) parts.push(`진행 ${processing}개`);
        if (failed > 0) parts.push(`실패 ${failed}개`);
        return `${parts.join(' · ')} · 상태는 3초마다 자동으로 갱신됩니다.`;
    }

    public workbenchComparisonFailureMessage(key: string = '') {
        const jobs = key
            ? this.workbenchComparisonJobsForModel(key)
            : this.workbenchComparisonJobs();
        const failed = jobs.find((job: any) =>
            this.workbenchComparisonFailedStatus(job?.status)
        );
        return failed ? this.jobErrorMessage(failed) : '';
    }

    public workbenchModelStatusLabel(key: string) {
        const phase = this.workbenchComparisonPhase(key);
        const labels: any = {
            idle: '생성 요청 전',
            loading: '상태 확인 중',
            queued: '대기',
            running: '생성 중',
            complete: '완료',
            partial: '일부 실패',
            failed: '실패'
        };
        return labels[phase] || '상태 확인 중';
    }

    public workbenchToggleImageSettings() {
        this.workbenchImageSettingsOpen = !this.workbenchImageSettingsOpen;
        this.changeDetector?.detectChanges();
    }

    public workbenchSetImageView(view: 'focus' | 'compare') {
        this.workbenchImageView = view;
        this.changeDetector?.detectChanges();
    }

    public workbenchSetImageFocus(key: string) {
        this.workbenchImageFocusKey = key;
        this.changeDetector?.detectChanges();
    }

    public workbenchImageCompareView() {
        return this.workbenchImageView === 'compare' || this.workbenchImageResultFilterActive() || this.workbenchCompareExpanded;
    }

    public workbenchImageFocusCards() {
        return this.workbenchComparisonCards().filter((card: any) => card.tile?.asset && this.visualUrl(card.tile.asset));
    }

    public workbenchImageFocusCard() {
        const cards = this.workbenchImageFocusCards();
        return cards.find((card: any) => card.key === this.workbenchImageFocusKey) || cards[0] || null;
    }

    public workbenchImageStoredCount() {
        return this.workbenchComparisonSourceTiles().filter((tile: any) => tile.asset && this.visualUrl(tile.asset)).length;
    }

    public workbenchImageEditScope() {
        if (this.workbenchExpression === 'blur') return '블러 기준 이미지·영역';
        return `${this.workbenchExpressionLabel(this.workbenchExpression)} · ${this.workbenchExpressionUsesIntensity() ? '강도 ' + this.workbenchPromptEditIntensity : '공통 프롬프트'}`;
    }

    public workbenchImageGenerationScope() {
        const levels = this.workbenchGenerationIntensities();
        const levelLabel = this.workbenchExpressionUsesIntensity() ? `강도 ${levels.join(', ')}` : '강도 구분 없음';
        const models = this.workbenchExpression === 'blur' ? '동일 기준 이미지' : `모델 ${this.workbenchSelectedModels.length}개`;
        return `${levelLabel} · ${models} · 총 ${this.workbenchTotalImageCount()}장`;
    }

    public workbenchImageCompareScope() {
        const label = this.workbenchExpressionLabel(this.workbenchCompareExpression);
        if (!this.workbenchComparisonUsesIntensity()) return `${label} · 강도 구분 없음`;
        return `${label} · ${this.workbenchResultView === 'intensity' ? '강도 1~5 비교' : '강도 ' + this.workbenchCompareIntensity}`;
    }

    public workbenchComparisonReportTitle() {
        const phase = this.workbenchComparisonPhase();
        if (phase === 'idle') return this.workbenchImageStoredCount() > 0
            ? `저장된 이미지 ${this.workbenchImageStoredCount()}장 · 새 생성 요청 없음` : '아직 생성된 이미지가 없습니다';
        if (phase === 'complete') {
            return `모델별 결과 ${this.workbenchCompletedModelCount()} / ${this.workbenchSelectedModels.length}개 확인 가능`;
        }
        if (phase === 'failed') return '등록한 이미지 생성 작업이 실패했습니다';
        if (phase === 'partial') return '완료된 결과와 실패한 작업을 함께 확인할 수 있습니다';
        return `이미지 생성 진행 중 · ${this.workbenchComparisonProgress()}%`;
    }

    public workbenchComparisonReportDetail() {
        const phase = this.workbenchComparisonPhase();
        if (phase === 'idle') return this.workbenchImageStoredCount() > 0
            ? '표시된 이미지는 저장된 기존 결과입니다. 새 요청의 진행 상태는 생성 후 별도로 표시됩니다.'
            : '생성 대상 강도·모델·수량을 확인한 뒤 시험 생성을 시작하세요.';
        if (['failed', 'partial'].includes(phase)) {
            return this.workbenchComparisonFailureMessage() || '실패 원인을 확인한 뒤 다시 시도해주세요.';
        }
        if (phase === 'complete') return '생성된 자산의 상태와 실제 비용을 비교할 수 있습니다.';
        return this.workbenchComparisonStatusDetail();
    }

    public workbenchCompletedModelCount() {
        return this.workbenchSelectedModels.filter((key: string) =>
            !!this.workbenchResultForModel(key).asset
        ).length;
    }

    public workbenchToggleIntensity(value: number) {
        const intensity = this.normalizeIntensityValue(value);
        const selected = this.workbenchSelectedIntensities.includes(intensity);
        if (selected && this.workbenchSelectedIntensities.length === 1) return;
        this.workbenchSelectedIntensities = selected
            ? this.workbenchSelectedIntensities.filter((item: number) => item !== intensity)
            : [...this.workbenchSelectedIntensities, intensity].sort((a, b) => a - b);
        if (!this.workbenchSelectedIntensities.includes(this.form.intensity)) {
            this.form.intensity = this.workbenchSelectedIntensities[0];
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public workbenchToggleCutStage() {
        this.workbenchCutStageOpen = !this.workbenchCutStageOpen;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleExpressionStage() {
        this.workbenchExpressionStageOpen = !this.workbenchExpressionStageOpen;
        this.changeDetector.detectChanges();
    }

    public workbenchToggleComparison() {
        if (this.workbenchCompareExpanded) return;
        this.workbenchSetComparisonOpen(!this.workbenchComparisonOpen);
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    private workbenchComparisonPreferenceKey() {
        const userId = String(this.service?.auth?.session?.id || '');
        return userId ? `ptsd.contentWorkbenchComparisonOpen.v1.${userId}` : '';
    }

    private workbenchRestoreComparisonOpen() {
        this.workbenchComparisonOpen = true;
        try {
            const key = this.workbenchComparisonPreferenceKey();
            const value = key ? window.localStorage.getItem(key) : null;
            if (value === 'true' || value === 'false') this.workbenchComparisonOpen = value === 'true';
        } catch (_error) { }
    }

    private workbenchSetComparisonOpen(open: boolean) {
        this.workbenchComparisonOpen = open;
        try {
            const key = this.workbenchComparisonPreferenceKey();
            if (key) window.localStorage.setItem(key, String(open));
        } catch (_error) { }
    }

    public workbenchGenerationIntensities() {
        return !this.workbenchExpressionUsesIntensity()
            ? [3]
            : [...this.workbenchSelectedIntensities];
    }

    public workbenchExpressionUsesIntensity(value: string = this.workbenchExpression) {
        return value !== 'trigger' && this.workbenchCustomExpression(value)?.uses_intensity !== false;
    }

    public workbenchCustomCommonPrompt(expression: string = this.workbenchExpression) {
        return String(this.workbenchPromptDraft.custom_expression_common?.[expression.slice(7)] || '');
    }

    public workbenchSetCustomCommonPrompt(value: string) {
        const custom = this.workbenchCustomExpression();
        if (!custom || this.workbenchExpressionUsesIntensity() || this.workbenchExpressionBusy) return;
        if (!this.workbenchPromptDraft.custom_expression_common) this.workbenchPromptDraft.custom_expression_common = {};
        this.workbenchPromptDraft.custom_expression_common[custom.id] = String(value || '').slice(0, 320);
        this.workbenchPromptChanged();
    }

    public workbenchTotalImageCount() {
        if (this.workbenchExpression === 'blur') return this.workbenchSelectedIntensities.length;
        const levels = this.workbenchGenerationIntensities();
        const additionalSceneMaster = this.sourceMode === 'scenario'
            && this.scenarioSelection?.memory_kind === 'trauma'
            && this.workbenchExpression === 'realistic'
            && this.workbenchReferenceEnabled()
            && !!this.workbenchReproductionReference()
            && levels.some((level: number) => level < 5)
            && !levels.includes(5) ? 1 : 0;
        return (levels.length + additionalSceneMaster)
            * this.workbenchSelectedModels.length
            * this.normalizeCandidateCount(this.imageCandidateCount);
    }

    public workbenchPromptTemplateVersion() {
        const id = this.templateIdForScenarioGeneration('image');
        const template = this.templates.find((item: any) =>
            String(item?.id || item?.template_id || '') === id
        );
        return Number(template?.version || 0);
    }

    public workbenchPromptAdjustmentCount(section: 'intensity' | 'model') {
        if (section === 'intensity' && this.workbenchCustomExpression()?.uses_intensity === false) {
            return this.workbenchCustomCommonPrompt().trim() ? 1 : 0;
        }
        if (section === 'intensity' && this.workbenchExpression === 'trigger') {
            return (this.workbenchPromptDraft.trigger_elements || []).length;
        }
        const entries = section === 'intensity'
            ? Object.values(this.workbenchIntensityDraft())
            : Object.values(this.workbenchPromptDraft.models);
        return entries.filter((value: any) => String(value || '').trim()).length;
    }

    public workbenchIntensityDraft(expression: string = this.workbenchExpression): { [key: number]: string } {
        if (expression.startsWith('custom:')) {
            const expressionId = expression.slice(7);
            if (!this.workbenchPromptDraft.custom_expression_intensities[expressionId]) {
                this.workbenchPromptDraft.custom_expression_intensities[expressionId] = {};
            }
            return this.workbenchPromptDraft.custom_expression_intensities[expressionId];
        }
        return expression === 'realistic' ? this.workbenchPromptDraft.intensities
            : this.workbenchPromptDraft.expression_intensities[expression as 'trigger' | 'blur'];
    }

    public workbenchSetIntensityPrompt(value: string) {
        this.workbenchIntensityDraft()[this.workbenchPromptEditIntensity] = value.slice(
            0, this.workbenchCustomExpression() ? 320 : 500
        );
        this.workbenchPromptChanged();
    }

    public workbenchAddTriggerElement() {
        const value = this.workbenchNewTriggerElement.trim().slice(0, 160);
        if (!value || this.workbenchPromptDraft.trigger_elements.length >= 12
            || this.workbenchPromptDraft.trigger_elements.includes(value)) return;
        this.workbenchPromptDraft.trigger_elements = [...this.workbenchPromptDraft.trigger_elements, value];
        this.workbenchNewTriggerElement = '';
        this.workbenchPromptChanged();
        this.changeDetector.detectChanges();
    }

    public workbenchSetTriggerElement(index: number, value: string) {
        if (index < 0 || index >= this.workbenchPromptDraft.trigger_elements.length) return;
        this.workbenchPromptDraft.trigger_elements[index] = value.slice(0, 160);
        // Blank in-progress rows are kept locally. Save once the row has content.
        if (this.workbenchPromptDraft.trigger_elements.every((item) => item.trim())) {
            this.workbenchPromptChanged();
        }
    }

    public workbenchCommitTriggerElement(index: number) {
        if (this.workbenchPromptDraft.trigger_elements[index]?.trim()) return;
        // A Delete click fires after input blur. Defer cleanup so it cannot delete
        // both the blank row and the next row in the same pointer action.
        window.setTimeout(() => {
            if (this.workbenchPromptDraft.trigger_elements[index] === '') {
                this.workbenchRemoveTriggerElement(index);
            }
        }, 0);
    }

    public workbenchRemoveTriggerElement(index: number) {
        this.workbenchPromptDraft.trigger_elements.splice(index, 1);
        this.workbenchPromptChanged();
        this.changeDetector.detectChanges();
    }

    public workbenchPromptAdjustments(intensity: number, modelKey: string) {
        const custom = this.workbenchCustomExpression();
        const reference = this.workbenchReproductionReference();
        const plan = this.workbenchPromptDraft.reference_plan;
        return {
            common: String(this.workbenchPromptDraft.common || '').trim(),
            intensity: !this.workbenchExpressionUsesIntensity() ? '' : String(this.workbenchIntensityDraft()[intensity] || '').trim(),
            intensity_expression: this.workbenchServerExpression(),
            custom_expression: custom ? { id: custom.id, name: custom.name,
                description: custom.description, uses_intensity: custom.uses_intensity !== false } : null,
            custom_expression_prompt: custom?.uses_intensity === false ? this.workbenchCustomCommonPrompt().trim() : '',
            trigger_elements: this.workbenchExpression === 'trigger'
                ? (this.workbenchPromptDraft.trigger_elements || []).map((value) => value.trim()).filter(Boolean) : [],
            reference_plan: this.workbenchExpression === 'realistic' && this.workbenchReferenceEnabled() && reference
                && plan.kind === reference.kind && plan.id === reference.id
                ? { target: plan.target.trim(), traits: this.workbenchReferenceStageTraits(intensity),
                    withheld_traits: plan.traits.slice(this.workbenchReferenceStageTraits(intensity).length),
                    scene_lock: plan.scene_lock.trim(), stage_level: intensity } : null,
            reference_instruction: this.workbenchExpression !== 'realistic'
                && this.workbenchReferenceEnabled() && this.workbenchVisualReferenceAvailable()
                ? this.workbenchReferenceInstruction().trim() : '',
            model: String(this.workbenchPromptDraft.models[modelKey] || '').trim()
        };
    }

    public workbenchAgentTarget(section: string, key: string | number = '') {
        if (this.workbenchAgentHighlightPhase === 'idle') return false;
        return this.workbenchAgentHighlightTargets.some((target) =>
            target.section === section && (key === '' || target.key === String(key))
        );
    }

    public workbenchAgentReadingExpression(expression: 'realistic' | 'trigger' | 'blur') {
        return this.workbenchAgentHighlightPhase !== 'idle'
            && this.workbenchAgentHighlightMode === 'reading'
            && this.workbenchAgentReadExpressions.includes(expression);
    }

    private workbenchAgentClearHighlight() {
        if (this.workbenchAgentHighlightTimer !== null) {
            window.clearTimeout(this.workbenchAgentHighlightTimer);
            this.workbenchAgentHighlightTimer = null;
        }
        this.workbenchAgentHighlightPhase = 'idle';
        this.workbenchAgentHighlightMode = 'editing';
        this.workbenchAgentHighlightTargets = [];
        this.workbenchAgentReadExpressions = [];
    }

    private workbenchAgentStartHighlight(request: string) {
        if (!this.workbenchAgentPromptContext()) return;
        if (this.form.media_type === 'audio') {
            this.workbenchAgentPulseTarget('workbench-audio-prompt');
            return;
        }
        this.workbenchAgentClearHighlight();
        const isQuestion = (/[?？]\s*$/.test(request) || /안\s*되는데|같은데|들어갔거든|문제/.test(request))
            && !/해\s*줘|해주세요|해줄래|넣어\s*줘|바꿔\s*줘|수정해\s*줘|삭제해\s*줘|저장해\s*줘|생성해\s*줘|선택해\s*줘|적용해\s*줘|추가해\s*줘/.test(request);
        if (isQuestion) {
            this.workbenchAgentHighlightMode = 'reading';
            this.workbenchAgentHighlightPhase = 'working';
            if (/사실적\s*묘사|참고\s*이미지\s*재현/.test(request)) this.workbenchAgentReadExpressions.push('realistic');
            if (/트리거\s*요소/.test(request)) this.workbenchAgentReadExpressions.push('trigger');
            if (/블러\s*처리/.test(request)) this.workbenchAgentReadExpressions.push('blur');
            if (/프롬프트|강도|표현/.test(request)) {
                this.workbenchAgentHighlightTargets = [{ section: 'intensity', key: '' }];
                this.workbenchExpressionStageOpen = true;
            }
            this.changeDetector.detectChanges();
            window.setTimeout(() => {
                if (this.workbenchAgentHighlightPhase !== 'working'
                    || this.workbenchAgentHighlightMode !== 'reading') return;
                document.getElementById(this.workbenchAgentReadExpressions.length
                    ? 'wb-agent-expression' : 'wb-prompt-title')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 0);
            return;
        }
        this.workbenchAgentHighlightMode = 'editing';
        const targets: Array<{ section: 'common' | 'intensity' | 'trigger_elements' | 'expression_common' | 'model' | 'reference_plan'; key: string }> = [];
        if (/참고\s*이미지.*(?:반영\s*계획|비교\s*대상|특징|고정할\s*장면)/.test(request)) {
            targets.push({ section: 'reference_plan', key: 'target' });
        }
        if (/트리거\s*(?:요소|단서)/.test(request)) {
            targets.push({ section: 'trigger_elements', key: 'all' });
        }
        const range = /(?:강도(?:별\s*조정)?\s*)?([1-5])\s*(?:~|〜|–|-|부터)\s*([1-5])\s*(?:단계|강도)?/.exec(request);
        if (range && Number(range[1]) <= Number(range[2])) {
            for (let value = Number(range[1]); value <= Number(range[2]); value++) {
                targets.push({ section: 'intensity', key: String(value) });
            }
        } else if (/(?:모든|전부|전체)\s*(?:강도|단계)|(?:강도|단계)\s*(?:모두|전부|전체)/.test(request)) {
            for (const value of this.intensityOptions) targets.push({ section: 'intensity', key: String(value) });
        } else {
            const one = /강도(?:별\s*조정)?\s*([1-5])|([1-5])\s*단계/.exec(request);
            if (one) {
                targets.push({ section: 'intensity', key: one[1] || one[2] });
            }
        }
        if (/공통/.test(request)) targets.push({ section: 'common', key: 'common' });
        if (/모델별\s*조정|모델\s*프롬프트/.test(request)) targets.push({ section: 'model', key: '' });
        this.workbenchAgentHighlightTargets = targets;
        this.workbenchAgentHighlightPhase = 'working';
        if (targets.length) {
            this.workbenchExpressionStageOpen = true;
            if (targets[0].section === 'common' || targets[0].section === 'model') {
                this.workbenchPromptOpen = true;
                this.workbenchPromptSection = targets[0].section;
            }
            if (targets[0].section === 'intensity') this.workbenchPromptEditIntensity = Number(targets[0].key);
        }
        this.changeDetector.detectChanges();
        window.setTimeout(() => {
            if (this.workbenchAgentHighlightPhase !== 'working') return;
            const first = targets[0];
            const fieldId = first?.section === 'reference_plan' ? 'wb-reference-plan'
                : first?.section === 'common' ? 'wb-common-prompt'
                : first?.section === 'intensity' ? `wb-intensity-prompt-${first.key}`
                    : first?.section === 'trigger_elements' ? 'wb-agent-expression'
                    : first?.section === 'model' ? 'wb-model-prompt' : 'wb-prompt-title';
            document.getElementById(fieldId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
    }

    private workbenchAgentCompleteReadHighlight() {
        this.workbenchAgentHighlightPhase = 'complete';
        this.workbenchAgentHighlightTimer = window.setTimeout(() => {
            this.workbenchAgentClearHighlight();
            this.changeDetector.detectChanges();
        }, 3200);
        this.changeDetector.detectChanges();
    }

    private workbenchAgentCompleteHighlight(edits: Array<{ section: 'common' | 'intensity' | 'trigger_elements' | 'expression_common' | 'model' | 'reference_plan'; key: string }>) {
        this.workbenchAgentClearHighlight();
        this.workbenchAgentHighlightTargets = edits.map((edit) => ({ section: edit.section, key: edit.key }));
        this.workbenchAgentHighlightPhase = 'complete';
        this.workbenchAgentHighlightTimer = window.setTimeout(() => {
            this.workbenchAgentClearHighlight();
            this.changeDetector.detectChanges();
        }, 4200);
    }

    private workbenchAgentPromptContext() {
        if (this.form.media_type === 'audio') return this.workbenchAgentAudioContext();
        if (this.loading || !this.can('content.write') || this.sourceMode !== 'scenario'
            || this.form.media_type !== 'image' || !this.selectedScenarioSet()) return null;
        const scenario = this.selectedScenarioSet();
        const cut = this.selectedScenarioCut();
        const cutSpec = this.scenarioAnalysisState === 'complete' ? this.scenarioCutRequestSpec() : null;
        const allMatchingImages = this.allReviewAssets('image').filter((asset: any) =>
            this.recordMatchesSelectedSource(asset) && (!cut || this.scenarioCutRecordMatches(asset, cut))
        );
        const selectedImage = allMatchingImages.find((asset: any) => this.assetId(asset) === this.assetId(this.selectedAsset));
        const matchingImages = allMatchingImages.slice(0, 12);
        if (selectedImage && !matchingImages.includes(selectedImage)) matchingImages[matchingImages.length - 1] = selectedImage;
        const imageIdentity = (asset: any) => asset ? {
            revision_id: this.assetId(asset), generation_job_id: this.jobId(asset),
            expression: String(asset.image_expression || this.primaryMetadata(asset)?.image_expression || ''),
            intensity: this.jobIntensity(asset), model: this.imageAssetModelKey(asset)
        } : null;
        const referenceEnabled = this.workbenchReferenceEnabled();
        const templateId = this.templateIdForScenarioGeneration('image');
        const template = this.templates.find((item: any) =>
            String(item?.id || item?.template_id || '') === templateId
        );
        const intensities: { [key: string]: string } = {};
        const expression_intensities: { [key: string]: { [key: string]: string } } = {};
        const models: { [key: string]: string } = {};
        for (const expression of ['realistic', 'trigger', 'blur']) {
            expression_intensities[expression] = {};
            for (const intensity of this.intensityOptions) {
                expression_intensities[expression][String(intensity)] =
                    String(this.workbenchIntensityDraft(expression as 'realistic' | 'trigger' | 'blur')[intensity] || '');
            }
        }
        for (const custom of (this.workbenchCustomExpressions || [])) {
            const key = `custom:${custom.id}`;
            expression_intensities[key] = {};
            for (const intensity of this.intensityOptions) {
                expression_intensities[key][String(intensity)] = String(
                    this.workbenchIntensityDraft(key)[intensity] || ''
                );
            }
        }
        for (const intensity of this.intensityOptions) {
            intensities[String(intensity)] = expression_intensities[this.workbenchExpression]?.[String(intensity)] || '';
        }
        for (const key of this.workbenchSelectedModels) {
            models[key] = String(this.workbenchPromptDraft.models[key] || '');
        }
        return {
            kind: 'scenario_image_prompt',
            blur: this.workbenchAgentBlurContext(),
            connected_actions: ['set_intensities', 'set_models', 'set_image_count', 'set_expression',
                'save_prompt', 'generate_images', 'attach_reference_image', 'add_custom_expression', 'set_expression_intensity', 'show_image_results', 'compare_image_results', 'download_images'],
            result_models: this.workbenchImageResultModelKeys(),
            comparison: {
                scope: 'cut',
                expressions: this.workbenchComparisonExpressions().map(({ key, label }) => ({ key, label })),
                models_with_results: this.workbenchComparisonModels(),
                current: {
                    expression: this.workbenchCompareExpression || 'blur',
                    intensity: this.workbenchCompareIntensity || 3,
                    mode: this.workbenchResultView || 'model',
                    model: this.workbenchCompareModel || this.workbenchComparisonModels()[0] || '',
                    expanded: !!this.workbenchCompareExpanded
                }
            },
            image_results: {
                can_query: true,
                scope: this.workbenchImageResultFilterActive() ? this.workbenchImageResultFilter!.scope : 'cut',
                filter_models: this.workbenchImageResultFilterActive() ? this.workbenchImageResultFilter!.models : [],
                matched_count: this.workbenchImageResultFilterActive() ? this.workbenchFilteredImageTiles().length : 0
            },
            scenario_id: String(this.scenarioSelection.scenario_set_id || '').toUpperCase(),
            memory_kind: String(this.scenarioSelection.memory_kind || 'trauma'),
            cut_order: Number(this.selectedScenarioCutOrder || 0),
            scenario_cut_spec: cutSpec,
            analysis_snapshot_sha256: String(cutSpec?.analysis_snapshot_sha256 || ''),
            analysis_contract_version: Number(cutSpec?.analysis_contract_version || 0),
            selected_image: imageIdentity(selectedImage),
            available_image_revisions: matchingImages.map(imageIdentity),
            source_revision_id: selectedImage ? this.assetId(selectedImage) : '',
            image_quality: this.selectedImageQuality || 'low',
            image_prompt_strategy: this.imagePromptStrategy || 'legacy',
            continuity_master_revision_id: this.workbenchSceneMasterRevisionId || '',
            scenario_photo_id: referenceEnabled ? this.workbenchScenarioPhotoId || '' : '',
            reference_enabled: referenceEnabled,
            reference_id: referenceEnabled ? String(this.selectedReferenceCondition?.reference_id || '') : '',
            reference_usage_mode: referenceEnabled ? this.referenceUsageMode || 'none' : 'none',
            reference_roles: referenceEnabled ? [...(this.referenceRoles || [])] : [],
            reference_strength: this.referenceStrength || 'medium',
            scenario_title: String(scenario?.title || scenario?.name || '').slice(0, 160),
            cut_title: String(cut?.title || cut?.summary || '').slice(0, 240),
            template_version: Number(template?.version || 0),
            template_id: templateId,
            template_preview: String(template?.positive_prompt_preview || '').slice(0, 1600),
            base_prompt: JSON.stringify(this.selectedScenarioPrompt() || {}).slice(0, 1600),
            selected_models: [...this.workbenchSelectedModels],
            available_models: this.generationModelOptions.image
                .filter((model: any) => this.generationModelAvailable(model.value, 'image'))
                .map((model: any) => String(model.value)),
            available_model_labels: Object.fromEntries(this.generationModelOptions.image
                .filter((model: any) => this.generationModelAvailable(model.value, 'image'))
                .map((model: any) => [String(model.value), this.workbenchModelLabel(model.value)])),
            model_labels: Object.fromEntries(this.workbenchSelectedModels.map((key: string) => [key, this.workbenchModelLabel(key)])),
            selected_intensities: [...this.workbenchSelectedIntensities],
            image_count_per_model: this.imageCandidateCount,
            expression: this.workbenchExpression,
            reference_reproduction: this.workbenchReproductionReference() ? {
                active: this.workbenchExpression === 'realistic' && this.workbenchReferenceEnabled(),
                reference: { kind: this.workbenchReproductionReference()!.kind,
                    id: this.workbenchReproductionReference()!.id,
                    source: this.workbenchReproductionReference()!.source,
                    roles: this.workbenchReproductionReference()!.roles },
                feature_plan: this.workbenchReferencePlanCurrent() ? {
                    target: this.workbenchPromptDraft.reference_plan.target,
                    traits: [...this.workbenchPromptDraft.reference_plan.traits],
                    scene_lock: this.workbenchPromptDraft.reference_plan.scene_lock
                } : null,
                image_supplied: false,
                levels: Object.fromEntries([1, 2, 3, 4, 5].map(level => [level, this.workbenchReproductionRubric(level)])),
                meaning: 'requested reference reconstruction level; actual result similarity requires visual review'
            } : null,
            custom_expressions: (this.workbenchCustomExpressions || []).map((item: any) => ({
                id: item.id, name: item.name, description: item.description, uses_intensity: item.uses_intensity !== false
            })),
            intensity_adjustment_scope: 'realistic_blur_custom_per_intensity;triggers_per_cut',
            total_image_count: this.workbenchTotalImageCount(),
            estimated_cost: this.workbenchEstimatedCostLabel(),
            draft: { common: String(this.workbenchPromptDraft.common || ''), intensities, expression_intensities,
                expression_common: Object.fromEntries((this.workbenchCustomExpressions || []).map((item: any) =>
                    [`custom:${item.id}`, this.workbenchCustomCommonPrompt(`custom:${item.id}`)])),
                trigger_elements: [...(this.workbenchPromptDraft.trigger_elements || [])], models,
                reference_plan: this.workbenchReferencePlanCurrent() ? {
                    target: String(this.workbenchPromptDraft.reference_plan.target || ''),
                    traits: [...this.workbenchPromptDraft.reference_plan.traits],
                    scene_lock: String(this.workbenchPromptDraft.reference_plan.scene_lock || '')
                } : { target: '', traits: [], scene_lock: '' } }
        };
    }

    private workbenchAgentAudioContext() {
        if (this.loading || !this.can('content.write') || this.sourceMode !== 'scenario'
            || this.form.media_type !== 'audio' || !this.selectedScenarioSet()) return null;
        const cut = this.selectedScenarioCut();
        const spec = this.scenarioCutRequestSpec();
        return {
            kind: 'scenario_audio_prompt',
            scenario_id: String(this.scenarioSelection.scenario_set_id || '').toUpperCase(),
            scenario_title: String(this.selectedScenarioSet()?.title || '').slice(0, 160),
            memory_kind: String(this.scenarioSelection.memory_kind || 'trauma'),
            cut_order: Number(cut?.order || 0),
            analysis_snapshot_sha256: String(spec?.analysis_snapshot_sha256 || ''),
            selected_cut: cut ? {
                order: Number(cut.order), title: String(cut.title || ''),
                event: String(cut.event || ''), time_place: String(cut.time_place || ''),
                sensory_cues: (cut.sensory_cues || []).slice(0, 6),
                sound: String(cut.production?.sound || '')
            } : null,
            connected_actions: ['edit_audio_prompt', 'set_audio_model', 'set_audio_intensity',
                'set_audio_duration', 'generate_audio'],
            available_models: this.generationModelOptions.audio
                .filter((model: any) => this.generationModelAvailable(model.value, 'audio'))
                .map((model: any) => model.value),
            available_model_labels: Object.fromEntries(this.generationModelOptions.audio
                .map((model: any) => [model.value, model.label])),
            audio: {
                model: String(this.selectedGenerationModelKeys.audio || ''),
                prompt_text: String(this.audioPromptText || ''),
                prompt_label: this.audioPromptLabel(), prompt_limit: this.audioPromptLimit(),
                intensity: Number(this.form.intensity), duration_seconds: Number(this.audioDurationSeconds),
                duration_options: [...this.audioDurationOptions],
                can_generate: this.workbenchCanGenerateCurrentMedia(),
                block_reason: this.workbenchAudioGenerationBlockReason(),
                request_key: String(this.form.idempotency_key || '')
            }
        };
    }

    private workbenchAudioGenerationRequested(request: string): boolean {
        if (/[?？]$/.test(request.trim()) && !/(?:해|만들어|뽑아)\s*(?:줘|주세요|줄래|줄\s*수|주실\s*수|주시겠|주겠)/.test(request)) return false;
        if (/생성(?:은|을)?\s*(?:하지\s*마|하지\s*말|금지|하지\s*않)|만들지\s*(?:마|말)|(?:don't|do\s+not)\s+(?:generate|create|make)/i.test(request)) return false;
        const text = request.replace(/(?:오디오|음향|음성|음악|효과음|환경음)?\s*생성(?:용|을\s*위한)?\s*(?:프롬프트|대본|설명)/g, '');
        return /(?:오디오|음향|음성|나레이션|배경음악|효과음|환경음|클립|음악|소리|사운드)(?:\s*파일)?(?:을|를|도|만|로|으로)?\s*(?:생성|만들|뽑아)|(?:이걸로|이대로|이\s*설정으로|지금\s*설정으로|현재\s*설정으로)\s*(?:생성|만들)|^\s*생성(?:을)?\s*(?:해|시작|진행)|(?:generate|create|make)\s+(?:the\s+)?(?:audio|sound|music|narration)/i.test(text);
    }

    private async workbenchExecuteAgentAudioAction(action: any, original: any,
        isCancelled: () => boolean, onProgress: (label: string) => void, request: string) {
        const current = this.workbenchAgentAudioContext();
        if (!current || original?.kind !== current.kind || current.scenario_id !== original.scenario_id
            || current.memory_kind !== original.memory_kind || current.cut_order !== original.cut_order
            || current.analysis_snapshot_sha256 !== original.analysis_snapshot_sha256) {
            return { applied: false, message: '선택한 컷이나 화면이 바뀌었습니다. 현재 컷에서 다시 요청해주세요.' };
        }
        const fields = ['model', 'prompt_text', 'intensity', 'duration_seconds', 'request_key'];
        if (fields.some((key) => current.audio[key] !== original.audio?.[key])) {
            return { applied: false, message: '오디오 입력이나 설정이 바뀌었습니다. 현재 내용을 확인한 뒤 다시 요청해주세요.' };
        }
        const edits = action?.edits || [];
        const operations = action?.operations || [];
        if (!['edit_prompts', 'run_actions'].includes(action?.kind) || !Array.isArray(edits)
            || !Array.isArray(operations) || edits.length > 1 || operations.length > 4
            || (action.kind === 'edit_prompts' ? edits.length !== 1 : edits.length !== 0 || !operations.length)) {
            return { applied: false, message: '허용되지 않은 오디오 작업입니다.' };
        }
        let model = current.audio.model;
        let intensity = current.audio.intensity;
        let duration = current.audio.duration_seconds;
        const seen = new Set<string>();
        for (const operation of operations) {
            if (!['set_audio_model', 'set_audio_intensity', 'set_audio_duration', 'generate_audio'].includes(operation?.type)
                || operation.attachment_index !== -1 || typeof operation.value !== 'string'
                || seen.has(operation.type) || seen.has('generate_audio')) {
                return { applied: false, message: '허용되지 않은 오디오 작업입니다.' };
            }
            seen.add(operation.type);
            if (operation.type === 'set_audio_model') {
                if (!current.available_models.includes(operation.value)) return { applied: false, message: '연결된 오디오 모델을 선택해주세요.' };
                model = operation.value;
            } else if (operation.type === 'set_audio_intensity') {
                if (!/^[1-5]$/.test(operation.value)) return { applied: false, message: '오디오 강도는 1~5에서 선택해주세요.' };
                intensity = Number(operation.value);
            } else if (operation.type === 'set_audio_duration') {
                if (!['10', '20', '30', '60'].includes(operation.value)) return { applied: false, message: '지원하는 클립 길이를 선택해주세요.' };
                duration = Number(operation.value);
            } else if (operation.value !== '') return { applied: false, message: '오디오 생성 요청을 확인하지 못했습니다.' };
        }
        if (model === 'evolink-qwen-tts' && seen.has('set_audio_duration')) {
            return { applied: false, message: '나레이션 길이는 입력한 대본에 따라 정해집니다.' };
        }
        if (seen.has('generate_audio') && !this.workbenchAudioGenerationRequested(request)) {
            return { applied: false, message: '오디오 생성은 생성 요청이 있을 때만 실행할 수 있습니다.' };
        }
        let text = model === current.audio.model ? current.audio.prompt_text : '';
        if (edits.length) {
            const edit = edits[0];
            if (edit.section !== 'audio_prompt' || edit.key !== 'audio_prompt' || edit.expression !== ''
                || edit.expected !== current.audio.prompt_text || typeof edit.value !== 'string') {
                return { applied: false, message: '오디오 입력란의 수정안을 확인하지 못했습니다.' };
            }
            text = edit.value;
        }
        const limit = model === 'evolink-seed-audio' ? 1500 : model === 'evolink-suno' ? 1000 : 5000;
        if (text.length > limit) return { applied: false, message: `오디오 입력은 ${limit}자 이내로 작성해주세요.` };
        if (isCancelled()) return { applied: false, message: '요청이 중지되었습니다.' };
        onProgress('선택한 컷의 오디오 입력과 설정 적용 중');
        this.selectedGenerationModelKeys.audio = model;
        this.audioPromptText = text;
        this.form.intensity = intensity;
        this.audioDurationSeconds = duration;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
        this.workbenchAgentPulseTarget(edits.length ? 'workbench-audio-prompt' : 'workbench-audio-model');
        const labels = [
            ...(edits.length ? ['오디오 설명 입력'] : []),
            ...(seen.has('set_audio_model') ? ['오디오 모델 선택'] : []),
            ...(seen.has('set_audio_intensity') ? [`강도 ${intensity} 선택`] : []),
            ...(seen.has('set_audio_duration') ? [`최대 ${duration}초 선택`] : [])
        ];
        if (seen.has('generate_audio')) {
            if (isCancelled()) return { applied: false, label: labels.join(' · '), message: '생성 요청을 중지했습니다.' };
            const reason = this.workbenchAudioGenerationBlockReason();
            if (reason) return { applied: false, label: labels.join(' · '), message: reason };
            onProgress('선택한 컷의 오디오 생성 요청 등록 중');
            const jobs = await this.createScenarioJob(true);
            if (!Array.isArray(jobs) || !jobs.some((job: any) => !!this.jobId(job))) {
                return { applied: false, label: labels.join(' · '), message: this.errorMessage || '오디오 생성 요청이 등록되지 않았습니다.' };
            }
            labels.push('오디오 생성 요청 등록');
        }
        return { applied: true, label: labels.join(' · '),
            message: `${current.cut_order}번 컷 ‘${current.selected_cut?.title || ''}’에 ${labels.join(' · ')}했습니다.`
                + (seen.has('generate_audio') ? ' 진행 상태와 완료된 오디오는 결과 영역에서 확인할 수 있습니다.' : '') };
    }

    private workbenchAgentBlurContext() {
        const sources = this.workbenchBlurSources();
        const source = sources.find((asset: any) => this.assetId(asset) === this.workbenchBlurSourceId) || sources[0] || null;
        const data = this.primaryMetadata(source);
        const expression = String(source?.image_expression || data?.image_expression || 'realistic');
        const intensity = source ? this.jobIntensity(source) : '-';
        const model = source ? this.imageAssetModelKey(source) : '';
        const region = this.workbenchBlurRegion || { x: 0, y: 0, width: 1, height: .55 };
        return {
            active: this.workbenchExpression === 'blur',
            available_source_count: sources.length,
            selected_source: source ? {
                origin: 'generated_image_result',
                asset_revision_id: this.assetId(source).slice(0, 128),
                generation_job_id: String(source.job_id || source.generation_job_id || data?.generation_job_id || '').slice(0, 128),
                model, model_label: this.workbenchModelLabel(model),
                cut_order: this.scenarioCutOrder(source),
                cut_title: this.scenarioCutTitle(source).slice(0, 240),
                expression,
                intensity: expression !== 'trigger' && typeof intensity === 'number' ? intensity : null,
                condition_label: this.imageResultConditionLabel(source).slice(0, 160),
                created_at: String(source.created_at || source.created || data?.created_at || data?.created || '').slice(0, 40)
            } : null,
            region_percent: { x: this.workbenchBlurPercent(region.x), y: this.workbenchBlurPercent(region.y),
                width: this.workbenchBlurPercent(region.width), height: this.workbenchBlurPercent(region.height) },
            selected_intensities: [...this.workbenchSelectedIntensities]
        };
    }

    private async workbenchExecuteAgentAction(action: any, originalContext: any, files: File[] = [], isCancelled: () => boolean = () => false, onProgress: (label: string) => void = () => {}, request: string = '') {
        if (this.form.media_type === 'audio' || originalContext?.kind === 'scenario_audio_prompt') {
            return this.workbenchExecuteAgentAudioAction(action, originalContext, isCancelled, onProgress, request);
        }
        const operations = Array.isArray(action?.operations) ? action.operations : [];
        const current = this.workbenchAgentPromptContext();
        if (!current || !originalContext || current.scenario_id !== originalContext.scenario_id
            || current.memory_kind !== originalContext.memory_kind
            || current.cut_order !== originalContext.cut_order || !this.can('content.write')) {
            return { applied: false, message: '작업 중 선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.' };
        }
        if (!['edit_prompts', 'run_actions'].includes(action?.kind)
            || operations.length > 7
            || (action.kind === 'run_actions' && (!operations.length || action.edits?.length))) {
            return { applied: false, message: '허용되지 않은 워크벤치 작업입니다.' };
        }
        const planRequest = /참고\s*이미지\s*반영\s*계획/.test(String(request || ''))
            && /채워|작성|수정|바꿔|입력|넣어|설정/.test(String(request || ''))
            && !/계획을?\s*바탕으로|계획을?\s*참고해서/.test(String(request || ''));
        if (planRequest && current.reference_reproduction?.active) {
            const edits = Array.isArray(action?.edits) ? action.edits : [];
            const plan = current.draft.reference_plan;
            const emptyFields = ['target', 'traits', 'scene_lock'].filter((key) => !plan[key]?.length);
            if (action.kind !== 'edit_prompts' || operations.length || !edits.length
                || edits.some((edit: any) => edit.section !== 'reference_plan')
                || emptyFields.some((key) => !edits.some((edit: any) => edit.key === key))) {
                return { applied: false, message: '단계별 참고 이미지 반영 계획 입력칸에 수정안이 적용되지 않았습니다. 다시 요청해주세요.' };
            }
        }
        const seen = new Set<string>();
        const prepared: Array<{ type: string; value: any; attachment_index: number }> = [];
        for (const operation of operations) {
            const type = operation?.type;
            const raw = operation?.value === undefined ? '' : operation.value;
            if (!['set_intensities', 'set_models', 'set_image_count', 'set_expression',
                    'save_prompt', 'generate_images', 'attach_reference_image', 'add_custom_expression', 'set_expression_intensity', 'show_image_results', 'compare_image_results', 'download_images'].includes(type)
                || seen.has(type) || !Number.isInteger(operation?.attachment_index)
                || typeof raw !== 'string' || raw.length > 500
                || (type !== 'attach_reference_image' && operation.attachment_index !== -1)
                || (type === 'generate_images' && seen.has('attach_reference_image'))
                || (type === 'attach_reference_image' && seen.has('generate_images'))
                || (type.startsWith('set_') && seen.has('generate_images'))) {
                return { applied: false, message: '허용되지 않은 워크벤치 작업입니다.' };
            }
            let value: any = raw;
            if (type === 'set_intensities') {
                if (!/^[1-5](,[1-5]){0,4}$/.test(raw)) return { applied: false, message: '선택할 강도를 확인하지 못했습니다.' };
                value = raw.split(',').map(Number);
                if (new Set(value).size !== value.length) return { applied: false, message: '선택할 강도를 확인하지 못했습니다.' };
                value.sort((a: number, b: number) => a - b);
            } else if (type === 'set_models') {
                value = raw.split(',');
                if (value.length < 1 || value.length > 8 || new Set(value).size !== value.length
                    || value.some((key: string) => !this.generationModelOptions.image.some(
                        (model: any) => model.value === key && this.generationModelAvailable(key, 'image')))) {
                    return { applied: false, message: '선택할 이미지 모델을 확인하지 못했습니다.' };
                }
            } else if (type === 'set_image_count') {
                if (!/^[1-5]$/.test(raw)) return { applied: false, message: '모델별 이미지 수를 확인하지 못했습니다.' };
                value = Number(raw);
            } else if (type === 'set_expression') {
                if (!['realistic', 'trigger', 'blur'].includes(raw)
                    && !this.workbenchCustomExpressions.some((item: any) => `custom:${item.id}` === raw)) {
                    return { applied: false, message: '강도별 표현 방식을 확인하지 못했습니다.' };
                }
            } else if (type === 'show_image_results') {
                try {
                    value = JSON.parse(raw);
                    const knownModels = this.workbenchImageResultModelKeys();
                    if (!value || Object.keys(value).sort().join(',') !== 'models,scope'
                        || !['cut', 'scenario'].includes(value.scope) || !Array.isArray(value.models)
                        || value.models.length > 8 || new Set(value.models).size !== value.models.length
                        || value.models.some((key: any) => typeof key !== 'string' || !knownModels.includes(key))) throw new Error();
                } catch (_error) {
                    return { applied: false, message: '표시할 이미지 조건을 확인하지 못했습니다.' };
                }
            } else if (type === 'compare_image_results') {
                try {
                    value = JSON.parse(raw);
                    if (!value || Object.keys(value).sort().join(',') !== 'expanded,expression,intensity,mode,model'
                        || typeof value.expression !== 'string'
                        || (value.expression !== '' && !this.workbenchComparisonExpressions().some(option => option.key === value.expression))
                        || (value.intensity !== null && (!Number.isInteger(value.intensity) || value.intensity < 1 || value.intensity > 5))
                        || !['', 'model', 'intensity'].includes(value.mode)
                        || typeof value.model !== 'string'
                        || (value.model !== '' && !this.workbenchImageResultModelKeys().includes(value.model))
                        || (value.expanded !== null && typeof value.expanded !== 'boolean')) throw new Error();
                    const expression = value.expression || this.workbenchCompareExpression || 'blur';
                    if (!this.workbenchComparisonUsesIntensity(expression) && (value.mode === 'intensity' || value.intensity !== null)) {
                        return { applied: false, message: '강도 없는 표현은 강도 구분 없이 모델별로 비교합니다.' };
                    }
                } catch (_error) {
                    return { applied: false, message: '비교할 이미지 조건을 확인하지 못했습니다.' };
                }
            } else if (type === 'download_images') {
                try {
                    value = JSON.parse(raw);
                    if (!value || Object.keys(value).sort().join(',') !== 'model,scope'
                        || !['scenario', 'model'].includes(value.scope)
                        || typeof value.model !== 'string'
                        || (value.scope === 'scenario' && value.model !== '')
                        || (value.scope === 'model' && !this.workbenchImageResultModelKeys().includes(value.model))) throw new Error();
                } catch (_error) {
                    return { applied: false, message: '다운로드할 시나리오와 모델을 확인하지 못했습니다.' };
                }
            } else if (type === 'set_expression_intensity') {
                try {
                    value = JSON.parse(raw);
                    if (!value || Object.keys(value).sort().join(',') !== 'expression_id,uses_intensity'
                        || typeof value.uses_intensity !== 'boolean'
                        || !current.custom_expressions?.some((item: any) => item.id === value.expression_id)) throw new Error();
                    const previous = originalContext.custom_expressions?.find((item: any) => item.id === value.expression_id);
                    const now = current.custom_expressions.find((item: any) => item.id === value.expression_id);
                    if (!previous || (previous.uses_intensity !== false) !== (now.uses_intensity !== false)) throw new Error();
                } catch (_error) {
                    return { applied: false, message: '변경할 표현과 현재 강도 설정을 확인한 뒤 다시 요청해주세요.' };
                }
            } else if (type === 'add_custom_expression') {
                try {
                    value = JSON.parse(raw);
                    if (Object.keys(value).sort().join(',') !== 'description,name'
                        || typeof value.name !== 'string' || !value.name.trim() || value.name.trim().length > 60
                        || typeof value.description !== 'string' || !value.description.trim()
                        || value.description.trim().length > 300) throw new Error();
                } catch (_error) {
                    return { applied: false, message: '새 표현의 이름과 설명을 확인하지 못했습니다.' };
                }
            } else if (raw) {
                return { applied: false, message: '워크벤치 작업 형식이 올바르지 않습니다.' };
            }
            if (type === 'attach_reference_image') {
                const file = files[operation.attachment_index];
                if (!file || !/\.(png|jpe?g|webp)$/i.test(file.name)
                    || (file.type && !/^image\/(png|jpeg|webp)$/.test(file.type))) {
                    return { applied: false, message: '채팅에 PNG·JPG·WEBP 참고 이미지를 첨부해주세요.' };
                }
            }
            prepared.push({ type, value, attachment_index: operation.attachment_index });
            seen.add(type);
        }
        if (seen.has('add_custom_expression') && prepared.length !== 1) {
            return { applied: false, message: '새 표현 추가는 다른 작업과 분리해서 요청해주세요.' };
        }
        if (seen.has('set_expression_intensity')) {
            if (prepared.length !== 1 || action.kind !== 'run_actions' || action.edits?.length || isCancelled()) {
                return { applied: false, message: '표현의 강도 사용 변경은 다른 작업과 분리해서 요청해주세요.' };
            }
            const value = prepared[0].value;
            const custom = current.custom_expressions.find((item: any) => item.id === value.expression_id);
            onProgress(`${custom.name} 표현의 강도 사용 설정을 저장 중`);
            const changed = await this.workbenchSetCustomExpressionIntensity(value.expression_id, value.uses_intensity, isCancelled);
            return changed ? { applied: true, label: `${custom.name} 강도 설정`, message: value.uses_intensity
                ? `${custom.name} 표현을 강도 1~5별 프롬프트를 사용하는 방식으로 변경했습니다.`
                : `${custom.name} 표현을 강도 없이 공통 프롬프트 하나를 사용하는 방식으로 변경했습니다. 기존 강도별 초안은 보존했습니다.` }
                : { applied: false, message: this.workbenchExpressionError || '표현의 강도 설정을 저장하지 못했습니다.' };
        }
        if (seen.has('show_image_results')) {
            if (prepared.length !== 1 || action.kind !== 'run_actions' || action.edits?.length) {
                return { applied: false, message: '이미지 결과 조회는 다른 작업과 분리해서 요청해주세요.' };
            }
            return this.workbenchShowImageResults(prepared[0].value, originalContext, isCancelled, onProgress);
        }
        if (seen.has('compare_image_results')) {
            if (prepared.length !== 1 || action.kind !== 'run_actions' || action.edits?.length) {
                return { applied: false, message: '이미지 비교는 다른 작업과 분리해서 요청해주세요.' };
            }
            return this.workbenchCompareImageResults(prepared[0].value, originalContext, isCancelled, onProgress);
        }
        if (seen.has('download_images')) {
            if (prepared.length !== 1 || action.kind !== 'run_actions' || action.edits?.length) {
                return { applied: false, message: '이미지 다운로드는 다른 작업과 분리해서 요청해주세요.' };
            }
            if (isCancelled()) return { applied: false, message: '요청이 중지되었습니다.' };
            onProgress('완료된 이미지와 ZIP 구성을 확인 중');
            const options = prepared[0].value;
            const checked = await this.workbenchInspectImageArchive(options.scope, options.model);
            if (isCancelled()) return { applied: false, message: '요청이 중지되었습니다.' };
            if (!checked.ok) return { applied: false, message: checked.message };
            this.workbenchStartImageArchiveDownload(checked.url);
            return { applied: true, label: '이미지 ZIP 준비',
                message: `${options.scope === 'model' ? this.workbenchModelLabel(options.model) : '현재 시나리오'}의 완료 이미지 ${checked.count}장 ZIP 다운로드를 시작했습니다. 아래 버튼으로 다시 받을 수 있습니다.`,
                downloadUrl: checked.url };
        }
        if (prepared.some((operation) => operation.type.startsWith('set_') || operation.type === 'generate_images')
            && (JSON.stringify(this.workbenchSelectedModels) !== JSON.stringify(originalContext.selected_models)
                || JSON.stringify(this.workbenchSelectedIntensities) !== JSON.stringify(originalContext.selected_intensities)
                || this.imageCandidateCount !== originalContext.image_count_per_model
                || this.workbenchExpression !== originalContext.expression)) {
            return { applied: false, message: '생성 조건이 바뀌었습니다. 현재 조건을 확인한 뒤 다시 요청해주세요.' };
        }
        const labels: string[] = [];
        let expectedModels = [...this.workbenchSelectedModels];
        let expectedIntensities = [...this.workbenchSelectedIntensities];
        let expectedCount = this.imageCandidateCount;
        let expectedExpression = this.workbenchExpression;
        if (isCancelled()) return { applied: false, message: '요청이 중지되었습니다.' };
        if (action.kind === 'edit_prompts') {
            onProgress('오른쪽 프롬프트 입력칸 수정 중');
            const edit = this.workbenchApplyAgentPromptAction(action, originalContext);
            if (!edit.applied) return edit;
            expectedExpression = this.workbenchExpression;
            onProgress('수정한 프롬프트를 서버에 저장 중');
            await this.workbenchFlushPromptSave();
            if (!this.workbenchPromptSaved || this.workbenchPromptSaveError) {
                return { applied: false, message: this.workbenchPromptSaveError
                    || '입력칸은 수정했지만 프롬프트를 서버에 저장하지 못했습니다.' };
            }
            labels.push(`${edit.label} 수정`);
        } else if (action.edits?.length) {
            return { applied: false, message: '허용되지 않은 워크벤치 작업입니다.' };
        }
        for (const operation of prepared) {
            if (isCancelled()) return { applied: false, message: '남은 화면 작업을 중지했습니다.', label: labels.join(' · ') };
            const type = operation?.type;
            if (type === 'set_intensities') {
                onProgress('오른쪽 화면에서 생성 강도 선택 중');
                expectedIntensities = operation.value;
                this.workbenchSelectedIntensities = [...expectedIntensities];
                if (!expectedIntensities.includes(this.form.intensity)) this.form.intensity = expectedIntensities[0];
                this.form.idempotency_key = this.newIdempotencyKey();
                this.changeDetector.detectChanges();
                this.workbenchAgentPulseTarget('wb-agent-intensities');
                labels.push(`강도 ${expectedIntensities.join('·')} 선택`);
            } else if (type === 'set_models') {
                onProgress('오른쪽 화면에서 이미지 모델 선택 중');
                expectedModels = operation.value;
                this.workbenchSelectedModels = [...expectedModels];
                if (!expectedModels.includes(this.workbenchPromptEditModel)) this.workbenchPromptEditModel = expectedModels[0];
                this.workbenchSaveModels();
                this.form.idempotency_key = this.newIdempotencyKey();
                this.changeDetector.detectChanges();
                this.workbenchAgentPulseTarget('wb-agent-models');
                labels.push(`${expectedModels.map((key) => this.workbenchModelLabel(key)).join('·')} 선택`);
            } else if (type === 'set_image_count') {
                onProgress('오른쪽 화면에서 모델별 이미지 수 선택 중');
                expectedCount = operation.value;
                await this.workbenchSelectCandidateCount(expectedCount);
                this.workbenchAgentPulseTarget('wb-model-count');
                labels.push(`모델별 ${expectedCount}장 선택`);
            } else if (type === 'set_expression') {
                onProgress('오른쪽 화면에서 강도별 표현 선택 중');
                this.workbenchSetExpression(operation.value);
                expectedExpression = operation.value;
                this.workbenchAgentPulseTarget('wb-agent-expression');
                labels.push(`${this.workbenchExpressionLabel(operation.value)} 선택`);
            } else if (type === 'add_custom_expression') {
                onProgress('오른쪽 화면에 표현을 추가하고 컷별 강도 초안을 생성 중');
                this.workbenchAgentPulseTarget('wb-agent-add-expression');
                const created = await this.createWorkbenchExpression(operation.value.name, operation.value.description);
                if (!created) return { applied: false, message: this.workbenchExpressionError || '표현을 추가하지 못했습니다.' };
                labels.push(`${operation.value.name.trim()} 표현 추가`);
            } else if (type === 'save_prompt') {
                onProgress('프롬프트 초안을 서버에 저장 중');
                this.workbenchAgentPulseTarget('wb-agent-save-prompt');
                await this.workbenchSavePromptDraft();
                if (!this.workbenchPromptSaved || this.workbenchPromptSaveError) {
                    return { applied: false, message: this.workbenchPromptSaveError || '프롬프트 초안을 저장하지 못했습니다.', label: labels.join(' · ') };
                }
                labels.push('프롬프트 초안 저장');
            } else if (type === 'generate_images') {
                const liveContext = this.workbenchAgentPromptContext();
                const custom = this.workbenchCustomExpression();
                const originalCustom = originalContext.custom_expressions?.find((item: any) => item.id === custom?.id);
                if (custom && (!originalCustom || (custom.uses_intensity !== false) !== (originalCustom.uses_intensity !== false))) {
                    return { applied: false, message: '표현의 강도 사용 설정이 바뀌었습니다. 현재 설정을 확인한 뒤 다시 생성해주세요.' };
                }
                if (!liveContext || liveContext.scenario_id !== originalContext.scenario_id
                    || liveContext.memory_kind !== originalContext.memory_kind
                    || liveContext.cut_order !== originalContext.cut_order) {
                    return { applied: false, message: '작업 중 선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.', label: labels.join(' · ') };
                }
                if (JSON.stringify(this.workbenchSelectedModels) !== JSON.stringify(expectedModels)
                    || JSON.stringify(this.workbenchSelectedIntensities) !== JSON.stringify(expectedIntensities)
                    || this.imageCandidateCount !== expectedCount || this.workbenchExpression !== expectedExpression) {
                    return { applied: false, message: '생성 조건이 바뀌었습니다. 현재 조건을 확인한 뒤 다시 요청해주세요.', label: labels.join(' · ') };
                }
                const blockReason = this.workbenchImageGenerationBlockReason();
                if (blockReason) {
                    return { applied: false, message: blockReason, label: labels.join(' · ') };
                }
                const requestedCount = this.workbenchTotalImageCount();
                const previousIds = new Set(Object.values(this.workbenchComparisonJobIds || {}).flat());
                onProgress(`${requestedCount}장 이미지 생성 요청 등록 중`);
                this.workbenchAgentPulseTarget('wb-agent-generate-images');
                await this.workbenchGenerateComparison(false, isCancelled);
                const submitted = new Set(Object.values(this.workbenchComparisonJobIds || {}).flat()
                    .filter((id: string) => !!id && !previousIds.has(id))).size;
                if (this.workbenchComparisonError) {
                    return { applied: false, message: this.workbenchComparisonError
                        + (submitted ? ` 등록된 생성 작업 ${submitted}건은 계속 진행됩니다.` : ''), label: labels.join(' · ') };
                }
                if (submitted !== requestedCount) {
                    return { applied: false, message: submitted
                        ? `${requestedCount}장 중 ${submitted}장만 생성 요청이 등록되었습니다. 결과 영역에서 작업 상태를 확인해주세요.`
                        : '이미지 생성 요청이 등록되지 않았습니다. 생성 조건과 작업 상태를 확인해주세요.', label: labels.join(' · ') };
                }
                labels.push(`${submitted}장 이미지 생성 요청 등록`);
            } else {
                onProgress('첨부 이미지를 참고 이미지 검토창에 연결 중');
                const file = files[operation.attachment_index];
                await this.workbenchOnScenarioPhotoFile({ target: { files: [file], value: '' } } as any);
                if (!this.workbenchScenarioUploadOpen || !this.patientSourcePreview) {
                    return { applied: false, message: this.workbenchScenarioUploadError || '참고 이미지를 열지 못했습니다.', label: labels.join(' · ') };
                }
                this.workbenchAgentPulseTarget('wb-scenario-upload-confirm');
                labels.push('참고 이미지 검토창 열기');
            }
        }
        return { applied: true, label: labels.join(' · '), message: seen.has('attach_reference_image')
            ? '참고 이미지 검토창을 열었습니다. 식별정보·동의·사용 권한을 확인한 뒤 업로드를 완료해주세요.'
            : `${labels.join(' · ')}했습니다.` + (seen.has('generate_images')
                ? ' 생성 진행 상태와 완료 이미지는 결과 영역에서 확인할 수 있습니다.' : '') };
    }

    private workbenchAgentPulseTarget(id: string) {
        window.setTimeout(() => {
            const target = document.getElementById(id);
            if (!target) return;
            target.classList.add('workbench-agent-action-target');
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            window.setTimeout(() => target.classList.remove('workbench-agent-action-target'), 4500);
        }, 0);
    }

    private workbenchApplyAgentPromptAction(action: any, originalContext: any) {
        const currentContext = this.workbenchAgentPromptContext();
        if (!currentContext || !originalContext || !action || action.kind !== 'edit_prompts') {
            return { applied: false, message: '현재 화면에서 수정할 프롬프트를 확인하지 못했습니다.' };
        }
        if (currentContext.scenario_id !== originalContext.scenario_id
            || currentContext.memory_kind !== originalContext.memory_kind
            || currentContext.cut_order !== originalContext.cut_order
            || currentContext.expression !== originalContext.expression) {
            return { applied: false, message: '작업 중 선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.' };
        }
        if (currentContext.reference_reproduction?.reference?.kind !== originalContext.reference_reproduction?.reference?.kind
            || currentContext.reference_reproduction?.reference?.id !== originalContext.reference_reproduction?.reference?.id) {
            return { applied: false, message: '작업 중 참고 이미지가 바뀌었습니다. 다시 요청해주세요.' };
        }
        if (!Array.isArray(action.edits) || action.edits.length < 1 || action.edits.length > 25) {
            return { applied: false, message: '수정안 형식을 확인하지 못했습니다.' };
        }
        const seen = new Set<string>();
        for (const edit of action.edits) {
            const section = edit?.section;
            const key = edit?.key;
            const value = edit?.value;
            const expected = edit?.expected;
            if (typeof key !== 'string' || typeof value !== 'string' || typeof expected !== 'string') {
                return { applied: false, message: '수정안 형식을 확인하지 못했습니다.' };
            }
            const expression = ['intensity', 'expression_common'].includes(section) ? String(edit?.expression || originalContext.expression) : '';
            const target = `${section}:${expression}:${key}`;
            if (seen.has(target)) return { applied: false, message: '수정안에 같은 항목이 중복됐습니다.' };
            seen.add(target);
            let current: string;
            let limit = 500;
            if (section === 'common' && key === 'common') {
                current = currentContext.draft.common;
                limit = 700;
            } else if (section === 'intensity' && /^[1-5]$/.test(key)) {
                if (!['realistic', 'blur'].includes(expression)
                    && !currentContext.custom_expressions?.some((item: any) => `custom:${item.id}` === expression && item.uses_intensity !== false)) {
                    return { applied: false, message: '표현 방식을 확인하지 못했습니다.' };
                }
                current = String(currentContext.draft.expression_intensities?.[expression]?.[key] || '');
                if (expression.startsWith('custom:')) limit = 320;
            } else if (section === 'expression_common' && key === 'all'
                && currentContext.custom_expressions?.some((item: any) => `custom:${item.id}` === expression && item.uses_intensity === false)) {
                current = String(currentContext.draft.expression_common?.[expression] || '');
                limit = 320;
            } else if (section === 'trigger_elements' && key === 'all' && expression === '') {
                current = JSON.stringify(currentContext.draft.trigger_elements);
                limit = 2500;
                try {
                    const proposed = JSON.parse(value);
                    if (!Array.isArray(proposed) || proposed.length > 12
                        || proposed.some((item: any) => typeof item !== 'string' || !item.trim() || item.length > 160)
                        || new Set(proposed).size !== proposed.length
                        ) {
                        return { applied: false, message: '트리거 요소 목록을 확인해주세요.' };
                    }
                } catch (_error) {
                    return { applied: false, message: '트리거 요소 목록을 확인해주세요.' };
                }
            } else if (section === 'reference_plan' && ['target', 'traits', 'scene_lock'].includes(key)
                && expression === '' && currentContext.reference_reproduction?.active) {
                const plan = currentContext.draft.reference_plan;
                if (key === 'traits') {
                    current = JSON.stringify(plan.traits);
                    limit = 1000;
                    try {
                        const proposed = JSON.parse(value);
                        if (!Array.isArray(proposed) || proposed.length > 8
                            || proposed.some((item: any) => typeof item !== 'string' || !item.trim() || item.length > 60)
                            || new Set(proposed).size !== proposed.length) {
                            return { applied: false, message: '참고 이미지 특징 목록을 확인해주세요.' };
                        }
                    } catch (_error) {
                        return { applied: false, message: '참고 이미지 특징 목록을 확인해주세요.' };
                    }
                } else {
                    current = String(plan[key] || '');
                    limit = key === 'target' ? 120 : 500;
                }
            } else if (section === 'model' && currentContext.selected_models.includes(key)) {
                current = currentContext.draft.models[key];
            } else {
                return { applied: false, message: '현재 화면에서 수정할 수 없는 항목입니다.' };
            }
            if (value.length > limit || current !== expected || value === current) {
                return { applied: false, message: '입력 내용이 바뀌었거나 수정안이 유효하지 않습니다. 다시 요청해주세요.' };
            }
        }

        if (action.edits.some((edit: any) => edit.section === 'reference_plan') && !this.workbenchReferencePlanCurrent()) {
            const reference = this.workbenchReproductionReference()!;
            this.workbenchPromptDraft.reference_plan = {
                kind: reference.kind, id: reference.id, target: '', traits: [], scene_lock: ''
            };
        }
        for (const edit of action.edits) {
            if (edit.section === 'common') this.workbenchPromptDraft.common = edit.value;
            if (edit.section === 'intensity') {
                const expression = edit.expression || originalContext.expression;
                this.workbenchIntensityDraft(expression)[Number(edit.key)] = edit.value;
            }
            if (edit.section === 'expression_common') {
                if (!this.workbenchPromptDraft.custom_expression_common) this.workbenchPromptDraft.custom_expression_common = {};
                this.workbenchPromptDraft.custom_expression_common[edit.expression.slice(7)] = edit.value;
            }
            if (edit.section === 'trigger_elements') {
                this.workbenchPromptDraft.trigger_elements = JSON.parse(edit.value);
            }
            if (edit.section === 'reference_plan') {
                if (edit.key === 'traits') this.workbenchPromptDraft.reference_plan.traits = JSON.parse(edit.value);
                else if (edit.key === 'target' || edit.key === 'scene_lock') this.workbenchPromptDraft.reference_plan[edit.key] = edit.value;
            }
            if (edit.section === 'model') this.workbenchPromptDraft.models[edit.key] = edit.value;
        }
        const first = action.edits[0];
        if (first.section === 'intensity') {
            this.workbenchExpression = first.expression || originalContext.expression;
            this.workbenchPromptEditIntensity = Number(first.key);
        }
        if (first.section === 'model') this.workbenchPromptEditModel = first.key;
        if (first.section === 'trigger_elements') this.workbenchExpression = 'trigger';
        if (first.section === 'expression_common') this.workbenchExpression = first.expression;
        this.workbenchExpressionStageOpen = true;
        if (first.section === 'common' || first.section === 'model') {
            this.workbenchPromptSection = first.section;
            this.workbenchPromptOpen = true;
        }
        this.workbenchPromptChanged();
        this.workbenchAgentCompleteHighlight(action.edits);
        this.changeDetector.detectChanges();
        const targetId = first.section === 'reference_plan' ? (first.key === 'scene_lock' ? 'wb-reference-scene-lock'
            : first.key === 'traits' ? 'wb-reference-trait' : 'wb-reference-target')
            : first.section === 'common' ? 'wb-common-prompt'
            : first.section === 'intensity' ? `wb-intensity-prompt-${first.key}`
                : first.section === 'trigger_elements' ? 'wb-trigger-editor'
                    : first.section === 'expression_common' ? 'wb-custom-common-prompt' : 'wb-model-prompt';
        window.setTimeout(() => {
            const field = document.getElementById(targetId);
            if (!(field instanceof HTMLElement)) return;
            field.classList.add('workbench-agent-prompt-target');
            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
            window.setTimeout(() => field.classList.remove('workbench-agent-prompt-target'), 3500);
        }, 0);
        const intensityKeys = action.edits.filter((edit: any) => edit.section === 'intensity')
            .map((edit: any) => Number(edit.key)).sort((a: number, b: number) => a - b);
        const firstExpression = first.section === 'intensity'
            ? this.workbenchExpressionLabel(first.expression || originalContext.expression) : '';
        const intensityExpressions = new Set(action.edits.filter((edit: any) => edit.section === 'intensity')
            .map((edit: any) => edit.expression || originalContext.expression));
        const label = action.edits.length === 1
            ? first.section === 'common' ? '공통 장면 지시'
                : first.section === 'reference_plan' ? '단계별 참고 이미지 반영 계획'
                : first.section === 'intensity' ? `${firstExpression} 강도 ${first.key} 추가 지시`
                    : first.section === 'trigger_elements' ? '트리거 요소'
                    : first.section === 'expression_common' ? `${this.workbenchExpressionLabel(first.expression)} 공통 프롬프트`
                    : `${this.workbenchModelLabel(first.key)} 추가 지시`
            : intensityKeys.length === action.edits.length && intensityExpressions.size === 1
                ? `${firstExpression} 강도 ${intensityKeys.join('·')} 추가 지시`
                : intensityKeys.length === action.edits.length
                    ? `${action.edits.length}개 표현별 강도 추가 지시`
                : action.edits.every((edit: any) => edit.section === 'reference_plan')
                    ? '단계별 참고 이미지 반영 계획'
                    : `${action.edits.length}개 프롬프트 항목`;
        return { applied: true, label };
    }

    private workbenchPromptScope() {
        const scenarioId = String(this.scenarioSelection.scenario_set_id || '').toUpperCase();
        const memoryKind = String(this.scenarioSelection.memory_kind || 'trauma');
        if (!scenarioId || this.sourceMode !== 'scenario') return null;
        return {
            scenario_id: scenarioId,
            memory_kind: memoryKind,
            cut_order: Number(this.selectedScenarioCutOrder || 0),
            cut_key: String(this.selectedScenarioCut()?.cut_key || '')
        };
    }

    private workbenchPromptStorageKey(scope = this.workbenchPromptScope()) {
        const userId = String(this.service.auth.session?.id || '');
        if (!scope || !userId) return '';
        return `ptsd.workbenchPromptDraft.v2.${userId}.${scope.scenario_id}.${scope.memory_kind}.${scope.cut_order}${scope.cut_key ? '.' + scope.cut_key : ''}`;
    }

    private workbenchApplyStoredPromptDraft(parsed: any) {
        if (!parsed || typeof parsed !== 'object') return;
        this.workbenchPromptDraft.common = typeof parsed.common === 'string'
            ? parsed.common.slice(0, 700) : '';
        this.workbenchPromptDraft.trigger_elements = Array.isArray(parsed.trigger_elements)
            ? parsed.trigger_elements.filter((item: any) => typeof item === 'string').slice(0, 12).map((item: string) => item.slice(0, 160)) : [];
        this.workbenchPromptDraft.analysis_seeded = parsed.analysis_seeded === true;
        const binding = parsed.analysis_binding;
        if (Number(binding?.version) >= 8 && /^[0-9a-f]{24}$/.test(String(binding?.cut_key || ''))) {
            this.workbenchPromptDraft.analysis_binding = { version: Number(binding.version), cut_key: binding.cut_key };
        }
        const plan = parsed.reference_plan;
        if (plan && typeof plan === 'object') {
            this.workbenchPromptDraft.reference_plan = {
                kind: typeof plan.kind === 'string' ? plan.kind.slice(0, 32) : '',
                id: typeof plan.id === 'string' ? plan.id.slice(0, 128) : '',
                target: typeof plan.target === 'string' ? plan.target.slice(0, 120) : '',
                traits: Array.isArray(plan.traits) ? plan.traits.filter((item: any) => typeof item === 'string')
                    .slice(0, 8).map((item: string) => item.slice(0, 60)) : [],
                scene_lock: typeof plan.scene_lock === 'string' ? plan.scene_lock.slice(0, 500) : ''
            };
        }
        if (parsed.reference_usage && typeof parsed.reference_usage === 'object') {
            this.workbenchPromptDraft.reference_usage = Object.fromEntries(
                Object.entries(parsed.reference_usage)
                    .filter(([expression, enabled]) => /^(realistic|trigger|custom:[0-9a-f]{32})$/.test(expression)
                        && typeof enabled === 'boolean')
                    .slice(0, 8));
        }
        if (parsed.reference_instructions && typeof parsed.reference_instructions === 'object') {
            this.workbenchPromptDraft.reference_instructions = Object.fromEntries(
                Object.entries(parsed.reference_instructions)
                    .filter(([expression, value]) => /^(realistic|trigger|custom:[0-9a-f]{32})$/.test(expression)
                        && typeof value === 'string')
                    .slice(0, 8).map(([expression, value]) => [expression, String(value).slice(0, 300)]));
        }
        if (parsed.custom_expression_intensities && typeof parsed.custom_expression_intensities === 'object') {
            for (const [expressionId, levels] of Object.entries(parsed.custom_expression_intensities).slice(0, 6)) {
                if (!/^[0-9a-f]{32}$/.test(expressionId) || !levels || typeof levels !== 'object') continue;
                const selected: { [key: number]: string } = {};
                for (const intensity of this.intensityOptions) {
                    const value = (levels as any)[intensity];
                    if (typeof value === 'string') selected[intensity] = value.slice(0, 320);
                }
                this.workbenchPromptDraft.custom_expression_intensities[expressionId] = selected;
            }
        }
        if (parsed.custom_expression_common && typeof parsed.custom_expression_common === 'object') {
            this.workbenchPromptDraft.custom_expression_common = Object.fromEntries(
                Object.entries(parsed.custom_expression_common).filter(([id, value]) => /^[0-9a-f]{32}$/.test(id) && typeof value === 'string')
                    .slice(0, 6).map(([id, value]) => [id, String(value).slice(0, 320)]));
        }
        for (const intensity of this.intensityOptions) {
            const value = parsed.intensities?.[intensity];
            if (typeof value === 'string') {
                this.workbenchPromptDraft.intensities[intensity] = value.slice(0, 500);
            }
        }
        for (const expression of ['trigger', 'blur'] as const) {
            for (const intensity of this.intensityOptions) {
                const value = parsed.expression_intensities?.[expression]?.[intensity];
                if (typeof value === 'string') {
                    this.workbenchPromptDraft.expression_intensities[expression][intensity] = value.slice(0, 500);
                }
            }
        }
        for (const model of this.generationModelOptions.image) {
            const value = parsed.models?.[model.value];
            if (typeof value === 'string') {
                this.workbenchPromptDraft.models[model.value] = value.slice(0, 500);
            }
        }
    }

    public async workbenchLoadPromptDraft() {
        void this.workbenchFlushPromptSave();
        const sequence = ++this.workbenchPromptLoadSequence;
        const revision = ++this.workbenchPromptChangeRevision;
        this.workbenchNewTriggerElement = '';
        this.workbenchPromptDraft = { common: '', intensities: {}, expression_intensities: { trigger: {}, blur: {} }, trigger_elements: [], custom_expression_intensities: {}, custom_expression_common: {}, analysis_seeded: false, models: {}, reference_plan: { kind: '', id: '', target: '', traits: [], scene_lock: '' }, reference_usage: {}, reference_instructions: {} };
        this.workbenchPromptSaved = true;
        this.workbenchPromptSaveError = '';
        const scope = this.workbenchPromptScope();
        const key = this.workbenchPromptStorageKey(scope);
        if (!scope || !key || !this.can('content.write')) return;
        let local: any = null;
        try {
            local = JSON.parse(window.sessionStorage.getItem(key) || 'null');
            if (local?.draft && scope.cut_key && local.draft.analysis_binding?.cut_key !== scope.cut_key) local = null;
            if (local?.draft) {
                this.workbenchApplyStoredPromptDraft(local.draft);
                this.workbenchPromptSaved = local.pending !== true;
            }
        } catch (_error) {
            local = null;
        }
        this.changeDetector.detectChanges();
        try {
            const query = new URLSearchParams({
                scenario_id: scope.scenario_id,
                memory_kind: scope.memory_kind,
                cut_order: String(scope.cut_order)
            });
            const response = await fetch(`/api/ptsd/codex/draft?${query}`, { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '저장된 초안을 불러오지 못했습니다.');
            if (sequence !== this.workbenchPromptLoadSequence
                || revision !== this.workbenchPromptChangeRevision
                || key !== this.workbenchPromptStorageKey()) return;
            if (local?.pending === true) {
                this.workbenchPromptPendingSave = {
                    scope, key, draft: JSON.parse(JSON.stringify(this.workbenchPromptDraft))
                };
                void this.workbenchFlushPromptSave();
            } else if (result.data?.updated && scope.cut_key && result.data.draft?.analysis_binding?.cut_key !== scope.cut_key) {
                const generated = this.scenarioAnalysis?.prompt_drafts?.[scope.cut_order];
                if (generated) {
                    this.workbenchApplyStoredPromptDraft({ ...this.workbenchPromptDraft,
                        intensities: generated.realistic, expression_intensities: { trigger: {}, blur: generated.blur },
                        trigger_elements: generated.trigger_elements, analysis_seeded: true,
                        analysis_binding: { version: this.scenarioAnalysisContractVersion, cut_key: scope.cut_key } });
                    this.workbenchPromptSaved = false;
                    this.workbenchPromptSaveError = '이전 컷의 저장본과 달라 새 분석 초안을 표시합니다. 확인 후 초안을 저장하세요. 이전 저장본은 이력에 보존됩니다.';
                }
            } else if (result.data?.updated) {
                this.workbenchPromptDraft = { common: '', intensities: {}, expression_intensities: { trigger: {}, blur: {} }, trigger_elements: [], custom_expression_intensities: {}, custom_expression_common: {}, analysis_seeded: false, models: {}, reference_plan: { kind: '', id: '', target: '', traits: [], scene_lock: '' }, reference_usage: {}, reference_instructions: {} };
                this.workbenchApplyStoredPromptDraft(result.data.draft);
                this.workbenchPromptSaved = true;
                window.sessionStorage.setItem(key, JSON.stringify({
                    draft: this.workbenchPromptDraft, pending: false
                }));
            } else if (local?.draft) {
                this.workbenchPromptPendingSave = {
                    scope, key, draft: JSON.parse(JSON.stringify(this.workbenchPromptDraft))
                };
                void this.workbenchFlushPromptSave();
            }
        } catch (_error) {
            if (sequence === this.workbenchPromptLoadSequence
                && key === this.workbenchPromptStorageKey()) {
                this.workbenchPromptSaveError = '저장된 프롬프트를 불러오지 못했습니다. 연결을 확인해주세요.';
            }
        }
        this.changeDetector.detectChanges();
    }

    public workbenchPromptChanged() {
        this.workbenchPromptSaved = false;
        this.workbenchPromptSaveError = '';
        this.form.idempotency_key = this.newIdempotencyKey();
        ++this.workbenchPromptChangeRevision;
        const scope = this.workbenchPromptScope();
        const key = this.workbenchPromptStorageKey(scope);
        if (!scope || !key || !this.can('content.write')) return;
        const draft = JSON.parse(JSON.stringify(this.workbenchPromptDraft));
        this.workbenchPromptPendingSave = { scope, key, draft };
        try {
            window.sessionStorage.setItem(key, JSON.stringify({ draft, pending: true }));
        } catch (_error) { /* Server autosave remains available. */ }
        if (this.workbenchPromptSaveTimer !== null) window.clearTimeout(this.workbenchPromptSaveTimer);
        this.workbenchPromptSaveTimer = window.setTimeout(() => {
            void this.workbenchFlushPromptSave();
        }, 700);
    }

    private workbenchFlushPromptSave(): Promise<void> {
        if (this.workbenchPromptSaveTimer !== null) {
            window.clearTimeout(this.workbenchPromptSaveTimer);
            this.workbenchPromptSaveTimer = null;
        }
        const pending = this.workbenchPromptPendingSave;
        this.workbenchPromptPendingSave = null;
        if (!pending) return this.workbenchPromptSaveQueue;
        this.workbenchPromptSaveQueue = this.workbenchPromptSaveQueue.then(async () => {
            const result: any = await this.service.request.post('/api/ptsd/codex/draft', {
                ...pending.scope,
                draft: JSON.stringify(pending.draft),
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) {
                throw new Error(result.data?.message || result.responseJSON?.data?.message || '초안을 저장하지 못했습니다.');
            }
            if (pending.key === this.workbenchPromptStorageKey()
                && JSON.stringify(this.workbenchPromptDraft) === JSON.stringify(pending.draft)) {
                this.workbenchPromptSaved = true;
                this.workbenchPromptSaveError = '';
            }
            try {
                const local = JSON.parse(window.sessionStorage.getItem(pending.key) || 'null');
                if (JSON.stringify(local?.draft) === JSON.stringify(pending.draft)) {
                    window.sessionStorage.setItem(pending.key, JSON.stringify({
                        draft: pending.draft, pending: false
                    }));
                }
            } catch (_error) { /* The database is the durable copy. */ }
        }).catch((error) => {
            if (pending.key === this.workbenchPromptStorageKey()) {
                this.workbenchPromptSaveError = String(error?.message || '초안을 저장하지 못했습니다.');
                this.workbenchPromptSaved = false;
            }
        }).then(() => { if (!this.destroyed) this.changeDetector.detectChanges(); });
        return this.workbenchPromptSaveQueue;
    }

    public async workbenchSavePromptDraft() {
        if (this.workbenchPromptPendingSave) {
            await this.workbenchFlushPromptSave();
            return;
        }
        const scope = this.workbenchPromptScope();
        const key = this.workbenchPromptStorageKey(scope);
        if (!scope || !key || !this.can('content.write')) return;
        this.workbenchPromptPendingSave = {
            scope, key, draft: JSON.parse(JSON.stringify(this.workbenchPromptDraft))
        };
        await this.workbenchFlushPromptSave();
    }

    public workbenchSetPromptSection(value: 'base' | 'common' | 'intensity' | 'model') {
        this.workbenchPromptSection = value;
        this.changeDetector.detectChanges();
    }

    public workbenchSetPromptEditIntensity(value: number) {
        this.workbenchPromptEditIntensity = this.normalizeIntensityValue(value);
        this.changeDetector.detectChanges();
    }

    public workbenchSetPromptEditModel(value: string) {
        if (!this.workbenchSelectedModels.includes(value)) return;
        this.workbenchPromptEditModel = value;
        this.changeDetector.detectChanges();
    }

    public workbenchTogglePrompt() {
        this.workbenchPromptOpen = !this.workbenchPromptOpen;
        this.changeDetector.detectChanges();
    }

    public workbenchOpenPromptPreview() {
        const model = this.workbenchSelectedModels.includes(this.workbenchPromptEditModel)
            ? this.workbenchPromptEditModel
            : this.workbenchSelectedModels[0];
        if (!model) return;
        this.openActualPromptPreviewFor(model, this.workbenchPromptEditIntensity);
    }

    public workbenchCustomExpression(value: string = this.workbenchExpression): any {
        if (!value.startsWith('custom:')) return null;
        return this.workbenchCustomExpressions.find((item: any) =>
            item.id === value.slice(7)) || null;
    }

    public workbenchCustomExpressionHasDraft(): boolean {
        const expression = this.workbenchCustomExpression();
        if (!expression) return false;
        if (expression.uses_intensity === false) return !!this.workbenchCustomCommonPrompt().trim();
        return Object.values(this.workbenchPromptDraft.custom_expression_intensities?.[expression.id] || {})
            .some((value: any) => String(value || '').trim().length > 0);
    }

    public workbenchReusableExpressionExists(name: string): boolean {
        return this.workbenchReusableExpressions.some((item: any) => item.name === name);
    }

    public workbenchServerExpression(): 'realistic' | 'trigger' | 'blur' {
        return this.workbenchCustomExpression() ? (this.workbenchExpressionUsesIntensity() ? 'realistic' : 'trigger')
            : this.workbenchExpression as 'realistic' | 'trigger' | 'blur';
    }

    public async workbenchSetCustomExpressionIntensity(expressionId: string, usesIntensity: boolean, isCancelled: () => boolean = () => false) {
        const expression = this.workbenchCustomExpressions.find((item: any) => item.id === expressionId);
        if (!expression || this.workbenchComparing || this.workbenchExpressionBusy || this.workbenchExpressionDrafting) return false;
        const scenarioId = this.scenarioSelection.scenario_set_id;
        this.workbenchExpressionBusy = true;
        this.workbenchExpressionError = '';
        this.changeDetector.detectChanges();
        try {
            await this.workbenchFlushPromptSave();
            if (!this.workbenchPromptSaved || this.workbenchPromptSaveError) throw new Error(this.workbenchPromptSaveError || '현재 프롬프트를 먼저 저장해주세요.');
            if (isCancelled()) throw new Error('요청이 중지되었습니다.');
            if (scenarioId !== this.scenarioSelection.scenario_set_id) throw new Error('선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.');
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions', {
                action: 'set_intensity', scenario_id: scenarioId, expression_id: expressionId,
                uses_intensity: String(usesIntensity), expected_uses_intensity: String(expression.uses_intensity !== false),
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200 || result.data?.expression?.uses_intensity !== usesIntensity) {
                throw new Error(result.data?.message || '표현의 강도 사용 설정을 저장하지 못했습니다.');
            }
            if (scenarioId === this.scenarioSelection.scenario_set_id) {
                await this.workbenchLoadCustomExpressions();
                this.workbenchSetExpression(`custom:${expressionId}`);
                await this.workbenchLoadPromptDraft();
            }
            return true;
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message || '표현 설정을 변경하지 못했습니다.');
            return false;
        } finally {
            this.workbenchExpressionBusy = false;
            this.changeDetector.detectChanges();
        }
    }

    public async workbenchLoadCustomExpressions() {
        const scenarioId = String(this.scenarioSelection.scenario_set_id || '').trim().toUpperCase();
        if (!scenarioId || this.sourceMode !== 'scenario') {
            this.workbenchCustomExpressions = [];
            this.workbenchReusableExpressions = [];
            return;
        }
        try {
            const query = new URLSearchParams({ scenario_id: scenarioId });
            const response = await fetch(`/api/ptsd/codex/expressions?${query}`, { credentials: 'same-origin' });
            const result = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '표현 목록을 불러오지 못했습니다.');
            if (scenarioId !== String(this.scenarioSelection.scenario_set_id || '').trim().toUpperCase()) return;
            const rows = Array.isArray(result.data?.expressions) ? result.data.expressions : [];
            this.workbenchCustomExpressions = rows.filter((item: any) => item.scenario_id === scenarioId);
            this.workbenchReusableExpressions = rows.filter((item: any) => item.reusable === true);
            if (this.workbenchExpression.startsWith('custom:') && !this.workbenchCustomExpression()) {
                this.workbenchExpression = 'realistic';
            }
        } catch (_error) {
            this.workbenchExpressionError = '사용자 정의 표현 목록을 불러오지 못했습니다.';
        }
        this.changeDetector.detectChanges();
    }

    public openWorkbenchExpressionDialog() {
        if (!this.selectedScenarioCut() || this.sourceMode !== 'scenario') return;
        this.workbenchExpressionReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement : null;
        this.workbenchExpressionName = '';
        this.workbenchExpressionDescription = '';
        this.workbenchExpressionError = '';
        this.workbenchExpressionDialogOpen = true;
        document.body.style.overflow = 'hidden';
        this.changeDetector.detectChanges();
        window.setTimeout(() => document.getElementById('wb-custom-expression-name')?.focus(), 0);
    }

    public closeWorkbenchExpressionDialog() {
        if (this.workbenchExpressionBusy) return;
        this.workbenchExpressionDialogOpen = false;
        document.body.style.overflow = '';
        this.changeDetector.detectChanges();
        const target = this.workbenchExpressionReturnFocus;
        this.workbenchExpressionReturnFocus = null;
        window.setTimeout(() => target?.focus(), 0);
    }

    public onWorkbenchExpressionDialogKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.workbenchExpressionBusy) {
            event.preventDefault();
            this.closeWorkbenchExpressionDialog();
        } else if (event.key === 'Tab') {
            this.trapDialogFocus(event, 'wb-custom-expression-dialog');
        }
    }

    private async workbenchAddExpressionFromResponse(expression: any) {
        const scenarioId = String(this.scenarioSelection.scenario_set_id || '').trim().toUpperCase();
        await this.workbenchLoadCustomExpressions();
        if (scenarioId !== String(this.scenarioSelection.scenario_set_id || '').trim().toUpperCase()
            || !this.workbenchCustomExpressions.some((item: any) => item.id === expression.id)) return false;
        this.workbenchSetExpression(`custom:${expression.id}`);
        this.closeWorkbenchExpressionDialog();
        if (expression.uses_intensity !== false) await this.workbenchGenerateCustomExpressionDraft(expression.id);
        return true;
    }

    public async createWorkbenchExpression(name = this.workbenchExpressionName,
                                           description = this.workbenchExpressionDescription) {
        name = String(name || '').trim();
        description = String(description || '').trim();
        if (!name || name.length > 60 || !description || description.length > 300) {
            this.workbenchExpressionError = '표현 이름과 의도를 입력해주세요.';
            return false;
        }
        if (!this.selectedScenarioCut() || this.sourceMode !== 'scenario' || this.workbenchExpressionBusy) return false;
        this.workbenchExpressionBusy = true;
        this.workbenchExpressionError = '';
        try {
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions', {
                action: 'create', scenario_id: this.scenarioSelection.scenario_set_id,
                name, description, csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error(result.data?.message || '표현을 추가하지 못했습니다.');
            this.workbenchExpressionBusy = false;
            return await this.workbenchAddExpressionFromResponse(result.data.expression);
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message || '표현을 추가하지 못했습니다.');
            return false;
        } finally {
            this.workbenchExpressionBusy = false;
            this.changeDetector.detectChanges();
        }
    }

    public async useWorkbenchExpressionPreset(expressionId: string) {
        if (!this.selectedScenarioCut() || this.workbenchExpressionBusy) return;
        this.workbenchExpressionBusy = true;
        this.workbenchExpressionError = '';
        try {
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions', {
                action: 'use_preset', expression_id: expressionId,
                scenario_id: this.scenarioSelection.scenario_set_id,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error(result.data?.message || '기본 표현을 가져오지 못했습니다.');
            this.workbenchExpressionBusy = false;
            await this.workbenchAddExpressionFromResponse(result.data.expression);
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message || '기본 표현을 가져오지 못했습니다.');
        } finally {
            this.workbenchExpressionBusy = false;
            this.changeDetector.detectChanges();
        }
    }

    public async workbenchGenerateCustomExpressionDraft(expressionId: string) {
        const cut = this.selectedScenarioCut();
        const expression = this.workbenchCustomExpressions.find((item: any) => item.id === expressionId);
        if (!cut || !expression || this.workbenchExpressionDrafting) return false;
        const scenarioId = String(this.scenarioSelection.scenario_set_id || '').toUpperCase();
        const order = Number(cut.order);
        this.workbenchExpressionDrafting = true;
        this.workbenchExpressionError = '';
        this.changeDetector.detectChanges();
        try {
            await this.workbenchFlushPromptSave();
            if (!this.workbenchPromptSaved || this.workbenchPromptSaveError) {
                throw new Error(this.workbenchPromptSaveError || '현재 초안을 먼저 저장해주세요.');
            }
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions/generate', {
                scenario_id: scenarioId, expression_id: expressionId,
                source_snapshot_sha256: this.scenarioAnalysis?.source_snapshot_sha256 || '',
                cut: JSON.stringify({ order, memory_kind: cut.memory_kind,
                    title: cut.title, event: cut.event, time_place: cut.time_place,
                    evidence: cut.evidence }),
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error(result.data?.message || '강도 초안을 만들지 못했습니다.');
            if (scenarioId === String(this.scenarioSelection.scenario_set_id || '').toUpperCase()
                && order === this.selectedScenarioCutOrder) await this.workbenchLoadPromptDraft();
            return true;
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message
                || '강도 초안을 만들지 못했습니다. 직접 입력할 수 있습니다.');
            return false;
        } finally {
            this.workbenchExpressionDrafting = false;
            this.changeDetector.detectChanges();
        }
    }

    public async saveWorkbenchExpressionAsReusable() {
        const expression = this.workbenchCustomExpression();
        if (!expression || this.workbenchExpressionBusy) return;
        this.workbenchExpressionBusy = true;
        this.workbenchExpressionError = '';
        try {
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions', {
                action: 'save_reusable', expression_id: expression.id,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error(result.data?.message || '기본 표현으로 저장하지 못했습니다.');
            await this.workbenchLoadCustomExpressions();
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message || '기본 표현으로 저장하지 못했습니다.');
        } finally {
            this.workbenchExpressionBusy = false;
            this.changeDetector.detectChanges();
        }
    }

    public async deleteWorkbenchExpression(expressionId: string) {
        if (this.workbenchExpressionDeleteArmed !== expressionId) {
            this.workbenchExpressionDeleteArmed = expressionId;
            this.changeDetector.detectChanges();
            return;
        }
        this.workbenchExpressionDeleteArmed = '';
        try {
            await this.workbenchFlushPromptSave();
            if (!this.workbenchPromptSaved || this.workbenchPromptSaveError) {
                throw new Error(this.workbenchPromptSaveError || '현재 초안을 먼저 저장해주세요.');
            }
            const result: any = await this.service.request.post('/api/ptsd/codex/expressions', {
                action: 'delete', expression_id: expressionId,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (result.code !== 200) throw new Error(result.data?.message || '표현을 삭제하지 못했습니다.');
            if (this.workbenchExpression === `custom:${expressionId}`) this.workbenchExpression = 'realistic';
            delete this.workbenchPromptDraft.custom_expression_intensities[expressionId];
            if (this.workbenchPromptDraft.custom_expression_common) delete this.workbenchPromptDraft.custom_expression_common[expressionId];
            await this.workbenchLoadCustomExpressions();
            await this.workbenchLoadPromptDraft();
        } catch (error) {
            this.workbenchExpressionError = String((error as Error)?.message || '표현을 삭제하지 못했습니다.');
        }
        this.changeDetector.detectChanges();
    }

    public workbenchSetExpression(value: string) {
        if (!['realistic', 'trigger', 'blur'].includes(value)
            && !this.workbenchCustomExpression(value)) return;
        this.workbenchExpression = value;
        if (value === 'blur') this.workbenchRestoreBlurPreset();
        this.workbenchExpressionStageOpen = true;
        if (this.workbenchPromptSection === 'intensity') this.workbenchPromptSection = 'common';
        if (!this.workbenchExpressionUsesIntensity(value)) {
            this.form.intensity = 3;
        }
        this.workbenchComparisonJobIds = {};
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public async workbenchChooseSource(mode: 'patient' | 'scenario') {
        const previousMode = this.sourceMode;
        const activeScenarioId = previousMode === 'scenario'
            ? String(this.selectedScenarioSet()?.id || '').toUpperCase()
            : '';
        if (
            mode === 'scenario'
            && activeScenarioId
            && !this.workbenchWorkedScenarioIds.includes(activeScenarioId)
        ) {
            this.workbenchWorkedScenarioIds = [
                ...this.workbenchWorkedScenarioIds,
                activeScenarioId
            ];
        }
        this.workbenchSourceChoice = mode;
        this.workbenchComparisonJobIds = {};
        this.workbenchReportOpen = false;
        this.workbenchScenarioPhotoId = '';
        this.workbenchScenarioPhotos = [];
        if (mode === 'patient') {
            this.form.patient_id = '';
            this.patientMemoryMode = 'trauma';
            this.selectedResourceMemoryId = '';
            this.workbenchExpression = 'realistic';
            this.workbenchCustomExpressions = [];
        } else {
            this.scenarioSelection.scenario_set_id = '';
        }
        await this.selectSourceMode(mode);
        if (mode === 'scenario') await this.refreshScenarioCatalog();
        if (mode === 'patient') await this.onPatientChange();
        else if (previousMode === 'scenario') await this.onScenarioSetChange();
        await this.service.render();
    }

    public async workbenchSelectPatient(patient: any) {
        this.workbenchSourceChoice = 'patient';
        this.form.patient_id = String(patient?.id || patient?.patient_id || '');
        this.patientMemoryMode = 'trauma';
        this.selectedResourceMemoryId = '';
        this.imageCandidateCount = 1;
        this.workbenchComparisonJobIds = {};
        this.workbenchReportOpen = false;
        await this.onPatientChange();
    }

    public async workbenchSelectScenario(scenario: any) {
        this.workbenchSourceChoice = 'scenario';
        this.scenarioSelection.scenario_set_id = String(scenario?.id || '');
        this.imageCandidateCount = 1;
        this.workbenchComparisonJobIds = {};
        this.workbenchReportOpen = false;
        await this.onScenarioSetChange();
        await this.workbenchLoadScenarioPhotos();
        await this.workbenchLoadPromptDraft();
    }

    public workbenchSelectScenarioCutOrder(value: number) {
        const cut = this.scenarioAnalysisCuts().find(
            (item: any) => Number(item?.order || 0) === Number(value)
        );
        if (cut) {
            this.selectScenarioCut(cut);
            this.workbenchComparisonJobIds = {};
            this.workbenchReportOpen = false;
        }
        this.workbenchCloseDropdowns();
        this.changeDetector.detectChanges();
    }

    public workbenchPatientReady(patient: any) {
        return patient?.scenario_description_ready === true
            && patient?.scenario_prompt_ready === true;
    }

    public workbenchSourceTitle() {
        return this.workbenchSourceChoice === 'scenario'
            ? String(this.selectedScenarioSet()?.title || '')
            : String(this.selectedPatientOption()?.patient_code || '');
    }

    public workbenchModelLabel(key: string) {
        const item = this.generationModelOptions.image.find(
            (model: any) => model.value === key
        );
        return String(item?.label || key);
    }

    public workbenchImageQualityOptions() {
        const configured = this.imagePricing?.models?.['openai-gpt-image-2']?.quality_options;
        if (!Array.isArray(configured) || configured.length === 0) {
            return this.openAIImageQualityOptions;
        }
        const supported = new Set(configured.map((value: any) =>
            String(value || '').trim().toLowerCase()
        ));
        return this.openAIImageQualityOptions.filter((option: any) =>
            supported.has(option.value)
        );
    }

    public workbenchImageQualityLabel() {
        const selected = this.workbenchImageQualityOptions().find(
            (option: any) => option.value === this.selectedImageQuality
        );
        return String(selected?.label || this.selectedImageQuality || 'Low · 낮음');
    }

    public workbenchExpressionLabel(value: string) {
        const custom = this.workbenchCustomExpression(value);
        if (custom) return custom.name;
        const labels: { [key: string]: string } = {
            realistic: this.workbenchReproductionReference() ? '참고 이미지 재현' : '사실적 묘사',
            trigger: '트리거 요소',
            blur: '블러 처리'
        };
        return labels[String(value || '')] || labels.realistic;
    }

    public workbenchAddModel(value: string) {
        const key = String(value || '');
        if (!key || !this.generationModelAvailable(key, 'image')) return;
        if (!this.workbenchSelectedModels.includes(key)) {
            this.workbenchSelectedModels = [...this.workbenchSelectedModels, key];
            if (this.workbenchSelectedModels.length === 1) {
                this.workbenchPromptEditModel = key;
            }
            this.workbenchSaveModels();
        }
        this.workbenchModelPickerOpen = false;
        this.changeDetector.detectChanges();
    }

    public workbenchRemoveModel(key: string) {
        this.workbenchSelectedModels = this.workbenchSelectedModels.filter(
            (value: string) => value !== key
        );
        if (this.workbenchPromptEditModel === key) {
            this.workbenchPromptEditModel = this.workbenchSelectedModels[0] || '';
        }
        this.workbenchSaveModels();
        this.changeDetector.detectChanges();
    }

    public workbenchScenarioWorked(scenario: any) {
        return this.workbenchWorkedScenarioIds.includes(
            String(scenario?.id || '').toUpperCase()
        );
    }

    public async workbenchLoadScenarioPhotos() {
        const scenarioId = String(this.selectedScenarioSet()?.id || '').toUpperCase();
        if (!scenarioId || !this.can('content.read')) {
            this.workbenchScenarioPhotos = [];
            this.workbenchScenarioPhotoId = '';
            return;
        }
        try {
            const { code, data } = await wiz.app('page.scenario.sets').call(
                'scenario_photos', { scenario_id: scenarioId }
            );
            if (code !== 200) return;
            this.workbenchScenarioPhotos = this.extractList(data, ['items']);
            let stored = '';
            try {
                stored = window.sessionStorage.getItem(
                    `ptsd.workbenchScenarioPhoto.${scenarioId}`
                ) || '';
            } catch (_error) {
            }
            this.workbenchScenarioPhotoId = this.workbenchScenarioPhotos.some(
                (photo: any) => photo.id === stored
            ) && !this.selectedReferenceCondition ? stored : '';
        } catch (_error) {
            this.workbenchScenarioPhotos = [];
            this.workbenchScenarioPhotoId = '';
        }
        this.changeDetector.detectChanges();
    }

    public workbenchSetScenarioPhoto(value: string) {
        const id = String(value || '');
        this.workbenchScenarioPhotoId = this.workbenchScenarioPhotos.some(
            (photo: any) => photo.id === id
        ) ? id : '';
        const scenarioId = String(this.selectedScenarioSet()?.id || '').toUpperCase();
        try {
            if (scenarioId) window.sessionStorage.setItem(
                `ptsd.workbenchScenarioPhoto.${scenarioId}`,
                this.workbenchScenarioPhotoId
            );
        } catch (_error) {
        }
        if (this.workbenchScenarioPhotoId) {
            this.selectedReferenceCondition = null;
            this.referenceUsageMode = 'none';
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public workbenchScenarioPhotoLabel() {
        const index = this.workbenchScenarioPhotos.findIndex(
            (photo: any) => photo.id === this.workbenchScenarioPhotoId
        );
        if (index < 0) return '업로드한 이미지 선택';
        const photo = this.workbenchScenarioPhotos[index];
        return `업로드한 이미지 ${index + 1} · ${photo.width}×${photo.height}`;
    }

    private workbenchScenarioPhotoPreviewUrlFresh(photo: any) {
        const url = this.safeSignedUrl(photo?.preview_url);
        if (!url) return false;
        const expires = Number(new URLSearchParams(url.split('?')[1] || '').get('expires'));
        return Number.isFinite(expires) && expires > Date.now() / 1000 + 5;
    }

    public async workbenchOpenScenarioPhotoPreview() {
        const photoId = this.workbenchScenarioPhotoPreviewPhoto?.id
            || this.workbenchScenarioPhotoId
            || this.workbenchScenarioPhotos[0]?.id;
        if (!photoId) return;
        if (!this.workbenchScenarioPhotoPreviewOpen) {
            this.workbenchScenarioPhotoPreviewReturnFocus = document.activeElement instanceof HTMLElement
                ? document.activeElement
                : null;
        }
        const sequence = ++this.workbenchScenarioPhotoPreviewSequence;
        this.workbenchScenarioPhotoPreviewOpen = true;
        this.workbenchScenarioPhotoPreviewError = '';
        setTimeout(() => document.getElementById('wb-scenario-photo-preview-close')?.focus(), 0);

        const cached = this.workbenchScenarioPhotos.find((photo: any) => photo.id === photoId);
        if (this.workbenchScenarioPhotoPreviewUrlFresh(cached)) {
            this.workbenchShowScenarioPhotoPreview(photoId);
            return;
        }

        // Signed URLs expire quickly; only refresh the list when the current URL is stale.
        this.workbenchScenarioPhotoPreviewLoading = true;
        this.workbenchScenarioPhotoPreviewPhoto = null;
        this.changeDetector.detectChanges();
        await this.workbenchLoadScenarioPhotos();
        if (sequence !== this.workbenchScenarioPhotoPreviewSequence || !this.workbenchScenarioPhotoPreviewOpen) return;
        this.workbenchShowScenarioPhotoPreview(photoId);
    }

    public workbenchShowScenarioPhotoPreview(photoId: string) {
        const index = this.workbenchScenarioPhotos.findIndex((photo: any) => photo.id === photoId);
        const photo = this.workbenchScenarioPhotos[index];
        this.workbenchScenarioPhotoPreviewIndex = index + 1;
        this.workbenchScenarioPhotoPreviewPhoto = photo || null;
        this.workbenchScenarioPhotoPreviewLoading = !!photo?.preview_url;
        this.workbenchScenarioPhotoPreviewError = this.workbenchScenarioPhotoPreviewUrlFresh(photo)
            ? ''
            : '이미지를 불러오지 못했습니다. 다시 시도해주세요.';
        if (this.workbenchScenarioPhotoPreviewError) this.workbenchScenarioPhotoPreviewLoading = false;
        this.changeDetector.detectChanges();
    }

    public workbenchSelectScenarioPhotoPreview(photoId: string) {
        const photo = this.workbenchScenarioPhotos.find((item: any) => item.id === photoId);
        if (this.workbenchScenarioPhotoPreviewUrlFresh(photo)) {
            this.workbenchShowScenarioPhotoPreview(photoId);
            return;
        }
        this.workbenchScenarioPhotoPreviewPhoto = photo || null;
        void this.workbenchOpenScenarioPhotoPreview();
    }

    public workbenchScenarioPhotoPreviewImageLoaded() {
        this.workbenchScenarioPhotoPreviewLoading = false;
        this.changeDetector.detectChanges();
    }

    public workbenchUseScenarioPhotoPreview() {
        if (!this.workbenchScenarioPhotoPreviewPhoto || this.workbenchScenarioPhotoPreviewError) return;
        this.workbenchSetScenarioPhoto(this.workbenchScenarioPhotoPreviewPhoto.id);
        void this.workbenchCloseScenarioPhotoPreview();
    }

    public workbenchClearScenarioPhotoPreview() {
        this.workbenchSetScenarioPhoto('');
        void this.workbenchCloseScenarioPhotoPreview();
    }

    public workbenchScenarioPhotoPreviewImageError() {
        this.workbenchScenarioPhotoPreviewLoading = false;
        this.workbenchScenarioPhotoPreviewError = '이미지를 표시하지 못했습니다. 다시 불러와 주세요.';
        this.changeDetector.detectChanges();
    }

    public async workbenchCloseScenarioPhotoPreview() {
        ++this.workbenchScenarioPhotoPreviewSequence;
        this.workbenchScenarioPhotoPreviewOpen = false;
        this.workbenchScenarioPhotoPreviewPhoto = null;
        this.workbenchScenarioPhotoPreviewError = '';
        await this.service.render();
        const target = this.workbenchScenarioPhotoPreviewReturnFocus;
        this.workbenchScenarioPhotoPreviewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public workbenchOnScenarioPhotoPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.workbenchCloseScenarioPhotoPreview();
            return;
        }
        if (event.key === 'Tab') this.trapDialogFocus(event, 'wb-scenario-photo-preview-dialog');
    }

    public async workbenchOnScenarioPhotoFile(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files?.[0]) return;
        this.workbenchScenarioUploadError = '';
        this.workbenchScenarioUploadOpen = true;
        try {
            await this.onPatientSourceFile(event);
            if (!this.patientSourcePreview) this.workbenchScenarioUploadOpen = false;
        } catch (error: any) {
            this.workbenchScenarioUploadError = error?.message || '사진을 읽지 못했습니다.';
            this.workbenchScenarioUploadOpen = false;
        } finally {
            input.value = '';
            await this.service.render();
        }
    }

    public async workbenchOnPatientDirectFile(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files?.[0]) return;
        this.workbenchOpenAdvanced('reference');
        await this.onPatientSourceFile(event);
        input.value = '';
        document.getElementById('patient-source-title')?.scrollIntoView({ block: 'center' });
    }

    public workbenchCloseScenarioUpload() {
        if (this.workbenchScenarioUploading) return;
        this.workbenchScenarioUploadOpen = false;
        this.workbenchScenarioUploadError = '';
        this.resetPatientSourceUpload();
        this.changeDetector.detectChanges();
    }

    public async workbenchUploadScenarioPhoto() {
        if (this.workbenchScenarioUploading || !this.patientSourceEncoded) return;
        if (!['passed', 'faces_detected'].includes(this.patientSourceFaceInspectionStatus)
            || !this.patientSourceIdentifierStatus
            || (this.patientSourceIdentifierStatus === 'masked'
                && this.patientSourceMasks.length === 0)
            || (this.patientSourceDetectedFaceCount > 0
                && this.patientSourceIdentifierStatus !== 'masked')
            || !this.patientSourceConsentConfirmed
            || !this.patientSourceRightsConfirmed) {
            this.workbenchScenarioUploadError = '식별정보 검토, 마스킹, 동의와 사용 권한을 확인해주세요.';
            this.changeDetector.detectChanges();
            return;
        }
        this.workbenchScenarioUploading = true;
        this.workbenchScenarioUploadError = '';
        try {
            const response: any = await wiz.app('page.scenario.sets').call(
                'upload_scenario_photo', {
                    scenario_id: this.selectedScenarioSet()?.id,
                    image_base64: this.patientSourceEncoded,
                    identifier_review_status: this.patientSourceIdentifierStatus,
                    mask_regions: JSON.stringify(this.patientSourceMasks),
                    consent_confirmed: this.patientSourceConsentConfirmed,
                    rights_confirmed: this.patientSourceRightsConfirmed,
                    csrf_token: this.csrfToken()
                }
            );
            const result = response?.responseJSON || response || {};
            if (result.code !== 201 || !result.data?.photo?.id) {
                throw new Error(result.data?.message || '사진을 저장하지 못했습니다.');
            }
            const photoId = String(result.data.photo.id);
            this.workbenchScenarioUploading = false;
            this.workbenchCloseScenarioUpload();
            await this.workbenchLoadScenarioPhotos();
            this.workbenchSetScenarioPhoto(photoId);
        } catch (error: any) {
            this.workbenchScenarioUploadError = error?.message || '사진을 저장하지 못했습니다.';
        } finally {
            this.workbenchScenarioUploading = false;
            await this.service.render();
        }
    }

    public workbenchUnselectedModels() {
        return this.generationModelOptions.image.filter((model: any) =>
            this.generationModelAvailable(model.value, 'image')
            && !this.workbenchSelectedModels.includes(model.value)
        );
    }

    public workbenchEstimatedCostMicros() {
        if (this.workbenchSelectedModels.length === 0) return null;
        const count = this.workbenchGenerationIntensities().length
            * this.normalizeCandidateCount(this.imageCandidateCount);
        let total = 0;
        for (const key of this.workbenchSelectedModels) {
            const pricing = this.imagePricing?.models?.[key];
            const configured = Number(pricing?.cost_micros_per_image);
            const estimated = Number(pricing?.estimate_micros_per_image);
            const rate = pricing?.pricing_status === 'configured'
                && Number.isFinite(configured) && configured > 0
                ? configured : estimated;
            if (!Number.isFinite(rate) || rate <= 0) return null;
            total += rate * count;
        }
        return total;
    }

    public workbenchEstimatedCostLabel() {
        if (this.workbenchExpression === 'blur') return '추가 AI 호출 없음';
        const cost = this.workbenchEstimatedCostMicros();
        return cost === null ? '요금 확인 필요' : `약 ${this.formatCost(cost)}`;
    }

    public workbenchRecentWorkTitle(job: any) {
        if (String(job?.source_kind || '') === 'scenario') {
            const id = String(job?.source_key || '').split(':')[0];
            const scenario = this.scenarioSets.find((item: any) =>
                String(item?.id || '') === id
            );
            return String(scenario?.title || job?.scenario_title || id || '시나리오 작업');
        }
        return String(job?.patient_code || job?.scenario_type || '환자 작업');
    }

    public workbenchCanResumeRecent(job: any) {
        if (String(job?.source_kind || '') === 'scenario') {
            const id = String(job?.source_key || '').split(':')[0];
            return this.scenarioSets.some((item: any) =>
                String(item?.id || '') === id
            );
        }
        return this.patients.some((item: any) =>
            String(item?.id || item?.patient_id || '') === String(job?.patient_id || '')
        );
    }

    public async workbenchResumeRecent(job: any) {
        if (String(job?.source_kind || '') === 'scenario') {
            const [id, memoryKind] = String(job?.source_key || '').split(':');
            const scenario = this.scenarioSets.find((item: any) =>
                String(item?.id || '') === id
            );
            if (!scenario) return;
            if (this.sourceMode !== 'scenario') await this.selectSourceMode('scenario');
            this.scenarioSelection.memory_kind = memoryKind === 'positive'
                ? 'positive' : 'trauma';
            await this.workbenchSelectScenario(scenario);
            return;
        }
        const patient = this.patients.find((item: any) =>
            String(item?.id || item?.patient_id || '') === String(job?.patient_id || '')
        );
        if (!patient) return;
        if (this.sourceMode !== 'patient') await this.selectSourceMode('patient');
        await this.workbenchSelectPatient(patient);
        if (String(job?.source_kind || '') === 'resource') {
            await this.selectPatientMemoryMode('resource');
            const resourceId = String(job?.source_key || '');
            if (this.resourceMemories.some((item: any) => String(item?.id || '') === resourceId)) {
                this.selectedResourceMemoryId = resourceId;
                await this.onResourceMemoryChange();
            }
        }
        await this.setContentTab(this.mediaType(job));
    }

    private workbenchImageResultSelectionKey() {
        return [this.sourceMode, this.scenarioSelection?.scenario_set_id,
            this.scenarioSelection?.memory_kind, this.selectedScenarioCutOrder || 0].join(':');
    }

    public workbenchImageResultModelKeys() {
        return [...new Set<string>([
            ...(this.generationModelOptions?.image || []).map((model: any) => String(model.value || '')),
            ...(this.workbenchSelectedModels || []),
            ...(this.jobs || []).filter((job: any) => this.recordMatchesSelectedSource(job))
                .map((job: any) => this.imageAssetModelKey(job))
        ].filter((key: string) => /^[a-z0-9][a-z0-9._-]{1,79}$/.test(key)))];
    }

    public workbenchImageResultFilterActive() {
        return !!this.workbenchImageResultFilter
            && this.workbenchImageResultSelection === this.workbenchImageResultSelectionKey();
    }

    public workbenchClearImageResultFilter() {
        this.workbenchImageResultLoadSequence = (this.workbenchImageResultLoadSequence || 0) + 1;
        this.workbenchImageResultFilter = null;
        this.workbenchImageResultLoading = false;
        this.workbenchImageResultError = '';
        this.workbenchImageResultSelection = '';
        this.workbenchCollectedImageJobs = [];
        this.workbenchCollectedImageAssets = [];
        this.workbenchImageResultPage = 1;
        this.workbenchComparisonCacheComplete = false;
        this.workbenchCompareInitialized = '';
        this.workbenchCompareCandidates = {};
        this.workbenchCompareMenu = '';
        this.changeDetector?.detectChanges();
    }

    public async workbenchClearImageResultFilterAndReload() {
        this.workbenchClearImageResultFilter();
        this.workbenchSetComparisonOpen(true);
        await this.workbenchEnsureComparisonResults();
    }

    public async workbenchEnsureComparisonResults(force: boolean = false) {
        if ((!force && !this.workbenchComparisonAutoLoadEnabled) || this.loading || this.destroyed || this.sourceMode !== 'scenario' || this.form.media_type !== 'image'
            || !this.can('content.read') || this.workbenchComparing || this.workbenchImageResultLoading
            || !this.selectedScenarioCut() || this.workbenchImageResultFilterActive()) return;
        if (!force && this.workbenchComparisonCacheComplete
            && this.workbenchImageResultSelection === this.workbenchImageResultSelectionKey()) return;
        const scenarioId = String(this.scenarioSelection?.scenario_set_id || '').toUpperCase();
        if (!scenarioId) return;
        await this.workbenchShowImageResults({ models: [], scope: 'cut' }, {
            scenario_id: scenarioId, memory_kind: this.scenarioSelection.memory_kind,
            cut_order: Number(this.selectedScenarioCutOrder || 0)
        }, () => false, () => {}, false);
    }

    public workbenchImageResultScopeLabel() {
        const memory = this.scenarioSelection?.memory_kind === 'positive' ? '행복 기억' : '외상 기억';
        return this.workbenchImageResultFilter?.scope === 'scenario'
            ? `현재 시나리오 · ${memory} · 전체 컷` : `현재 컷 · ${memory}`;
    }

    public workbenchImageResultFilterLabel() {
        return this.workbenchImageResultFilter?.models.length
            ? this.workbenchImageResultFilter.models.map((key) => this.workbenchModelLabel(key)).join(' · ')
            : '전체 모델';
    }

    public workbenchFilteredImageTiles() {
        if (!this.workbenchImageResultFilterActive()) return [];
        const filter = this.workbenchImageResultFilter!;
        const jobs = this.workbenchCollectedImageJobs || [];
        const assets = new Map((this.workbenchCollectedImageAssets || []).map((asset: any) => [this.jobId(asset), asset]));
        const replaced = new Set(jobs.filter((job: any) =>
            job.replaces_job_id && job.asset_revision_id && ['review_pending', 'approved'].includes(job.status)
        ).map((job: any) => String(job.replaces_job_id)));
        const cut = this.selectedScenarioCut();
        return jobs.filter((job: any) =>
            this.recordMatchesSelectedSource(job) && !job.archived_at && !replaced.has(this.jobId(job))
            && this.mediaType(job) === 'image' && this.panoramaGenerationMode(job) !== 'image_to_panorama'
            && (!filter.models.length || filter.models.includes(this.imageAssetModelKey(job)))
            && (filter.scope === 'scenario' || (cut && this.scenarioCutRecordMatches(job, cut)))
        ).map((job: any) => ({ job, modelKey: this.imageAssetModelKey(job),
            asset: assets.get(this.jobId(job)), intensity: Number(job.intensity || 1),
            candidateIndex: Number(job.candidate_index || 1)
        })).filter((tile: any) => tile.asset && this.visualUrl(tile.asset));
    }

    public workbenchFilteredImagePage() {
        const start = (this.workbenchImageResultPage - 1) * 24;
        return this.workbenchFilteredImageTiles().slice(start, start + 24);
    }

    public workbenchFilteredImagePageCount() {
        return Math.max(1, Math.ceil(this.workbenchFilteredImageTiles().length / 24));
    }

    public workbenchSetFilteredImagePage(page: number) {
        if (page < 1 || page > this.workbenchFilteredImagePageCount()) return;
        this.workbenchImageResultPage = page;
        this.changeDetector.detectChanges();
    }

    public async workbenchRefreshImageResults() {
        const context = this.workbenchAgentPromptContext();
        if (!context || !this.workbenchImageResultFilter || this.workbenchImageResultLoading) return;
        await this.workbenchShowImageResults(this.workbenchImageResultFilter, context);
    }

    private async workbenchCompareImageResults(options: any, originalContext: any,
        isCancelled: () => boolean = () => false, onProgress: (label: string) => void = () => {}) {
        const selection = this.workbenchImageResultSelectionKey();
        const current = () => !this.destroyed && !isCancelled() && selection === this.workbenchImageResultSelectionKey();
        if (!this.selectedScenarioCut() || !this.can('content.read')) {
            return { applied: false, message: '이미지를 비교할 컷을 먼저 선택해주세요.' };
        }
        if (!current()) return { applied: false, message: '이미지 비교 요청을 중지했습니다.' };
        if (options.expanded === false && !options.expression && options.intensity === null && !options.mode && !options.model) {
            await this.workbenchCloseComparison();
            return { applied: current(), label: '확대 비교 닫기', message: current()
                ? '확대 비교 화면을 닫았습니다.' : '비교 중 선택한 컷이 바뀌었거나 요청이 중지되었습니다.' };
        }
        // Unspecified fields refer to the comparison, independently of generation controls.
        const expression = options.expression || this.workbenchCompareExpression || 'blur';
        const intensity = options.intensity ?? this.workbenchCompareIntensity ?? 3;
        const mode = !this.workbenchComparisonUsesIntensity(expression) ? 'model' : options.mode || this.workbenchResultView || 'model';
        const requestedModel = options.model || this.workbenchCompareModel || '';
        // Refresh explicit requests: private image URLs expire, and jobs may have
        // completed since the last comparison was loaded.
        const loaded = await this.workbenchShowImageResults({ models: [], scope: 'cut' }, originalContext,
            isCancelled, onProgress, false);
        if (!loaded.applied) return loaded;
        if (!current()) return { applied: false, message: '조회 중 선택한 컷이 바뀌었거나 요청이 중지되었습니다.' };
        const models = this.workbenchComparisonModels();
        if (mode === 'intensity' && options.model && !models.includes(options.model)) {
            return { applied: false, message: `${this.workbenchModelLabel(options.model)}의 현재 컷 이미지가 없어 강도별로 비교할 수 없습니다.` };
        }
        onProgress('표현·강도와 이미지 비교 방식 적용 중');
        this.workbenchImageResultFilter = null;
        this.workbenchSetComparisonOpen(true);
        this.workbenchCompareExpression = expression;
        this.workbenchCompareIntensity = intensity;
        this.workbenchResultView = mode;
        this.workbenchCompareModel = models.includes(requestedModel) ? requestedModel : models[0] || '';
        this.workbenchCompareInitialized = selection;
        this.workbenchCompareMenu = '';
        this.workbenchCompareCandidates = {};
        await this.service.render();
        if (!current()) return { applied: false, message: '비교 중 선택한 컷이 바뀌었거나 요청이 중지되었습니다.' };
        if (options.expanded === true) await this.workbenchOpenComparison();
        else if (options.expanded === false) await this.workbenchCloseComparison();
        if (!current()) return { applied: false, message: '비교 중 선택한 컷이 바뀌었거나 요청이 중지되었습니다.' };
        const cards = this.workbenchComparisonCards();
        const ready = cards.filter(card => card.tile?.asset && this.visualUrl(card.tile.asset));
        const name = this.workbenchComparisonExpressions().find(option => option.key === expression)?.label || expression;
        const condition = !this.workbenchComparisonUsesIntensity(expression) ? name : `${name} · ${intensity}/5`;
        const description = mode === 'intensity'
            ? `${this.workbenchModelLabel(this.workbenchCompareModel)} · ${name}의 강도 1~5를 비교하도록 표시했습니다. ${cards.length}개 단계 중 ${ready.length}개에 완료 이미지가 있습니다.`
            : `${condition}의 모델별 비교를 표시했습니다. ${cards.length}개 모델 중 ${ready.length}개에 완료 이미지가 있습니다.`;
        const missing = mode === 'intensity' ? cards.filter(card => !ready.includes(card)).map(card => card.intensity) : [];
        this.workbenchAgentPulseTarget('wb-results-title');
        return { applied: true, label: mode === 'intensity' ? '강도별 이미지 비교' : '모델별 이미지 비교',
            message: cards.length ? description + (missing.length ? ` 완료 이미지가 없는 단계: ${missing.join('·')}.` : '')
                : '현재 컷에 비교할 이미지가 없습니다. 새 이미지를 생성하지 않고 비교 조건만 적용했습니다.' };
    }

    private async workbenchShowImageResults(filter: { models: string[]; scope: 'cut' | 'scenario' },
        originalContext: any, isCancelled: () => boolean = () => false, onProgress: (label: string) => void = () => {}, activateFilter: boolean = true) {
        const selection = this.workbenchImageResultSelectionKey();
        if (this.sourceMode !== 'scenario' || !this.can('content.read')
            || String(this.scenarioSelection?.scenario_set_id || '').toUpperCase() !== originalContext.scenario_id
            || this.scenarioSelection?.memory_kind !== originalContext.memory_kind
            || Number(this.selectedScenarioCutOrder || 0) !== originalContext.cut_order) {
            return { applied: false, message: '조회할 시나리오와 컷을 다시 선택해주세요.' };
        }
        if (filter.scope === 'cut' && !this.selectedScenarioCut()) {
            return { applied: false, message: '결과를 볼 컷을 선택하거나 시나리오 전체 결과를 요청해주세요.' };
        }
        const sequence = (this.workbenchImageResultLoadSequence || 0) + 1;
        this.workbenchImageResultLoadSequence = sequence;
        const current = () => !this.destroyed && !isCancelled() && sequence === this.workbenchImageResultLoadSequence
            && selection === this.workbenchImageResultSelectionKey();
        this.workbenchImageResultLoading = true;
        this.workbenchImageResultError = '';
        this.changeDetector.detectChanges();
        const jobs = new Map<string, any>();
        const assets = new Map<string, any>();
        try {
            for (let page = 1; ; page++) {
                if (!current()) return { applied: false, message: '이미지 결과 조회를 중지했습니다. 현재 시나리오에서 다시 요청해주세요.' };
                onProgress(`저장된 이미지 결과 ${page}페이지 조회 중`);
                const { code, data } = await wiz.call('search', {
                    source_mode: 'scenario', scenario_set_id: originalContext.scenario_id,
                    memory_kind: originalContext.memory_kind, media_type: 'image',
                    status: '', text: '', page, dump: 50
                });
                if (!current()) return { applied: false, message: '이미지 결과 조회를 중지했습니다. 현재 시나리오에서 다시 요청해주세요.' };
                if (code !== 200) throw new Error(data?.message || '저장된 이미지 결과를 불러오지 못했습니다.');
                const rows = this.extractList(data, ['jobs', 'generation_jobs']);
                for (const job of rows) {
                    if (this.jobId(job) && this.recordMatchesSelectedSource(job)) jobs.set(this.jobId(job), job);
                }
                for (const asset of this.extractList(data, ['assets', 'artifacts', 'media_assets'])) {
                    if (this.jobId(asset) && this.recordMatchesSelectedSource(asset)) assets.set(this.jobId(asset), asset);
                }
                const total = Number(data?.total ?? rows.length);
                const dump = Number(data?.dump || 50);
                if (!Number.isFinite(total) || total < 0 || ![10, 20, 50].includes(dump)) {
                    throw new Error('이미지 결과 목록을 확인하지 못했습니다. 다시 조회해주세요.');
                }
                if (page * dump >= total) break;
                if (!rows.length) throw new Error('이미지 결과 목록이 바뀌었습니다. 다시 조회해주세요.');
                if (page >= 100) throw new Error('결과가 많아 전체 조회를 마치지 못했습니다. 기존 결과 목록에서 페이지별로 확인해주세요.');
            }
            if (activateFilter && this.workbenchCompareExpanded) {
                await this.workbenchCloseComparison();
                if (!current()) return { applied: false, message: '조회 중 선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.' };
            }
            this.workbenchCollectedImageJobs = [...jobs.values()];
            this.workbenchCollectedImageAssets = [...assets.values()];
            this.workbenchRestoreVideoSource();
            this.workbenchImageResultSelection = selection;
            this.workbenchComparisonCacheComplete = true;
            if (activateFilter) this.workbenchImageResultFilter = { models: [...filter.models], scope: filter.scope };
            this.workbenchImageResultPage = 1;
            this.workbenchInitializeComparison();
            await this.service.render();
            if (!current()) return { applied: false, message: '조회 중 선택한 시나리오가 바뀌었습니다. 다시 요청해주세요.' };
            if (!activateFilter) return { applied: true, label: '저장된 비교 결과 조회', message: '' };
            const count = this.workbenchFilteredImageTiles().length;
            const scope = this.workbenchImageResultScopeLabel();
            const models = this.workbenchImageResultFilterLabel();
            this.workbenchAgentPulseTarget('wb-agent-image-results-heading');
            return { applied: true, label: `${models} 완료 이미지 ${count}장 조회`, message: count
                ? `${scope}에서 ${models}로 생성한 이미지 ${count}장을 찾아 결과 영역에 표시했습니다.`
                    + (count > 24 ? ' 한 페이지에 24장씩 볼 수 있습니다.' : '')
                : `${scope}에서 ${models}로 생성해 표시할 수 있는 완료 이미지가 없습니다.` };
        } catch (error: any) {
            const message = error?.message || '이미지 결과를 불러오지 못했습니다.';
            if (current()) this.workbenchImageResultError = message;
            return { applied: false, message };
        } finally {
            if (sequence === this.workbenchImageResultLoadSequence) {
                this.workbenchImageResultLoading = false;
                await this.service.render();
            }
        }
    }

    private workbenchImageResultJobs(key: string) {
        // Browser-only comparison IDs describe the active request. The gallery
        // is rebuilt from persisted jobs so every loaded result survives reload.
        const trackedIds = this.workbenchComparisonJobIds[key] || [];
        const jobs = new Map<string, any>();
        trackedIds.forEach((id: string) => {
            const job = this.workbenchComparisonJobSnapshots[id];
            if (job) jobs.set(id, job);
        });
        this.jobs.forEach((job: any) => jobs.set(this.jobId(job), job));
        const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
        const replaced = new Set(this.jobs.filter((job: any) =>
            !!job?.replaces_job_id && !!job?.asset_revision_id
            && ['review_pending', 'approved'].includes(job.status)
        ).map((job: any) => String(job.replaces_job_id)));
        return [...jobs.values()].filter((job: any) =>
            !!this.jobId(job) && !job?.archived_at && !replaced.has(this.jobId(job))
            && this.recordMatchesSelectedSource(job)
            && this.mediaType(job) === 'image'
            && this.panoramaGenerationMode(job) !== 'image_to_panorama'
            && (this.imageAssetModelKey(job) === key || trackedIds.includes(this.jobId(job)))
            && (!cut || this.scenarioCutRecordMatches(job, cut))
        );
    }

    public workbenchResultForModel(key: string) {
        const tiles = this.workbenchResultTiles(key);
        const matchingJobs = tiles.map((tile: any) => tile.job);
        const matchingAssets = tiles.map((tile: any) => tile.asset).filter(Boolean);
        const costKnown = matchingJobs.length > 0 && matchingJobs.every(
            (job: any) => this.generationUsageAvailable(job)
        );
        const costMicros = costKnown
            ? matchingJobs.reduce((total: number, job: any) =>
                total + Number(this.generationUsage(job)?.cost_micros || 0), 0)
            : null;
        return {
            asset: matchingAssets[0] || null,
            job: matchingJobs[0] || null,
            count: matchingAssets.length,
            costLabel: costMicros === null ? '집계 전' : this.formatCost(costMicros)
        };
    }

    public workbenchResultTiles(key: string) {
        const assets = this.allReviewAssets('image');
        return this.workbenchImageResultJobs(key)
            .map((job: any) => ({
                intensity: Number(job?.intensity || 1),
                candidateIndex: Number(job?.candidate_index || 1),
                job,
                asset: assets.find((asset: any) => this.jobId(asset) === this.jobId(job)) || null
            }))
            .sort((a: any, b: any) => a.intensity - b.intensity
                || a.candidateIndex - b.candidateIndex);
    }

    public workbenchResultTilesForIntensity(intensity: number) {
        return this.workbenchSelectedModels.flatMap((key: string) =>
            this.workbenchResultTiles(key)
                .filter((tile: any) => tile.intensity === intensity)
                .map((tile: any) => ({ ...tile, modelKey: key }))
        );
    }

    public imageResultConditionLabel(item: any) {
        const data = this.primaryMetadata(item);
        const expression = String(item?.image_expression || data?.image_expression || 'realistic');
        const customName = String(item?.image_expression_name || data?.image_expression_name || '').trim();
        const name = customName || ({
            realistic: '사실적 묘사', trigger: '트리거 요소', blur: '블러 처리'
        } as { [key: string]: string })[expression] || '사실적 묘사';
        if (expression === 'trigger') return name;
        const intensity = this.jobIntensity(item);
        if (expression === 'blur' && String(item?.generation_mode || data?.generation_mode || '') === 'selective_blur') {
            const labels: { [key: string]: string } = { '1': '강한 흐림', '2': '중간보다 강한 흐림',
                '3': '중간 흐림', '4': '약한 흐림', '5': '추가 흐림 없음' };
            return `${name} · ${intensity}/5 · ${labels[String(intensity)] || '고정 영역'}`;
        }
        return intensity === '-' ? name : `${name} · ${this.intensityScaleLabel()} ${intensity}/5`;
    }

    public workbenchImageConditionLabel(intensity: number) {
        return this.imageResultConditionLabel({
            image_expression: this.workbenchServerExpression(),
            image_expression_name: this.workbenchCustomExpression()?.name || '',
            intensity
        });
    }

    public workbenchResultTileLabel(tile: any) {
        const label = this.imageResultConditionLabel(tile.job);
        return Number(tile.job?.candidate_count || 1) > 1
            ? `${label} · ${tile.candidateIndex}번` : label;
    }

    public workbenchSetResultView(view: 'model' | 'intensity') {
        this.workbenchImageView = 'compare';
        if (view === 'intensity' && !this.workbenchComparisonUsesIntensity()) return;
        this.workbenchResultView = view;
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    private workbenchComparisonExpression(job: any) {
        const data = this.primaryMetadata(job);
        const expression = String(job?.image_expression || data?.image_expression || 'realistic');
        const customName = String(job?.image_expression_name || data?.image_expression_name || '').trim();
        if (customName && (expression === 'trigger' || job?.image_expression_uses_intensity === false || data?.image_expression_uses_intensity === false)) {
            return `single_custom:${customName}`;
        }
        return customName || expression === 'custom' ? `custom:${customName || '사용자 표현'}` : expression;
    }

    public workbenchComparisonUsesIntensity(expression: string = this.workbenchCompareExpression) {
        return expression !== 'trigger' && !expression.startsWith('single_custom:');
    }

    public workbenchComparisonExpressions() {
        const options = [
            { key: 'blur', label: '블러 처리', icon: 'fa-solid fa-layer-group' },
            { key: 'trigger', label: '트리거 요소', icon: 'fa-solid fa-wand-magic-sparkles' },
            { key: 'realistic', label: this.workbenchReferenceReproductionActive() ? '참고 이미지 재현' : '사실적 묘사', icon: 'fa-regular fa-image' }
        ];
        const seen = new Set(options.map((option) => option.key));
        this.workbenchComparisonSourceTiles().forEach((tile: any) => {
            const key = this.workbenchComparisonExpression(tile.job);
            if (!seen.has(key)) {
                options.push({ key, label: key.replace(/^(single_custom|custom):/, '')
                    + (key.startsWith('single_custom:') ? ' · 강도 없음' : ''), icon: 'fa-solid fa-sliders' });
                seen.add(key);
            }
        });
        return options;
    }

    public workbenchComparisonSourceTiles() {
        const cacheCurrent = this.workbenchImageResultSelection === this.workbenchImageResultSelectionKey();
        const jobs = new Map<string, any>();
        const assets = new Map<string, any>();
        if (cacheCurrent) {
            (this.workbenchCollectedImageJobs || []).forEach((job: any) => jobs.set(this.jobId(job), job));
            (this.workbenchCollectedImageAssets || []).forEach((asset: any) => assets.set(this.jobId(asset), asset));
        }
        if (!cacheCurrent || !this.workbenchComparisonCacheComplete) {
            Object.values(this.workbenchComparisonJobSnapshots || {}).forEach((job: any) => jobs.set(this.jobId(job), job));
            (this.jobs || []).forEach((job: any) => jobs.set(this.jobId(job), job));
            (this.assets || []).forEach((asset: any) => assets.set(this.jobId(asset), asset));
        }
        const replaced = new Set([...jobs.values()].filter((job: any) => job.replaces_job_id && job.asset_revision_id
            && ['review_pending', 'approved'].includes(job.status)).map((job: any) => String(job.replaces_job_id)));
        const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
        return [...jobs.values()].filter((job: any) => this.jobId(job) && !job.archived_at
            && this.recordMatchesSelectedSource(job) && !replaced.has(this.jobId(job))
            && this.mediaType(job) === 'image' && this.panoramaGenerationMode(job) !== 'image_to_panorama'
            && (this.sourceMode !== 'scenario' || (cut && this.scenarioCutRecordMatches(job, cut)))
        ).map((job: any) => ({ job, asset: assets.get(this.jobId(job)) || null,
            modelKey: this.imageAssetModelKey(job), intensity: Number(job.intensity || 1),
            candidateIndex: Number(job.candidate_index || 1)
        })).sort((a: any, b: any) => {
            const readyA = !!(a.asset && this.visualUrl(a.asset));
            const readyB = !!(b.asset && this.visualUrl(b.asset));
            return Number(readyB) - Number(readyA)
                || Date.parse(b.job.created_at || b.job.created || '1970-01-01')
                    - Date.parse(a.job.created_at || a.job.created || '1970-01-01')
                || a.candidateIndex - b.candidateIndex;
        });
    }

    public workbenchComparisonModels() {
        const tiles = this.workbenchComparisonSourceTiles();
        const present = new Set(tiles.map((tile: any) => tile.modelKey).filter(Boolean));
        const ordered = (this.generationModelOptions?.image || []).map((model: any) => String(model.value));
        return [...new Set([...ordered, ...present])].filter((key) => present.has(key));
    }

    private workbenchInitializeComparison() {
        const key = this.workbenchImageResultSelectionKey();
        if (this.workbenchCompareInitialized === key) return;
        const tiles = this.workbenchComparisonSourceTiles();
        if (!tiles.length) return;
        this.workbenchCompareInitialized = key;
        const expressions = new Set(tiles.map((tile: any) => this.workbenchComparisonExpression(tile.job)));
        if (!expressions.has(this.workbenchCompareExpression)) {
            this.workbenchCompareExpression = ['blur', 'realistic', 'trigger'].find((expression) => expressions.has(expression))
                || [...expressions][0];
        }
        const matching = tiles.filter((tile: any) => this.workbenchComparisonExpression(tile.job) === this.workbenchCompareExpression);
        const levels = [...new Set<number>(matching.map((tile: any) => tile.intensity))];
        if (!levels.includes(this.workbenchCompareIntensity)) {
            this.workbenchCompareIntensity = levels.sort((a, b) => Math.abs(a - 3) - Math.abs(b - 3))[0] || 3;
        }
        const models = this.workbenchComparisonModels();
        this.workbenchCompareModel = models.find((model) => matching.some((tile: any) => tile.modelKey === model)) || models[0] || '';
        if (!this.workbenchComparisonUsesIntensity()) this.workbenchResultView = 'model';
    }

    public workbenchSetComparisonExpression(expression: string) {
        if (!this.workbenchComparisonExpressions().some((option) => option.key === expression)) return;
        this.workbenchCompareExpression = expression;
        if (!this.workbenchComparisonUsesIntensity(expression)) this.workbenchResultView = 'model';
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    public workbenchSetComparisonIntensity(intensity: number) {
        if (![1, 2, 3, 4, 5].includes(intensity) || !this.workbenchComparisonUsesIntensity()) return;
        this.workbenchCompareIntensity = intensity;
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    public workbenchSetComparisonModel(model: string) {
        if (!this.workbenchComparisonModels().includes(model)) return;
        this.workbenchCompareModel = model;
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    public workbenchComparisonLevelLabel(level: number = this.workbenchCompareIntensity) {
        if (this.workbenchCompareExpression === 'blur') {
            return this.workbenchBlurLevels.find((item) => item.value === level)?.label || '';
        }
        if (this.workbenchRealisticFidelityActive()) return this.workbenchRealisticRubric(level).title;
        return `${this.intensityScaleLabel()} ${level}/5`;
    }

    public workbenchRealisticFidelityActive() {
        return this.workbenchCompareExpression === 'realistic' && (this.workbenchReferenceReproductionActive()
            || (this.sourceMode === 'scenario' && this.scenarioSelection?.memory_kind === 'trauma'));
    }

    public workbenchReproductionReference() {
        if (this.sourceMode === 'patient' && this.patientMemoryMode === 'resource') return null;
        if (this.sourceMode === 'scenario' && this.scenarioSelection?.memory_kind === 'positive') return null;
        const photo = (this.workbenchScenarioPhotos || []).find((item: any) => item.id === this.workbenchScenarioPhotoId);
        if (this.sourceMode === 'scenario' && photo) return {
            kind: 'scenario_photo', id: photo.id, title: this.workbenchScenarioPhotoLabel(),
            source: '직접 업로드한 참고 이미지', url: this.safeSignedUrl(photo.preview_url), roles: ['확인된 장면 요소']
        };
        if (this.sourceMode === 'patient' && this.selectedPatientSource) return {
            kind: 'patient_source', id: this.selectedPatientSource.patient_source_image_id || this.selectedPatientSource.id,
            title: this.selectedPatientSource.title || '환자 제공 참고 사진', source: '식별정보를 제거한 환자 제공 사진',
            url: this.safeSignedUrl(this.selectedPatientSource.preview_url), roles: ['확인된 장면 요소']
        };
        if (this.referenceUsageMode === 'visual' && this.selectedReferenceCondition) return {
            kind: 'library', id: this.selectedReferenceCondition.reference_id, title: this.selectedReferenceCondition.title,
            source: this.selectedReferenceCondition.source_label || '자료실', url: this.referenceConditionThumbnailUrl(),
            roles: (this.referenceRoles || []).map((key: string) =>
                (this.referenceRoleOptions || []).find((item: any) => item.value === key)?.label || key)
        };
        return null;
    }

    public workbenchSelectedReferenceSummary() {
        const photo = this.sourceMode === 'scenario'
            ? this.workbenchScenarioPhotos.find((item: any) => item.id === this.workbenchScenarioPhotoId)
            : null;
        if (photo) return { kind: 'scenario_photo', title: this.workbenchScenarioPhotoLabel(),
            source: '직접 업로드한 참고 이미지', url: this.safeSignedUrl(photo.preview_url) };
        if (this.sourceMode === 'patient' && this.selectedPatientSource) return {
            kind: 'patient_source', title: this.selectedPatientSource.title || '환자 제공 참고 사진',
            source: '환자 제공 사진', url: this.safeSignedUrl(this.selectedPatientSource.preview_url)
        };
        if (this.selectedReferenceCondition) return { kind: 'library',
            title: this.selectedReferenceCondition.title,
            source: this.selectedReferenceCondition.source_label || '자료실',
            url: this.referenceConditionThumbnailUrl() };
        return null;
    }

    public workbenchReferenceSummaryLabel() {
        const reference = this.workbenchSelectedReferenceSummary();
        if (!reference) return '선택 안 함';
        const applied = this.workbenchReferenceEnabled()
            && (reference.kind !== 'library' || this.referenceUsageMode !== 'none');
        return `${reference.title} · ${applied ? '적용' : '적용 안 함'}`;
    }

    public workbenchReferenceEnabled() {
        return this.workbenchExpression !== 'blur'
            && this.workbenchPromptDraft.reference_usage?.[this.workbenchExpression] !== false;
    }

    public workbenchVisualReferenceAvailable() {
        return !!((this.sourceMode === 'scenario' && this.workbenchScenarioPhotoId)
            || (this.sourceMode === 'patient' && this.selectedPatientSource)
            || (this.selectedReferenceCondition && this.referenceUsageMode === 'visual'));
    }

    public workbenchReferenceInstruction() {
        return String(this.workbenchPromptDraft.reference_instructions?.[this.workbenchExpression] || '');
    }

    public workbenchSetReferenceInstruction(value: string) {
        if (!this.workbenchPromptDraft.reference_instructions) this.workbenchPromptDraft.reference_instructions = {};
        this.workbenchPromptDraft.reference_instructions[this.workbenchExpression] = String(value || '').slice(0, 300);
        if (this.sourceMode === 'scenario') this.workbenchPromptChanged();
        this.resetActualPromptPreview();
    }

    public workbenchSetReferenceEnabled(enabled: boolean) {
        if (this.workbenchExpression === 'blur') return;
        if (!this.workbenchPromptDraft.reference_usage) this.workbenchPromptDraft.reference_usage = {};
        this.workbenchPromptDraft.reference_usage[this.workbenchExpression] = enabled;
        if (enabled && this.selectedReferenceCondition && this.referenceUsageMode === 'none') {
            void this.setReferenceUsageMode('visual');
        }
        this.form.idempotency_key = this.newIdempotencyKey();
        this.resetActualPromptPreview();
        if (this.sourceMode === 'scenario') this.workbenchPromptChanged();
        this.changeDetector.detectChanges();
    }

    public workbenchOpenSelectedReferencePreview() {
        const reference = this.workbenchSelectedReferenceSummary();
        if (reference?.kind === 'scenario_photo') void this.workbenchOpenScenarioPhotoPreview();
        else if (reference?.kind === 'library') void this.openReferenceConditionPreview();
        else if (reference?.url) window.open(reference.url, '_blank', 'noopener,noreferrer');
    }

    public workbenchFocusSharedReference() {
        this.workbenchExpressionStageOpen = true;
        this.changeDetector.detectChanges();
        setTimeout(() => document.getElementById('wb-shared-reference')?.scrollIntoView({ block: 'center', behavior: 'smooth' }), 0);
    }

    public workbenchReferencePlanCurrent() {
        const reference = this.workbenchReproductionReference();
        const plan = this.workbenchPromptDraft.reference_plan;
        return !!reference && plan.kind === reference.kind && plan.id === reference.id;
    }

    public workbenchReferenceStageTraits(level: number) {
        if (!this.workbenchReferencePlanCurrent()) return [];
        const traits = this.workbenchPromptDraft.reference_plan.traits;
        const count = Math.ceil(traits.length * Math.max(0, Math.min(4, Number(level) - 1)) / 4);
        return traits.slice(0, count);
    }

    public workbenchStartReferencePlan() {
        const reference = this.workbenchReproductionReference();
        if (!reference || this.sourceMode !== 'scenario') return;
        this.workbenchPromptDraft.reference_plan = {
            kind: reference.kind, id: reference.id, target: '', traits: [], scene_lock: ''
        };
        this.workbenchNewReferenceTrait = '';
        this.workbenchPromptChanged();
    }

    public workbenchAddReferenceTrait() {
        if (!this.workbenchReferencePlanCurrent()) return;
        const trait = this.workbenchNewReferenceTrait.trim().slice(0, 60);
        const traits = this.workbenchPromptDraft.reference_plan.traits;
        if (!trait || traits.length >= 8 || traits.includes(trait)) return;
        this.workbenchPromptDraft.reference_plan.traits = [...traits, trait];
        this.workbenchNewReferenceTrait = '';
        this.workbenchPromptChanged();
    }

    public workbenchRemoveReferenceTrait(index: number) {
        if (!this.workbenchReferencePlanCurrent()) return;
        this.workbenchPromptDraft.reference_plan.traits = this.workbenchPromptDraft.reference_plan.traits
            .filter((_trait, position) => position !== index);
        this.workbenchPromptChanged();
    }

    public scenarioElementKindLabel(kind: string) {
        return ({ visual: '시각', auditory: '청각', olfactory: '후각', tactile: '촉각', action: '행동',
            context: '사건·맥락', cognition: '생각', emotion: '감정', bodily_response: '신체 반응' } as any)[kind] || '검토 필요';
    }

    public workbenchApplyAnalyzedVisualTriggers() {
        const cut = this.selectedScenarioCut();
        const values = this.scenarioAnalysis?.prompt_drafts?.[String(cut?.order)]?.trigger_elements;
        if (!cut || !Array.isArray(values) || Number(this.scenarioAnalysis?.version) < this.scenarioAnalysisContractVersion) return;
        this.workbenchPromptDraft.trigger_elements = values.filter((value: any) => typeof value === 'string').slice(0, 12);
        this.workbenchExpression = 'trigger';
        this.workbenchPromptChanged();
        this.changeDetector?.detectChanges();
    }

    public workbenchRequestReferenceStageDraft() {
        const reference = this.workbenchReproductionReference();
        if (!reference) return;
        const plan = this.workbenchReferencePlanCurrent() ? this.workbenchPromptDraft.reference_plan : null;
        const target = plan?.target?.trim() || '선택한 참고 이미지의 확인된 대상';
        const traits = plan?.traits?.length ? `반영할 특징은 ${plan.traits.join('·')}입니다.` : '';
        const scene = plan?.scene_lock?.trim() ? `모든 단계에서 유지할 장면은 ${plan.scene_lock.trim()}입니다.` : '';
        window.dispatchEvent(new CustomEvent('ptsd:agent:prefill', { detail: {
            text: `현재 선택한 컷의 사실적 묘사 강도 1~5 추가 지시를 각각 작성해 해당 입력칸에 넣어줘. 참고 이미지의 비교 대상은 ${target}입니다. ${traits} ${scene} 확인되지 않은 요소는 만들지 말고 구도와 대상 위치를 유지해줘.`
        } }));
    }

    public workbenchReferenceReproductionActive() {
        if (this.workbenchCompareExpression !== 'realistic') return false;
        return !!this.workbenchReproductionReference() || this.workbenchComparisonSourceTiles().some((tile: any) =>
            this.workbenchComparisonExpression(tile.job) === 'realistic' && tile.job?.reference_reproduction?.version === 1);
    }

    public workbenchComparisonReference() {
        if (!this.workbenchReferenceReproductionActive()) return null;
        const current = this.workbenchReproductionReference();
        const snapshots = this.workbenchComparisonCards().map((card: any) => card.tile?.job?.reference_reproduction)
            .filter((item: any) => item?.version === 1);
        const refs = [...new Map(snapshots.map((item: any) =>
            [`${item.reference.kind}:${item.reference.id}`, item.reference])).values()] as any[];
        if (!refs.length) return current ? { ...current, note: '다음 생성에 사용할 참고 이미지 · 기존 결과에는 소급 적용되지 않습니다.' } : null;
        if (refs.length > 1) return { title: '서로 다른 참고 이미지가 포함되어 있습니다', source: '결과별 기준 확인 필요',
            url: '', roles: [], note: '같은 참고 이미지로 생성한 결과를 선택해 비교해 주세요.' };
        const ref = refs[0];
        if (current?.id === ref.id && current?.kind === ref.kind) return {
            ...current, note: '생성 요청에 기록된 참고 이미지 · 단계는 요청한 재현 수준입니다. 실제 유사도는 결과에서 확인해 주세요.'
        };
        const photo = ref.kind === 'scenario_photo' ? (this.workbenchScenarioPhotos || []).find((item: any) => item.id === ref.id) : null;
        return { ...ref, title: photo ? `업로드한 참고 이미지 · ${photo.width}×${photo.height}`
            : (ref.kind === 'library' ? '생성 당시 자료실 이미지' : '생성 당시 참고 이미지'),
            source: `기준 이미지 ${String(ref.id || '').slice(0, 8)}`, url: photo ? this.safeSignedUrl(photo.preview_url) : '',
            roles: [], note: '현재 선택한 이미지와 다른 기준으로 생성한 결과입니다. 생성 당시 기준으로 비교해 주세요.' };
    }

    public workbenchReproductionRubric(level: number) {
        const rows = [
            ['장소·구조 중심', '장소·공간 구조 중심 · 고유 세부 절제'],
            ['대상 형태 반영', '핵심 대상의 종류·윤곽·비율'],
            ['주요 특징 반영', '형태 유지 · 색상·방향·주요 특징'],
            ['세부 특징 반영', '창문·전조등·재질 등 확인된 세부'],
            ['참고 특징 충실 재현', '선택한 요소의 확인 가능한 특징을 충실히 반영']
        ];
        const row = rows[Math.max(0, Math.min(4, Number(level || 3) - 1))];
        return { title: row[0], description: row[1] };
    }

    public workbenchRealisticRubric(level: number) {
        if (this.workbenchReferenceReproductionActive()) return this.workbenchReproductionRubric(level);
        const rows = [
            ['윤곽 중심', '외곽과 큰 색면 · 미세 질감 최소화'],
            ['주요 형태', '주요 경계와 큰 구조 구분'],
            ['재질 구분', '재질 차이와 기본 명암'],
            ['세부 구조', '내부 구조·접촉 그림자·반사'],
            ['확인된 세부 완성', '앞 단계 유지 · 확인 가능한 표면 세부']
        ];
        const row = rows[Math.max(0, Math.min(4, Number(level || 3) - 1))];
        return { title: row[0], description: row[1] };
    }

    public workbenchFidelityResultLabel(card: any) {
        if (!card.tile?.asset) return '';
        if (card.tile.job?.reference_reproduction?.version === 1) return card.tile.job.reference_reproduction.input_mode === 'shared_scene_master'
            ? '동일한 기준 장면 편집 · 결과 유사도 검토 필요'
            : '참고 이미지 입력 · 결과 유사도 검토 필요';
        if (this.workbenchReferenceReproductionActive()) return '이전 생성 방식 · 참고 이미지 재현 단계와 별도 결과';
        const review = card.tile.job?.realistic_fidelity_review;
        if (review?.version !== 16) return '이전 기준 결과 · 새 기준으로 재생성 필요';
        if (review?.ignored_adjustment_sections?.length) return '시점·감정 지시 충돌 제외 · 결과 검토 필요';
        return '단계 기준 적용 · 시각 검토 필요';
    }

    public workbenchFidelityNearDuplicate(left: any, right: any) {
        if (!left || !right || left.version !== 'dhash32-rgb-v1' || right.version !== left.version) return false;
        const distance = (a: any, b: any) => {
            if (typeof a !== 'string' || typeof b !== 'string' || a.length !== b.length || !/^[a-f0-9]+$/i.test(a + b)) return 1;
            let bits = 0;
            for (let i = 0; i < a.length; i++) {
                let value = parseInt(a[i], 16) ^ parseInt(b[i], 16);
                while (value) { bits += value & 1; value >>= 1; }
            }
            return bits / (a.length * 4);
        };
        const colorLeft = left.mean_rgb, colorRight = right.mean_rgb;
        return Array.isArray(colorLeft) && Array.isArray(colorRight) && colorLeft.length === 3 && colorRight.length === 3
            && Math.max(...colorLeft.map((value: number, i: number) => Math.abs(value - colorRight[i]))) <= 3
            && (distance(left.horizontal, right.horizontal) + distance(left.vertical, right.vertical)) / 2 <= 0.01;
    }

    public workbenchFidelityComparisonAudit() {
        const cards = this.workbenchComparisonCards();
        const completed = cards.filter((card: any) => card.tile?.asset && this.visualUrl(card.tile.asset));
        const warnings: string[] = [];
        const reproduction = this.workbenchReferenceReproductionActive();
        if (reproduction && completed.length) {
            warnings.push('재현 단계는 목표값입니다. 실제 참고 이미지 유사도와 대상 위치의 단계별 순서를 직접 검토해 주세요.');
        }
        if (completed.length < 5) warnings.push(`5단계 중 ${completed.length}단계 결과만 있습니다. 전체 순서는 아직 확인할 수 없습니다.`);
        if (completed.some((card: any) => reproduction ? card.tile.job?.reference_reproduction?.version !== 1
            : card.tile.job?.realistic_fidelity_review?.version !== 16)) {
            warnings.push('이전 기준으로 생성한 이미지가 포함되어 있습니다. 새 기준으로 1~5단계를 다시 생성해 비교해 주세요.');
        }
        const keys = completed.map((card: any) => reproduction ? card.tile.job?.reference_reproduction?.comparison_key
            : card.tile.job?.realistic_fidelity_review?.comparison_key);
        if (completed.length > 1 && (keys.some((key: any) => !key) || new Set(keys).size > 1)) {
            warnings.push('같은 장면·모델·참고 이미지·생성 조건의 결과인지 확인이 필요합니다.');
        }
        const metadata = completed.map((card: any) => this.primaryMetadata(card.tile.asset));
        if (reproduction && completed.length > 1) {
            const sourceChecksums = metadata.map((item: any) =>
                item.provenance?.reference_reproduction?.input_checksum_sha256 || '');
            const sceneEdits = completed.filter((card: any) =>
                card.tile.job?.reference_reproduction?.input_mode === 'shared_scene_master');
            if (sceneEdits.length) {
                const master = completed.find((card: any) => Number(card.intensity) === 5);
                const masterChecksum = master ? this.primaryMetadata(master.tile.asset)?.checksum_sha256 : '';
                const masterIds = sceneEdits.map((card: any) =>
                    card.tile.job?.reference_reproduction?.scene_master_revision_id || '');
                const editChecksums = sceneEdits.map((card: any) =>
                    this.primaryMetadata(card.tile.asset)?.provenance?.reference_reproduction?.input_checksum_sha256 || '');
                if (!masterChecksum || masterIds.some((id: string) => !id)
                    || new Set(masterIds).size > 1
                    || editChecksums.some((checksum: string) => checksum !== masterChecksum)) {
                    warnings.push('낮은 단계가 동일한 5단계 기준 장면을 입력받았는지 확인이 필요합니다.');
                }
            } else if (sourceChecksums.some((checksum: string) => !checksum)
                || new Set(sourceChecksums).size > 1) {
                warnings.push('단계별로 실제 전달된 참고 이미지가 같은지 확인이 필요합니다.');
            }
        }
        if (metadata.some((item: any) => !item.checksum_sha256 || !item.provenance?.intensity_visual_signature)) {
            warnings.push('파일 또는 시각 지문이 없어 일부 중복 점검을 수행할 수 없습니다.');
        }
        let duplicate = false;
        for (let i = 0; i < metadata.length; i++) {
            for (let j = i + 1; j < metadata.length; j++) {
                const left = metadata[i], right = metadata[j];
                if ((left.checksum_sha256 && left.checksum_sha256 === right.checksum_sha256)
                    || this.workbenchFidelityNearDuplicate(left.provenance?.intensity_visual_signature, right.provenance?.intensity_visual_signature)) duplicate = true;
            }
        }
        if (duplicate) warnings.push('서로 다른 단계에 동일하거나 거의 같은 이미지가 있습니다. 단계 차이를 확인하고 재생성해 주세요.');
        if (completed.some((card: any) => card.tile.job?.realistic_fidelity_review?.ignored_adjustment_sections?.length)) {
            warnings.push('저장된 추가 지시 중 시점·거리·감정을 바꾸는 문구를 생성 요청에서 제외했습니다. 강도별 초안을 확인해 주세요.');
        }
        return { completed: completed.length, warnings,
            summary: warnings.length ? '비교 전 확인 필요' : '누락·조건·중복 점검 완료 · 시각 검토 필요' };
    }

    public workbenchComparisonScaleLabel() {
        if (this.workbenchReferenceReproductionActive()) return '참고 재현 단계';
        return this.workbenchCompareExpression === 'blur' ? '블러 강도' : this.intensityScaleLabel();
    }

    public workbenchComparisonCardCaption(card: any) {
        if (this.workbenchReferenceReproductionActive()) return `요청 재현 단계 ${card.intensity}/5`;
        const name = ({ blur: '블러', realistic: '사실적 묘사', trigger: '트리거 요소' } as { [key: string]: string })[
            this.workbenchCompareExpression] || this.workbenchCompareExpression.replace(/^(single_custom|custom):/, '');
        return !this.workbenchComparisonUsesIntensity() ? name : `${name} · ${card.intensity}/5`;
    }

    public workbenchCanSelectComparisonVideoSource(asset: any) {
        if (!this.can('content.write') || !this.videoSourceEligible(asset)) return false;
        if (this.sourceMode === 'patient') return this.patientMemoryMode === 'trauma';
        const cut = this.selectedScenarioCut();
        return this.sourceMode === 'scenario'
            && !!cut
            && this.recordMatchesSelectedSource(asset)
            && this.scenarioCutRecordMatches(asset, cut);
    }

    public workbenchSelectComparisonVideoSource(asset: any) {
        if (!this.workbenchCanSelectComparisonVideoSource(asset)) return;
        this.chooseReviewAsset(asset);
    }

    public workbenchComparisonCards() {
        const tiles = this.workbenchComparisonSourceTiles().filter((tile: any) =>
            this.workbenchComparisonExpression(tile.job) === this.workbenchCompareExpression);
        const models = this.workbenchComparisonModels();
        const mode = this.workbenchResultView === 'intensity' && this.workbenchComparisonUsesIntensity()
            ? 'intensity' : 'model';
        const selectedModel = models.includes(this.workbenchCompareModel) ? this.workbenchCompareModel : models[0];
        const make = (model: string, level: number, index: number) => {
            const matches = tiles.filter((tile: any) => tile.modelKey === model
                && (!this.workbenchComparisonUsesIntensity() || tile.intensity === level));
            const key = `${mode}:${model}:${this.workbenchCompareExpression}:${level}`;
            const candidate = Math.min(this.workbenchCompareCandidates?.[key] || 0, Math.max(0, matches.length - 1));
            const costs = matches.filter((tile: any) => tile.asset);
            const known = costs.length && costs.every((tile: any) => this.generationUsageAvailable(tile.job));
            const costLabel = known ? `${costs.length}장 합계 ${this.formatCost(costs.reduce((sum: number, tile: any) =>
                sum + Number(this.generationUsage(tile.job)?.cost_micros || 0), 0))}` : '';
            return { key, modelKey: model, intensity: level, ordinal: index + 1,
                title: mode === 'model' ? this.workbenchModelLabel(model) : `${level}단계 · ${this.workbenchComparisonLevelLabel(level)}`,
                tile: matches[candidate] || null, count: matches.length, candidate, costLabel };
        };
        return mode === 'model' ? models.map((model, index) => make(model, this.workbenchCompareIntensity, index))
            : selectedModel ? [1, 2, 3, 4, 5].map((level, index) => make(selectedModel, level, index)) : [];
    }

    public trackWorkbenchComparisonCard(_index: number, card: any) { return card.key; }

    public workbenchMoveComparisonCandidate(card: any, direction: number) {
        const next = card.candidate + direction;
        if (![-1, 1].includes(direction) || next < 0 || next >= card.count) return;
        this.workbenchCompareCandidates = { ...this.workbenchCompareCandidates, [card.key]: next };
        this.workbenchCompareMenu = '';
        this.changeDetector.detectChanges();
    }

    public workbenchToggleComparisonMenu(key: string) {
        this.workbenchCompareMenu = this.workbenchCompareMenu === key ? '' : key;
        this.changeDetector.detectChanges();
    }

    private workbenchImageArchiveUrl(scope: 'scenario' | 'model', model: string = ''): string {
        const scenarioId = String(this.scenarioSelection?.scenario_set_id || '').toUpperCase();
        const memoryKind = String(this.scenarioSelection?.memory_kind || '');
        if (!/^(?:[A-Z]{2}-[0-9]{2}|[A-Z][0-9]{2}|IM[0-9A-F]{14})$/.test(scenarioId)
            || !['trauma', 'positive'].includes(memoryKind)
            || (scope === 'model' && !this.workbenchImageResultModelKeys().includes(model))) return '';
        const params = new URLSearchParams({ scenario_set_id: scenarioId, memory_kind: memoryKind, scope });
        if (scope === 'model') params.set('model', model);
        return `/api/ptsd/content/archive?${params.toString()}`;
    }

    private async workbenchInspectImageArchive(scope: 'scenario' | 'model', model: string = ''):
        Promise<{ ok: boolean; message: string; count: number; url: string }> {
        const url = this.workbenchImageArchiveUrl(scope, model);
        if (!url || !this.can('content.read')) return { ok: false, message: '다운로드할 시나리오를 선택해주세요.', count: 0, url: '' };
        try {
            const response = await fetch(`${url}&inspect=1`, { credentials: 'same-origin' });
            const body = await response.json();
            if (!response.ok || body.code !== 200 || !Number(body.data?.count)) {
                return { ok: false, message: body.data?.message || '다운로드할 완료 이미지가 없습니다.', count: 0, url: '' };
            }
            return { ok: true, message: '', count: Number(body.data.count), url };
        } catch (_error) {
            return { ok: false, message: '이미지 ZIP을 확인하지 못했습니다. 다시 시도해주세요.', count: 0, url: '' };
        }
    }

    private workbenchStartImageArchiveDownload(url: string) {
        const link = document.createElement('a');
        link.href = url;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    public async workbenchDownloadImageArchive(scope: 'scenario' | 'model', model: string = '') {
        if (this.workbenchImageArchiveBusy) return;
        this.workbenchCompareMenu = '';
        this.workbenchImageArchiveBusy = true;
        this.workbenchImageArchiveError = '';
        this.changeDetector.detectChanges();
        const checked = await this.workbenchInspectImageArchive(scope, model);
        this.workbenchImageArchiveBusy = false;
        if (!checked.ok) {
            this.workbenchImageArchiveError = checked.message;
        } else {
            this.workbenchStartImageArchiveDownload(checked.url);
        }
        this.changeDetector.detectChanges();
    }

    public async workbenchOpenComparison() {
        if (this.workbenchCompareExpanded) return;
        this.workbenchSetComparisonOpen(true);
        this.workbenchCompareReturnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.workbenchComparePreviousOverflow = document.body.style.overflow;
        this.workbenchCompareExpanded = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        document.getElementById('wb-comparison-close')?.focus();
    }

    public async workbenchCloseComparison() {
        if (!this.workbenchCompareExpanded) return;
        this.workbenchCompareExpanded = false;
        this.workbenchCompareMenu = '';
        document.body.style.overflow = this.workbenchComparePreviousOverflow;
        await this.service.render();
        const target = this.workbenchCompareReturnFocus;
        this.workbenchCompareReturnFocus = null;
        if (target?.isConnected) target.focus();
        else document.getElementById('wb-comparison-expand')?.focus();
    }

    public trackWorkbenchComparisonExpression(_index: number, option: any) {
        return option.key;
    }

    public workbenchComparisonKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.selectedAsset) {
            event.preventDefault();
            if (this.workbenchCompareMenu) {
                this.workbenchCompareMenu = '';
                this.changeDetector.detectChanges();
            } else void this.workbenchCloseComparison();
        } else if (event.key === 'Tab' && this.workbenchCompareExpanded && !this.selectedAsset) {
            this.trapDialogFocus(event, 'wb-comparison');
        }
    }

    public trackWorkbenchResultTile(index: number, tile: any) {
        return String(tile?.job?.job_id || tile?.job?.generation_job_id || tile?.job?.id || index);
    }

    public trackWorkbenchResultGroup(_index: number, group: any) {
        return group.label;
    }

    public workbenchResultGroups() {
        const groups = new Map<string, { label: string; tiles: any[] }>();
        this.workbenchSelectedModels.forEach((key: string) => {
            this.workbenchResultTiles(key).forEach((tile: any) => {
                const label = this.imageResultConditionLabel(tile.job);
                if (!groups.has(label)) groups.set(label, { label, tiles: [] });
                groups.get(label)!.tiles.push({ ...tile, modelKey: key });
            });
        });
        return [...groups.values()];
    }

    public async workbenchGenerateComparison(showSuccessModal: boolean = true, isCancelled: () => boolean = () => false) {
        // Kept for callers that still pass the legacy flag. Progress and
        // completion are now shown inline instead of in a blocking modal.
        void showSuccessModal;
        if (this.workbenchComparing || !this.can('content.write')) return;
        if (this.workbenchExpression === 'blur') {
            this.workbenchSetComparisonOpen(true);
            this.workbenchClearImageResultFilter();
            await this.workbenchGenerateBlur();
            return;
        }
        if (!this.workbenchHasSelection() || !this.contentSettingsReady()) {
            this.workbenchComparisonError = '출처의 준비 상태와 생성 기준을 먼저 확인해주세요.';
            return;
        }
        if (this.workbenchSelectedModels.length === 0) {
            this.workbenchComparisonError = '이미지 모델을 하나 이상 선택해주세요.';
            return;
        }
        if (
            this.sourceMode === 'patient'
            && this.workbenchReferenceEnabled()
            && this.selectedPatientSource
            && this.workbenchSelectedModels.some((key: string) => key !== 'openai-gpt-image-2')
        ) {
            this.workbenchComparisonError = '환자 제공 사진을 사용하는 경우 OpenAI Image 모델만 선택할 수 있습니다.';
            return;
        }
        if (
            this.sourceMode === 'scenario'
            && (this.selectedScenarioCompletedRaw() || this.scenarioAnalysisState === 'complete')
            && !this.scenarioCutRequestSpec()
        ) {
            this.workbenchComparisonError = '시나리오 분석 결과에서 생성할 컷을 먼저 선택해주세요.';
            return;
        }
        this.workbenchClearImageResultFilter();
        this.form.media_type = 'image';
        this.workbenchSetComparisonOpen(true);
        this.workbenchComparing = true;
        this.workbenchComparisonError = '';
        this.errorMessage = '';
        this.workbenchComparisonJobIds = {};
        this.workbenchComparisonJobSnapshots = {};
        const previousModel = this.selectedGenerationModelKeys.image;
        const previousIntensity = this.form.intensity;
        const previousScope = this.imageGenerationScope;
        const failed: string[] = [];
        let stopped = false;
        try {
            for (const key of this.workbenchSelectedModels) {
                if (isCancelled()) { stopped = true; break; }
                this.selectedGenerationModelKeys.image = key;
                const selectedIntensities = this.workbenchGenerationIntensities();
                const fixedScene = this.sourceMode === 'scenario'
                    && this.scenarioSelection?.memory_kind === 'trauma'
                    && this.workbenchExpression === 'realistic'
                    && this.workbenchReferenceEnabled()
                    && !!this.workbenchReproductionReference()
                    && selectedIntensities.some((level: number) => level < 5);
                const submit = async (intensity: number): Promise<any[]> => {
                    if (isCancelled()) { stopped = true; return []; }
                    this.form.intensity = intensity;
                    this.imageGenerationScope = 'single';
                    if (!this.generationModelAvailable(key, 'image')
                        || !this.imageGenerationRequestValid()) {
                        failed.push(`${this.workbenchModelLabel(key)} · ${this.workbenchImageConditionLabel(intensity)}`);
                        return [];
                    }
                    this.form.idempotency_key = this.newIdempotencyKey();
                    const createdJobs = await this.createJob(true);
                    const normalizedJobs = (Array.isArray(createdJobs) ? createdJobs : [])
                        .filter((job: any) => !!this.jobId(job));
                    const added = normalizedJobs
                        .map((job: any) => this.jobId(job))
                        .filter((jobId: string) => !!jobId);
                    if (added.length > 0) {
                        normalizedJobs.forEach((job: any) => {
                            const jobId = this.jobId(job);
                            const trackedJob = {
                                ...job,
                                status: String(job?.status || '').trim() || 'queued'
                            };
                            this.workbenchComparisonJobSnapshots[jobId] = trackedJob;
                            this.upsertJob(trackedJob, true);
                            if (!this.jobs.some((item: any) => this.jobId(item) === jobId)) {
                                this.jobs = [trackedJob, ...this.jobs];
                            }
                        });
                        this.workbenchComparisonJobIds[key] = [
                            ...(this.workbenchComparisonJobIds[key] || []), ...added
                        ];
                        await this.service.render();
                    } else failed.push(`${this.workbenchModelLabel(key)} · ${this.workbenchImageConditionLabel(intensity)}`);
                    return normalizedJobs;
                };
                this.workbenchSceneMasterRevisionId = '';
                if (fixedScene) {
                    const masters = await submit(5);
                    if (stopped) break;
                    if (!masters.length) continue;
                    this.workbenchSceneMasterWaiting = true;
                    await this.service.render();
                    const masterIds = masters.map((job: any) => this.jobId(job)).filter(Boolean);
                    const deadline = Date.now() + 8 * 60 * 1000;
                    while (!isCancelled() && Date.now() < deadline) {
                        await Promise.all(masterIds.map((id: string) => this.refreshJob(id, false)));
                        const ready = masterIds.map((id: string) => this.jobs.find((job: any) => this.jobId(job) === id))
                            .find((job: any) => ['review_pending', 'approved'].includes(String(job?.status || ''))
                                && !!String(job?.asset_revision_id || ''));
                        if (ready) {
                            this.workbenchSceneMasterRevisionId = String(ready.asset_revision_id);
                            break;
                        }
                        const terminal = masterIds.every((id: string) => {
                            const job = this.jobs.find((item: any) => this.jobId(item) === id);
                            return ['review_pending', 'approved', 'failed', 'cancelled'].includes(String(job?.status || ''));
                        });
                        if (terminal) break;
                        await new Promise<void>((resolve) => window.setTimeout(resolve, 4000));
                    }
                    this.workbenchSceneMasterWaiting = false;
                    if (isCancelled()) { stopped = true; break; }
                    if (!this.workbenchSceneMasterRevisionId) {
                        failed.push(`${this.workbenchModelLabel(key)} · 기준 장면 생성`);
                        continue;
                    }
                }
                for (const intensity of selectedIntensities) {
                    if (fixedScene && intensity === 5) continue;
                    await submit(intensity);
                    if (stopped) break;
                }
            }
            if (stopped) {
                this.workbenchComparisonError = '남은 이미지 생성 요청을 중지했습니다.';
            } else if (failed.length > 0) {
                this.workbenchComparisonError = `${failed.join(', ')} 생성 요청을 등록하지 못했습니다. ${this.errorMessage || ''}`.trim();
            }
        } finally {
            this.selectedGenerationModelKeys.image = previousModel;
            this.form.intensity = previousIntensity;
            this.imageGenerationScope = previousScope;
            this.workbenchSceneMasterRevisionId = '';
            this.workbenchSceneMasterWaiting = false;
            this.workbenchComparing = false;
            await this.service.render();
        }
    }

    public workbenchBlurSources() {
        const cut = this.sourceMode === 'scenario' ? this.selectedScenarioCut() : null;
        return this.allReviewAssets('image').filter((asset: any) =>
            this.recordMatchesSelectedSource(asset)
            && (!cut || this.scenarioCutRecordMatches(asset, cut))
            && this.assetSafetyStatus(asset) === 'passed'
            && ['pending', 'review_pending', 'approved'].includes(this.assetReviewStatus(asset))
            && String(asset?.generation_mode || this.primaryMetadata(asset)?.generation_mode || '') !== 'selective_blur'
        );
    }

    public workbenchBlurSource() {
        const sources = this.workbenchBlurSources();
        return sources.find((asset: any) => this.assetId(asset) === this.workbenchBlurSourceId)
            || sources[0] || null;
    }

    public workbenchBlurSourceDetails(asset: any) {
        return [asset?.scenario_cut_order ? `컷 ${asset.scenario_cut_order}` : '',
            this.imageResultConditionLabel(asset), this.assetId(asset).slice(0, 8)]
            .filter(Boolean).join(' · ');
    }

    public workbenchToggleBlurSourcePicker() {
        if (this.workbenchComparing || !this.workbenchBlurSources().length) return;
        const next = !this.workbenchBlurSourcePickerOpen;
        this.workbenchCloseDropdowns();
        this.workbenchBlurSourcePickerOpen = next;
        this.changeDetector.detectChanges();
        if (next) this.workbenchFocusBlurSource();
    }

    private workbenchFocusBlurSource(index?: number) {
        const options = Array.from(document.querySelectorAll<HTMLButtonElement>('#wb-blur-source-menu [role="option"]'));
        const option = index === undefined
            ? options.find(item => item.getAttribute('aria-selected') === 'true') || options[0]
            : options[index];
        option?.focus({ preventScroll: true });
        option?.scrollIntoView({ block: 'nearest' });
    }

    public workbenchSelectBlurSource(id: string) {
        if (this.workbenchComparing || !this.workbenchBlurSources().some((asset: any) => this.assetId(asset) === id)) return;
        this.workbenchCloseDropdowns();
        if (this.assetId(this.workbenchBlurSource()) !== id) this.workbenchSetBlurSource(id);
        else this.changeDetector.detectChanges();
        document.getElementById('wb-blur-source')?.focus({ preventScroll: true });
    }

    public workbenchBlurSourceKeydown(event: KeyboardEvent) {
        if (this.workbenchComparing) return;
        if (this.workbenchBlurSourcePickerOpen && ['Escape', 'Tab'].includes(event.key)) {
            if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); }
            this.workbenchCloseDropdowns();
            this.changeDetector.detectChanges();
            document.getElementById('wb-blur-source')?.focus({ preventScroll: true });
            return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const sources = this.workbenchBlurSources();
        if (!sources.length) return;
        event.preventDefault();
        const options = Array.from(document.querySelectorAll('#wb-blur-source-menu [role="option"]'));
        const focused = options.indexOf(document.activeElement);
        let index = focused >= 0 ? focused : Math.max(0, sources.findIndex((asset: any) => this.assetId(asset) === this.assetId(this.workbenchBlurSource())));
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = sources.length - 1;
        else if (this.workbenchBlurSourcePickerOpen && focused >= 0) index += event.key === 'ArrowDown' ? 1 : -1;
        this.workbenchCloseDropdowns();
        this.workbenchBlurSourcePickerOpen = true;
        this.changeDetector.detectChanges();
        this.workbenchFocusBlurSource(Math.max(0, Math.min(sources.length - 1, index)));
    }

    public workbenchBlurSourceFocusOut(event: FocusEvent) {
        if (!this.workbenchBlurSourcePickerOpen || (event.currentTarget as HTMLElement).contains(event.relatedTarget as Node)) return;
        this.workbenchBlurSourcePickerOpen = false;
        this.changeDetector.detectChanges();
    }

    public workbenchSetBlurSource(id: string) {
        this.workbenchBlurSourceId = id;
        this.workbenchBlurPreviewFailedId = '';
        this.workbenchBlurPreviewReadyId = '';
        this.workbenchBlurRegion = { x: 0, y: 0, width: 1, height: .55 };
        this.workbenchSaveBlurPreset();
        this.changeDetector.detectChanges();
    }

    public workbenchBlurPreviewAvailable(source: any) {
        return !!this.masterUrl(source) && this.workbenchBlurPreviewFailedId !== this.assetId(source);
    }

    public workbenchBlurPreviewLoaded(source: any) {
        this.workbenchBlurPreviewReadyId = this.assetId(source);
        if (this.workbenchBlurPreviewFailedId === this.assetId(source)) {
            this.workbenchBlurPreviewFailedId = '';
        }
        this.changeDetector.detectChanges();
    }

    public async workbenchBlurPreviewError(source: any) {
        const id = this.assetId(source);
        if (!id || this.workbenchBlurPreviewFailedId === id) return;
        const failedUrl = this.masterUrl(source);
        this.workbenchBlurPreviewFailedId = id;
        this.workbenchBlurPreviewReadyId = '';
        this.changeDetector.detectChanges();
        if (this.workbenchBlurPreviewRefreshIds.has(id)) return;
        this.workbenchBlurPreviewRefreshIds.add(id);
        try {
            await this.search(false, false);
            const refreshed = this.workbenchBlurSource();
            if (this.assetId(refreshed) === id && this.masterUrl(refreshed)
                && this.masterUrl(refreshed) !== failedUrl) {
                this.workbenchBlurPreviewFailedId = '';
            }
        } catch (_error) {
            // Keep the visible retry state when the refresh request fails.
        } finally {
            this.changeDetector.detectChanges();
        }
    }

    public async workbenchRetryBlurPreview() {
        const id = this.assetId(this.workbenchBlurSource());
        if (!id) return;
        this.workbenchBlurPreviewRefreshIds.delete(id);
        this.workbenchBlurPreviewFailedId = '';
        this.workbenchBlurPreviewReadyId = '';
        try {
            await this.search(false, false);
        } catch (_error) {
            this.workbenchBlurPreviewFailedId = id;
        } finally {
            this.changeDetector.detectChanges();
        }
    }

    public workbenchBlurPercent(value: number) {
        return Math.round(value * 100);
    }

    public workbenchSetBlurRegion(key: string, raw: any) {
        if (!['x', 'y', 'width', 'height'].includes(key) || this.workbenchComparing) return;
        const value = Number(raw) / 100;
        if (!Number.isFinite(value)) return;
        const region: any = { ...this.workbenchBlurRegion, [key]: Math.max(0, Math.min(1, value)) };
        region.x = Math.min(.98, region.x);
        region.y = Math.min(.98, region.y);
        region.width = Math.max(.02, Math.min(1 - region.x, region.width));
        region.height = Math.max(.02, Math.min(1 - region.y, region.height));
        this.workbenchBlurRegion = region;
        this.workbenchSaveBlurPreset();
        this.changeDetector.detectChanges();
    }

    private workbenchBlurPoint(event: PointerEvent) {
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        return { x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)),
                 y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height)) };
    }

    public workbenchBlurPointerStart(event: PointerEvent) {
        if (this.workbenchComparing || event.button !== 0) return;
        event.preventDefault();
        this.workbenchBlurDrag = this.workbenchBlurPoint(event);
        (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    }

    public workbenchBlurPointerMove(event: PointerEvent) {
        if (!this.workbenchBlurDrag) return;
        const point = this.workbenchBlurPoint(event), start = this.workbenchBlurDrag;
        if (Math.abs(point.x - start.x) < .02 || Math.abs(point.y - start.y) < .02) return;
        this.workbenchBlurRegion = { x: Math.min(point.x, start.x), y: Math.min(point.y, start.y),
            width: Math.abs(point.x - start.x), height: Math.abs(point.y - start.y) };
        this.changeDetector.detectChanges();
    }

    public workbenchBlurPointerEnd(event: PointerEvent) {
        if (event.type !== 'pointercancel') this.workbenchBlurPointerMove(event);
        this.workbenchBlurDrag = null;
        this.workbenchSaveBlurPreset();
    }

    private workbenchBlurPresetKey() {
        const identity = this.sourceMode === 'patient' ? this.form.patient_id : this.scenarioSelection.scenario_set_id;
        const memory = this.sourceMode === 'patient'
            ? (this.patientMemoryMode === 'resource' ? this.selectedResourceMemoryId : 'trauma')
            : this.scenarioSelection.memory_kind;
        return `ptsd.blurPreset.v1.${this.service.auth.session?.id || ''}.${this.sourceMode}.${identity}.${memory}.${this.sourceMode === 'scenario' ? this.selectedScenarioCut()?.order || 0 : 0}`;
    }

    private workbenchSaveBlurPreset() {
        try { localStorage.setItem(this.workbenchBlurPresetKey(), JSON.stringify({
            source: this.workbenchBlurSourceId, region: this.workbenchBlurRegion })); } catch (_error) { }
    }

    private workbenchRestoreBlurPreset() {
        this.workbenchBlurSourceId = '';
        this.workbenchBlurPreviewFailedId = '';
        this.workbenchBlurPreviewReadyId = '';
        this.workbenchBlurPreviewRefreshIds.clear();
        this.workbenchBlurRegion = { x: 0, y: 0, width: 1, height: .55 };
        try {
            const saved = JSON.parse(localStorage.getItem(this.workbenchBlurPresetKey()) || 'null');
            if (saved && this.workbenchBlurSources().some((asset: any) => this.assetId(asset) === saved.source)) {
                const r = saved.region;
                if (r && [r.x, r.y, r.width, r.height].every(Number.isFinite)
                    && r.x >= 0 && r.y >= 0 && r.width >= .02 && r.height >= .02
                    && r.x + r.width <= 1 && r.y + r.height <= 1) {
                    this.workbenchBlurSourceId = saved.source;
                    this.workbenchBlurRegion = r;
                }
            }
        } catch (_error) { }
        this.workbenchBlurSourceId = this.assetId(this.workbenchBlurSource());
    }

    private async workbenchGenerateBlur() {
        const source = this.workbenchBlurSource();
        if (!source) {
            this.workbenchComparisonError = '같은 컷의 기준 이미지를 먼저 생성한 뒤 블러 처리를 선택해주세요.';
            this.changeDetector.detectChanges();
            return;
        }
        this.workbenchComparing = true;
        this.workbenchComparisonError = '';
        this.workbenchComparisonJobIds = {};
        this.workbenchComparisonJobSnapshots = {};
        const key = this.imageAssetModelKey(source);
        if (key && !this.workbenchSelectedModels.includes(key)) {
            this.workbenchSelectedModels = [...this.workbenchSelectedModels, key];
            this.workbenchSaveModels();
        }
        try {
            const { code, data } = await wiz.call('create_blur_images', {
                source_mode: this.sourceMode,
                scenario_id: this.scenarioSelection.scenario_set_id,
                memory_kind: this.scenarioSelection.memory_kind,
                cut_order: Number(this.selectedScenarioCut()?.order || source?.scenario_cut_order
                    || this.primaryMetadata(source)?.scenario_cut_order || 0),
                patient_id: this.form.patient_id,
                source_revision_id: this.assetId(source),
                resource_memory_id: this.patientMemoryMode === 'resource' ? this.selectedResourceMemoryId : '',
                region: JSON.stringify(this.workbenchBlurRegion),
                intensities: JSON.stringify([...this.workbenchSelectedIntensities]),
                idempotency_key: this.newIdempotencyKey(), csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) throw new Error(data?.message || '블러 생성 요청을 등록하지 못했습니다.');
            for (const job of data.jobs || []) {
                const id = this.jobId(job);
                this.workbenchComparisonJobSnapshots[id] = job;
                this.upsertJob(job, true);
                this.workbenchComparisonJobIds[key] = [...(this.workbenchComparisonJobIds[key] || []), id];
            }
            this.mergeAssets(this.assetsFromPayload(data));
            this.changeDetector.detectChanges();
            await this.search(false, false);
        } catch (error) {
            this.workbenchComparisonError = String((error as Error)?.message || '블러 생성 요청을 등록하지 못했습니다.');
        } finally {
            this.workbenchComparing = false;
            await this.service.render();
        }
    }

    public workbenchDismissComparisonError() {
        this.workbenchComparisonError = '';
        this.changeDetector.detectChanges();
    }
}

export default PageContentComponent;